import React from 'react';

const Trope2: React.FC = () => {
  return (
    <g
      className="prefix__trope-decor-2 prefix__trope-decor"
      transform="translate(115, 205)"
    >
      <g>
        <g>
          <g>
            <g>
              <path
                d="M1322.74,146c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1322.74,146Z"
                fill="#2f6840"
              />
              <path
                d="M1322.24,145.6c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,1322.24,145.6Z"
                fill="#3ba525"
              />
              <path
                d="M1323,145.58a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.38,2.38,0,0,1,.47.53A1,1,0,0,1,1323,145.58Z"
                fill="#2f6840"
              />
              <path
                d="M1326.47,144.78c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1326.47,144.78Z"
                fill="#2f6840"
              />
              <path
                d="M1325.1,148a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1325.1,148Z"
                fill="#2f6840"
              />
              <path
                d="M1323.14,146a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1323.14,146Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1320.08,154.68c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1320.08,154.68Z"
                fill="#2f6840"
              />
              <path
                d="M1319.58,154.33c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1319.58,154.33Z"
                fill="#3ba525"
              />
              <path
                d="M1320.33,154.31a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1320.33,154.31Z"
                fill="#2f6840"
              />
              <path
                d="M1323.81,153.51c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1323.81,153.51Z"
                fill="#2f6840"
              />
              <path
                d="M1322.44,156.72a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1322.44,156.72Z"
                fill="#2f6840"
              />
              <path
                d="M1320.48,154.76c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1320.48,154.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1314.73,149.72c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1314.73,149.72Z"
                fill="#2f6840"
              />
              <path
                d="M1314.22,149.38c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1314.22,149.38Z"
                fill="#3ba525"
              />
              <path
                d="M1315,149.35a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1315,149.35Z"
                fill="#2f6840"
              />
              <path
                d="M1318.45,148.55c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1318.45,148.55Z"
                fill="#2f6840"
              />
              <path
                d="M1317.09,151.76a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1317.09,151.76Z"
                fill="#2f6840"
              />
              <path
                d="M1315.13,149.81a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1315.13,149.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1306.39,146.35c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1306.39,146.35Z"
                fill="#2f6840"
              />
              <path
                d="M1305.88,146c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1305.88,146Z"
                fill="#3ba525"
              />
              <path
                d="M1306.63,146a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1306.63,146Z"
                fill="#2f6840"
              />
              <path
                d="M1310.11,145.18c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1310.11,145.18Z"
                fill="#2f6840"
              />
              <path
                d="M1308.74,148.39a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1308.74,148.39Z"
                fill="#2f6840"
              />
              <path
                d="M1306.79,146.44a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1306.79,146.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1321.09,161.84c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.25-2.27-2.08-2.36A14.65,14.65,0,0,1,1321.09,161.84Z"
                fill="#2f6840"
              />
              <path
                d="M1320.59,161.49c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1320.59,161.49Z"
                fill="#3ba525"
              />
              <path
                d="M1321.34,161.47a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1321.34,161.47Z"
                fill="#2f6840"
              />
              <path
                d="M1324.82,160.67c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1324.82,160.67Z"
                fill="#2f6840"
              />
              <path
                d="M1323.45,163.88a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1323.45,163.88Z"
                fill="#2f6840"
              />
              <path
                d="M1321.49,161.92c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1321.49,161.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1307.64,156.27c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1307.64,156.27Z"
                fill="#2f6840"
              />
              <path
                d="M1307.13,155.92c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1307.13,155.92Z"
                fill="#3ba525"
              />
              <path
                d="M1307.88,155.9a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1307.88,155.9Z"
                fill="#2f6840"
              />
              <path
                d="M1311.36,155.1c-.26,0-.49,0-.72.1a3.76,3.76,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1311.36,155.1Z"
                fill="#2f6840"
              />
              <path
                d="M1310,158.31a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1310,158.31Z"
                fill="#2f6840"
              />
              <path
                d="M1308,156.36a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1308,156.36Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1296,155.84c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1296,155.84Z"
                fill="#2f6840"
              />
              <path
                d="M1295.52,155.49c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1295.52,155.49Z"
                fill="#3ba525"
              />
              <path
                d="M1296.27,155.46a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1296.27,155.46Z"
                fill="#2f6840"
              />
              <path
                d="M1299.75,154.67a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1299.75,154.67Z"
                fill="#2f6840"
              />
              <path
                d="M1298.38,157.88a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1298.38,157.88Z"
                fill="#2f6840"
              />
              <path
                d="M1296.42,155.92c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1296.42,155.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1293.36,164.57c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1293.36,164.57Z"
                fill="#2f6840"
              />
              <path
                d="M1292.86,164.22c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1292.86,164.22Z"
                fill="#3ba525"
              />
              <path
                d="M1293.61,164.19a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1293.61,164.19Z"
                fill="#2f6840"
              />
              <path
                d="M1297.09,163.4c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1297.09,163.4Z"
                fill="#2f6840"
              />
              <path
                d="M1295.72,166.61a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1295.72,166.61Z"
                fill="#2f6840"
              />
              <path
                d="M1293.76,164.65c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1293.76,164.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1288,159.61c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1288,159.61Z"
                fill="#2f6840"
              />
              <path
                d="M1287.51,159.26c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1287.51,159.26Z"
                fill="#3ba525"
              />
              <path
                d="M1288.26,159.23a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1288.26,159.23Z"
                fill="#2f6840"
              />
              <path
                d="M1291.74,158.44c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1291.74,158.44Z"
                fill="#2f6840"
              />
              <path
                d="M1290.37,161.65a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1290.37,161.65Z"
                fill="#2f6840"
              />
              <path
                d="M1288.41,159.69c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1288.41,159.69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1279.67,156.24c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1279.67,156.24Z"
                fill="#2f6840"
              />
              <path
                d="M1279.16,155.89c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1279.16,155.89Z"
                fill="#3ba525"
              />
              <path
                d="M1279.92,155.86a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1279.92,155.86Z"
                fill="#2f6840"
              />
              <path
                d="M1283.39,155.07a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1283.39,155.07Z"
                fill="#2f6840"
              />
              <path
                d="M1282,158.28a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1282,158.28Z"
                fill="#2f6840"
              />
              <path
                d="M1280.07,156.32c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,11.51,11.51,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1280.07,156.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1294.37,171.73c4.43-.26-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1294.37,171.73Z"
                fill="#2f6840"
              />
              <path
                d="M1293.87,171.38c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1293.87,171.38Z"
                fill="#3ba525"
              />
              <path
                d="M1294.62,171.35a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1294.62,171.35Z"
                fill="#2f6840"
              />
              <path
                d="M1298.1,170.56c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.48,2.48,0,0,1,1.24-.86A2.07,2.07,0,0,1,1298.1,170.56Z"
                fill="#2f6840"
              />
              <path
                d="M1296.73,173.77a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1296.73,173.77Z"
                fill="#2f6840"
              />
              <path
                d="M1294.77,171.81c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1294.77,171.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1280.92,166.16c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1280.92,166.16Z"
                fill="#2f6840"
              />
              <path
                d="M1280.41,165.81c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1280.41,165.81Z"
                fill="#3ba525"
              />
              <path
                d="M1281.16,165.78a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1281.16,165.78Z"
                fill="#2f6840"
              />
              <path
                d="M1284.64,165a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.45,10.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1284.64,165Z"
                fill="#2f6840"
              />
              <path
                d="M1283.27,168.2a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1283.27,168.2Z"
                fill="#2f6840"
              />
              <path
                d="M1281.32,166.24c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1281.32,166.24Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1268.63,163.63c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1268.63,163.63Z"
                fill="#2f6840"
              />
              <path
                d="M1268.13,163.28c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1268.13,163.28Z"
                fill="#3ba525"
              />
              <path
                d="M1268.88,163.25a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1268.88,163.25Z"
                fill="#2f6840"
              />
              <path
                d="M1272.36,162.46c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1272.36,162.46Z"
                fill="#2f6840"
              />
              <path
                d="M1271,165.67a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1271,165.67Z"
                fill="#2f6840"
              />
              <path
                d="M1269,163.71c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1269,163.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1266,172.36c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1266,172.36Z"
                fill="#2f6840"
              />
              <path
                d="M1265.47,172c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1265.47,172Z"
                fill="#3ba525"
              />
              <path
                d="M1266.22,172a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1266.22,172Z"
                fill="#2f6840"
              />
              <path
                d="M1269.7,171.19a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1269.7,171.19Z"
                fill="#2f6840"
              />
              <path
                d="M1268.33,174.4a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1268.33,174.4Z"
                fill="#2f6840"
              />
              <path
                d="M1266.37,172.44c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1266.37,172.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1260.62,167.4c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1260.62,167.4Z"
                fill="#2f6840"
              />
              <path
                d="M1260.11,167.05c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1260.11,167.05Z"
                fill="#3ba525"
              />
              <path
                d="M1260.87,167a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1260.87,167Z"
                fill="#2f6840"
              />
              <path
                d="M1264.34,166.23c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1264.34,166.23Z"
                fill="#2f6840"
              />
              <path
                d="M1263,169.44a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1263,169.44Z"
                fill="#2f6840"
              />
              <path
                d="M1261,167.48c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1261,167.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1252.28,164c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1252.28,164Z"
                fill="#2f6840"
              />
              <path
                d="M1251.77,163.68c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1251.77,163.68Z"
                fill="#3ba525"
              />
              <path
                d="M1252.52,163.65a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1252.52,163.65Z"
                fill="#2f6840"
              />
              <path
                d="M1256,162.86a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1256,162.86Z"
                fill="#2f6840"
              />
              <path
                d="M1254.63,166.07a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1254.63,166.07Z"
                fill="#2f6840"
              />
              <path
                d="M1252.68,164.11c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1252.68,164.11Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1267,179.52c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1267,179.52Z"
                fill="#2f6840"
              />
              <path
                d="M1266.48,179.17c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1266.48,179.17Z"
                fill="#3ba525"
              />
              <path
                d="M1267.23,179.14a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1267.23,179.14Z"
                fill="#2f6840"
              />
              <path
                d="M1270.71,178.35a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1270.71,178.35Z"
                fill="#2f6840"
              />
              <path
                d="M1269.34,181.56a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1269.34,181.56Z"
                fill="#2f6840"
              />
              <path
                d="M1267.38,179.6c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1267.38,179.6Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1253.53,174c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1253.53,174Z"
                fill="#2f6840"
              />
              <path
                d="M1253,173.6c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1253,173.6Z"
                fill="#3ba525"
              />
              <path
                d="M1253.77,173.57a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1253.77,173.57Z"
                fill="#2f6840"
              />
              <path
                d="M1257.25,172.78a5.21,5.21,0,0,0-.72.1,3.08,3.08,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1257.25,172.78Z"
                fill="#2f6840"
              />
              <path
                d="M1255.88,176a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1255.88,176Z"
                fill="#2f6840"
              />
              <path
                d="M1253.92,174c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1253.92,174Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1240.37,166.76c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1240.37,166.76Z"
                fill="#2f6840"
              />
              <path
                d="M1239.87,166.42c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1239.87,166.42Z"
                fill="#3ba525"
              />
              <path
                d="M1240.62,166.39a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1240.62,166.39Z"
                fill="#2f6840"
              />
              <path
                d="M1244.1,165.6c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1244.1,165.6Z"
                fill="#2f6840"
              />
              <path
                d="M1242.73,168.81a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1242.73,168.81Z"
                fill="#2f6840"
              />
              <path
                d="M1240.77,166.85c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1240.77,166.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1237.71,175.49c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1237.71,175.49Z"
                fill="#2f6840"
              />
              <path
                d="M1237.21,175.15c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1237.21,175.15Z"
                fill="#3ba525"
              />
              <path
                d="M1238,175.12a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1238,175.12Z"
                fill="#2f6840"
              />
              <path
                d="M1241.44,174.32c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1241.44,174.32Z"
                fill="#2f6840"
              />
              <path
                d="M1240.07,177.53a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1240.07,177.53Z"
                fill="#2f6840"
              />
              <path
                d="M1238.11,175.58c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1238.11,175.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1232.36,170.53c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.77,14.77,0,0,1,1232.36,170.53Z"
                fill="#2f6840"
              />
              <path
                d="M1231.86,170.19c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1231.86,170.19Z"
                fill="#3ba525"
              />
              <path
                d="M1232.61,170.16a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1232.61,170.16Z"
                fill="#2f6840"
              />
              <path
                d="M1236.09,169.37c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1236.09,169.37Z"
                fill="#2f6840"
              />
              <path
                d="M1234.72,172.58a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1234.72,172.58Z"
                fill="#2f6840"
              />
              <path
                d="M1232.76,170.62c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1232.76,170.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1224,167.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1224,167.16Z"
                fill="#2f6840"
              />
              <path
                d="M1223.51,166.82c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1223.51,166.82Z"
                fill="#3ba525"
              />
              <path
                d="M1224.27,166.79a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1224.27,166.79Z"
                fill="#2f6840"
              />
              <path
                d="M1227.74,166c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1227.74,166Z"
                fill="#2f6840"
              />
              <path
                d="M1226.38,169.2a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1226.38,169.2Z"
                fill="#2f6840"
              />
              <path
                d="M1224.42,167.25c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1224.42,167.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1238.72,182.65c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1238.72,182.65Z"
                fill="#2f6840"
              />
              <path
                d="M1238.22,182.31c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1238.22,182.31Z"
                fill="#3ba525"
              />
              <path
                d="M1239,182.28a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1239,182.28Z"
                fill="#2f6840"
              />
              <path
                d="M1242.45,181.48c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1242.45,181.48Z"
                fill="#2f6840"
              />
              <path
                d="M1241.08,184.69a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1241.08,184.69Z"
                fill="#2f6840"
              />
              <path
                d="M1239.12,182.74c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1239.12,182.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1225.27,177.08c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1225.27,177.08Z"
                fill="#2f6840"
              />
              <path
                d="M1224.76,176.74c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1224.76,176.74Z"
                fill="#3ba525"
              />
              <path
                d="M1225.51,176.71a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1225.51,176.71Z"
                fill="#2f6840"
              />
              <path
                d="M1229,175.91c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,1229,175.91Z"
                fill="#2f6840"
              />
              <path
                d="M1227.62,179.12a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1227.62,179.12Z"
                fill="#2f6840"
              />
              <path
                d="M1225.67,177.17c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1225.67,177.17Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1211.93,165.58c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1211.93,165.58Z"
                fill="#2f6840"
              />
              <path
                d="M1211.42,165.24c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1211.42,165.24Z"
                fill="#3ba525"
              />
              <path
                d="M1212.17,165.21a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1212.17,165.21Z"
                fill="#2f6840"
              />
              <path
                d="M1215.65,164.41c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1215.65,164.41Z"
                fill="#2f6840"
              />
              <path
                d="M1214.28,167.62a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1214.28,167.62Z"
                fill="#2f6840"
              />
              <path
                d="M1212.32,165.67c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1212.32,165.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1209.27,174.31c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1209.27,174.31Z"
                fill="#2f6840"
              />
              <path
                d="M1208.76,174c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1208.76,174Z"
                fill="#3ba525"
              />
              <path
                d="M1209.51,173.94a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1209.51,173.94Z"
                fill="#2f6840"
              />
              <path
                d="M1213,173.14c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1213,173.14Z"
                fill="#2f6840"
              />
              <path
                d="M1211.62,176.35a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1211.62,176.35Z"
                fill="#2f6840"
              />
              <path
                d="M1209.67,174.4c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,1209.67,174.4Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1203.91,169.35c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1203.91,169.35Z"
                fill="#2f6840"
              />
              <path
                d="M1203.41,169c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1203.41,169Z"
                fill="#3ba525"
              />
              <path
                d="M1204.16,169a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1204.16,169Z"
                fill="#2f6840"
              />
              <path
                d="M1207.64,168.19c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1207.64,168.19Z"
                fill="#2f6840"
              />
              <path
                d="M1206.27,171.4a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1206.27,171.4Z"
                fill="#2f6840"
              />
              <path
                d="M1204.31,169.44c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1204.31,169.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1195.57,166c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1195.57,166Z"
                fill="#2f6840"
              />
              <path
                d="M1195.07,165.64c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1195.07,165.64Z"
                fill="#3ba525"
              />
              <path
                d="M1195.82,165.61a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1195.82,165.61Z"
                fill="#2f6840"
              />
              <path
                d="M1199.3,164.81c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1199.3,164.81Z"
                fill="#2f6840"
              />
              <path
                d="M1197.93,168a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1197.93,168Z"
                fill="#2f6840"
              />
              <path
                d="M1196,166.07c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1196,166.07Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1210.28,181.47c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1210.28,181.47Z"
                fill="#2f6840"
              />
              <path
                d="M1209.77,181.13c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1209.77,181.13Z"
                fill="#3ba525"
              />
              <path
                d="M1210.52,181.1a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.35,2.35,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1210.52,181.1Z"
                fill="#2f6840"
              />
              <path
                d="M1214,180.3c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1214,180.3Z"
                fill="#2f6840"
              />
              <path
                d="M1212.63,183.51a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1212.63,183.51Z"
                fill="#2f6840"
              />
              <path
                d="M1210.68,181.56c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,1210.68,181.56Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1196.82,175.9c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1196.82,175.9Z"
                fill="#2f6840"
              />
              <path
                d="M1196.31,175.56c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1196.31,175.56Z"
                fill="#3ba525"
              />
              <path
                d="M1197.07,175.53a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1197.07,175.53Z"
                fill="#2f6840"
              />
              <path
                d="M1200.54,174.73c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1200.54,174.73Z"
                fill="#2f6840"
              />
              <path
                d="M1199.18,177.94a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1199.18,177.94Z"
                fill="#2f6840"
              />
              <path
                d="M1197.22,176c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.8,8.8,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1197.22,176Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1183.68,161.9c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1183.68,161.9Z"
                fill="#2f6840"
              />
              <path
                d="M1183.17,161.55c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1183.17,161.55Z"
                fill="#3ba525"
              />
              <path
                d="M1183.93,161.52a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1183.93,161.52Z"
                fill="#2f6840"
              />
              <path
                d="M1187.4,160.73c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1187.4,160.73Z"
                fill="#2f6840"
              />
              <path
                d="M1186,163.94a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1186,163.94Z"
                fill="#2f6840"
              />
              <path
                d="M1184.08,162c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1184.08,162Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1181,170.63c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1181,170.63Z"
                fill="#2f6840"
              />
              <path
                d="M1180.52,170.28c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1180.52,170.28Z"
                fill="#3ba525"
              />
              <path
                d="M1181.27,170.25a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1181.27,170.25Z"
                fill="#2f6840"
              />
              <path
                d="M1184.75,169.46a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1184.75,169.46Z"
                fill="#2f6840"
              />
              <path
                d="M1183.38,172.67a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1183.38,172.67Z"
                fill="#2f6840"
              />
              <path
                d="M1181.42,170.71c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1181.42,170.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1175.67,165.67c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1175.67,165.67Z"
                fill="#2f6840"
              />
              <path
                d="M1175.16,165.32c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1175.16,165.32Z"
                fill="#3ba525"
              />
              <path
                d="M1175.92,165.3a2.18,2.18,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1175.92,165.3Z"
                fill="#2f6840"
              />
              <path
                d="M1179.39,164.5c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1179.39,164.5Z"
                fill="#2f6840"
              />
              <path
                d="M1178,167.71a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A1,1,0,0,1,1178,167.71Z"
                fill="#2f6840"
              />
              <path
                d="M1176.07,165.76a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1176.07,165.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1167.33,162.3c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1167.33,162.3Z"
                fill="#2f6840"
              />
              <path
                d="M1166.82,162c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1166.82,162Z"
                fill="#3ba525"
              />
              <path
                d="M1167.57,161.92a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1167.57,161.92Z"
                fill="#2f6840"
              />
              <path
                d="M1171.05,161.13c-.26,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1171.05,161.13Z"
                fill="#2f6840"
              />
              <path
                d="M1169.68,164.34a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1169.68,164.34Z"
                fill="#2f6840"
              />
              <path
                d="M1167.72,162.38c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1167.72,162.38Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1182,177.79c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1182,177.79Z"
                fill="#2f6840"
              />
              <path
                d="M1181.52,177.44c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1181.52,177.44Z"
                fill="#3ba525"
              />
              <path
                d="M1182.28,177.41a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1182.28,177.41Z"
                fill="#2f6840"
              />
              <path
                d="M1185.76,176.62a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1185.76,176.62Z"
                fill="#2f6840"
              />
              <path
                d="M1184.39,179.83a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1184.39,179.83Z"
                fill="#2f6840"
              />
              <path
                d="M1182.43,177.87c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1182.43,177.87Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1168.57,172.22c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1168.57,172.22Z"
                fill="#2f6840"
              />
              <path
                d="M1168.07,171.87c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1168.07,171.87Z"
                fill="#3ba525"
              />
              <path
                d="M1168.82,171.84a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1168.82,171.84Z"
                fill="#2f6840"
              />
              <path
                d="M1172.3,171.05c-.26,0-.49,0-.73.1a3,3,0,0,0-.67.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1172.3,171.05Z"
                fill="#2f6840"
              />
              <path
                d="M1170.93,174.26a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1170.93,174.26Z"
                fill="#2f6840"
              />
              <path
                d="M1169,172.3c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1169,172.3Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1155.77,164c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1155.77,164Z"
                fill="#2f6840"
              />
              <path
                d="M1155.26,163.67c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1155.26,163.67Z"
                fill="#3ba525"
              />
              <path
                d="M1156,163.64a2.24,2.24,0,0,0-.8-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1156,163.64Z"
                fill="#2f6840"
              />
              <path
                d="M1159.49,162.84c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1159.49,162.84Z"
                fill="#2f6840"
              />
              <path
                d="M1158.12,166.05a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1158.12,166.05Z"
                fill="#2f6840"
              />
              <path
                d="M1156.17,164.1a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1156.17,164.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1153.11,172.74c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1153.11,172.74Z"
                fill="#2f6840"
              />
              <path
                d="M1152.6,172.39c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1152.6,172.39Z"
                fill="#3ba525"
              />
              <path
                d="M1153.36,172.37a2.12,2.12,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1153.36,172.37Z"
                fill="#2f6840"
              />
              <path
                d="M1156.83,171.57c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1156.83,171.57Z"
                fill="#2f6840"
              />
              <path
                d="M1155.47,174.78a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1155.47,174.78Z"
                fill="#2f6840"
              />
              <path
                d="M1153.51,172.83a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1153.51,172.83Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1147.76,167.78c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1147.76,167.78Z"
                fill="#2f6840"
              />
              <path
                d="M1147.25,167.44c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1147.25,167.44Z"
                fill="#3ba525"
              />
              <path
                d="M1148,167.41a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1148,167.41Z"
                fill="#2f6840"
              />
              <path
                d="M1151.48,166.61c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1151.48,166.61Z"
                fill="#2f6840"
              />
              <path
                d="M1150.11,169.82a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1150.11,169.82Z"
                fill="#2f6840"
              />
              <path
                d="M1148.16,167.87a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2.07,2.07,0,0,1,1148.16,167.87Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1139.41,164.41c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1139.41,164.41Z"
                fill="#2f6840"
              />
              <path
                d="M1138.91,164.07c4.42-.26-4.33.45-4.35-.62s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1138.91,164.07Z"
                fill="#3ba525"
              />
              <path
                d="M1139.66,164a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1139.66,164Z"
                fill="#2f6840"
              />
              <path
                d="M1143.14,163.24c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1143.14,163.24Z"
                fill="#2f6840"
              />
              <path
                d="M1141.77,166.45a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1141.77,166.45Z"
                fill="#2f6840"
              />
              <path
                d="M1139.81,164.5c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1139.81,164.5Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1154.12,179.9c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1154.12,179.9Z"
                fill="#2f6840"
              />
              <path
                d="M1153.61,179.55c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1153.61,179.55Z"
                fill="#3ba525"
              />
              <path
                d="M1154.37,179.53a2.18,2.18,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1154.37,179.53Z"
                fill="#2f6840"
              />
              <path
                d="M1157.84,178.73c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1157.84,178.73Z"
                fill="#2f6840"
              />
              <path
                d="M1156.48,181.94a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A1,1,0,0,1,1156.48,181.94Z"
                fill="#2f6840"
              />
              <path
                d="M1154.52,180a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1154.52,180Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1140.66,174.33c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1140.66,174.33Z"
                fill="#2f6840"
              />
              <path
                d="M1140.16,174c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1140.16,174Z"
                fill="#3ba525"
              />
              <path
                d="M1140.91,174a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.38,2.38,0,0,1,.47.53A1,1,0,0,1,1140.91,174Z"
                fill="#2f6840"
              />
              <path
                d="M1144.39,173.16c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1144.39,173.16Z"
                fill="#2f6840"
              />
              <path
                d="M1143,176.37a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1143,176.37Z"
                fill="#2f6840"
              />
              <path
                d="M1141.06,174.42a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1141.06,174.42Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1128.94,173.6c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1128.94,173.6Z"
                fill="#2f6840"
              />
              <path
                d="M1128.44,173.26c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1128.44,173.26Z"
                fill="#3ba525"
              />
              <path
                d="M1129.19,173.23a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1129.19,173.23Z"
                fill="#2f6840"
              />
              <path
                d="M1132.67,172.43c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1132.67,172.43Z"
                fill="#2f6840"
              />
              <path
                d="M1131.3,175.64a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1131.3,175.64Z"
                fill="#2f6840"
              />
              <path
                d="M1129.34,173.69c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1129.34,173.69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1126.28,182.33c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1126.28,182.33Z"
                fill="#2f6840"
              />
              <path
                d="M1125.78,182c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1125.78,182Z"
                fill="#3ba525"
              />
              <path
                d="M1126.53,182a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1126.53,182Z"
                fill="#2f6840"
              />
              <path
                d="M1130,181.16c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1130,181.16Z"
                fill="#2f6840"
              />
              <path
                d="M1128.64,184.37a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1128.64,184.37Z"
                fill="#2f6840"
              />
              <path
                d="M1126.68,182.42c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1126.68,182.42Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1120.93,177.37c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1120.93,177.37Z"
                fill="#2f6840"
              />
              <path
                d="M1120.43,177c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1120.43,177Z"
                fill="#3ba525"
              />
              <path
                d="M1121.18,177a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1121.18,177Z"
                fill="#2f6840"
              />
              <path
                d="M1124.66,176.2c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1124.66,176.2Z"
                fill="#2f6840"
              />
              <path
                d="M1123.29,179.41a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1123.29,179.41Z"
                fill="#2f6840"
              />
              <path
                d="M1121.33,177.46c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1121.33,177.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1112.59,174c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1112.59,174Z"
                fill="#2f6840"
              />
              <path
                d="M1112.08,173.66c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1112.08,173.66Z"
                fill="#3ba525"
              />
              <path
                d="M1112.84,173.63a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1112.84,173.63Z"
                fill="#2f6840"
              />
              <path
                d="M1116.31,172.83c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1116.31,172.83Z"
                fill="#2f6840"
              />
              <path
                d="M1115,176a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1115,176Z"
                fill="#2f6840"
              />
              <path
                d="M1113,174.09a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1113,174.09Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1127.29,189.49c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1127.29,189.49Z"
                fill="#2f6840"
              />
              <path
                d="M1126.79,189.15c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1126.79,189.15Z"
                fill="#3ba525"
              />
              <path
                d="M1127.54,189.12a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1127.54,189.12Z"
                fill="#2f6840"
              />
              <path
                d="M1131,188.32c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1131,188.32Z"
                fill="#2f6840"
              />
              <path
                d="M1129.65,191.53a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1129.65,191.53Z"
                fill="#2f6840"
              />
              <path
                d="M1127.69,189.58c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1127.69,189.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1113.84,183.92c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1113.84,183.92Z"
                fill="#2f6840"
              />
              <path
                d="M1113.33,183.58c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1113.33,183.58Z"
                fill="#3ba525"
              />
              <path
                d="M1114.08,183.55a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1114.08,183.55Z"
                fill="#2f6840"
              />
              <path
                d="M1117.56,182.75c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1117.56,182.75Z"
                fill="#2f6840"
              />
              <path
                d="M1116.19,186a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1116.19,186Z"
                fill="#2f6840"
              />
              <path
                d="M1114.24,184a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1114.24,184Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1100.57,172.79c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1100.57,172.79Z"
                fill="#2f6840"
              />
              <path
                d="M1100.06,172.45c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1100.06,172.45Z"
                fill="#3ba525"
              />
              <path
                d="M1100.81,172.42a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1100.81,172.42Z"
                fill="#2f6840"
              />
              <path
                d="M1104.29,171.62c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1104.29,171.62Z"
                fill="#2f6840"
              />
              <path
                d="M1102.92,174.83a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1102.92,174.83Z"
                fill="#2f6840"
              />
              <path
                d="M1101,172.88a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2.07,2.07,0,0,1,1101,172.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1097.91,181.52c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1097.91,181.52Z"
                fill="#2f6840"
              />
              <path
                d="M1097.4,181.18c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1097.4,181.18Z"
                fill="#3ba525"
              />
              <path
                d="M1098.15,181.15a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1098.15,181.15Z"
                fill="#2f6840"
              />
              <path
                d="M1101.63,180.35c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1101.63,180.35Z"
                fill="#2f6840"
              />
              <path
                d="M1100.26,183.56a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1100.26,183.56Z"
                fill="#2f6840"
              />
              <path
                d="M1098.31,181.61a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1098.31,181.61Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1092.56,176.56c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1092.56,176.56Z"
                fill="#2f6840"
              />
              <path
                d="M1092.05,176.22c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1092.05,176.22Z"
                fill="#3ba525"
              />
              <path
                d="M1092.8,176.19a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1092.8,176.19Z"
                fill="#2f6840"
              />
              <path
                d="M1096.28,175.39c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1096.28,175.39Z"
                fill="#2f6840"
              />
              <path
                d="M1094.91,178.6a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1094.91,178.6Z"
                fill="#2f6840"
              />
              <path
                d="M1093,176.65c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1093,176.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1084.21,173.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1084.21,173.19Z"
                fill="#2f6840"
              />
              <path
                d="M1083.71,172.85c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1083.71,172.85Z"
                fill="#3ba525"
              />
              <path
                d="M1084.46,172.82a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1084.46,172.82Z"
                fill="#2f6840"
              />
              <path
                d="M1087.94,172c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1087.94,172Z"
                fill="#2f6840"
              />
              <path
                d="M1086.57,175.23a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1086.57,175.23Z"
                fill="#2f6840"
              />
              <path
                d="M1084.61,173.28c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1084.61,173.28Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1098.92,188.68c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1098.92,188.68Z"
                fill="#2f6840"
              />
              <path
                d="M1098.41,188.34c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1098.41,188.34Z"
                fill="#3ba525"
              />
              <path
                d="M1099.16,188.31a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1099.16,188.31Z"
                fill="#2f6840"
              />
              <path
                d="M1102.64,187.51c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1102.64,187.51Z"
                fill="#2f6840"
              />
              <path
                d="M1101.27,190.72a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1101.27,190.72Z"
                fill="#2f6840"
              />
              <path
                d="M1099.32,188.77a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1099.32,188.77Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1085.46,183.11c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72S1086,184,1086,184s-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1085.46,183.11Z"
                fill="#2f6840"
              />
              <path
                d="M1085,182.77c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1085,182.77Z"
                fill="#3ba525"
              />
              <path
                d="M1085.71,182.74a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.07,2.07,0,0,1,.48.54A1,1,0,0,1,1085.71,182.74Z"
                fill="#2f6840"
              />
              <path
                d="M1089.19,181.94c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1089.19,181.94Z"
                fill="#2f6840"
              />
              <path
                d="M1087.82,185.15a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1087.82,185.15Z"
                fill="#2f6840"
              />
              <path
                d="M1085.86,183.2c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1085.86,183.2Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1077,179.37c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1077,179.37Z"
                fill="#2f6840"
              />
              <path
                d="M1076.45,179c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1076.45,179Z"
                fill="#3ba525"
              />
              <path
                d="M1077.2,179a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1077.2,179Z"
                fill="#2f6840"
              />
              <path
                d="M1080.68,178.21c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1080.68,178.21Z"
                fill="#2f6840"
              />
              <path
                d="M1079.31,181.42a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1079.31,181.42Z"
                fill="#2f6840"
              />
              <path
                d="M1077.36,179.46c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1077.36,179.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1074.3,188.1c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1074.3,188.1Z"
                fill="#2f6840"
              />
              <path
                d="M1073.79,187.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1073.79,187.76Z"
                fill="#3ba525"
              />
              <path
                d="M1074.54,187.73a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1074.54,187.73Z"
                fill="#2f6840"
              />
              <path
                d="M1078,186.94c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1078,186.94Z"
                fill="#2f6840"
              />
              <path
                d="M1076.65,190.15a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1076.65,190.15Z"
                fill="#2f6840"
              />
              <path
                d="M1074.7,188.19c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1074.7,188.19Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1068.94,183.15c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1068.94,183.15Z"
                fill="#2f6840"
              />
              <path
                d="M1068.44,182.8c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1068.44,182.8Z"
                fill="#3ba525"
              />
              <path
                d="M1069.19,182.77a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1069.19,182.77Z"
                fill="#2f6840"
              />
              <path
                d="M1072.67,182c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.48,2.48,0,0,1,1.24-.86A2.07,2.07,0,0,1,1072.67,182Z"
                fill="#2f6840"
              />
              <path
                d="M1071.3,185.19a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1071.3,185.19Z"
                fill="#2f6840"
              />
              <path
                d="M1069.34,183.23c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1069.34,183.23Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1060.6,179.77c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1060.6,179.77Z"
                fill="#2f6840"
              />
              <path
                d="M1060.1,179.43c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1060.1,179.43Z"
                fill="#3ba525"
              />
              <path
                d="M1060.85,179.4a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1060.85,179.4Z"
                fill="#2f6840"
              />
              <path
                d="M1064.33,178.61c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1064.33,178.61Z"
                fill="#2f6840"
              />
              <path
                d="M1063,181.82a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1063,181.82Z"
                fill="#2f6840"
              />
              <path
                d="M1061,179.86c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1061,179.86Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1075.31,195.26c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1075.31,195.26Z"
                fill="#2f6840"
              />
              <path
                d="M1074.8,194.92c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1074.8,194.92Z"
                fill="#3ba525"
              />
              <path
                d="M1075.55,194.89a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1075.55,194.89Z"
                fill="#2f6840"
              />
              <path
                d="M1079,194.1c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1079,194.1Z"
                fill="#2f6840"
              />
              <path
                d="M1077.66,197.31a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1077.66,197.31Z"
                fill="#2f6840"
              />
              <path
                d="M1075.71,195.35c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1075.71,195.35Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1061.85,189.69c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1061.85,189.69Z"
                fill="#2f6840"
              />
              <path
                d="M1061.34,189.35c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1061.34,189.35Z"
                fill="#3ba525"
              />
              <path
                d="M1062.1,189.32a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1062.1,189.32Z"
                fill="#2f6840"
              />
              <path
                d="M1065.57,188.53c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1065.57,188.53Z"
                fill="#2f6840"
              />
              <path
                d="M1064.21,191.74a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1064.21,191.74Z"
                fill="#2f6840"
              />
              <path
                d="M1062.25,189.78c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1062.25,189.78Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1084.89,206.19c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1084.89,206.19Z"
                fill="#2f6840"
              />
              <path
                d="M1084.38,205.84c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1084.38,205.84Z"
                fill="#3ba525"
              />
              <path
                d="M1085.14,205.81a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1085.14,205.81Z"
                fill="#2f6840"
              />
              <path
                d="M1088.61,205a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1088.61,205Z"
                fill="#2f6840"
              />
              <path
                d="M1087.25,208.23a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1087.25,208.23Z"
                fill="#2f6840"
              />
              <path
                d="M1085.29,206.27c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1085.29,206.27Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1082.23,214.92c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1082.23,214.92Z"
                fill="#2f6840"
              />
              <path
                d="M1081.72,214.57c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1081.72,214.57Z"
                fill="#3ba525"
              />
              <path
                d="M1082.48,214.54a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1082.48,214.54Z"
                fill="#2f6840"
              />
              <path
                d="M1086,213.75c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.23-.86A2.07,2.07,0,0,1,1086,213.75Z"
                fill="#2f6840"
              />
              <path
                d="M1084.59,217a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1084.59,217Z"
                fill="#2f6840"
              />
              <path
                d="M1082.63,215c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1082.63,215Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1076.88,210c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1076.88,210Z"
                fill="#2f6840"
              />
              <path
                d="M1076.37,209.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1076.37,209.61Z"
                fill="#3ba525"
              />
              <path
                d="M1077.12,209.58a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1077.12,209.58Z"
                fill="#2f6840"
              />
              <path
                d="M1080.6,208.79c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1080.6,208.79Z"
                fill="#2f6840"
              />
              <path
                d="M1079.23,212a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1079.23,212Z"
                fill="#2f6840"
              />
              <path
                d="M1077.28,210c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1077.28,210Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1068.53,206.59c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1068.53,206.59Z"
                fill="#2f6840"
              />
              <path
                d="M1068,206.24c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1068,206.24Z"
                fill="#3ba525"
              />
              <path
                d="M1068.78,206.21a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1068.78,206.21Z"
                fill="#2f6840"
              />
              <path
                d="M1072.26,205.42a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1072.26,205.42Z"
                fill="#2f6840"
              />
              <path
                d="M1070.89,208.63a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1070.89,208.63Z"
                fill="#2f6840"
              />
              <path
                d="M1068.93,206.67c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1068.93,206.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1083.24,222.08c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1083.24,222.08Z"
                fill="#2f6840"
              />
              <path
                d="M1082.73,221.73c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1082.73,221.73Z"
                fill="#3ba525"
              />
              <path
                d="M1083.49,221.7a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1083.49,221.7Z"
                fill="#2f6840"
              />
              <path
                d="M1087,220.91c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.23-.86A2.07,2.07,0,0,1,1087,220.91Z"
                fill="#2f6840"
              />
              <path
                d="M1085.6,224.12a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1085.6,224.12Z"
                fill="#2f6840"
              />
              <path
                d="M1083.64,222.16c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1083.64,222.16Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1069.78,216.51c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1069.78,216.51Z"
                fill="#2f6840"
              />
              <path
                d="M1069.28,216.16c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1069.28,216.16Z"
                fill="#3ba525"
              />
              <path
                d="M1070,216.13a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1070,216.13Z"
                fill="#2f6840"
              />
              <path
                d="M1073.51,215.34a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1073.51,215.34Z"
                fill="#2f6840"
              />
              <path
                d="M1072.14,218.55a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1072.14,218.55Z"
                fill="#2f6840"
              />
              <path
                d="M1070.18,216.59c-.24.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1070.18,216.59Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M1172.37,399.51c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1172.37,399.51Z"
                fill="#2f6840"
              />
              <path
                d="M1171.87,399.17c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1171.87,399.17Z"
                fill="#3ba525"
              />
              <path
                d="M1172.62,399.14a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,1172.62,399.14Z"
                fill="#2f6840"
              />
              <path
                d="M1176.1,398.34c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1176.1,398.34Z"
                fill="#2f6840"
              />
              <path
                d="M1174.73,401.55a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1174.73,401.55Z"
                fill="#2f6840"
              />
              <path
                d="M1172.77,399.6c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1172.77,399.6Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1169.71,408.24c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.46,14.46,0,0,1,1169.71,408.24Z"
                fill="#2f6840"
              />
              <path
                d="M1169.21,407.9c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1169.21,407.9Z"
                fill="#3ba525"
              />
              <path
                d="M1170,407.87a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1170,407.87Z"
                fill="#2f6840"
              />
              <path
                d="M1173.44,407.07c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1173.44,407.07Z"
                fill="#2f6840"
              />
              <path
                d="M1172.07,410.28a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1172.07,410.28Z"
                fill="#2f6840"
              />
              <path
                d="M1170.11,408.33a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1170.11,408.33Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1164.36,403.28c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1164.36,403.28Z"
                fill="#2f6840"
              />
              <path
                d="M1163.85,402.94c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1163.85,402.94Z"
                fill="#3ba525"
              />
              <path
                d="M1164.61,402.91a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1164.61,402.91Z"
                fill="#2f6840"
              />
              <path
                d="M1168.08,402.11c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1168.08,402.11Z"
                fill="#2f6840"
              />
              <path
                d="M1166.72,405.32a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1166.72,405.32Z"
                fill="#2f6840"
              />
              <path
                d="M1164.76,403.37c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1164.76,403.37Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1156,399.91c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1156,399.91Z"
                fill="#2f6840"
              />
              <path
                d="M1155.51,399.57c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1155.51,399.57Z"
                fill="#3ba525"
              />
              <path
                d="M1156.26,399.54a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1156.26,399.54Z"
                fill="#2f6840"
              />
              <path
                d="M1159.74,398.74c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1159.74,398.74Z"
                fill="#2f6840"
              />
              <path
                d="M1158.37,402a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1158.37,402Z"
                fill="#2f6840"
              />
              <path
                d="M1156.42,400a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1156.42,400Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1170.72,415.4c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1170.72,415.4Z"
                fill="#2f6840"
              />
              <path
                d="M1170.22,415.06c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1170.22,415.06Z"
                fill="#3ba525"
              />
              <path
                d="M1171,415a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.23,2.23,0,0,1,.47.54A1,1,0,0,1,1171,415Z"
                fill="#2f6840"
              />
              <path
                d="M1174.45,414.23c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1174.45,414.23Z"
                fill="#2f6840"
              />
              <path
                d="M1173.08,417.44a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1173.08,417.44Z"
                fill="#2f6840"
              />
              <path
                d="M1171.12,415.49c-.25.06-.48.08-.7.15a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1171.12,415.49Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1157.27,409.83c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1157.27,409.83Z"
                fill="#2f6840"
              />
              <path
                d="M1156.76,409.49c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1156.76,409.49Z"
                fill="#3ba525"
              />
              <path
                d="M1157.51,409.46a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1157.51,409.46Z"
                fill="#2f6840"
              />
              <path
                d="M1161,408.66c-.26,0-.49,0-.72.1a4.51,4.51,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1161,408.66Z"
                fill="#2f6840"
              />
              <path
                d="M1159.62,411.87a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1159.62,411.87Z"
                fill="#2f6840"
              />
              <path
                d="M1157.66,409.92a7,7,0,0,0-.69.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1157.66,409.92Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1198.37,388.06c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1198.37,388.06Z"
                fill="#2f6840"
              />
              <path
                d="M1197.86,387.72c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1197.86,387.72Z"
                fill="#3ba525"
              />
              <path
                d="M1198.61,387.69a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1198.61,387.69Z"
                fill="#2f6840"
              />
              <path
                d="M1202.09,386.9c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1202.09,386.9Z"
                fill="#2f6840"
              />
              <path
                d="M1200.72,390.11a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1200.72,390.11Z"
                fill="#2f6840"
              />
              <path
                d="M1198.76,388.15c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1198.76,388.15Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1195.71,396.79c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1195.71,396.79Z"
                fill="#2f6840"
              />
              <path
                d="M1195.2,396.45c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1195.2,396.45Z"
                fill="#3ba525"
              />
              <path
                d="M1196,396.42a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1196,396.42Z"
                fill="#2f6840"
              />
              <path
                d="M1199.43,395.62c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1199.43,395.62Z"
                fill="#2f6840"
              />
              <path
                d="M1198.06,398.83a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1198.06,398.83Z"
                fill="#2f6840"
              />
              <path
                d="M1196.11,396.88c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1196.11,396.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1190.35,391.83c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1190.35,391.83Z"
                fill="#2f6840"
              />
              <path
                d="M1189.85,391.49c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1189.85,391.49Z"
                fill="#3ba525"
              />
              <path
                d="M1190.6,391.46a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1190.6,391.46Z"
                fill="#2f6840"
              />
              <path
                d="M1194.08,390.67c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1194.08,390.67Z"
                fill="#2f6840"
              />
              <path
                d="M1192.71,393.88a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1192.71,393.88Z"
                fill="#2f6840"
              />
              <path
                d="M1190.75,391.92c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1190.75,391.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1182,388.46c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1182,388.46Z"
                fill="#2f6840"
              />
              <path
                d="M1181.51,388.12c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72S1182,389,1182,389s-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1181.51,388.12Z"
                fill="#3ba525"
              />
              <path
                d="M1182.26,388.09a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1182.26,388.09Z"
                fill="#2f6840"
              />
              <path
                d="M1185.74,387.29c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1185.74,387.29Z"
                fill="#2f6840"
              />
              <path
                d="M1184.37,390.5a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1184.37,390.5Z"
                fill="#2f6840"
              />
              <path
                d="M1182.41,388.55c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1182.41,388.55Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1196.72,404c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1196.72,404Z"
                fill="#2f6840"
              />
              <path
                d="M1196.21,403.61c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1196.21,403.61Z"
                fill="#3ba525"
              />
              <path
                d="M1197,403.58a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1197,403.58Z"
                fill="#2f6840"
              />
              <path
                d="M1200.44,402.78c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1200.44,402.78Z"
                fill="#2f6840"
              />
              <path
                d="M1199.07,406a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1199.07,406Z"
                fill="#2f6840"
              />
              <path
                d="M1197.12,404c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1197.12,404Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1183.26,398.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1183.26,398.38Z"
                fill="#2f6840"
              />
              <path
                d="M1182.75,398c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1182.75,398Z"
                fill="#3ba525"
              />
              <path
                d="M1183.51,398a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1183.51,398Z"
                fill="#2f6840"
              />
              <path
                d="M1187,397.21c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1187,397.21Z"
                fill="#2f6840"
              />
              <path
                d="M1185.62,400.42a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1185.62,400.42Z"
                fill="#2f6840"
              />
              <path
                d="M1183.66,398.47c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1183.66,398.47Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1224.48,376.65c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1224.48,376.65Z"
                fill="#2f6840"
              />
              <path
                d="M1224,376.31c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1224,376.31Z"
                fill="#3ba525"
              />
              <path
                d="M1224.72,376.28a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1224.72,376.28Z"
                fill="#2f6840"
              />
              <path
                d="M1228.2,375.49c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1228.2,375.49Z"
                fill="#2f6840"
              />
              <path
                d="M1226.83,378.7a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1226.83,378.7Z"
                fill="#2f6840"
              />
              <path
                d="M1224.88,376.74c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1224.88,376.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1221.82,385.38c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1221.82,385.38Z"
                fill="#2f6840"
              />
              <path
                d="M1221.31,385c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1221.31,385Z"
                fill="#3ba525"
              />
              <path
                d="M1222.06,385a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.23,2.23,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1222.06,385Z"
                fill="#2f6840"
              />
              <path
                d="M1225.54,384.21c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1225.54,384.21Z"
                fill="#2f6840"
              />
              <path
                d="M1224.17,387.42a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1224.17,387.42Z"
                fill="#2f6840"
              />
              <path
                d="M1222.22,385.47c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1222.22,385.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1216.46,380.42c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.86,14.86,0,0,1,1216.46,380.42Z"
                fill="#2f6840"
              />
              <path
                d="M1216,380.08c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1216,380.08Z"
                fill="#3ba525"
              />
              <path
                d="M1216.71,380.05a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1216.71,380.05Z"
                fill="#2f6840"
              />
              <path
                d="M1220.19,379.26c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1220.19,379.26Z"
                fill="#2f6840"
              />
              <path
                d="M1218.82,382.47a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1218.82,382.47Z"
                fill="#2f6840"
              />
              <path
                d="M1216.86,380.51c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1216.86,380.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1208.12,377.05c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.08-2.37A14.65,14.65,0,0,1,1208.12,377.05Z"
                fill="#2f6840"
              />
              <path
                d="M1207.62,376.71c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1207.62,376.71Z"
                fill="#3ba525"
              />
              <path
                d="M1208.37,376.68a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1208.37,376.68Z"
                fill="#2f6840"
              />
              <path
                d="M1211.85,375.88c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1211.85,375.88Z"
                fill="#2f6840"
              />
              <path
                d="M1210.48,379.09a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1210.48,379.09Z"
                fill="#2f6840"
              />
              <path
                d="M1208.52,377.14c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1208.52,377.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1222.83,392.54c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1222.83,392.54Z"
                fill="#2f6840"
              />
              <path
                d="M1222.32,392.2c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1222.32,392.2Z"
                fill="#3ba525"
              />
              <path
                d="M1223.07,392.17a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1223.07,392.17Z"
                fill="#2f6840"
              />
              <path
                d="M1226.55,391.37c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1226.55,391.37Z"
                fill="#2f6840"
              />
              <path
                d="M1225.18,394.58a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1225.18,394.58Z"
                fill="#2f6840"
              />
              <path
                d="M1223.23,392.63c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1223.23,392.63Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1209.37,387c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1209.37,387Z"
                fill="#2f6840"
              />
              <path
                d="M1208.86,386.63c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1208.86,386.63Z"
                fill="#3ba525"
              />
              <path
                d="M1209.62,386.6a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1209.62,386.6Z"
                fill="#2f6840"
              />
              <path
                d="M1213.09,385.8c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1213.09,385.8Z"
                fill="#2f6840"
              />
              <path
                d="M1211.73,389a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1211.73,389Z"
                fill="#2f6840"
              />
              <path
                d="M1209.77,387.06c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1209.77,387.06Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1246.87,360.31c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1246.87,360.31Z"
                fill="#2f6840"
              />
              <path
                d="M1246.36,360c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1246.36,360Z"
                fill="#3ba525"
              />
              <path
                d="M1247.11,359.94a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1247.11,359.94Z"
                fill="#2f6840"
              />
              <path
                d="M1250.59,359.14c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1250.59,359.14Z"
                fill="#2f6840"
              />
              <path
                d="M1249.22,362.35a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1249.22,362.35Z"
                fill="#2f6840"
              />
              <path
                d="M1247.27,360.4c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1247.27,360.4Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1244.21,369c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1244.21,369Z"
                fill="#2f6840"
              />
              <path
                d="M1243.7,368.7c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1243.7,368.7Z"
                fill="#3ba525"
              />
              <path
                d="M1244.45,368.67a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1244.45,368.67Z"
                fill="#2f6840"
              />
              <path
                d="M1247.93,367.87c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1247.93,367.87Z"
                fill="#2f6840"
              />
              <path
                d="M1246.56,371.08a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1246.56,371.08Z"
                fill="#2f6840"
              />
              <path
                d="M1244.61,369.13c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1244.61,369.13Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1238.85,364.08c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1238.85,364.08Z"
                fill="#2f6840"
              />
              <path
                d="M1238.35,363.74c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1238.35,363.74Z"
                fill="#3ba525"
              />
              <path
                d="M1239.1,363.71a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1239.1,363.71Z"
                fill="#2f6840"
              />
              <path
                d="M1242.58,362.92c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1242.58,362.92Z"
                fill="#2f6840"
              />
              <path
                d="M1241.21,366.13a1.88,1.88,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1241.21,366.13Z"
                fill="#2f6840"
              />
              <path
                d="M1239.25,364.17c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1239.25,364.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1230.51,360.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1230.51,360.71Z"
                fill="#2f6840"
              />
              <path
                d="M1230,360.37c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1230,360.37Z"
                fill="#3ba525"
              />
              <path
                d="M1230.76,360.34a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1230.76,360.34Z"
                fill="#2f6840"
              />
              <path
                d="M1234.24,359.54c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1234.24,359.54Z"
                fill="#2f6840"
              />
              <path
                d="M1232.87,362.75a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1232.87,362.75Z"
                fill="#2f6840"
              />
              <path
                d="M1230.91,360.8c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1230.91,360.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1245.22,376.2c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1245.22,376.2Z"
                fill="#2f6840"
              />
              <path
                d="M1244.71,375.86c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1244.71,375.86Z"
                fill="#3ba525"
              />
              <path
                d="M1245.46,375.83a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1245.46,375.83Z"
                fill="#2f6840"
              />
              <path
                d="M1248.94,375c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1248.94,375Z"
                fill="#2f6840"
              />
              <path
                d="M1247.57,378.24a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1247.57,378.24Z"
                fill="#2f6840"
              />
              <path
                d="M1245.62,376.29c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,1245.62,376.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1231.76,370.63c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1231.76,370.63Z"
                fill="#2f6840"
              />
              <path
                d="M1231.25,370.29c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1231.25,370.29Z"
                fill="#3ba525"
              />
              <path
                d="M1232,370.26a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1232,370.26Z"
                fill="#2f6840"
              />
              <path
                d="M1235.48,369.46c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1235.48,369.46Z"
                fill="#2f6840"
              />
              <path
                d="M1234.12,372.67a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1234.12,372.67Z"
                fill="#2f6840"
              />
              <path
                d="M1232.16,370.72c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1232.16,370.72Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1246.48,332.17c4.42-.26-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71S1247,333,1247,333s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1246.48,332.17Z"
                fill="#2f6840"
              />
              <path
                d="M1246,331.82c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1246,331.82Z"
                fill="#3ba525"
              />
              <path
                d="M1246.72,331.79a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1246.72,331.79Z"
                fill="#2f6840"
              />
              <path
                d="M1250.2,331c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.48,2.48,0,0,1,1.24-.86A2.07,2.07,0,0,1,1250.2,331Z"
                fill="#2f6840"
              />
              <path
                d="M1248.83,334.21a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1248.83,334.21Z"
                fill="#2f6840"
              />
              <path
                d="M1246.88,332.25c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2.07,2.07,0,0,1,1246.88,332.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1243.82,340.89c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1243.82,340.89Z"
                fill="#2f6840"
              />
              <path
                d="M1243.31,340.55c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1243.31,340.55Z"
                fill="#3ba525"
              />
              <path
                d="M1244.06,340.52a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1244.06,340.52Z"
                fill="#2f6840"
              />
              <path
                d="M1247.54,339.73c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1247.54,339.73Z"
                fill="#2f6840"
              />
              <path
                d="M1246.17,342.94a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1246.17,342.94Z"
                fill="#2f6840"
              />
              <path
                d="M1244.22,341c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1244.22,341Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1238.46,335.94c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1238.46,335.94Z"
                fill="#2f6840"
              />
              <path
                d="M1238,335.59c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1238,335.59Z"
                fill="#3ba525"
              />
              <path
                d="M1238.71,335.56a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1238.71,335.56Z"
                fill="#2f6840"
              />
              <path
                d="M1242.19,334.77a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1242.19,334.77Z"
                fill="#2f6840"
              />
              <path
                d="M1240.82,338a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1240.82,338Z"
                fill="#2f6840"
              />
              <path
                d="M1238.86,336c-.24.06-.47.09-.69.16a3.58,3.58,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1238.86,336Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1230.12,332.56c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1230.12,332.56Z"
                fill="#2f6840"
              />
              <path
                d="M1229.62,332.22c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1229.62,332.22Z"
                fill="#3ba525"
              />
              <path
                d="M1230.37,332.19a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1230.37,332.19Z"
                fill="#2f6840"
              />
              <path
                d="M1233.85,331.4c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1233.85,331.4Z"
                fill="#2f6840"
              />
              <path
                d="M1232.48,334.61a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1232.48,334.61Z"
                fill="#2f6840"
              />
              <path
                d="M1230.52,332.65c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1230.52,332.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1244.83,348.05c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1244.83,348.05Z"
                fill="#2f6840"
              />
              <path
                d="M1244.32,347.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1244.32,347.71Z"
                fill="#3ba525"
              />
              <path
                d="M1245.07,347.68a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1245.07,347.68Z"
                fill="#2f6840"
              />
              <path
                d="M1248.55,346.89c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1248.55,346.89Z"
                fill="#2f6840"
              />
              <path
                d="M1247.18,350.1a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1247.18,350.1Z"
                fill="#2f6840"
              />
              <path
                d="M1245.23,348.14c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1245.23,348.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1231.37,342.48c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1231.37,342.48Z"
                fill="#2f6840"
              />
              <path
                d="M1230.86,342.14c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1230.86,342.14Z"
                fill="#3ba525"
              />
              <path
                d="M1231.62,342.11a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1231.62,342.11Z"
                fill="#2f6840"
              />
              <path
                d="M1235.09,341.32c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1235.09,341.32Z"
                fill="#2f6840"
              />
              <path
                d="M1233.73,344.53a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1233.73,344.53Z"
                fill="#2f6840"
              />
              <path
                d="M1231.77,342.57c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1231.77,342.57Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1239.85,304.75c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1239.85,304.75Z"
                fill="#2f6840"
              />
              <path
                d="M1239.34,304.4c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1239.34,304.4Z"
                fill="#3ba525"
              />
              <path
                d="M1240.1,304.38a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1240.1,304.38Z"
                fill="#2f6840"
              />
              <path
                d="M1243.57,303.58c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1243.57,303.58Z"
                fill="#2f6840"
              />
              <path
                d="M1242.21,306.79a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1242.21,306.79Z"
                fill="#2f6840"
              />
              <path
                d="M1240.25,304.83c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1240.25,304.83Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1237.19,313.48c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1237.19,313.48Z"
                fill="#2f6840"
              />
              <path
                d="M1236.68,313.13c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1236.68,313.13Z"
                fill="#3ba525"
              />
              <path
                d="M1237.44,313.1a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1237.44,313.1Z"
                fill="#2f6840"
              />
              <path
                d="M1240.91,312.31a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1240.91,312.31Z"
                fill="#2f6840"
              />
              <path
                d="M1239.55,315.52a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1239.55,315.52Z"
                fill="#2f6840"
              />
              <path
                d="M1237.59,313.56c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1237.59,313.56Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1231.84,308.52c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1231.84,308.52Z"
                fill="#2f6840"
              />
              <path
                d="M1231.33,308.17c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1231.33,308.17Z"
                fill="#3ba525"
              />
              <path
                d="M1232.08,308.15a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1232.08,308.15Z"
                fill="#2f6840"
              />
              <path
                d="M1235.56,307.35c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1235.56,307.35Z"
                fill="#2f6840"
              />
              <path
                d="M1234.19,310.56a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1234.19,310.56Z"
                fill="#2f6840"
              />
              <path
                d="M1232.24,308.61a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1232.24,308.61Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1223.5,305.15c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71S1224,306,1224,306s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1223.5,305.15Z"
                fill="#2f6840"
              />
              <path
                d="M1223,304.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1223,304.8Z"
                fill="#3ba525"
              />
              <path
                d="M1223.74,304.77a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1223.74,304.77Z"
                fill="#2f6840"
              />
              <path
                d="M1227.22,304c-.26,0-.49,0-.72.1a3,3,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1227.22,304Z"
                fill="#2f6840"
              />
              <path
                d="M1225.85,307.19a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1225.85,307.19Z"
                fill="#2f6840"
              />
              <path
                d="M1223.89,305.23c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1223.89,305.23Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1238.2,320.64c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1238.2,320.64Z"
                fill="#2f6840"
              />
              <path
                d="M1237.69,320.29c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1237.69,320.29Z"
                fill="#3ba525"
              />
              <path
                d="M1238.45,320.26a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1238.45,320.26Z"
                fill="#2f6840"
              />
              <path
                d="M1241.92,319.47a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1241.92,319.47Z"
                fill="#2f6840"
              />
              <path
                d="M1240.56,322.68a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1240.56,322.68Z"
                fill="#2f6840"
              />
              <path
                d="M1238.6,320.72c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1238.6,320.72Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1224.74,315.07c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1224.74,315.07Z"
                fill="#2f6840"
              />
              <path
                d="M1224.24,314.72c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1224.24,314.72Z"
                fill="#3ba525"
              />
              <path
                d="M1225,314.69a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1225,314.69Z"
                fill="#2f6840"
              />
              <path
                d="M1228.47,313.9c-.26,0-.49,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1228.47,313.9Z"
                fill="#2f6840"
              />
              <path
                d="M1227.1,317.11a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1227.1,317.11Z"
                fill="#2f6840"
              />
              <path
                d="M1225.14,315.15c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1225.14,315.15Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1212.75,299.61c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1212.75,299.61Z"
                fill="#2f6840"
              />
              <path
                d="M1212.24,299.27c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1212.24,299.27Z"
                fill="#3ba525"
              />
              <path
                d="M1213,299.24a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1213,299.24Z"
                fill="#2f6840"
              />
              <path
                d="M1216.47,298.45c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1216.47,298.45Z"
                fill="#2f6840"
              />
              <path
                d="M1215.1,301.66a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1215.1,301.66Z"
                fill="#2f6840"
              />
              <path
                d="M1213.15,299.7c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1213.15,299.7Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1210.09,308.34c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1210.09,308.34Z"
                fill="#2f6840"
              />
              <path
                d="M1209.58,308c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1209.58,308Z"
                fill="#3ba525"
              />
              <path
                d="M1210.34,308a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1210.34,308Z"
                fill="#2f6840"
              />
              <path
                d="M1213.81,307.17c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1213.81,307.17Z"
                fill="#2f6840"
              />
              <path
                d="M1212.45,310.38a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1212.45,310.38Z"
                fill="#2f6840"
              />
              <path
                d="M1210.49,308.43c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.31,8.31,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1210.49,308.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1204.74,303.38c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1204.74,303.38Z"
                fill="#2f6840"
              />
              <path
                d="M1204.23,303c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1204.23,303Z"
                fill="#3ba525"
              />
              <path
                d="M1205,303a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1205,303Z"
                fill="#2f6840"
              />
              <path
                d="M1208.46,302.22c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1208.46,302.22Z"
                fill="#2f6840"
              />
              <path
                d="M1207.09,305.43a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1207.09,305.43Z"
                fill="#2f6840"
              />
              <path
                d="M1205.14,303.47c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1205.14,303.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1196.39,300c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1196.39,300Z"
                fill="#2f6840"
              />
              <path
                d="M1195.89,299.67c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1195.89,299.67Z"
                fill="#3ba525"
              />
              <path
                d="M1196.64,299.64a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1196.64,299.64Z"
                fill="#2f6840"
              />
              <path
                d="M1200.12,298.84c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1200.12,298.84Z"
                fill="#2f6840"
              />
              <path
                d="M1198.75,302.05a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1198.75,302.05Z"
                fill="#2f6840"
              />
              <path
                d="M1196.79,300.1c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1196.79,300.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1211.1,315.5c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1211.1,315.5Z"
                fill="#2f6840"
              />
              <path
                d="M1210.59,315.16c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1210.59,315.16Z"
                fill="#3ba525"
              />
              <path
                d="M1211.35,315.13a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1211.35,315.13Z"
                fill="#2f6840"
              />
              <path
                d="M1214.82,314.33c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1214.82,314.33Z"
                fill="#2f6840"
              />
              <path
                d="M1213.46,317.54a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1213.46,317.54Z"
                fill="#2f6840"
              />
              <path
                d="M1211.5,315.59c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1211.5,315.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1197.64,309.93c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1197.64,309.93Z"
                fill="#2f6840"
              />
              <path
                d="M1197.14,309.59c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1197.14,309.59Z"
                fill="#3ba525"
              />
              <path
                d="M1197.89,309.56a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1197.89,309.56Z"
                fill="#2f6840"
              />
              <path
                d="M1201.37,308.76c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1201.37,308.76Z"
                fill="#2f6840"
              />
              <path
                d="M1200,312a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1200,312Z"
                fill="#2f6840"
              />
              <path
                d="M1198,310c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1198,310Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1184.27,298.66c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1184.27,298.66Z"
                fill="#2f6840"
              />
              <path
                d="M1183.76,298.32c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1183.76,298.32Z"
                fill="#3ba525"
              />
              <path
                d="M1184.52,298.29a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1184.52,298.29Z"
                fill="#2f6840"
              />
              <path
                d="M1188,297.49c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1188,297.49Z"
                fill="#2f6840"
              />
              <path
                d="M1186.63,300.7a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1186.63,300.7Z"
                fill="#2f6840"
              />
              <path
                d="M1184.67,298.75c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.8,8.8,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1184.67,298.75Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1181.61,307.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1181.61,307.39Z"
                fill="#2f6840"
              />
              <path
                d="M1181.1,307.05c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1181.1,307.05Z"
                fill="#3ba525"
              />
              <path
                d="M1181.86,307a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1181.86,307Z"
                fill="#2f6840"
              />
              <path
                d="M1185.33,306.22c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1185.33,306.22Z"
                fill="#2f6840"
              />
              <path
                d="M1184,309.43a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1184,309.43Z"
                fill="#2f6840"
              />
              <path
                d="M1182,307.48c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1182,307.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1176.26,302.43c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1176.26,302.43Z"
                fill="#2f6840"
              />
              <path
                d="M1175.75,302.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1175.75,302.09Z"
                fill="#3ba525"
              />
              <path
                d="M1176.5,302.06a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1176.5,302.06Z"
                fill="#2f6840"
              />
              <path
                d="M1180,301.26c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,1180,301.26Z"
                fill="#2f6840"
              />
              <path
                d="M1178.61,304.47a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1178.61,304.47Z"
                fill="#2f6840"
              />
              <path
                d="M1176.66,302.52c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1176.66,302.52Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1167.92,299.06c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1167.92,299.06Z"
                fill="#2f6840"
              />
              <path
                d="M1167.41,298.72c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1167.41,298.72Z"
                fill="#3ba525"
              />
              <path
                d="M1168.16,298.69a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1168.16,298.69Z"
                fill="#2f6840"
              />
              <path
                d="M1171.64,297.89c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1171.64,297.89Z"
                fill="#2f6840"
              />
              <path
                d="M1170.27,301.1a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1170.27,301.1Z"
                fill="#2f6840"
              />
              <path
                d="M1168.31,299.15c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1168.31,299.15Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1182.62,314.55c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1182.62,314.55Z"
                fill="#2f6840"
              />
              <path
                d="M1182.11,314.21c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1182.11,314.21Z"
                fill="#3ba525"
              />
              <path
                d="M1182.87,314.18a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1182.87,314.18Z"
                fill="#2f6840"
              />
              <path
                d="M1186.34,313.38c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1186.34,313.38Z"
                fill="#2f6840"
              />
              <path
                d="M1185,316.59a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1185,316.59Z"
                fill="#2f6840"
              />
              <path
                d="M1183,314.64c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1183,314.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1169.16,309c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1169.16,309Z"
                fill="#2f6840"
              />
              <path
                d="M1168.66,308.64c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1168.66,308.64Z"
                fill="#3ba525"
              />
              <path
                d="M1169.41,308.61a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1169.41,308.61Z"
                fill="#2f6840"
              />
              <path
                d="M1172.89,307.81c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1172.89,307.81Z"
                fill="#2f6840"
              />
              <path
                d="M1171.52,311a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1171.52,311Z"
                fill="#2f6840"
              />
              <path
                d="M1169.56,309.07c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1169.56,309.07Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1161.92,286c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1161.92,286Z"
                fill="#2f6840"
              />
              <path
                d="M1161.41,285.69c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1161.41,285.69Z"
                fill="#3ba525"
              />
              <path
                d="M1162.16,285.66a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1162.16,285.66Z"
                fill="#2f6840"
              />
              <path
                d="M1165.64,284.87c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1165.64,284.87Z"
                fill="#2f6840"
              />
              <path
                d="M1164.27,288.08a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1164.27,288.08Z"
                fill="#2f6840"
              />
              <path
                d="M1162.32,286.12c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1162.32,286.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1159.26,294.77c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1159.26,294.77Z"
                fill="#2f6840"
              />
              <path
                d="M1158.75,294.42c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1158.75,294.42Z"
                fill="#3ba525"
              />
              <path
                d="M1159.5,294.39a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1159.5,294.39Z"
                fill="#2f6840"
              />
              <path
                d="M1163,293.6a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1163,293.6Z"
                fill="#2f6840"
              />
              <path
                d="M1161.61,296.81a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1161.61,296.81Z"
                fill="#2f6840"
              />
              <path
                d="M1159.66,294.85c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1159.66,294.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1153.91,289.81c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1153.91,289.81Z"
                fill="#2f6840"
              />
              <path
                d="M1153.4,289.46c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1153.4,289.46Z"
                fill="#3ba525"
              />
              <path
                d="M1154.15,289.44a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1154.15,289.44Z"
                fill="#2f6840"
              />
              <path
                d="M1157.63,288.64c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1157.63,288.64Z"
                fill="#2f6840"
              />
              <path
                d="M1156.26,291.85a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.22.55,1.9,1.9,0,0,1,.4.56A1,1,0,0,1,1156.26,291.85Z"
                fill="#2f6840"
              />
              <path
                d="M1154.3,289.89c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1154.3,289.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1145.56,286.44c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1145.56,286.44Z"
                fill="#2f6840"
              />
              <path
                d="M1145.06,286.09c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1145.06,286.09Z"
                fill="#3ba525"
              />
              <path
                d="M1145.81,286.06a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1145.81,286.06Z"
                fill="#2f6840"
              />
              <path
                d="M1149.29,285.27a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1149.29,285.27Z"
                fill="#2f6840"
              />
              <path
                d="M1147.92,288.48a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1147.92,288.48Z"
                fill="#2f6840"
              />
              <path
                d="M1146,286.52c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1146,286.52Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1160.27,301.93c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1160.27,301.93Z"
                fill="#2f6840"
              />
              <path
                d="M1159.76,301.58c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1159.76,301.58Z"
                fill="#3ba525"
              />
              <path
                d="M1160.51,301.55a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1160.51,301.55Z"
                fill="#2f6840"
              />
              <path
                d="M1164,300.76a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1164,300.76Z"
                fill="#2f6840"
              />
              <path
                d="M1162.62,304a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1162.62,304Z"
                fill="#2f6840"
              />
              <path
                d="M1160.67,302c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1160.67,302Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1146.81,296.36c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1146.81,296.36Z"
                fill="#2f6840"
              />
              <path
                d="M1146.3,296c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1146.3,296Z"
                fill="#3ba525"
              />
              <path
                d="M1147.06,296a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1147.06,296Z"
                fill="#2f6840"
              />
              <path
                d="M1150.54,295.19a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1150.54,295.19Z"
                fill="#2f6840"
              />
              <path
                d="M1149.17,298.4a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1149.17,298.4Z"
                fill="#2f6840"
              />
              <path
                d="M1147.21,296.44c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1147.21,296.44Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1174.05,270.87c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1174.05,270.87Z"
                fill="#2f6840"
              />
              <path
                d="M1173.54,270.53c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1173.54,270.53Z"
                fill="#3ba525"
              />
              <path
                d="M1174.29,270.5a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1174.29,270.5Z"
                fill="#2f6840"
              />
              <path
                d="M1177.77,269.7c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1177.77,269.7Z"
                fill="#2f6840"
              />
              <path
                d="M1176.4,272.91a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1176.4,272.91Z"
                fill="#2f6840"
              />
              <path
                d="M1174.45,271c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1174.45,271Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1171.39,279.6c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1171.39,279.6Z"
                fill="#2f6840"
              />
              <path
                d="M1170.88,279.26c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1170.88,279.26Z"
                fill="#3ba525"
              />
              <path
                d="M1171.63,279.23a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1171.63,279.23Z"
                fill="#2f6840"
              />
              <path
                d="M1175.11,278.43c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1175.11,278.43Z"
                fill="#2f6840"
              />
              <path
                d="M1173.74,281.64a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1173.74,281.64Z"
                fill="#2f6840"
              />
              <path
                d="M1171.79,279.69a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1171.79,279.69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1166,274.64c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1166,274.64Z"
                fill="#2f6840"
              />
              <path
                d="M1165.53,274.3c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1165.53,274.3Z"
                fill="#3ba525"
              />
              <path
                d="M1166.28,274.27a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1166.28,274.27Z"
                fill="#2f6840"
              />
              <path
                d="M1169.76,273.47c-.26,0-.49,0-.72.1a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1169.76,273.47Z"
                fill="#2f6840"
              />
              <path
                d="M1168.39,276.68a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1168.39,276.68Z"
                fill="#2f6840"
              />
              <path
                d="M1166.43,274.73c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1166.43,274.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1157.69,271.27c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1157.69,271.27Z"
                fill="#2f6840"
              />
              <path
                d="M1157.19,270.93c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1157.19,270.93Z"
                fill="#3ba525"
              />
              <path
                d="M1157.94,270.9a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1157.94,270.9Z"
                fill="#2f6840"
              />
              <path
                d="M1161.42,270.1c-.26,0-.49,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1161.42,270.1Z"
                fill="#2f6840"
              />
              <path
                d="M1160.05,273.31a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1160.05,273.31Z"
                fill="#2f6840"
              />
              <path
                d="M1158.09,271.36a7.18,7.18,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1158.09,271.36Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1172.4,286.76c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1172.4,286.76Z"
                fill="#2f6840"
              />
              <path
                d="M1171.89,286.42c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1171.89,286.42Z"
                fill="#3ba525"
              />
              <path
                d="M1172.64,286.39a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1172.64,286.39Z"
                fill="#2f6840"
              />
              <path
                d="M1176.12,285.59c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1176.12,285.59Z"
                fill="#2f6840"
              />
              <path
                d="M1174.75,288.8a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1174.75,288.8Z"
                fill="#2f6840"
              />
              <path
                d="M1172.8,286.85a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1172.8,286.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1158.94,281.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1158.94,281.19Z"
                fill="#2f6840"
              />
              <path
                d="M1158.43,280.85c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1158.43,280.85Z"
                fill="#3ba525"
              />
              <path
                d="M1159.19,280.82a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.07,2.07,0,0,1,.48.54A1,1,0,0,1,1159.19,280.82Z"
                fill="#2f6840"
              />
              <path
                d="M1162.67,280c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1162.67,280Z"
                fill="#2f6840"
              />
              <path
                d="M1161.3,283.23a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1161.3,283.23Z"
                fill="#2f6840"
              />
              <path
                d="M1159.34,281.28a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1159.34,281.28Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1202.51,270.43c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1202.51,270.43Z"
                fill="#2f6840"
              />
              <path
                d="M1202,270.09c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1202,270.09Z"
                fill="#3ba525"
              />
              <path
                d="M1202.76,270.06a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1202.76,270.06Z"
                fill="#2f6840"
              />
              <path
                d="M1206.24,269.26c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1206.24,269.26Z"
                fill="#2f6840"
              />
              <path
                d="M1204.87,272.47a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1204.87,272.47Z"
                fill="#2f6840"
              />
              <path
                d="M1202.91,270.52c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1202.91,270.52Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1199.85,279.16c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1199.85,279.16Z"
                fill="#2f6840"
              />
              <path
                d="M1199.35,278.82c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1199.35,278.82Z"
                fill="#3ba525"
              />
              <path
                d="M1200.1,278.79a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1200.1,278.79Z"
                fill="#2f6840"
              />
              <path
                d="M1203.58,278c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1203.58,278Z"
                fill="#2f6840"
              />
              <path
                d="M1202.21,281.2a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1202.21,281.2Z"
                fill="#2f6840"
              />
              <path
                d="M1200.25,279.25c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1200.25,279.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1194.5,274.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1194.5,274.2Z"
                fill="#2f6840"
              />
              <path
                d="M1194,273.86c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1194,273.86Z"
                fill="#3ba525"
              />
              <path
                d="M1194.75,273.83a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1194.75,273.83Z"
                fill="#2f6840"
              />
              <path
                d="M1198.23,273c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1198.23,273Z"
                fill="#2f6840"
              />
              <path
                d="M1196.86,276.25a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1196.86,276.25Z"
                fill="#2f6840"
              />
              <path
                d="M1194.9,274.29c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1194.9,274.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1186.16,270.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1186.16,270.83Z"
                fill="#2f6840"
              />
              <path
                d="M1185.65,270.49c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1185.65,270.49Z"
                fill="#3ba525"
              />
              <path
                d="M1186.41,270.46a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1186.41,270.46Z"
                fill="#2f6840"
              />
              <path
                d="M1189.88,269.66c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1189.88,269.66Z"
                fill="#2f6840"
              />
              <path
                d="M1188.52,272.87a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1188.52,272.87Z"
                fill="#2f6840"
              />
              <path
                d="M1186.56,270.92c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1186.56,270.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1200.86,286.32c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1200.86,286.32Z"
                fill="#2f6840"
              />
              <path
                d="M1200.36,286c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1200.36,286Z"
                fill="#3ba525"
              />
              <path
                d="M1201.11,286a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1201.11,286Z"
                fill="#2f6840"
              />
              <path
                d="M1204.59,285.15c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1204.59,285.15Z"
                fill="#2f6840"
              />
              <path
                d="M1203.22,288.36a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1203.22,288.36Z"
                fill="#2f6840"
              />
              <path
                d="M1201.26,286.41c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1201.26,286.41Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1187.41,280.75c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1187.41,280.75Z"
                fill="#2f6840"
              />
              <path
                d="M1186.9,280.41c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1186.9,280.41Z"
                fill="#3ba525"
              />
              <path
                d="M1187.65,280.38a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1187.65,280.38Z"
                fill="#2f6840"
              />
              <path
                d="M1191.13,279.58c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1191.13,279.58Z"
                fill="#2f6840"
              />
              <path
                d="M1189.76,282.79a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1189.76,282.79Z"
                fill="#2f6840"
              />
              <path
                d="M1187.81,280.84c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1187.81,280.84Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1221.85,259.29c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1221.85,259.29Z"
                fill="#2f6840"
              />
              <path
                d="M1221.34,258.94c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1221.34,258.94Z"
                fill="#3ba525"
              />
              <path
                d="M1222.1,258.91a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1222.1,258.91Z"
                fill="#2f6840"
              />
              <path
                d="M1225.57,258.12a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1225.57,258.12Z"
                fill="#2f6840"
              />
              <path
                d="M1224.21,261.33a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1224.21,261.33Z"
                fill="#2f6840"
              />
              <path
                d="M1222.25,259.37c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1222.25,259.37Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1219.19,268c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1219.19,268Z"
                fill="#2f6840"
              />
              <path
                d="M1218.68,267.67c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1218.68,267.67Z"
                fill="#3ba525"
              />
              <path
                d="M1219.44,267.64a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1219.44,267.64Z"
                fill="#2f6840"
              />
              <path
                d="M1222.91,266.85c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1222.91,266.85Z"
                fill="#2f6840"
              />
              <path
                d="M1221.55,270.06a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1221.55,270.06Z"
                fill="#2f6840"
              />
              <path
                d="M1219.59,268.1c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1219.59,268.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1213.84,263.06c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1213.84,263.06Z"
                fill="#2f6840"
              />
              <path
                d="M1213.33,262.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1213.33,262.71Z"
                fill="#3ba525"
              />
              <path
                d="M1214.08,262.68a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1214.08,262.68Z"
                fill="#2f6840"
              />
              <path
                d="M1217.56,261.89a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1217.56,261.89Z"
                fill="#2f6840"
              />
              <path
                d="M1216.19,265.1a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1216.19,265.1Z"
                fill="#2f6840"
              />
              <path
                d="M1214.24,263.14c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1214.24,263.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1205.49,259.69c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.24,14.24,0,0,1,1205.49,259.69Z"
                fill="#2f6840"
              />
              <path
                d="M1205,259.34c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1205,259.34Z"
                fill="#3ba525"
              />
              <path
                d="M1205.74,259.31a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1205.74,259.31Z"
                fill="#2f6840"
              />
              <path
                d="M1209.22,258.52c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1209.22,258.52Z"
                fill="#2f6840"
              />
              <path
                d="M1207.85,261.73a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1207.85,261.73Z"
                fill="#2f6840"
              />
              <path
                d="M1205.89,259.77c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1205.89,259.77Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1220.2,275.17c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1220.2,275.17Z"
                fill="#2f6840"
              />
              <path
                d="M1219.69,274.83c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1219.69,274.83Z"
                fill="#3ba525"
              />
              <path
                d="M1220.45,274.8a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1220.45,274.8Z"
                fill="#2f6840"
              />
              <path
                d="M1223.92,274c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1223.92,274Z"
                fill="#2f6840"
              />
              <path
                d="M1222.56,277.22a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1222.56,277.22Z"
                fill="#2f6840"
              />
              <path
                d="M1220.6,275.26c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1220.6,275.26Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1206.74,269.61c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1206.74,269.61Z"
                fill="#2f6840"
              />
              <path
                d="M1206.24,269.26c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1206.24,269.26Z"
                fill="#3ba525"
              />
              <path
                d="M1207,269.23a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1207,269.23Z"
                fill="#2f6840"
              />
              <path
                d="M1210.47,268.44c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1210.47,268.44Z"
                fill="#2f6840"
              />
              <path
                d="M1209.1,271.65a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1209.1,271.65Z"
                fill="#2f6840"
              />
              <path
                d="M1207.14,269.69c-.24.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1207.14,269.69Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1203.1,237.86c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1203.1,237.86Z"
                fill="#2f6840"
              />
              <path
                d="M1202.6,237.51c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1202.6,237.51Z"
                fill="#3ba525"
              />
              <path
                d="M1203.35,237.48a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1203.35,237.48Z"
                fill="#2f6840"
              />
              <path
                d="M1206.83,236.69c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1206.83,236.69Z"
                fill="#2f6840"
              />
              <path
                d="M1205.46,239.9a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1205.46,239.9Z"
                fill="#2f6840"
              />
              <path
                d="M1203.5,237.94c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1203.5,237.94Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1200.45,246.58c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1200.45,246.58Z"
                fill="#2f6840"
              />
              <path
                d="M1199.94,246.24c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1199.94,246.24Z"
                fill="#3ba525"
              />
              <path
                d="M1200.69,246.21a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1200.69,246.21Z"
                fill="#2f6840"
              />
              <path
                d="M1204.17,245.42c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1204.17,245.42Z"
                fill="#2f6840"
              />
              <path
                d="M1202.8,248.63a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1202.8,248.63Z"
                fill="#2f6840"
              />
              <path
                d="M1200.84,246.67c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1200.84,246.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1195.09,241.63c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1195.09,241.63Z"
                fill="#2f6840"
              />
              <path
                d="M1194.59,241.28c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1194.59,241.28Z"
                fill="#3ba525"
              />
              <path
                d="M1195.34,241.25a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1195.34,241.25Z"
                fill="#2f6840"
              />
              <path
                d="M1198.82,240.46a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1198.82,240.46Z"
                fill="#2f6840"
              />
              <path
                d="M1197.45,243.67a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1197.45,243.67Z"
                fill="#2f6840"
              />
              <path
                d="M1195.49,241.71c-.24.06-.47.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1195.49,241.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1186.75,238.25c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1186.75,238.25Z"
                fill="#2f6840"
              />
              <path
                d="M1186.24,237.91c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1186.24,237.91Z"
                fill="#3ba525"
              />
              <path
                d="M1187,237.88a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1187,237.88Z"
                fill="#2f6840"
              />
              <path
                d="M1190.47,237.09c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52A2.39,2.39,0,0,1,1189,237,2.07,2.07,0,0,1,1190.47,237.09Z"
                fill="#2f6840"
              />
              <path
                d="M1189.11,240.3a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1189.11,240.3Z"
                fill="#2f6840"
              />
              <path
                d="M1187.15,238.34c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1187.15,238.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1201.45,253.74c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.86,14.86,0,0,1,1201.45,253.74Z"
                fill="#2f6840"
              />
              <path
                d="M1201,253.4c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1201,253.4Z"
                fill="#3ba525"
              />
              <path
                d="M1201.7,253.37a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1201.7,253.37Z"
                fill="#2f6840"
              />
              <path
                d="M1205.18,252.58c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1205.18,252.58Z"
                fill="#2f6840"
              />
              <path
                d="M1203.81,255.79a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1203.81,255.79Z"
                fill="#2f6840"
              />
              <path
                d="M1201.85,253.83c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1201.85,253.83Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1188,248.17c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1188,248.17Z"
                fill="#2f6840"
              />
              <path
                d="M1187.49,247.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1187.49,247.83Z"
                fill="#3ba525"
              />
              <path
                d="M1188.25,247.8a2.15,2.15,0,0,0-.8-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1188.25,247.8Z"
                fill="#2f6840"
              />
              <path
                d="M1191.72,247c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1191.72,247Z"
                fill="#2f6840"
              />
              <path
                d="M1190.35,250.22a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1190.35,250.22Z"
                fill="#2f6840"
              />
              <path
                d="M1188.4,248.26c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1188.4,248.26Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1183.41,217.27c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1183.41,217.27Z"
                fill="#2f6840"
              />
              <path
                d="M1182.91,216.93c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1182.91,216.93Z"
                fill="#3ba525"
              />
              <path
                d="M1183.66,216.9a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1183.66,216.9Z"
                fill="#2f6840"
              />
              <path
                d="M1187.14,216.11c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1187.14,216.11Z"
                fill="#2f6840"
              />
              <path
                d="M1185.77,219.32a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1185.77,219.32Z"
                fill="#2f6840"
              />
              <path
                d="M1183.81,217.36c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1183.81,217.36Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1180.75,226c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1180.75,226Z"
                fill="#2f6840"
              />
              <path
                d="M1180.25,225.66c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1180.25,225.66Z"
                fill="#3ba525"
              />
              <path
                d="M1181,225.63a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1181,225.63Z"
                fill="#2f6840"
              />
              <path
                d="M1184.48,224.84c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1184.48,224.84Z"
                fill="#2f6840"
              />
              <path
                d="M1183.11,228.05a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1183.11,228.05Z"
                fill="#2f6840"
              />
              <path
                d="M1181.15,226.09c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1181.15,226.09Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1175.4,221.05c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1175.4,221.05Z"
                fill="#2f6840"
              />
              <path
                d="M1174.89,220.7c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1174.89,220.7Z"
                fill="#3ba525"
              />
              <path
                d="M1175.65,220.67a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1175.65,220.67Z"
                fill="#2f6840"
              />
              <path
                d="M1179.12,219.88c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1179.12,219.88Z"
                fill="#2f6840"
              />
              <path
                d="M1177.76,223.09a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1177.76,223.09Z"
                fill="#2f6840"
              />
              <path
                d="M1175.8,221.13c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1175.8,221.13Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1167.06,217.67c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1167.06,217.67Z"
                fill="#2f6840"
              />
              <path
                d="M1166.55,217.33c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1166.55,217.33Z"
                fill="#3ba525"
              />
              <path
                d="M1167.3,217.3a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1167.3,217.3Z"
                fill="#2f6840"
              />
              <path
                d="M1170.78,216.51c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1170.78,216.51Z"
                fill="#2f6840"
              />
              <path
                d="M1169.41,219.72a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1169.41,219.72Z"
                fill="#2f6840"
              />
              <path
                d="M1167.46,217.76c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1167.46,217.76Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1181.76,233.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1181.76,233.16Z"
                fill="#2f6840"
              />
              <path
                d="M1181.26,232.82c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1181.26,232.82Z"
                fill="#3ba525"
              />
              <path
                d="M1182,232.79a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1182,232.79Z"
                fill="#2f6840"
              />
              <path
                d="M1185.49,232c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1185.49,232Z"
                fill="#2f6840"
              />
              <path
                d="M1184.12,235.21a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1184.12,235.21Z"
                fill="#2f6840"
              />
              <path
                d="M1182.16,233.25c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1182.16,233.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1168.3,227.59c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1168.3,227.59Z"
                fill="#2f6840"
              />
              <path
                d="M1167.8,227.25c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1167.8,227.25Z"
                fill="#3ba525"
              />
              <path
                d="M1168.55,227.22a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1168.55,227.22Z"
                fill="#2f6840"
              />
              <path
                d="M1172,226.43c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1172,226.43Z"
                fill="#2f6840"
              />
              <path
                d="M1170.66,229.64a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1170.66,229.64Z"
                fill="#2f6840"
              />
              <path
                d="M1168.7,227.68c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1168.7,227.68Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1157.64,207c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1157.64,207Z"
                fill="#2f6840"
              />
              <path
                d="M1157.13,206.69c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1157.13,206.69Z"
                fill="#3ba525"
              />
              <path
                d="M1157.88,206.66a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1157.88,206.66Z"
                fill="#2f6840"
              />
              <path
                d="M1161.36,205.86c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1161.36,205.86Z"
                fill="#2f6840"
              />
              <path
                d="M1160,209.07a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1160,209.07Z"
                fill="#2f6840"
              />
              <path
                d="M1158,207.12c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1158,207.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1155,215.76c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1155,215.76Z"
                fill="#2f6840"
              />
              <path
                d="M1154.47,215.42c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1154.47,215.42Z"
                fill="#3ba525"
              />
              <path
                d="M1155.22,215.39a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1155.22,215.39Z"
                fill="#2f6840"
              />
              <path
                d="M1158.7,214.59c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1158.7,214.59Z"
                fill="#2f6840"
              />
              <path
                d="M1157.33,217.8a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1157.33,217.8Z"
                fill="#2f6840"
              />
              <path
                d="M1155.37,215.85a7,7,0,0,0-.69.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1155.37,215.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1149.62,210.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1149.62,210.8Z"
                fill="#2f6840"
              />
              <path
                d="M1149.12,210.46c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1149.12,210.46Z"
                fill="#3ba525"
              />
              <path
                d="M1149.87,210.43a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1149.87,210.43Z"
                fill="#2f6840"
              />
              <path
                d="M1153.35,209.63c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1153.35,209.63Z"
                fill="#2f6840"
              />
              <path
                d="M1152,212.84a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1152,212.84Z"
                fill="#2f6840"
              />
              <path
                d="M1150,210.89c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1150,210.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1141.28,207.43c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1141.28,207.43Z"
                fill="#2f6840"
              />
              <path
                d="M1140.78,207.09c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1140.78,207.09Z"
                fill="#3ba525"
              />
              <path
                d="M1141.53,207.06a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.07,2.07,0,0,1,.48.54A1,1,0,0,1,1141.53,207.06Z"
                fill="#2f6840"
              />
              <path
                d="M1145,206.26c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1145,206.26Z"
                fill="#2f6840"
              />
              <path
                d="M1143.64,209.47a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1143.64,209.47Z"
                fill="#2f6840"
              />
              <path
                d="M1141.68,207.52a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1141.68,207.52Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1156,222.92c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1156,222.92Z"
                fill="#2f6840"
              />
              <path
                d="M1155.48,222.58c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1155.48,222.58Z"
                fill="#3ba525"
              />
              <path
                d="M1156.23,222.55a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.54A1,1,0,0,1,1156.23,222.55Z"
                fill="#2f6840"
              />
              <path
                d="M1159.71,221.75c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1159.71,221.75Z"
                fill="#2f6840"
              />
              <path
                d="M1158.34,225a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1158.34,225Z"
                fill="#2f6840"
              />
              <path
                d="M1156.38,223c-.24.06-.47.08-.69.15a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1156.38,223Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1142.53,217.35c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1142.53,217.35Z"
                fill="#2f6840"
              />
              <path
                d="M1142,217c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1142,217Z"
                fill="#3ba525"
              />
              <path
                d="M1142.78,217a2.17,2.17,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1142.78,217Z"
                fill="#2f6840"
              />
              <path
                d="M1146.25,216.18c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1146.25,216.18Z"
                fill="#2f6840"
              />
              <path
                d="M1144.89,219.39a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1144.89,219.39Z"
                fill="#2f6840"
              />
              <path
                d="M1142.93,217.44a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1142.93,217.44Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1131.9,217.8c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1131.9,217.8Z"
                fill="#2f6840"
              />
              <path
                d="M1131.39,217.46c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1131.39,217.46Z"
                fill="#3ba525"
              />
              <path
                d="M1132.14,217.43a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1132.14,217.43Z"
                fill="#2f6840"
              />
              <path
                d="M1135.62,216.63c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1135.62,216.63Z"
                fill="#2f6840"
              />
              <path
                d="M1134.25,219.84a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1134.25,219.84Z"
                fill="#2f6840"
              />
              <path
                d="M1132.3,217.89c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,1132.3,217.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1129.24,226.53c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1129.24,226.53Z"
                fill="#2f6840"
              />
              <path
                d="M1128.73,226.19c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1128.73,226.19Z"
                fill="#3ba525"
              />
              <path
                d="M1129.48,226.16a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1129.48,226.16Z"
                fill="#2f6840"
              />
              <path
                d="M1133,225.36c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1133,225.36Z"
                fill="#2f6840"
              />
              <path
                d="M1131.59,228.57a1.94,1.94,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1131.59,228.57Z"
                fill="#2f6840"
              />
              <path
                d="M1129.64,226.62a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1129.64,226.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1123.88,221.57c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1123.88,221.57Z"
                fill="#2f6840"
              />
              <path
                d="M1123.38,221.23c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1123.38,221.23Z"
                fill="#3ba525"
              />
              <path
                d="M1124.13,221.2a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1124.13,221.2Z"
                fill="#2f6840"
              />
              <path
                d="M1127.61,220.4c-.26,0-.49,0-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1127.61,220.4Z"
                fill="#2f6840"
              />
              <path
                d="M1126.24,223.61a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1126.24,223.61Z"
                fill="#2f6840"
              />
              <path
                d="M1124.28,221.66c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1124.28,221.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1115.54,218.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1115.54,218.2Z"
                fill="#2f6840"
              />
              <path
                d="M1115,217.86c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1115,217.86Z"
                fill="#3ba525"
              />
              <path
                d="M1115.79,217.83a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1115.79,217.83Z"
                fill="#2f6840"
              />
              <path
                d="M1119.27,217c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1119.27,217Z"
                fill="#2f6840"
              />
              <path
                d="M1117.9,220.24a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1117.9,220.24Z"
                fill="#2f6840"
              />
              <path
                d="M1115.94,218.29c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1115.94,218.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1130.25,233.69c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1130.25,233.69Z"
                fill="#2f6840"
              />
              <path
                d="M1129.74,233.35c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1129.74,233.35Z"
                fill="#3ba525"
              />
              <path
                d="M1130.49,233.32a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1130.49,233.32Z"
                fill="#2f6840"
              />
              <path
                d="M1134,232.52c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1134,232.52Z"
                fill="#2f6840"
              />
              <path
                d="M1132.6,235.73a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1132.6,235.73Z"
                fill="#2f6840"
              />
              <path
                d="M1130.65,233.78a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1130.65,233.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1116.79,228.12c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1116.79,228.12Z"
                fill="#2f6840"
              />
              <path
                d="M1116.28,227.78c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1116.28,227.78Z"
                fill="#3ba525"
              />
              <path
                d="M1117,227.75a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1117,227.75Z"
                fill="#2f6840"
              />
              <path
                d="M1120.51,227c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1120.51,227Z"
                fill="#2f6840"
              />
              <path
                d="M1119.15,230.16a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1119.15,230.16Z"
                fill="#2f6840"
              />
              <path
                d="M1117.19,228.21c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1117.19,228.21Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1105.22,226.4c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,1105.22,226.4Z"
                fill="#2f6840"
              />
              <path
                d="M1104.71,226.06c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1104.71,226.06Z"
                fill="#3ba525"
              />
              <path
                d="M1105.46,226a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1105.46,226Z"
                fill="#2f6840"
              />
              <path
                d="M1108.94,225.24c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1108.94,225.24Z"
                fill="#2f6840"
              />
              <path
                d="M1107.57,228.45a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,2,2,0,0,1,.4.57A1,1,0,0,1,1107.57,228.45Z"
                fill="#2f6840"
              />
              <path
                d="M1105.61,226.49c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1105.61,226.49Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1102.56,235.13c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1102.56,235.13Z"
                fill="#2f6840"
              />
              <path
                d="M1102.05,234.79c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1102.05,234.79Z"
                fill="#3ba525"
              />
              <path
                d="M1102.8,234.76a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1102.8,234.76Z"
                fill="#2f6840"
              />
              <path
                d="M1106.28,234c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1106.28,234Z"
                fill="#2f6840"
              />
              <path
                d="M1104.91,237.18a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1104.91,237.18Z"
                fill="#2f6840"
              />
              <path
                d="M1103,235.22c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1103,235.22Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1097.2,230.18c4.43-.26-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1097.2,230.18Z"
                fill="#2f6840"
              />
              <path
                d="M1096.7,229.83c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1096.7,229.83Z"
                fill="#3ba525"
              />
              <path
                d="M1097.45,229.8a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1097.45,229.8Z"
                fill="#2f6840"
              />
              <path
                d="M1100.93,229c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1100.93,229Z"
                fill="#2f6840"
              />
              <path
                d="M1099.56,232.22a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1099.56,232.22Z"
                fill="#2f6840"
              />
              <path
                d="M1097.6,230.26c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1097.6,230.26Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1088.86,226.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1088.86,226.8Z"
                fill="#2f6840"
              />
              <path
                d="M1088.36,226.46c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1088.36,226.46Z"
                fill="#3ba525"
              />
              <path
                d="M1089.11,226.43a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1089.11,226.43Z"
                fill="#2f6840"
              />
              <path
                d="M1092.59,225.64c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1092.59,225.64Z"
                fill="#2f6840"
              />
              <path
                d="M1091.22,228.85a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1091.22,228.85Z"
                fill="#2f6840"
              />
              <path
                d="M1089.26,226.89c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1089.26,226.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1103.57,242.29c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1103.57,242.29Z"
                fill="#2f6840"
              />
              <path
                d="M1103.06,242c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1103.06,242Z"
                fill="#3ba525"
              />
              <path
                d="M1103.81,241.92a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1103.81,241.92Z"
                fill="#2f6840"
              />
              <path
                d="M1107.29,241.13c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1107.29,241.13Z"
                fill="#2f6840"
              />
              <path
                d="M1105.92,244.34a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1105.92,244.34Z"
                fill="#2f6840"
              />
              <path
                d="M1104,242.38c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1104,242.38Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1090.11,236.72c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1090.11,236.72Z"
                fill="#2f6840"
              />
              <path
                d="M1089.6,236.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1089.6,236.38Z"
                fill="#3ba525"
              />
              <path
                d="M1090.36,236.35a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1090.36,236.35Z"
                fill="#2f6840"
              />
              <path
                d="M1093.83,235.56c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1093.83,235.56Z"
                fill="#2f6840"
              />
              <path
                d="M1092.47,238.77a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1092.47,238.77Z"
                fill="#2f6840"
              />
              <path
                d="M1090.51,236.81c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1090.51,236.81Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1086.88,210c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1086.88,210Z"
                fill="#2f6840"
              />
              <path
                d="M1086.37,209.62c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1086.37,209.62Z"
                fill="#3ba525"
              />
              <path
                d="M1087.13,209.59a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1087.13,209.59Z"
                fill="#2f6840"
              />
              <path
                d="M1090.6,208.8c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1090.6,208.8Z"
                fill="#2f6840"
              />
              <path
                d="M1089.24,212a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1089.24,212Z"
                fill="#2f6840"
              />
              <path
                d="M1087.28,210.05c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1087.28,210.05Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1084.22,218.69c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1084.22,218.69Z"
                fill="#2f6840"
              />
              <path
                d="M1083.71,218.35c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1083.71,218.35Z"
                fill="#3ba525"
              />
              <path
                d="M1084.47,218.32a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1084.47,218.32Z"
                fill="#2f6840"
              />
              <path
                d="M1087.94,217.53c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1087.94,217.53Z"
                fill="#2f6840"
              />
              <path
                d="M1086.58,220.74a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1086.58,220.74Z"
                fill="#2f6840"
              />
              <path
                d="M1084.62,218.78c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1084.62,218.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1078.87,213.74c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1078.87,213.74Z"
                fill="#2f6840"
              />
              <path
                d="M1078.36,213.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1078.36,213.39Z"
                fill="#3ba525"
              />
              <path
                d="M1079.11,213.36a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1079.11,213.36Z"
                fill="#2f6840"
              />
              <path
                d="M1082.59,212.57a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.45,10.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1082.59,212.57Z"
                fill="#2f6840"
              />
              <path
                d="M1081.22,215.78a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1081.22,215.78Z"
                fill="#2f6840"
              />
              <path
                d="M1079.27,213.82c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1079.27,213.82Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1070.53,210.36c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1070.53,210.36Z"
                fill="#2f6840"
              />
              <path
                d="M1070,210c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1070,210Z"
                fill="#3ba525"
              />
              <path
                d="M1070.77,210a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1070.77,210Z"
                fill="#2f6840"
              />
              <path
                d="M1074.25,209.2c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1074.25,209.2Z"
                fill="#2f6840"
              />
              <path
                d="M1072.88,212.41a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1072.88,212.41Z"
                fill="#2f6840"
              />
              <path
                d="M1070.92,210.45c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1070.92,210.45Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1085.23,225.85c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1085.23,225.85Z"
                fill="#2f6840"
              />
              <path
                d="M1084.72,225.51c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1084.72,225.51Z"
                fill="#3ba525"
              />
              <path
                d="M1085.48,225.48a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1085.48,225.48Z"
                fill="#2f6840"
              />
              <path
                d="M1089,224.69c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1089,224.69Z"
                fill="#2f6840"
              />
              <path
                d="M1087.59,227.9a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1087.59,227.9Z"
                fill="#2f6840"
              />
              <path
                d="M1085.63,225.94c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1085.63,225.94Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1071.77,220.28c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1071.77,220.28Z"
                fill="#2f6840"
              />
              <path
                d="M1071.27,219.94c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1071.27,219.94Z"
                fill="#3ba525"
              />
              <path
                d="M1072,219.91a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1072,219.91Z"
                fill="#2f6840"
              />
              <path
                d="M1075.5,219.12c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1075.5,219.12Z"
                fill="#2f6840"
              />
              <path
                d="M1074.13,222.33a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1074.13,222.33Z"
                fill="#2f6840"
              />
              <path
                d="M1072.17,220.37c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1072.17,220.37Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1076.07,183.91c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.23-2.77,2.92-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1076.07,183.91Z"
                fill="#2f6840"
              />
              <path
                d="M1075.56,183.57c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1075.56,183.57Z"
                fill="#3ba525"
              />
              <path
                d="M1076.32,183.54a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1076.32,183.54Z"
                fill="#2f6840"
              />
              <path
                d="M1079.8,182.74c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1079.8,182.74Z"
                fill="#2f6840"
              />
              <path
                d="M1078.43,186a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1078.43,186Z"
                fill="#2f6840"
              />
              <path
                d="M1076.47,184a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1076.47,184Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1073.41,192.64c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1073.41,192.64Z"
                fill="#2f6840"
              />
              <path
                d="M1072.91,192.29c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1072.91,192.29Z"
                fill="#3ba525"
              />
              <path
                d="M1073.66,192.27a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.48.53A1,1,0,0,1,1073.66,192.27Z"
                fill="#2f6840"
              />
              <path
                d="M1077.14,191.47c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1077.14,191.47Z"
                fill="#2f6840"
              />
              <path
                d="M1075.77,194.68a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1075.77,194.68Z"
                fill="#2f6840"
              />
              <path
                d="M1073.81,192.73a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1073.81,192.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1068.06,187.68c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1068.06,187.68Z"
                fill="#2f6840"
              />
              <path
                d="M1067.55,187.34c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1067.55,187.34Z"
                fill="#3ba525"
              />
              <path
                d="M1068.31,187.31a2.24,2.24,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1068.31,187.31Z"
                fill="#2f6840"
              />
              <path
                d="M1071.78,186.51c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1071.78,186.51Z"
                fill="#2f6840"
              />
              <path
                d="M1070.42,189.72a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A1,1,0,0,1,1070.42,189.72Z"
                fill="#2f6840"
              />
              <path
                d="M1068.46,187.77a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1068.46,187.77Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1059.72,184.31c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1059.72,184.31Z"
                fill="#2f6840"
              />
              <path
                d="M1059.21,184c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1059.21,184Z"
                fill="#3ba525"
              />
              <path
                d="M1060,183.94a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1060,183.94Z"
                fill="#2f6840"
              />
              <path
                d="M1063.44,183.14c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1063.44,183.14Z"
                fill="#2f6840"
              />
              <path
                d="M1062.07,186.35a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1062.07,186.35Z"
                fill="#2f6840"
              />
              <path
                d="M1060.11,184.4a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1060.11,184.4Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1074.42,199.8c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1074.42,199.8Z"
                fill="#2f6840"
              />
              <path
                d="M1073.92,199.45c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1073.92,199.45Z"
                fill="#3ba525"
              />
              <path
                d="M1074.67,199.43a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.48.53A1,1,0,0,1,1074.67,199.43Z"
                fill="#2f6840"
              />
              <path
                d="M1078.15,198.63c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1078.15,198.63Z"
                fill="#2f6840"
              />
              <path
                d="M1076.78,201.84a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1076.78,201.84Z"
                fill="#2f6840"
              />
              <path
                d="M1074.82,199.88c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1074.82,199.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1061,194.23c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1061,194.23Z"
                fill="#2f6840"
              />
              <path
                d="M1060.46,193.88c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1060.46,193.88Z"
                fill="#3ba525"
              />
              <path
                d="M1061.21,193.86a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1061.21,193.86Z"
                fill="#2f6840"
              />
              <path
                d="M1064.69,193.06c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1064.69,193.06Z"
                fill="#2f6840"
              />
              <path
                d="M1063.32,196.27a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1063.32,196.27Z"
                fill="#2f6840"
              />
              <path
                d="M1061.36,194.32c-.24.05-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1061.36,194.32Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M1153.53,176.78l3,1.85a1,1,0,0,0,.91.06l7.17-3.2a1,1,0,0,0,.24-1.62h0a1,1,0,0,0-.77-.23L1153.91,175A1,1,0,0,0,1153.53,176.78Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1158.83 169.37 1154.79 170.22 1151.23 172.96 1157.19 175.35 1164.5 172.36 1158.83 169.37"
              fill="#ffedc8"
            />
            <polygon
              points="1151.23 172.96 1151.23 175.35 1156.95 177.8 1164.65 174.68 1164.5 172.36 1157.19 175.35 1151.23 172.96"
              fill="#ccae79"
            />
            <polygon
              points="1157.19 175.35 1156.95 177.8 1164.65 174.68 1164.5 172.36 1157.19 175.35"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1152.93,173.64a1.09,1.09,0,0,1,0,1.23c.27-.39.33-1.1.46-1.05Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.45,174.65a3.39,3.39,0,0,0,1.5-1.53l-1.08,1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1160.21,174.11a1.11,1.11,0,0,1,.59,1l-.18-1.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1162.88,171.5a6.82,6.82,0,0,1-2.37,0,3.5,3.5,0,0,1-1.73.13s1.27-.13,1.73.31A10.09,10.09,0,0,1,1162.88,171.5Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1076.64,237.56l6.43,4a2.11,2.11,0,0,0,2,.13l15.43-6.9a2.08,2.08,0,0,0,.52-3.48h0a2.11,2.11,0,0,0-1.65-.5l-21.85,2.91A2.09,2.09,0,0,0,1076.64,237.56Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1088.05 221.6 1079.35 223.44 1071.69 229.33 1084.53 234.48 1100.26 228.04 1088.05 221.6"
              fill="#ffedc8"
            />
            <polygon
              points="1071.69 229.33 1071.69 234.48 1084.01 239.76 1100.6 233.03 1100.26 228.04 1084.53 234.48 1071.69 229.33"
              fill="#ccae79"
            />
            <polygon
              points="1084.53 234.48 1084.01 239.76 1100.6 233.03 1100.26 228.04 1084.53 234.48"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1075.35,230.8a2.31,2.31,0,0,1,0,2.64c.58-.82.72-2.35,1-2.24S1075.35,230.8,1075.35,230.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1080.77,233a7.28,7.28,0,0,0,3.24-3.29l-2.33,3.66Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1091,231.82a2.37,2.37,0,0,1,1.28,2.08l-.38-2.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1096.77,226.2c-.16-.09-3.25.63-5.1,0a7.35,7.35,0,0,1-3.73.26s2.73-.26,3.73.67A21.78,21.78,0,0,1,1096.77,226.2Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1123.67,233l2.22,1.38a.72.72,0,0,0,.68,0l5.34-2.38a.73.73,0,0,0,.17-1.21h0a.68.68,0,0,0-.56-.17l-7.56,1A.72.72,0,0,0,1123.67,233Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1127.62 227.48 1124.61 228.11 1121.96 230.15 1126.4 231.93 1131.84 229.7 1127.62 227.48"
              fill="#ffedc8"
            />
            <polygon
              points="1121.96 230.15 1121.96 231.93 1126.22 233.76 1131.95 231.43 1131.84 229.7 1126.4 231.93 1121.96 230.15"
              fill="#ccae79"
            />
            <polygon
              points="1126.4 231.93 1126.22 233.76 1131.95 231.43 1131.84 229.7 1126.4 231.93"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1123.23,230.66a.81.81,0,0,1,0,.91c.2-.28.24-.81.33-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1125.1,231.41a2.55,2.55,0,0,0,1.12-1.14l-.81,1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1128.64,231a.82.82,0,0,1,.45.72l-.14-.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1130.63,229.07a5.41,5.41,0,0,1-1.76,0,2.56,2.56,0,0,1-1.29.09s.94-.09,1.29.23A7.23,7.23,0,0,1,1130.63,229.07Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1107.73,237.36l2.22,1.38a.75.75,0,0,0,.68,0l5.34-2.39a.72.72,0,0,0,.18-1.2h0a.71.71,0,0,0-.57-.17l-7.56,1A.72.72,0,0,0,1107.73,237.36Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1111.68 231.84 1108.67 232.48 1106.02 234.52 1110.46 236.3 1115.9 234.07 1111.68 231.84"
              fill="#ffedc8"
            />
            <polygon
              points="1106.02 234.52 1106.02 236.3 1110.28 238.12 1116.02 235.8 1115.9 234.07 1110.46 236.3 1106.02 234.52"
              fill="#ccae79"
            />
            <polygon
              points="1110.46 236.3 1110.28 238.12 1116.02 235.8 1115.9 234.07 1110.46 236.3"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1107.29,235a.81.81,0,0,1,0,.91c.2-.29.24-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1109.16,235.78a2.55,2.55,0,0,0,1.12-1.14l-.81,1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1112.71,235.38a.82.82,0,0,1,.44.72l-.13-.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1114.69,233.43a5.13,5.13,0,0,1-1.76,0,2.56,2.56,0,0,1-1.29.09s.95-.09,1.29.23A7.78,7.78,0,0,1,1114.69,233.43Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1123.24,221l2.22,1.38a.75.75,0,0,0,.68,0l5.33-2.39a.71.71,0,0,0,.18-1.2h0a.69.69,0,0,0-.57-.17l-7.55,1A.72.72,0,0,0,1123.24,221Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1127.18 215.47 1124.18 216.11 1121.53 218.15 1125.97 219.93 1131.41 217.7 1127.18 215.47"
              fill="#ffedc8"
            />
            <polygon
              points="1121.53 218.15 1121.53 219.93 1125.79 221.75 1131.52 219.43 1131.41 217.7 1125.97 219.93 1121.53 218.15"
              fill="#ccae79"
            />
            <polygon
              points="1125.97 219.93 1125.79 221.75 1131.52 219.43 1131.41 217.7 1125.97 219.93"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1122.79,218.65a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1124.67,219.41a2.6,2.6,0,0,0,1.12-1.14l-.81,1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1128.21,219a.84.84,0,0,1,.45.72l-.14-.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1130.2,217.06a5.14,5.14,0,0,1-1.76,0,2.56,2.56,0,0,1-1.29.09s.94-.09,1.29.23A7.78,7.78,0,0,1,1130.2,217.06Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1159.22,222.54l4.71,2.92a1.54,1.54,0,0,0,1.43.1l11.3-5.06A1.52,1.52,0,0,0,1177,218h0a1.51,1.51,0,0,0-1.2-.36l-16,2.13A1.53,1.53,0,0,0,1159.22,222.54Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1167.58 210.85 1161.21 212.2 1155.59 216.51 1165 220.28 1176.52 215.56 1167.58 210.85"
              fill="#ffedc8"
            />
            <polygon
              points="1155.59 216.51 1155.59 220.28 1164.62 224.15 1176.77 219.22 1176.52 215.56 1165 220.28 1155.59 216.51"
              fill="#ccae79"
            />
            <polygon
              points="1165 220.28 1164.62 224.15 1176.77 219.22 1176.52 215.56 1165 220.28"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1158.28,217.59a1.7,1.7,0,0,1,0,1.93c.42-.6.52-1.72.72-1.64Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1162.25,219.18a5.34,5.34,0,0,0,2.37-2.41l-1.71,2.68Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1169.76,218.33a1.75,1.75,0,0,1,.94,1.53l-.29-1.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1174,214.22c-.12-.07-2.38.45-3.74,0a5.38,5.38,0,0,1-2.73.19s2-.2,2.73.49A15.91,15.91,0,0,1,1174,214.22Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1182.56,226.63l4.65,2.89a1.5,1.5,0,0,0,1.41.09l11.17-5a1.51,1.51,0,0,0,.38-2.52h0a1.48,1.48,0,0,0-1.19-.36l-15.82,2.1A1.52,1.52,0,0,0,1182.56,226.63Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1190.82 215.08 1184.52 216.41 1178.97 220.68 1188.27 224.4 1199.65 219.74 1190.82 215.08"
              fill="#ffedc8"
            />
            <polygon
              points="1178.97 220.68 1178.97 224.4 1187.89 228.22 1199.9 223.35 1199.65 219.74 1188.27 224.4 1178.97 220.68"
              fill="#ccae79"
            />
            <polygon
              points="1188.27 224.4 1187.89 228.22 1199.9 223.35 1199.65 219.74 1188.27 224.4"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1181.63,221.74a1.69,1.69,0,0,1,0,1.91c.42-.6.51-1.7.71-1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.55,223.31a5.27,5.27,0,0,0,2.34-2.38l-1.68,2.64Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1193,222.48a1.69,1.69,0,0,1,.92,1.5l-.27-1.77Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1197.13,218.41c-.12-.06-2.35.45-3.7,0a5.36,5.36,0,0,1-2.69.19s2-.2,2.69.48A16,16,0,0,1,1197.13,218.41Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1204.48,243.91l-4,2.46a1.31,1.31,0,0,1-1.2.08l-9.51-4.25a1.29,1.29,0,0,1-.32-2.15h0a1.33,1.33,0,0,1,1-.31l13.48,1.8A1.29,1.29,0,0,1,1204.48,243.91Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1197.44 234.07 1202.81 235.21 1207.53 238.84 1199.61 242.01 1189.92 238.04 1197.44 234.07"
              fill="#ffedc8"
            />
            <polygon
              points="1207.53 238.84 1207.53 242.01 1199.93 245.27 1189.71 241.12 1189.92 238.04 1199.61 242.01 1207.53 238.84"
              fill="#ccae79"
            />
            <polygon
              points="1199.61 242.01 1199.93 245.27 1189.71 241.12 1189.92 238.04 1199.61 242.01"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1205.27,239.74a1.44,1.44,0,0,0,0,1.63c-.36-.51-.44-1.45-.61-1.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1201.93,241.08a4.52,4.52,0,0,1-2-2l1.44,2.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1195.61,240.37a1.47,1.47,0,0,0-.79,1.28l.24-1.51Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1192.07,236.91a9.7,9.7,0,0,0,3.14,0,4.57,4.57,0,0,0,2.3.16s-1.69-.17-2.3.41A13.29,13.29,0,0,0,1192.07,236.91Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1194.48,254.63l3,1.88a1,1,0,0,0,.92.06l7.28-3.25a1,1,0,0,0,.24-1.64h0a.94.94,0,0,0-.77-.23l-10.31,1.37A1,1,0,0,0,1194.48,254.63Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1199.86 247.1 1195.76 247.97 1192.14 250.75 1198.2 253.18 1205.62 250.14 1199.86 247.1"
              fill="#ffedc8"
            />
            <polygon
              points="1192.14 250.75 1192.14 253.18 1197.96 255.67 1205.78 252.5 1205.62 250.14 1198.2 253.18 1192.14 250.75"
              fill="#ccae79"
            />
            <polygon
              points="1198.2 253.18 1197.96 255.67 1205.78 252.5 1205.62 250.14 1198.2 253.18"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1193.87,251.44a1.1,1.1,0,0,1,0,1.25c.28-.39.34-1.11.47-1.06Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1196.43,252.47a3.47,3.47,0,0,0,1.53-1.55l-1.1,1.72Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1201.26,251.92a1.15,1.15,0,0,1,.61,1l-.18-1.16Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1204,249.27a7,7,0,0,1-2.4,0,3.47,3.47,0,0,1-1.76.13s1.29-.13,1.76.31A10.35,10.35,0,0,1,1204,249.27Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1179,279.15l3.82,2.37a1.23,1.23,0,0,0,1.16.08l9.17-4.1a1.24,1.24,0,0,0,.3-2.07h0a1.23,1.23,0,0,0-1-.29l-13,1.73A1.24,1.24,0,0,0,1179,279.15Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1185.77 269.67 1180.6 270.77 1176.05 274.27 1183.68 277.32 1193.02 273.5 1185.77 269.67"
              fill="#ffedc8"
            />
            <polygon
              points="1176.05 274.27 1176.05 277.32 1183.37 280.46 1193.22 276.46 1193.02 273.5 1183.68 277.32 1176.05 274.27"
              fill="#ccae79"
            />
            <polygon
              points="1183.68 277.32 1183.37 280.46 1193.22 276.46 1193.02 273.5 1183.68 277.32"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1178.23,275.14a1.38,1.38,0,0,1,0,1.57c.34-.49.42-1.4.58-1.34Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1181.45,276.43a4.36,4.36,0,0,0,1.92-2l-1.38,2.18Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1187.54,275.74a1.42,1.42,0,0,1,.76,1.24l-.23-1.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1191,272.41a9.33,9.33,0,0,1-3,0,4.41,4.41,0,0,1-2.21.15s1.62-.16,2.21.4A13.14,13.14,0,0,1,1191,272.41Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1169.3,274.46l2.25,1.4a.73.73,0,0,0,.69,0l5.42-2.42a.73.73,0,0,0,.18-1.22h0a.76.76,0,0,0-.58-.18l-7.67,1A.73.73,0,0,0,1169.3,274.46Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1173.3 268.85 1170.25 269.5 1167.56 271.57 1172.07 273.38 1177.59 271.11 1173.3 268.85"
              fill="#ffedc8"
            />
            <polygon
              points="1167.56 271.57 1167.56 273.38 1171.88 275.23 1177.71 272.87 1177.59 271.11 1172.07 273.38 1167.56 271.57"
              fill="#ccae79"
            />
            <polygon
              points="1172.07 273.38 1171.88 275.23 1177.71 272.87 1177.59 271.11 1172.07 273.38"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1168.84,272.08a.81.81,0,0,1,0,.93c.21-.29.26-.83.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1170.75,272.85a2.58,2.58,0,0,0,1.13-1.16l-.81,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1174.35,272.44a.84.84,0,0,1,.45.73l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1176.37,270.47a5.37,5.37,0,0,1-1.8,0,2.6,2.6,0,0,1-1.3.09s1-.09,1.3.23A8.1,8.1,0,0,1,1176.37,270.47Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1152.88,304.72l5.23,3.25a1.69,1.69,0,0,0,1.59.11l12.56-5.62a1.69,1.69,0,0,0,.42-2.83h0a1.68,1.68,0,0,0-1.34-.4l-17.79,2.36A1.7,1.7,0,0,0,1152.88,304.72Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1162.16 291.73 1155.09 293.23 1148.85 298.03 1159.3 302.22 1172.1 296.98 1162.16 291.73"
              fill="#ffedc8"
            />
            <polygon
              points="1148.85 298.03 1148.85 302.22 1158.88 306.52 1172.38 301.04 1172.1 296.98 1159.3 302.22 1148.85 298.03"
              fill="#ccae79"
            />
            <polygon
              points="1159.3 302.22 1158.88 306.52 1172.38 301.04 1172.1 296.98 1159.3 302.22"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1151.83,299.22a1.88,1.88,0,0,1,0,2.15c.47-.67.58-1.91.8-1.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156.24,301a6,6,0,0,0,2.64-2.68l-1.9,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1164.59,300.05a1.94,1.94,0,0,1,1,1.7l-.31-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1169.26,295.48c-.13-.07-2.64.51-4.15,0a6,6,0,0,1-3,.21s2.22-.22,3,.54A17.87,17.87,0,0,1,1169.26,295.48Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1204.22,389.82l5,3.08a1.62,1.62,0,0,0,1.51.1l11.91-5.33a1.61,1.61,0,0,0,.4-2.69h0a1.63,1.63,0,0,0-1.27-.38l-16.87,2.25A1.61,1.61,0,0,0,1204.22,389.82Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1213.03 377.49 1206.31 378.92 1200.39 383.46 1210.31 387.44 1222.45 382.47 1213.03 377.49"
              fill="#ffedc8"
            />
            <polygon
              points="1200.39 383.46 1200.39 387.44 1209.91 391.52 1222.71 386.32 1222.45 382.47 1210.31 387.44 1200.39 383.46"
              fill="#ccae79"
            />
            <polygon
              points="1210.31 387.44 1209.91 391.52 1222.71 386.32 1222.45 382.47 1210.31 387.44"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1203.22,384.6a1.78,1.78,0,0,1,0,2c.45-.64.55-1.82.76-1.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1207.41,386.28a5.65,5.65,0,0,0,2.5-2.55l-1.8,2.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1215.32,385.39a1.83,1.83,0,0,1,1,1.6l-.29-1.89Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1219.76,381.05c-.13-.07-2.51.48-3.94,0a5.73,5.73,0,0,1-2.87.2s2.1-.21,2.87.51A17,17,0,0,1,1219.76,381.05Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1201.42,398.1l2.26,1.4a.76.76,0,0,0,.69,0l5.41-2.42a.73.73,0,0,0,.19-1.22h0a.76.76,0,0,0-.58-.18l-7.68,1A.74.74,0,0,0,1201.42,398.1Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1205.43 392.49 1202.37 393.14 1199.68 395.21 1204.19 397.01 1209.72 394.75 1205.43 392.49"
              fill="#ffedc8"
            />
            <polygon
              points="1199.68 395.21 1199.68 397.01 1204.01 398.87 1209.84 396.5 1209.72 394.75 1204.19 397.01 1199.68 395.21"
              fill="#ccae79"
            />
            <polygon
              points="1204.19 397.01 1204.01 398.87 1209.84 396.5 1209.72 394.75 1204.19 397.01"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1201,395.72a.82.82,0,0,1,0,.93c.2-.29.25-.83.34-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1202.87,396.49a2.57,2.57,0,0,0,1.14-1.16l-.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1206.47,396.08a.83.83,0,0,1,.45.73l-.13-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1208.49,394.11a5.32,5.32,0,0,1-1.79,0,2.64,2.64,0,0,1-1.31.09s1-.1,1.31.23A8,8,0,0,1,1208.49,394.11Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1184.17,407.66l2.25,1.4a.74.74,0,0,0,.69.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.72.72,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1184.17,407.66Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1188.17 402.06 1185.12 402.7 1182.43 404.77 1186.94 406.58 1192.46 404.32 1188.17 402.06"
              fill="#ffedc8"
            />
            <polygon
              points="1182.43 404.77 1182.43 406.58 1186.76 408.43 1192.58 406.07 1192.46 404.32 1186.94 406.58 1182.43 404.77"
              fill="#ccae79"
            />
            <polygon
              points="1186.94 406.58 1186.76 408.43 1192.58 406.07 1192.46 404.32 1186.94 406.58"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1183.71,405.29a.8.8,0,0,1,0,.93c.21-.3.26-.83.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.62,406.05a2.62,2.62,0,0,0,1.14-1.16l-.82,1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1189.22,405.65a.83.83,0,0,1,.45.73l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1191.24,403.67a5.37,5.37,0,0,1-1.8,0,2.47,2.47,0,0,1-1.3.09s1-.09,1.3.24A7.8,7.8,0,0,1,1191.24,403.67Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1168.85,409.4l2.26,1.4a.71.71,0,0,0,.68.05l5.42-2.43a.73.73,0,0,0,.18-1.22h0a.71.71,0,0,0-.57-.17l-7.68,1A.73.73,0,0,0,1168.85,409.4Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1172.86 403.79 1169.8 404.44 1167.11 406.51 1171.62 408.32 1177.14 406.06 1172.86 403.79"
              fill="#ffedc8"
            />
            <polygon
              points="1167.11 406.51 1167.11 408.32 1171.44 410.17 1177.26 407.81 1177.14 406.06 1171.62 408.32 1167.11 406.51"
              fill="#ccae79"
            />
            <polygon
              points="1171.62 408.32 1171.44 410.17 1177.26 407.81 1177.14 406.06 1171.62 408.32"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1168.4,407a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1170.3,407.79a2.57,2.57,0,0,0,1.14-1.16l-.82,1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1173.9,407.38a.84.84,0,0,1,.45.73l-.13-.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1175.92,405.41a5.32,5.32,0,0,1-1.79,0,2.51,2.51,0,0,1-1.31.09s1-.09,1.31.24A7.66,7.66,0,0,1,1175.92,405.41Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1169.09,400.93l5.23,3.24a1.69,1.69,0,0,0,1.59.11l12.55-5.61a1.71,1.71,0,0,0,.42-2.84h0a1.76,1.76,0,0,0-1.34-.4l-17.78,2.37A1.7,1.7,0,0,0,1169.09,400.93Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1178.37 387.95 1171.29 389.45 1165.06 394.24 1175.51 398.42 1188.3 393.19 1178.37 387.95"
              fill="#ffedc8"
            />
            <polygon
              points="1165.06 394.24 1165.06 398.42 1175.09 402.72 1188.58 397.25 1188.3 393.19 1175.51 398.42 1165.06 394.24"
              fill="#ccae79"
            />
            <polygon
              points="1175.51 398.42 1175.09 402.72 1188.58 397.25 1188.3 393.19 1175.51 398.42"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1168,395.43a1.88,1.88,0,0,1,0,2.15c.47-.67.58-1.91.8-1.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1172.45,397.2a5.92,5.92,0,0,0,2.63-2.68l-1.89,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1180.79,396.26a1.93,1.93,0,0,1,1,1.69l-.31-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1185.46,391.69c-.13-.07-2.64.51-4.15,0a6,6,0,0,1-3,.21s2.22-.21,3,.54A17.87,17.87,0,0,1,1185.46,391.69Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1155,409.6l2.26,1.4a.71.71,0,0,0,.68.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.76.76,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1155,409.6Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1158.99 404 1155.94 404.65 1153.25 406.71 1157.76 408.52 1163.28 406.26 1158.99 404"
              fill="#ffedc8"
            />
            <polygon
              points="1153.25 406.71 1153.25 408.52 1157.58 410.38 1163.4 408.01 1163.28 406.26 1157.76 408.52 1153.25 406.71"
              fill="#ccae79"
            />
            <polygon
              points="1157.76 408.52 1157.58 410.38 1163.4 408.01 1163.28 406.26 1157.76 408.52"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1154.54,407.23a.82.82,0,0,1,0,.93c.2-.29.25-.83.34-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156.44,408a2.57,2.57,0,0,0,1.14-1.15l-.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1160,407.59a.83.83,0,0,1,.45.73l-.14-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1162.06,405.61a5.32,5.32,0,0,1-1.79,0,2.59,2.59,0,0,1-1.31.1s1-.1,1.31.23A7.66,7.66,0,0,1,1162.06,405.61Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1156.84,420l-2.26,1.4a.73.73,0,0,1-.69,0l-5.42-2.42a.73.73,0,0,1-.18-1.22h0a.76.76,0,0,1,.58-.18l7.68,1A.74.74,0,0,1,1156.84,420Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1152.83 414.39 1155.88 415.04 1158.58 417.11 1154.07 418.92 1148.54 416.65 1152.83 414.39"
              fill="#ffedc8"
            />
            <polygon
              points="1158.58 417.11 1158.58 418.92 1154.25 420.77 1148.42 418.41 1148.54 416.65 1154.07 418.92 1158.58 417.11"
              fill="#ccae79"
            />
            <polygon
              points="1154.07 418.92 1154.25 420.77 1148.42 418.41 1148.54 416.65 1154.07 418.92"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1157.29,417.62a.82.82,0,0,0,0,.93c-.21-.29-.25-.83-.35-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.39,418.39a2.57,2.57,0,0,1-1.14-1.16l.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1151.78,418a.82.82,0,0,0-.44.73l.13-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1149.77,416a5.31,5.31,0,0,0,1.79,0,2.64,2.64,0,0,0,1.31.09s-1-.09-1.31.23A8,8,0,0,0,1149.77,416Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1142.34,285.11l2.26,1.4a.71.71,0,0,0,.68.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.74.74,0,0,0-.57-.17l-7.68,1A.73.73,0,0,0,1142.34,285.11Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1146.35 279.51 1143.29 280.16 1140.6 282.22 1145.11 284.03 1150.63 281.77 1146.35 279.51"
              fill="#ffedc8"
            />
            <polygon
              points="1140.6 282.22 1140.6 284.03 1144.93 285.89 1150.75 283.52 1150.63 281.77 1145.11 284.03 1140.6 282.22"
              fill="#ccae79"
            />
            <polygon
              points="1145.11 284.03 1144.93 285.89 1150.75 283.52 1150.63 281.77 1145.11 284.03"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1141.89,282.74a.82.82,0,0,1,0,.93c.2-.29.25-.83.34-.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1143.79,283.5a2.57,2.57,0,0,0,1.14-1.15l-.82,1.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1147.39,283.1a.83.83,0,0,1,.45.73l-.13-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1149.41,281.12a5.32,5.32,0,0,1-1.79,0,2.51,2.51,0,0,1-1.31.09s1-.09,1.31.24A7.66,7.66,0,0,1,1149.41,281.12Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1195.35,309.52l6.06,3.76a2,2,0,0,0,1.84.12l14.55-6.5a2,2,0,0,0,.48-3.29h0a1.94,1.94,0,0,0-1.55-.46l-20.6,2.74A2,2,0,0,0,1195.35,309.52Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1206.1 294.47 1197.9 296.21 1190.67 301.76 1202.78 306.61 1217.61 300.54 1206.1 294.47"
              fill="#ffedc8"
            />
            <polygon
              points="1190.67 301.76 1190.67 306.61 1202.29 311.59 1217.93 305.25 1217.61 300.54 1202.78 306.61 1190.67 301.76"
              fill="#ccae79"
            />
            <polygon
              points="1202.78 306.61 1202.29 311.59 1217.93 305.25 1217.61 300.54 1202.78 306.61"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1194.13,303.15a2.18,2.18,0,0,1,0,2.49c.55-.78.67-2.23.93-2.12Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1199.24,305.19a6.82,6.82,0,0,0,3-3.1l-2.19,3.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1208.91,304.11a2.22,2.22,0,0,1,1.2,2l-.36-2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1214.33,298.81c-.16-.09-3.07.59-4.82,0a6.88,6.88,0,0,1-3.51.24s2.58-.25,3.51.63A20.61,20.61,0,0,1,1214.33,298.81Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1225.31,327.91l6.06,3.76a1.94,1.94,0,0,0,1.84.13l14.55-6.5a2,2,0,0,0,.49-3.29h0a2,2,0,0,0-1.55-.47l-20.61,2.75A2,2,0,0,0,1225.31,327.91Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1236.07 312.86 1227.86 314.6 1220.63 320.16 1232.74 325.01 1247.58 318.94 1236.07 312.86"
              fill="#ffedc8"
            />
            <polygon
              points="1220.63 320.16 1220.63 325.01 1232.26 329.99 1247.9 323.64 1247.58 318.94 1232.74 325.01 1220.63 320.16"
              fill="#ccae79"
            />
            <polygon
              points="1232.74 325.01 1232.26 329.99 1247.9 323.64 1247.58 318.94 1232.74 325.01"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1224.09,321.54a2.18,2.18,0,0,1,0,2.49c.55-.78.68-2.22.93-2.12Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1229.2,323.59a6.87,6.87,0,0,0,3.06-3.1l-2.2,3.44Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1238.87,322.5a2.26,2.26,0,0,1,1.21,2l-.36-2.3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1244.29,317.2c-.15-.08-3.06.59-4.81,0a7,7,0,0,1-3.51.25s2.57-.25,3.51.63A20.66,20.66,0,0,1,1244.29,317.2Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1237,337.81l3.31,1.59a1.31,1.31,0,0,0,1,.05l7.94-2.74c.72-.25.86-1,.26-1.39h0a1.33,1.33,0,0,0-.84-.19l-11.25,1.15C1236.45,336.39,1236.16,337.4,1237,337.81Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1242.89 331.47 1238.42 332.2 1234.47 334.54 1241.08 336.59 1249.18 334.03 1242.89 331.47"
              fill="#ffedc8"
            />
            <polygon
              points="1234.47 334.54 1234.47 336.59 1240.82 338.69 1249.35 336.01 1249.18 334.03 1241.08 336.59 1234.47 334.54"
              fill="#ccae79"
            />
            <polygon
              points="1241.08 336.59 1240.82 338.69 1249.35 336.01 1249.18 334.03 1241.08 336.59"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1236.36,335.13a.76.76,0,0,1,0,1.05c.3-.33.37-.94.5-.9Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1239.15,336a3.54,3.54,0,0,0,1.66-1.31l-1.19,1.46Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1244.42,335.53s.72.29.66.83l-.19-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1247.38,333.3a10.26,10.26,0,0,1-2.62,0,5,5,0,0,1-1.92.1,4,4,0,0,1,1.92.27A14.21,14.21,0,0,1,1247.38,333.3Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1228,347.56l3.3,1.59a1.41,1.41,0,0,0,1,.05l7.94-2.74c.72-.25.86-1,.27-1.39h0a1.3,1.3,0,0,0-.85-.19L1228.37,346C1227.37,346.13,1227.09,347.15,1228,347.56Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1233.82 341.21 1229.34 341.95 1225.4 344.29 1232.01 346.34 1240.1 343.77 1233.82 341.21"
              fill="#ffedc8"
            />
            <polygon
              points="1225.4 344.29 1225.4 346.34 1231.74 348.44 1240.28 345.76 1240.1 343.77 1232.01 346.34 1225.4 344.29"
              fill="#ccae79"
            />
            <polygon
              points="1232.01 346.34 1231.74 348.44 1240.28 345.76 1240.1 343.77 1232.01 346.34"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1227.28,344.87a.76.76,0,0,1,0,1.06c.3-.33.37-.94.51-.9Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1230.07,345.74a3.54,3.54,0,0,0,1.67-1.31l-1.2,1.45Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1235.35,345.28s.72.29.66.83l-.2-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1238.31,343a9.88,9.88,0,0,1-2.63,0,4.82,4.82,0,0,1-1.91.11,4,4,0,0,1,1.91.26A14.39,14.39,0,0,1,1238.31,343Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1152.6,289.4l4.68,2.91a1.54,1.54,0,0,0,1.43.1l11.24-5a1.52,1.52,0,0,0,.38-2.54h0a1.51,1.51,0,0,0-1.2-.36l-15.93,2.12A1.52,1.52,0,0,0,1152.6,289.4Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1160.91 277.77 1154.57 279.12 1148.99 283.41 1158.35 287.16 1169.81 282.47 1160.91 277.77"
              fill="#ffedc8"
            />
            <polygon
              points="1148.99 283.41 1148.99 287.16 1157.97 291.01 1170.06 286.1 1169.81 282.47 1158.35 287.16 1148.99 283.41"
              fill="#ccae79"
            />
            <polygon
              points="1158.35 287.16 1157.97 291.01 1170.06 286.1 1169.81 282.47 1158.35 287.16"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1151.66,284.48a1.68,1.68,0,0,1,0,1.92c.42-.6.52-1.71.72-1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.61,286.06a5.36,5.36,0,0,0,2.36-2.4l-1.7,2.67Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1163.08,285.22a1.74,1.74,0,0,1,.93,1.52l-.28-1.79Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1167.27,281.13c-.12-.07-2.37.45-3.72,0a5.44,5.44,0,0,1-2.71.19s2-.2,2.71.48A16.08,16.08,0,0,1,1167.27,281.13Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1138.08,214.27l5.72,3.55a1.87,1.87,0,0,0,1.75.12l13.75-6.15a1.86,1.86,0,0,0,.46-3.1h0a1.88,1.88,0,0,0-1.47-.44l-19.48,2.59A1.86,1.86,0,0,0,1138.08,214.27Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1148.24 200.04 1140.49 201.69 1133.66 206.93 1145.11 211.52 1159.12 205.78 1148.24 200.04"
              fill="#ffedc8"
            />
            <polygon
              points="1133.66 206.93 1133.66 211.52 1144.64 216.23 1159.43 210.23 1159.12 205.78 1145.11 211.52 1133.66 206.93"
              fill="#ccae79"
            />
            <polygon
              points="1145.11 211.52 1144.64 216.23 1159.43 210.23 1159.12 205.78 1145.11 211.52"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1136.93,208.24a2.07,2.07,0,0,1,0,2.36c.51-.74.63-2.1.87-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1141.76,210.18a6.52,6.52,0,0,0,2.88-2.93l-2.07,3.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1150.89,209.15A2.15,2.15,0,0,1,1152,211l-.35-2.19Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156,204.14c-.15-.07-2.9.56-4.55,0a6.47,6.47,0,0,1-3.32.23s2.43-.23,3.32.6A19.88,19.88,0,0,1,1156,204.14Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1139,177.29l2.23,1.38a.72.72,0,0,0,.67.05l5.34-2.39a.73.73,0,0,0,.18-1.21h0a.79.79,0,0,0-.57-.17l-7.56,1A.72.72,0,0,0,1139,177.29Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1142.95 171.77 1139.94 172.41 1137.29 174.45 1141.73 176.23 1147.17 174 1142.95 171.77"
              fill="#ffedc8"
            />
            <polygon
              points="1137.29 174.45 1137.29 176.23 1141.55 178.05 1147.29 175.72 1147.17 174 1141.73 176.23 1137.29 174.45"
              fill="#ccae79"
            />
            <polygon
              points="1141.73 176.23 1141.55 178.05 1147.29 175.72 1147.17 174 1141.73 176.23"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1138.56,175a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1140.43,175.71a2.55,2.55,0,0,0,1.12-1.14l-.8,1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1144,175.31a.82.82,0,0,1,.44.72l-.13-.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1146,173.36a5.2,5.2,0,0,1-1.77,0,2.56,2.56,0,0,1-1.29.09s.95-.09,1.29.23A7.83,7.83,0,0,1,1146,173.36Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1119.24,174.48l3,1.86a1,1,0,0,0,.91.06l7.17-3.21a1,1,0,0,0,.24-1.62h0a1,1,0,0,0-.77-.22l-10.15,1.35A1,1,0,0,0,1119.24,174.48Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1124.54 167.07 1120.5 167.93 1116.94 170.66 1122.9 173.05 1130.21 170.06 1124.54 167.07"
              fill="#ffedc8"
            />
            <polygon
              points="1116.94 170.66 1116.94 173.05 1122.66 175.51 1130.36 172.38 1130.21 170.06 1122.9 173.05 1116.94 170.66"
              fill="#ccae79"
            />
            <polygon
              points="1122.9 173.05 1122.66 175.51 1130.36 172.38 1130.21 170.06 1122.9 173.05"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1118.64,171.34a1.09,1.09,0,0,1,0,1.23c.27-.38.33-1.09.46-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1121.16,172.35a3.39,3.39,0,0,0,1.5-1.53l-1.08,1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1125.92,171.82a1.09,1.09,0,0,1,.59,1l-.18-1.13Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1128.59,169.21a7.09,7.09,0,0,1-2.37,0,3.41,3.41,0,0,1-1.73.12s1.27-.12,1.73.31A9.83,9.83,0,0,1,1128.59,169.21Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1091.6,207.42l5.14,3.19a1.66,1.66,0,0,0,1.57.11l12.36-5.53a1.67,1.67,0,0,0,.42-2.79h0a1.68,1.68,0,0,0-1.32-.39l-17.51,2.33A1.67,1.67,0,0,0,1091.6,207.42Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1100.73 194.63 1093.77 196.11 1087.63 200.83 1097.91 204.95 1110.52 199.79 1100.73 194.63"
              fill="#ffedc8"
            />
            <polygon
              points="1087.63 200.83 1087.63 204.95 1097.5 209.18 1110.79 203.79 1110.52 199.79 1097.91 204.95 1087.63 200.83"
              fill="#ccae79"
            />
            <polygon
              points="1097.91 204.95 1097.5 209.18 1110.79 203.79 1110.52 199.79 1097.91 204.95"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1090.56,202a1.87,1.87,0,0,1,0,2.12c.47-.66.58-1.89.79-1.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1094.9,203.74a5.86,5.86,0,0,0,2.6-2.63l-1.87,2.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1103.12,202.82a1.9,1.9,0,0,1,1,1.67l-.3-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1107.72,198.32c-.13-.07-2.6.5-4.09,0a6,6,0,0,1-3,.21s2.19-.22,3,.53A17.73,17.73,0,0,1,1107.72,198.32Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1070.71,194.07l5.29,3.28a1.71,1.71,0,0,0,1.6.11l12.69-5.67a1.72,1.72,0,0,0,.43-2.87h0a1.75,1.75,0,0,0-1.35-.41l-18,2.4A1.72,1.72,0,0,0,1070.71,194.07Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1080.09 180.94 1072.94 182.46 1066.64 187.3 1077.2 191.54 1090.13 186.24 1080.09 180.94"
              fill="#ffedc8"
            />
            <polygon
              points="1066.64 187.3 1066.64 191.54 1076.77 195.88 1090.41 190.34 1090.13 186.24 1077.2 191.54 1066.64 187.3"
              fill="#ccae79"
            />
            <polygon
              points="1077.2 191.54 1076.77 195.88 1090.41 190.34 1090.13 186.24 1077.2 191.54"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1069.65,188.51a1.92,1.92,0,0,1,0,2.18c.48-.69.59-1.94.81-1.85Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1074.11,190.3a6,6,0,0,0,2.66-2.71l-1.91,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1082.54,189.35a2,2,0,0,1,1,1.71l-.31-2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1087.27,184.73c-.14-.07-2.67.51-4.2,0a6,6,0,0,1-3.06.21s2.24-.22,3.06.55A18.43,18.43,0,0,1,1087.27,184.73Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1101.54,179.92l2.87,1.78a.92.92,0,0,0,.87.06l6.87-3.07a.93.93,0,0,0,.23-1.56h0a1,1,0,0,0-.73-.22l-9.74,1.3A.93.93,0,0,0,1101.54,179.92Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1106.63 172.81 1102.75 173.63 1099.33 176.25 1105.06 178.55 1112.07 175.68 1106.63 172.81"
              fill="#ffedc8"
            />
            <polygon
              points="1099.33 176.25 1099.33 178.55 1104.83 180.91 1112.22 177.9 1112.07 175.68 1105.06 178.55 1099.33 176.25"
              fill="#ccae79"
            />
            <polygon
              points="1105.06 178.55 1104.83 180.91 1112.22 177.9 1112.07 175.68 1105.06 178.55"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1101,176.91a1,1,0,0,1,0,1.18c.25-.37.31-1.05.43-1S1101,176.91,1101,176.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1103.38,177.88a3.3,3.3,0,0,0,1.45-1.47l-1,1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1108,177.36a1.07,1.07,0,0,1,.57.93l-.17-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1110.51,174.86a6.76,6.76,0,0,1-2.27,0,3.2,3.2,0,0,1-1.66.11s1.22-.11,1.66.3A9.82,9.82,0,0,1,1110.51,174.86Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1142.36,166.31l6,3.72a2,2,0,0,0,1.83.13l14.41-6.44a2,2,0,0,0,.48-3.26h0a1.94,1.94,0,0,0-1.53-.46l-20.41,2.71A2,2,0,0,0,1142.36,166.31Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1153.02 151.4 1144.89 153.13 1137.73 158.63 1149.73 163.43 1164.42 157.42 1153.02 151.4"
              fill="#ffedc8"
            />
            <polygon
              points="1137.73 158.63 1137.73 163.43 1149.24 168.37 1164.73 162.08 1164.42 157.42 1149.73 163.43 1137.73 158.63"
              fill="#ccae79"
            />
            <polygon
              points="1149.73 163.43 1149.24 168.37 1164.73 162.08 1164.42 157.42 1149.73 163.43"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1141.16,160a2.17,2.17,0,0,1,0,2.47c.54-.78.67-2.2.92-2.1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1146.22,162a6.81,6.81,0,0,0,3-3.08l-2.17,3.42Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1155.79,161a2.23,2.23,0,0,1,1.2,1.94l-.36-2.28Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1161.16,155.7c-.15-.08-3,.58-4.77,0a6.86,6.86,0,0,1-3.47.24s2.55-.24,3.47.63A20.81,20.81,0,0,1,1161.16,155.7Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1162.27,164s1,2.07,2.49,2.42,3.64-1.1,3.31.1,2.73,1.72,4,1.4,4.21-3.14,4.19-4S1162.27,164,1162.27,164Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1162.22,162.28l0,1.7,2.5,1.74,3.24-.09.76,1.24s2.24,1,3.73-.1a12.05,12.05,0,0,0,2.62-3.14l0-1.7Z"
              fill="#ccae79"
            />
            <path
              d="M1164.82,161.1l-2.6,1.18,2.68,1.73,3.1-.09,1,1.28s3,.82,3.42-.09a18.8,18.8,0,0,1,2.62-3.18l-2.43-1Z"
              fill="#ffedc8"
            />
            <polygon
              points="1164.9 164.01 1164.77 165.72 1168.01 165.63 1168 163.93 1164.9 164.01"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1171.68,165.52s.53,1.54,0,1.65a7.45,7.45,0,0,0,3.4-3.54l0-1.7S1172.39,165.51,1171.68,165.52Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1169.59,165.33l.61.11s-.38-.1-.29.62A1.7,1.7,0,0,0,1169.59,165.33Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1171,165.55c-.06,0,.13,0,.68-.58a3.58,3.58,0,0,0,.75-1.16s-1.31,1.51-1,1.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1163.79,163.29a10.65,10.65,0,0,1,0,1.23s-.07-.93.19-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1168.55,161l1.23,0c.09,0-1,0-1.22.58V161"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1163.53,161.69l.65-.3s-.37.24-.22.28.72.29,1,.16a1,1,0,0,1,.62,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1096.31,223.55s2,4,4.77,4.63,7-2.09,6.32.19,5.23,3.3,7.75,2.68,8-6,8-7.71S1096.31,223.55,1096.31,223.55Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1096.23,220.3l.08,3.25,4.78,3.33,6.2-.17,1.47,2.38s4.27,2,7.12-.19a23.11,23.11,0,0,0,5-6l-.09-3.25Z"
              fill="#ccae79"
            />
            <path
              d="M1101.2,218.06l-5,2.24,5.12,3.31,5.92-.16,2,2.44s5.82,1.57,6.53-.17,5-6.08,5-6.08l-4.65-2Z"
              fill="#ffedc8"
            />
            <polygon
              points="1101.35 223.61 1101.09 226.88 1107.29 226.71 1107.27 223.45 1101.35 223.61"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1114.31,226.5s1,3,.09,3.16a14.25,14.25,0,0,0,6.48-6.77l-.09-3.25S1115.67,226.48,1114.31,226.5Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1110.31,226.14l1.18.21s-.73-.19-.55,1.18A3.32,3.32,0,0,0,1110.31,226.14Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1113,226.56c-.13-.05.23,0,1.28-1.1a6.75,6.75,0,0,0,1.44-2.23s-2.51,2.9-1.89,3.3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1099.22,222.24a18.57,18.57,0,0,1,.07,2.35s-.14-1.77.35-2.08Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1108.32,217.87l2.35-.07c.18,0-1.84,0-2.32,1.11l0-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1098.73,219.17l1.24-.55s-.7.44-.42.53,1.38.54,1.82.3a1.83,1.83,0,0,1,1.18,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1130.86,223.67s1.56,3.1,3.74,3.63,5.47-1.64,5,.15,4.11,2.59,6.09,2.1,6.32-4.71,6.29-6.05S1130.86,223.67,1130.86,223.67Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1130.79,221.11l.07,2.56,3.75,2.61,4.86-.13,1.16,1.87s3.35,1.56,5.59-.15a18.31,18.31,0,0,0,3.93-4.73l-.07-2.55Z"
              fill="#ccae79"
            />
            <path
              d="M1134.7,219.35l-3.91,1.76,4,2.6,4.64-.12,1.56,1.91s4.57,1.23,5.13-.14,3.93-4.77,3.93-4.77l-3.66-1.55Z"
              fill="#ffedc8"
            />
            <polygon
              points="1134.82 223.72 1134.61 226.28 1139.47 226.15 1139.46 223.59 1134.82 223.72"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1145,226s.8,2.32.07,2.48a11.2,11.2,0,0,0,5.09-5.32l-.07-2.55S1146.06,226,1145,226Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1141.85,225.7l.92.17s-.57-.15-.43.92A2.58,2.58,0,0,0,1141.85,225.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1144,226c-.1,0,.18,0,1-.86a5.63,5.63,0,0,0,1.13-1.76s-2,2.28-1.49,2.6Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1133.14,222.63a14.48,14.48,0,0,1,0,1.85s-.1-1.39.28-1.63Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1140.29,219.2l1.84,0c.14,0-1.45,0-1.82.87l0-.82"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1132.76,220.23l1-.44s-.55.35-.33.42,1.08.42,1.43.24a1.39,1.39,0,0,1,.93,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1194,273.82s1.84,3.64,4.4,4.26,6.41-1.93,5.81.17,4.82,3,7.13,2.47,7.42-5.53,7.39-7.1S1194,273.82,1194,273.82Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1193.89,270.83l.08,3,4.4,3.06,5.71-.15,1.35,2.19s3.94,1.83,6.56-.18a21.17,21.17,0,0,0,4.6-5.53l-.08-3Z"
              fill="#ccae79"
            />
            <path
              d="M1198.48,268.76l-4.59,2.07,4.72,3.05,5.45-.15,1.83,2.24s5.36,1.45,6-.16,4.61-5.59,4.61-5.59l-4.28-1.83Z"
              fill="#ffedc8"
            />
            <polygon
              points="1198.61 273.88 1198.38 276.88 1204.08 276.73 1204.06 273.73 1198.61 273.88"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1210.55,276.53s.93,2.72.07,2.91a13.05,13.05,0,0,0,6-6.23l-.08-3S1211.8,276.51,1210.55,276.53Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1206.86,276.2l1.09.2s-.68-.18-.51,1.08A3.07,3.07,0,0,0,1206.86,276.2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1209.34,276.59c-.12,0,.21,0,1.18-1a6.33,6.33,0,0,0,1.32-2.06s-2.31,2.67-1.74,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1196.65,272.61a18.65,18.65,0,0,1,.06,2.16s-.12-1.63.33-1.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1205,268.58l2.17-.05c.15,0-1.71,0-2.15,1l0-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1196.2,269.79l1.14-.52s-.64.42-.38.5,1.27.49,1.67.27a1.7,1.7,0,0,1,1.09,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1185.43,232.85s-1.26,2.5-3,2.93-4.4-1.32-4,.12-3.3,2.08-4.89,1.69-5.09-3.79-5.06-4.87S1185.43,232.85,1185.43,232.85Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1185.48,230.8l0,2-3,2.11-3.91-.11-.93,1.5s-2.7,1.26-4.5-.12a14.52,14.52,0,0,1-3.16-3.8l0-2.05Z"
              fill="#ccae79"
            />
            <path
              d="M1182.34,229.38l3.14,1.42-3.24,2.09-3.73-.1-1.26,1.54s-3.67,1-4.12-.11-3.17-3.84-3.17-3.84l2.94-1.25Z"
              fill="#ffedc8"
            />
            <polygon
              points="1182.24 232.89 1182.41 234.96 1178.5 234.85 1178.51 232.79 1182.24 232.89"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1174.06,234.72s-.65,1.86-.06,2a8.94,8.94,0,0,1-4.09-4.28l0-2.05S1173.2,234.7,1174.06,234.72Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1176.58,234.49l-.74.13s.46-.12.35.75A2.14,2.14,0,0,1,1176.58,234.49Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1174.89,234.75c.08,0-.15,0-.81-.69a4.24,4.24,0,0,1-.91-1.41s1.58,1.83,1.19,2.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1183.59,232a11.73,11.73,0,0,0,0,1.49s.09-1.12-.23-1.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1177.84,229.26l-1.48,0c-.11,0,1.16,0,1.47.7v-.66"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1183.9,230.09l-.78-.35s.44.28.26.33-.87.34-1.15.19a1.17,1.17,0,0,0-.74,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1162.43,272.89s-1,2.08-2.5,2.43-3.66-1.1-3.32.1-2.74,1.73-4.06,1.41-4.22-3.15-4.2-4.05S1162.43,272.89,1162.43,272.89Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1162.47,271.19l0,1.7-2.51,1.75-3.25-.09-.77,1.25s-2.24,1-3.73-.1a12.2,12.2,0,0,1-2.62-3.15l0-1.71Z"
              fill="#ccae79"
            />
            <path
              d="M1159.86,270l2.61,1.17-2.69,1.74-3.1-.09-1,1.28s-3.05.82-3.42-.09a18.51,18.51,0,0,0-2.63-3.19l2.44-1Z"
              fill="#ffedc8"
            />
            <polygon
              points="1159.78 272.93 1159.92 274.64 1156.67 274.55 1156.68 272.84 1159.78 272.93"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1153,274.44s-.53,1.55,0,1.66a7.49,7.49,0,0,1-3.4-3.55l0-1.71S1152.28,274.43,1153,274.44Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1155.09,274.25l-.62.11s.38-.1.29.62A1.77,1.77,0,0,1,1155.09,274.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1153.68,274.47c.07,0-.12,0-.67-.57a3.59,3.59,0,0,1-.76-1.18s1.32,1.52,1,1.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1160.9,272.21a10.65,10.65,0,0,0,0,1.23s.07-.93-.19-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156.13,269.91l-1.23,0c-.09,0,1,0,1.22.58v-.55"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1161.16,270.6l-.65-.29s.36.23.22.28-.72.28-1,.16a.91.91,0,0,0-.62,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1200.28,390.5s-1,2.08-2.5,2.43-3.65-1.1-3.32.1-2.74,1.73-4.06,1.4-4.22-3.15-4.2-4S1200.28,390.5,1200.28,390.5Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1200.32,388.8l0,1.7-2.51,1.75-3.25-.09-.77,1.25s-2.24,1-3.73-.1a12.17,12.17,0,0,1-2.62-3.16l0-1.7Z"
              fill="#ccae79"
            />
            <path
              d="M1197.71,387.62l2.61,1.18-2.69,1.74-3.1-.09-1,1.28s-3,.82-3.42-.09a18.56,18.56,0,0,0-2.62-3.19l2.43-1Z"
              fill="#ffedc8"
            />
            <polygon
              points="1197.63 390.54 1197.77 392.25 1194.53 392.16 1194.53 390.45 1197.63 390.54"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1190.84,392.05s-.53,1.55,0,1.66a7.49,7.49,0,0,1-3.4-3.56l0-1.7S1190.13,392,1190.84,392.05Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1192.94,391.86l-.62.11s.38-.1.29.62A1.77,1.77,0,0,1,1192.94,391.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1191.53,392.08c.07,0-.12,0-.67-.58a3.71,3.71,0,0,1-.76-1.17s1.32,1.52,1,1.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1198.75,389.81a10.87,10.87,0,0,0,0,1.24s.07-.93-.19-1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1194,387.52l-1.23,0c-.09,0,1,0,1.22.58v-.55"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1199,388.21l-.65-.29s.36.23.22.28-.72.28-1,.15a1,1,0,0,0-.62,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1190.54,423.06s-1.8,3.57-4.29,4.17-6.27-1.88-5.69.17-4.7,3-7,2.41-7.24-5.4-7.21-6.94S1190.54,423.06,1190.54,423.06Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1190.62,420.14l-.08,2.92-4.3,3-5.58-.15-1.32,2.14s-3.85,1.79-6.41-.17a20.84,20.84,0,0,1-4.5-5.41l.08-2.93Z"
              fill="#ccae79"
            />
            <path
              d="M1186.14,418.12l4.48,2-4.62,3-5.32-.14-1.79,2.19s-5.24,1.41-5.87-.16-4.51-5.47-4.51-5.47l4.19-1.78Z"
              fill="#ffedc8"
            />
            <polygon
              points="1186 423.12 1186.24 426.06 1180.66 425.91 1180.68 422.98 1186 423.12"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1174.34,425.72s-.92,2.66-.08,2.84a12.8,12.8,0,0,1-5.83-6.09l.08-2.93S1173.12,425.7,1174.34,425.72Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1177.94,425.39l-1.06.2s.66-.17.5,1.06A3,3,0,0,1,1177.94,425.39Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1175.52,425.77c.12,0-.21,0-1.15-1a6.22,6.22,0,0,1-1.3-2s2.26,2.61,1.7,3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1187.92,421.88a18,18,0,0,0-.06,2.12s.12-1.59-.32-1.87Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1179.73,418l-2.11-.06c-.16,0,1.66,0,2.09,1l0-.94"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1188.36,419.13l-1.11-.51s.62.41.37.49-1.24.48-1.63.27a1.67,1.67,0,0,0-1.07,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M1339.74,135.86c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1339.74,135.86Z"
                fill="#2f6840"
              />
              <path
                d="M1339.23,135.51c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16S1347,136.1,1346,136s-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1339.23,135.51Z"
                fill="#3ba525"
              />
              <path
                d="M1340,135.48a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1340,135.48Z"
                fill="#2f6840"
              />
              <path
                d="M1343.46,134.69a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1343.46,134.69Z"
                fill="#2f6840"
              />
              <path
                d="M1342.09,137.9a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1342.09,137.9Z"
                fill="#2f6840"
              />
              <path
                d="M1340.14,135.94c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2.07,2.07,0,0,1,1340.14,135.94Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1337.08,144.58c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,1337.08,144.58Z"
                fill="#2f6840"
              />
              <path
                d="M1336.57,144.24c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1336.57,144.24Z"
                fill="#3ba525"
              />
              <path
                d="M1337.32,144.21a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1337.32,144.21Z"
                fill="#2f6840"
              />
              <path
                d="M1340.8,143.42c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1340.8,143.42Z"
                fill="#2f6840"
              />
              <path
                d="M1339.43,146.63a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1339.43,146.63Z"
                fill="#2f6840"
              />
              <path
                d="M1337.48,144.67c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1337.48,144.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1331.72,139.63c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1331.72,139.63Z"
                fill="#2f6840"
              />
              <path
                d="M1331.22,139.28c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1331.22,139.28Z"
                fill="#3ba525"
              />
              <path
                d="M1332,139.25a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1332,139.25Z"
                fill="#2f6840"
              />
              <path
                d="M1335.45,138.46a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1335.45,138.46Z"
                fill="#2f6840"
              />
              <path
                d="M1334.08,141.67a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1334.08,141.67Z"
                fill="#2f6840"
              />
              <path
                d="M1332.12,139.71c-.24.06-.47.09-.69.16a4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1332.12,139.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1323.38,136.26c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1323.38,136.26Z"
                fill="#2f6840"
              />
              <path
                d="M1322.88,135.91c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1322.88,135.91Z"
                fill="#3ba525"
              />
              <path
                d="M1323.63,135.88a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1323.63,135.88Z"
                fill="#2f6840"
              />
              <path
                d="M1327.11,135.09c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1327.11,135.09Z"
                fill="#2f6840"
              />
              <path
                d="M1325.74,138.3a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1325.74,138.3Z"
                fill="#2f6840"
              />
              <path
                d="M1323.78,136.34c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1323.78,136.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1338.09,151.74c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1338.09,151.74Z"
                fill="#2f6840"
              />
              <path
                d="M1337.58,151.4c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1337.58,151.4Z"
                fill="#3ba525"
              />
              <path
                d="M1338.33,151.37a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1338.33,151.37Z"
                fill="#2f6840"
              />
              <path
                d="M1341.81,150.58c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1341.81,150.58Z"
                fill="#2f6840"
              />
              <path
                d="M1340.44,153.79a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1340.44,153.79Z"
                fill="#2f6840"
              />
              <path
                d="M1338.49,151.83c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1338.49,151.83Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1324.63,146.18c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1324.63,146.18Z"
                fill="#2f6840"
              />
              <path
                d="M1324.12,145.83c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1324.12,145.83Z"
                fill="#3ba525"
              />
              <path
                d="M1324.88,145.8a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1324.88,145.8Z"
                fill="#2f6840"
              />
              <path
                d="M1328.35,145c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1328.35,145Z"
                fill="#2f6840"
              />
              <path
                d="M1327,148.22a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1327,148.22Z"
                fill="#2f6840"
              />
              <path
                d="M1325,146.26c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1325,146.26Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1352,111.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1352,111.57Z"
                fill="#2f6840"
              />
              <path
                d="M1351.47,111.22c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1351.47,111.22Z"
                fill="#3ba525"
              />
              <path
                d="M1352.23,111.2a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1352.23,111.2Z"
                fill="#2f6840"
              />
              <path
                d="M1355.7,110.4c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1355.7,110.4Z"
                fill="#2f6840"
              />
              <path
                d="M1354.34,113.61a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1354.34,113.61Z"
                fill="#2f6840"
              />
              <path
                d="M1352.38,111.66a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1352.38,111.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1349.32,120.3c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1349.32,120.3Z"
                fill="#2f6840"
              />
              <path
                d="M1348.81,120c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1348.81,120Z"
                fill="#3ba525"
              />
              <path
                d="M1349.57,119.93a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1349.57,119.93Z"
                fill="#2f6840"
              />
              <path
                d="M1353,119.13c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1353,119.13Z"
                fill="#2f6840"
              />
              <path
                d="M1351.68,122.34a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1351.68,122.34Z"
                fill="#2f6840"
              />
              <path
                d="M1349.72,120.38c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1349.72,120.38Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1344,115.34c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1344,115.34Z"
                fill="#2f6840"
              />
              <path
                d="M1343.46,115c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1343.46,115Z"
                fill="#3ba525"
              />
              <path
                d="M1344.21,115a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1344.21,115Z"
                fill="#2f6840"
              />
              <path
                d="M1347.69,114.17c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1347.69,114.17Z"
                fill="#2f6840"
              />
              <path
                d="M1346.32,117.38a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1346.32,117.38Z"
                fill="#2f6840"
              />
              <path
                d="M1344.37,115.43c-.25.06-.48.08-.7.15a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1344.37,115.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1335.63,112c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1335.63,112Z"
                fill="#2f6840"
              />
              <path
                d="M1335.12,111.62c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1335.12,111.62Z"
                fill="#3ba525"
              />
              <path
                d="M1335.87,111.6a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1335.87,111.6Z"
                fill="#2f6840"
              />
              <path
                d="M1339.35,110.8c-.26,0-.49,0-.72.1a3.56,3.56,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1339.35,110.8Z"
                fill="#2f6840"
              />
              <path
                d="M1338,114a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1338,114Z"
                fill="#2f6840"
              />
              <path
                d="M1336,112.05c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1336,112.05Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1350.33,127.46c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1350.33,127.46Z"
                fill="#2f6840"
              />
              <path
                d="M1349.82,127.11c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1349.82,127.11Z"
                fill="#3ba525"
              />
              <path
                d="M1350.58,127.08a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1350.58,127.08Z"
                fill="#2f6840"
              />
              <path
                d="M1354.05,126.29c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1354.05,126.29Z"
                fill="#2f6840"
              />
              <path
                d="M1352.69,129.5a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1352.69,129.5Z"
                fill="#2f6840"
              />
              <path
                d="M1350.73,127.54c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1350.73,127.54Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1336.87,121.89c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1336.87,121.89Z"
                fill="#2f6840"
              />
              <path
                d="M1336.37,121.54c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1336.37,121.54Z"
                fill="#3ba525"
              />
              <path
                d="M1337.12,121.52a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1337.12,121.52Z"
                fill="#2f6840"
              />
              <path
                d="M1340.6,120.72c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1340.6,120.72Z"
                fill="#2f6840"
              />
              <path
                d="M1339.23,123.93a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1339.23,123.93Z"
                fill="#2f6840"
              />
              <path
                d="M1337.27,122c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1337.27,122Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1343.28,85.33c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1343.28,85.33Z"
                fill="#2f6840"
              />
              <path
                d="M1342.78,85c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,1342.78,85Z"
                fill="#3ba525"
              />
              <path
                d="M1343.53,85a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1343.53,85Z"
                fill="#2f6840"
              />
              <path
                d="M1347,84.16c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1347,84.16Z"
                fill="#2f6840"
              />
              <path
                d="M1345.64,87.37a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1345.64,87.37Z"
                fill="#2f6840"
              />
              <path
                d="M1343.68,85.42a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1343.68,85.42Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1340.62,94.06c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1340.62,94.06Z"
                fill="#2f6840"
              />
              <path
                d="M1340.12,93.71c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1340.12,93.71Z"
                fill="#3ba525"
              />
              <path
                d="M1340.87,93.69a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1340.87,93.69Z"
                fill="#2f6840"
              />
              <path
                d="M1344.35,92.89c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1344.35,92.89Z"
                fill="#2f6840"
              />
              <path
                d="M1343,96.1a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1343,96.1Z"
                fill="#2f6840"
              />
              <path
                d="M1341,94.14c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1341,94.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1335.27,89.1c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1335.27,89.1Z"
                fill="#2f6840"
              />
              <path
                d="M1334.76,88.76c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1334.76,88.76Z"
                fill="#3ba525"
              />
              <path
                d="M1335.52,88.73a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1335.52,88.73Z"
                fill="#2f6840"
              />
              <path
                d="M1339,87.93c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1339,87.93Z"
                fill="#2f6840"
              />
              <path
                d="M1337.63,91.14a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1337.63,91.14Z"
                fill="#2f6840"
              />
              <path
                d="M1335.67,89.19a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1335.67,89.19Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1326.93,85.73c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1326.93,85.73Z"
                fill="#2f6840"
              />
              <path
                d="M1326.42,85.38c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1326.42,85.38Z"
                fill="#3ba525"
              />
              <path
                d="M1327.17,85.36a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1327.17,85.36Z"
                fill="#2f6840"
              />
              <path
                d="M1330.65,84.56c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.07,2.07,0,0,1,1330.65,84.56Z"
                fill="#2f6840"
              />
              <path
                d="M1329.28,87.77a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1329.28,87.77Z"
                fill="#2f6840"
              />
              <path
                d="M1327.33,85.82a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1327.33,85.82Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1341.63,101.22c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1341.63,101.22Z"
                fill="#2f6840"
              />
              <path
                d="M1341.13,100.87c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1341.13,100.87Z"
                fill="#3ba525"
              />
              <path
                d="M1341.88,100.85a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1341.88,100.85Z"
                fill="#2f6840"
              />
              <path
                d="M1345.36,100.05c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1345.36,100.05Z"
                fill="#2f6840"
              />
              <path
                d="M1344,103.26a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1344,103.26Z"
                fill="#2f6840"
              />
              <path
                d="M1342,101.3c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1342,101.3Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1328.17,95.65c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1328.17,95.65Z"
                fill="#2f6840"
              />
              <path
                d="M1327.67,95.3c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1327.67,95.3Z"
                fill="#3ba525"
              />
              <path
                d="M1328.42,95.28a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1328.42,95.28Z"
                fill="#2f6840"
              />
              <path
                d="M1331.9,94.48c-.26,0-.49,0-.72.1a3.56,3.56,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1331.9,94.48Z"
                fill="#2f6840"
              />
              <path
                d="M1330.53,97.69a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1330.53,97.69Z"
                fill="#2f6840"
              />
              <path
                d="M1328.57,95.74a7,7,0,0,0-.69.15,4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1328.57,95.74Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1320.66,68.34c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1320.66,68.34Z"
                fill="#2f6840"
              />
              <path
                d="M1320.16,68c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1320.16,68Z"
                fill="#3ba525"
              />
              <path
                d="M1320.91,68a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1320.91,68Z"
                fill="#2f6840"
              />
              <path
                d="M1324.39,67.18c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1324.39,67.18Z"
                fill="#2f6840"
              />
              <path
                d="M1323,70.39a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1323,70.39Z"
                fill="#2f6840"
              />
              <path
                d="M1321.06,68.43c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1321.06,68.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1318,77.07c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1318,77.07Z"
                fill="#2f6840"
              />
              <path
                d="M1317.5,76.73c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1317.5,76.73Z"
                fill="#3ba525"
              />
              <path
                d="M1318.25,76.7a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1318.25,76.7Z"
                fill="#2f6840"
              />
              <path
                d="M1321.73,75.91c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1321.73,75.91Z"
                fill="#2f6840"
              />
              <path
                d="M1320.36,79.12a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1320.36,79.12Z"
                fill="#2f6840"
              />
              <path
                d="M1318.4,77.16c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1318.4,77.16Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1312.65,72.12c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1312.65,72.12Z"
                fill="#2f6840"
              />
              <path
                d="M1312.14,71.77c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1312.14,71.77Z"
                fill="#3ba525"
              />
              <path
                d="M1312.9,71.74a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1312.9,71.74Z"
                fill="#2f6840"
              />
              <path
                d="M1316.37,71c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.23-.86A2.07,2.07,0,0,1,1316.37,71Z"
                fill="#2f6840"
              />
              <path
                d="M1315,74.16a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1315,74.16Z"
                fill="#2f6840"
              />
              <path
                d="M1313.05,72.2c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1313.05,72.2Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1304.31,68.74c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1304.31,68.74Z"
                fill="#2f6840"
              />
              <path
                d="M1303.8,68.4c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1303.8,68.4Z"
                fill="#3ba525"
              />
              <path
                d="M1304.55,68.37a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1304.55,68.37Z"
                fill="#2f6840"
              />
              <path
                d="M1308,67.58c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1308,67.58Z"
                fill="#2f6840"
              />
              <path
                d="M1306.66,70.79a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1306.66,70.79Z"
                fill="#2f6840"
              />
              <path
                d="M1304.71,68.83c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1304.71,68.83Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1319,84.23c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1319,84.23Z"
                fill="#2f6840"
              />
              <path
                d="M1318.51,83.89c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55S1313.78,85,1314,85A14.56,14.56,0,0,1,1318.51,83.89Z"
                fill="#3ba525"
              />
              <path
                d="M1319.26,83.86a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1319.26,83.86Z"
                fill="#2f6840"
              />
              <path
                d="M1322.74,83.07c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1322.74,83.07Z"
                fill="#2f6840"
              />
              <path
                d="M1321.37,86.28a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8A2.13,2.13,0,0,1,1321,85a1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1321.37,86.28Z"
                fill="#2f6840"
              />
              <path
                d="M1319.41,84.32c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1319.41,84.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1305.55,78.66c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1305.55,78.66Z"
                fill="#2f6840"
              />
              <path
                d="M1305.05,78.32c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1305.05,78.32Z"
                fill="#3ba525"
              />
              <path
                d="M1305.8,78.29a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1305.8,78.29Z"
                fill="#2f6840"
              />
              <path
                d="M1309.28,77.5c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1309.28,77.5Z"
                fill="#2f6840"
              />
              <path
                d="M1307.91,80.71a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1307.91,80.71Z"
                fill="#2f6840"
              />
              <path
                d="M1306,78.75c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1306,78.75Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M1310.31,91.22l3.53,2.19a1.15,1.15,0,0,0,1.08.07l8.47-3.79a1.14,1.14,0,0,0,.28-1.91h0a1.13,1.13,0,0,0-.9-.27l-12,1.6A1.15,1.15,0,0,0,1310.31,91.22Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1316.58 82.45 1311.8 83.47 1307.59 86.7 1314.64 89.53 1323.28 85.99 1316.58 82.45"
              fill="#ffedc8"
            />
            <polygon
              points="1307.59 86.7 1307.59 89.53 1314.36 92.43 1323.47 88.73 1323.28 85.99 1314.64 89.53 1307.59 86.7"
              fill="#ccae79"
            />
            <polygon
              points="1314.64 89.53 1314.36 92.43 1323.47 88.73 1323.28 85.99 1314.64 89.53"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1309.61,87.51a1.28,1.28,0,0,1,0,1.45c.31-.46.39-1.29.53-1.24Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1312.58,88.7a4,4,0,0,0,1.78-1.81l-1.28,2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1318.21,88.07a1.29,1.29,0,0,1,.7,1.14l-.21-1.34Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1321.37,85a8.58,8.58,0,0,1-2.81,0,4,4,0,0,1-2,.14s1.5-.14,2,.37A12.31,12.31,0,0,1,1321.37,85Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1326.41,83.07l4.74,2.94a1.54,1.54,0,0,0,1.44.1L1344,81a1.54,1.54,0,0,0,.39-2.57h0a1.55,1.55,0,0,0-1.22-.36L1327,80.23A1.54,1.54,0,0,0,1326.41,83.07Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1334.83 71.3 1328.41 72.66 1322.76 77 1332.23 80.8 1343.83 76.05 1334.83 71.3"
              fill="#ffedc8"
            />
            <polygon
              points="1322.76 77 1322.76 80.8 1331.85 84.69 1344.08 79.73 1343.83 76.05 1332.23 80.8 1322.76 77"
              fill="#ccae79"
            />
            <polygon
              points="1332.23 80.8 1331.85 84.69 1344.08 79.73 1343.83 76.05 1332.23 80.8"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1325.46,78.09a1.71,1.71,0,0,1,0,2c.43-.62.53-1.74.73-1.66Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1329.46,79.69a5.43,5.43,0,0,0,2.39-2.43l-1.72,2.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1337,78.84a1.73,1.73,0,0,1,.94,1.53l-.28-1.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1341.26,74.69c-.12-.06-2.4.46-3.76,0a5.32,5.32,0,0,1-2.75.19s2-.19,2.75.5A16.21,16.21,0,0,1,1341.26,74.69Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1349,128.15l4,2.51a1.33,1.33,0,0,0,1.24.08l9.72-4.34a1.32,1.32,0,0,0,.32-2.2h0a1.33,1.33,0,0,0-1-.31l-13.77,1.83A1.32,1.32,0,0,0,1349,128.15Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1356.22 118.09 1350.74 119.25 1345.91 122.97 1354.01 126.21 1363.91 122.15 1356.22 118.09"
              fill="#ffedc8"
            />
            <polygon
              points="1345.91 122.97 1345.91 126.21 1353.68 129.53 1364.13 125.29 1363.91 122.15 1354.01 126.21 1345.91 122.97"
              fill="#ccae79"
            />
            <polygon
              points="1354.01 126.21 1353.68 129.53 1364.13 125.29 1363.91 122.15 1354.01 126.21"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1348.22,123.89a1.46,1.46,0,0,1,0,1.67c.37-.53.45-1.49.62-1.42Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1351.64,125.26a4.64,4.64,0,0,0,2-2.08l-1.47,2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1358.1,124.53a1.5,1.5,0,0,1,.8,1.31l-.24-1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1361.72,121a9.35,9.35,0,0,1-3.22,0,4.67,4.67,0,0,1-2.34.17s1.72-.17,2.34.42A13.81,13.81,0,0,1,1361.72,121Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1324.05,123.8l4,2.51a1.33,1.33,0,0,0,1.24.08l9.71-4.34a1.32,1.32,0,0,0,.33-2.2h0a1.31,1.31,0,0,0-1-.31l-13.76,1.83A1.32,1.32,0,0,0,1324.05,123.8Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1331.23 113.74 1325.75 114.91 1320.92 118.61 1329.01 121.86 1338.92 117.8 1331.23 113.74"
              fill="#ffedc8"
            />
            <polygon
              points="1320.92 118.61 1320.92 121.86 1328.69 125.19 1339.14 120.94 1338.92 117.8 1329.01 121.86 1320.92 118.61"
              fill="#ccae79"
            />
            <polygon
              points="1329.01 121.86 1328.69 125.19 1339.14 120.94 1338.92 117.8 1329.01 121.86"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1323.23,119.54a1.44,1.44,0,0,1,0,1.66c.37-.52.45-1.48.62-1.41Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1326.65,120.91a4.64,4.64,0,0,0,2-2.08l-1.47,2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1333.11,120.18a1.5,1.5,0,0,1,.8,1.31l-.24-1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1336.73,116.64a9.35,9.35,0,0,1-3.22,0,4.67,4.67,0,0,1-2.34.17s1.72-.17,2.34.42A13.81,13.81,0,0,1,1336.73,116.64Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1325.2,102.13l4.74,2.94a1.54,1.54,0,0,0,1.44.1l11.38-5.09a1.54,1.54,0,0,0,.38-2.57h0a1.52,1.52,0,0,0-1.21-.36l-16.12,2.14A1.54,1.54,0,0,0,1325.2,102.13Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1333.62 90.36 1327.2 91.72 1321.55 96.06 1331.02 99.86 1342.62 95.11 1333.62 90.36"
              fill="#ffedc8"
            />
            <polygon
              points="1321.55 96.06 1321.55 99.86 1330.64 103.76 1342.87 98.79 1342.62 95.11 1331.02 99.86 1321.55 96.06"
              fill="#ccae79"
            />
            <polygon
              points="1331.02 99.86 1330.64 103.76 1342.87 98.79 1342.62 95.11 1331.02 99.86"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1324.25,97.15a1.71,1.71,0,0,1,0,1.95c.43-.61.53-1.74.73-1.66Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1328.25,98.75a5.41,5.41,0,0,0,2.39-2.43l-1.72,2.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1335.81,97.9a1.73,1.73,0,0,1,.94,1.53l-.28-1.8Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1340.05,93.75c-.12-.06-2.4.47-3.77,0a5.37,5.37,0,0,1-2.74.2s2-.2,2.74.49A16.36,16.36,0,0,1,1340.05,93.75Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1347.51,94.26l3.53,2.19a1.13,1.13,0,0,0,1.07.07l8.48-3.78a1.15,1.15,0,0,0,.28-1.92h0a1.18,1.18,0,0,0-.9-.27l-12,1.6A1.15,1.15,0,0,0,1347.51,94.26Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1353.78 85.5 1349 86.51 1344.79 89.74 1351.84 92.57 1360.48 89.03 1353.78 85.5"
              fill="#ffedc8"
            />
            <polygon
              points="1344.79 89.74 1344.79 92.57 1351.56 95.47 1360.67 91.77 1360.48 89.03 1351.84 92.57 1344.79 89.74"
              fill="#ccae79"
            />
            <polygon
              points="1351.84 92.57 1351.56 95.47 1360.67 91.77 1360.48 89.03 1351.84 92.57"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1346.8,90.55a1.26,1.26,0,0,1,0,1.45c.32-.45.4-1.29.54-1.23S1346.8,90.55,1346.8,90.55Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1349.78,91.74a4,4,0,0,0,1.78-1.81l-1.28,2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1355.41,91.11a1.31,1.31,0,0,1,.7,1.14l-.21-1.34Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1358.57,88a8.3,8.3,0,0,1-2.81,0,4,4,0,0,1-2,.14s1.5-.14,2,.37A12.22,12.22,0,0,1,1358.57,88Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1328,134.55s1.85,3.67,4.43,4.3,6.47-1.95,5.87.17,4.85,3.07,7.19,2.49,7.48-5.58,7.45-7.17S1328,134.55,1328,134.55Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1328,131.53l.09,3,4.44,3.09,5.75-.16,1.36,2.21s4,1.86,6.62-.17a21.56,21.56,0,0,0,4.65-5.59l-.08-3Z"
              fill="#ccae79"
            />
            <path
              d="M1332.58,129.44l-4.63,2.09,4.77,3.07,5.49-.14,1.85,2.26s5.41,1.46,6.06-.16,4.66-5.65,4.66-5.65l-4.33-1.84Z"
              fill="#ffedc8"
            />
            <polygon
              points="1332.72 134.6 1332.48 137.64 1338.23 137.48 1338.21 134.46 1332.72 134.6"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1344.76,137.28s.94,2.75.08,2.94a13.21,13.21,0,0,0,6-6.29l-.08-3S1346,137.27,1344.76,137.28Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1341,137l1.09.2s-.68-.18-.51,1.09A3.08,3.08,0,0,0,1341,137Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1343.54,137.34c-.12,0,.21,0,1.19-1a6.37,6.37,0,0,0,1.34-2.08s-2.33,2.7-1.76,3.08Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1330.74,133.33a19,19,0,0,1,.06,2.18s-.13-1.64.33-1.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1339.19,129.27l2.19-.06c.16,0-1.72,0-2.16,1l0-1"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1330.28,130.48l1.15-.52s-.65.42-.39.5,1.29.5,1.69.28a1.69,1.69,0,0,1,1.1,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1218.38,180.15l4,2.52a1.31,1.31,0,0,0,1.23.08l9.72-4.34a1.32,1.32,0,0,0,.33-2.2h0a1.31,1.31,0,0,0-1-.31l-13.77,1.83A1.31,1.31,0,0,0,1218.38,180.15Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1225.57 170.1 1220.09 171.26 1215.26 174.97 1223.35 178.22 1233.26 174.16 1225.57 170.1"
              fill="#ffedc8"
            />
            <polygon
              points="1215.26 174.97 1215.26 178.22 1223.03 181.54 1233.47 177.3 1233.26 174.16 1223.35 178.22 1215.26 174.97"
              fill="#ccae79"
            />
            <polygon
              points="1223.35 178.22 1223.03 181.54 1233.47 177.3 1233.26 174.16 1223.35 178.22"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1217.57,175.9a1.44,1.44,0,0,1,0,1.66c.37-.52.45-1.48.62-1.41Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1221,177.27a4.64,4.64,0,0,0,2-2.08l-1.46,2.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1227.44,176.54a1.5,1.5,0,0,1,.81,1.31l-.24-1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1231.06,173a9.54,9.54,0,0,1-3.21,0,4.62,4.62,0,0,1-2.35.16s1.72-.16,2.35.42A14.13,14.13,0,0,1,1231.06,173Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1241.85,169.29l2.39,1.48a.8.8,0,0,0,.72,0l5.73-2.56a.78.78,0,0,0,.19-1.3h0a.78.78,0,0,0-.61-.18l-8.11,1.08A.78.78,0,0,0,1241.85,169.29Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1246.09 163.36 1242.86 164.05 1240.02 166.23 1244.78 168.15 1250.62 165.75 1246.09 163.36"
              fill="#ffedc8"
            />
            <polygon
              points="1240.02 166.23 1240.02 168.15 1244.59 170.11 1250.75 167.61 1250.62 165.75 1244.78 168.15 1240.02 166.23"
              fill="#ccae79"
            />
            <polygon
              points="1244.78 168.15 1244.59 170.11 1250.75 167.61 1250.62 165.75 1244.78 168.15"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1241.38,166.78a.86.86,0,0,1,0,1c.21-.31.26-.87.36-.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1243.39,167.59a2.76,2.76,0,0,0,1.2-1.23l-.87,1.36Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1247.19,167.16a.89.89,0,0,1,.48.77l-.14-.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1249.33,165.07a5.69,5.69,0,0,1-1.9,0,2.72,2.72,0,0,1-1.38.1s1-.1,1.38.25A8.36,8.36,0,0,1,1249.33,165.07Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1259.78,173.66l2.38,1.49a.79.79,0,0,0,.73,0l5.72-2.56a.77.77,0,0,0,.2-1.29h0a.76.76,0,0,0-.61-.18l-8.12,1.08A.77.77,0,0,0,1259.78,173.66Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1264.01 167.74 1260.78 168.43 1257.94 170.61 1262.7 172.52 1268.54 170.13 1264.01 167.74"
              fill="#ffedc8"
            />
            <polygon
              points="1257.94 170.61 1257.94 172.52 1262.51 174.48 1268.67 171.98 1268.54 170.13 1262.7 172.52 1257.94 170.61"
              fill="#ccae79"
            />
            <polygon
              points="1262.7 172.52 1262.51 174.48 1268.67 171.98 1268.54 170.13 1262.7 172.52"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1259.3,171.16a.86.86,0,0,1,0,1c.21-.31.26-.88.36-.84Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1261.31,172a2.7,2.7,0,0,0,1.2-1.22l-.86,1.36Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1265.12,171.53a.89.89,0,0,1,.47.78l-.14-.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1267.25,169.45a5.69,5.69,0,0,1-1.9,0,2.64,2.64,0,0,1-1.38.09s1-.09,1.38.25A8.25,8.25,0,0,1,1267.25,169.45Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1283.57,170.37l4,2.51a1.28,1.28,0,0,0,1.23.09l9.72-4.35a1.31,1.31,0,0,0,.32-2.19h0a1.29,1.29,0,0,0-1-.31L1284.09,168A1.31,1.31,0,0,0,1283.57,170.37Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1290.76 160.32 1285.28 161.48 1280.45 165.19 1288.54 168.43 1298.45 164.38 1290.76 160.32"
              fill="#ffedc8"
            />
            <polygon
              points="1280.45 165.19 1280.45 168.43 1288.21 171.76 1298.66 167.52 1298.45 164.38 1288.54 168.43 1280.45 165.19"
              fill="#ccae79"
            />
            <polygon
              points="1288.54 168.43 1288.21 171.76 1298.66 167.52 1298.45 164.38 1288.54 168.43"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1282.76,166.12a1.46,1.46,0,0,1,0,1.66c.36-.52.45-1.48.62-1.42Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1286.17,167.48a4.58,4.58,0,0,0,2-2.07l-1.47,2.3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1292.63,166.76a1.49,1.49,0,0,1,.81,1.31l-.25-1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1296.25,163.22a9.89,9.89,0,0,1-3.22,0,4.59,4.59,0,0,1-2.34.16s1.72-.17,2.34.42A14.19,14.19,0,0,1,1296.25,163.22Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1263.59,160.24l4,2.51a1.31,1.31,0,0,0,1.23.08l9.72-4.34a1.32,1.32,0,0,0,.33-2.2h0a1.35,1.35,0,0,0-1-.31l-13.76,1.83A1.32,1.32,0,0,0,1263.59,160.24Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1270.77 150.18 1265.29 151.35 1260.46 155.06 1268.55 158.3 1278.46 154.24 1270.77 150.18"
              fill="#ffedc8"
            />
            <polygon
              points="1260.46 155.06 1260.46 158.3 1268.23 161.63 1278.67 157.38 1278.46 154.24 1268.55 158.3 1260.46 155.06"
              fill="#ccae79"
            />
            <polygon
              points="1268.55 158.3 1268.23 161.63 1278.67 157.38 1278.46 154.24 1268.55 158.3"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1262.77,156a1.46,1.46,0,0,1,0,1.67c.37-.53.45-1.49.62-1.42Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1266.19,157.35a4.58,4.58,0,0,0,2-2.07l-1.47,2.3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1272.64,156.62a1.5,1.5,0,0,1,.81,1.31l-.24-1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1276.26,153.08a9.27,9.27,0,0,1-3.21,0,4.67,4.67,0,0,1-2.34.17s1.72-.17,2.34.42A13.76,13.76,0,0,1,1276.26,153.08Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1298.19,152.82s1.24,2.48,3,2.9,4.36-1.31,3.95.12,3.27,2.06,4.85,1.68,5-3.76,5-4.83S1298.19,152.82,1298.19,152.82Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1298.13,150.79l.06,2,3,2.08,3.87-.1.92,1.49s2.68,1.25,4.46-.12a14.51,14.51,0,0,0,3.13-3.76l-.06-2Z"
              fill="#ccae79"
            />
            <path
              d="M1301.24,149.39l-3.11,1.4,3.21,2.07,3.7-.1,1.24,1.53s3.64,1,4.09-.11,3.13-3.81,3.13-3.81l-2.91-1.24Z"
              fill="#ffedc8"
            />
            <polygon
              points="1301.34 152.86 1301.18 154.91 1305.05 154.8 1305.04 152.76 1301.34 152.86"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1309.45,154.67s.64,1.85,0,2a9,9,0,0,0,4.06-4.24l-.06-2S1310.3,154.65,1309.45,154.67Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1307,154.44l.73.14s-.46-.12-.35.73A2.06,2.06,0,0,0,1307,154.44Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1308.63,154.7c-.08,0,.14,0,.8-.68a4.33,4.33,0,0,0,.9-1.4s-1.57,1.81-1.18,2.07Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1300,152a13.86,13.86,0,0,1,0,1.47s-.09-1.11.22-1.3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1305.7,149.27l1.47,0c.11,0-1.16,0-1.45.69l0-.65"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1299.7,150.08l.77-.35s-.43.28-.26.34.86.34,1.14.19a1.1,1.1,0,0,1,.74,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1195.71,168.71s1.32,2.44,3.06,2.81,4.32-1.43,4,0,3.33,2,4.89,1.54,4.93-3.9,4.88-5S1195.71,168.71,1195.71,168.71Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1195.6,166.68l.11,2,3,2,3.87-.22,1,1.47s2.71,1.17,4.45-.25a14.49,14.49,0,0,0,3-3.85l-.11-2Z"
              fill="#ccae79"
            />
            <path
              d="M1198.67,165.19l-3.07,1.49,3.26,2,3.7-.2,1.28,1.49s3.67.87,4.09-.23,3-3.89,3-3.89l-3-1.16Z"
              fill="#ffedc8"
            />
            <polygon
              points="1198.86 168.66 1198.76 170.71 1202.63 170.49 1202.56 168.46 1198.86 168.66"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1207,170.24s.69,1.83.11,2a8.83,8.83,0,0,0,3.93-4.35l-.11-2S1207.87,170.2,1207,170.24Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1204.51,170.08l.74.12s-.46-.11-.32.74A2.14,2.14,0,0,0,1204.51,170.08Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1206.2,170.3c-.08,0,.15,0,.78-.71a4.33,4.33,0,0,0,.86-1.43s-1.51,1.86-1.12,2.11Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1197.51,167.84a12.14,12.14,0,0,1,.08,1.47s-.12-1.11.18-1.31Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1203.12,164.94l1.47-.08c.11,0-1.15.06-1.43.74l0-.66"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1197.15,165.93l.76-.37s-.43.29-.25.34.87.31,1.14.16a1.09,1.09,0,0,1,.74,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M42.57,161.22c5.23-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.65.31,2.65,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,42.57,161.22Z"
                fill="#2f6840"
              />
              <path
                d="M42,160.81c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.8A17.65,17.65,0,0,1,42,160.81Z"
                fill="#3ba525"
              />
              <path
                d="M42.86,160.78a2.45,2.45,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.12,2.12,0,0,1,.56.63A1.13,1.13,0,0,1,42.86,160.78Z"
                fill="#2f6840"
              />
              <path
                d="M47,159.84c-.31,0-.59,0-.86.11a5.22,5.22,0,0,0-.8.21,13.7,13.7,0,0,0-1.59.62,2.81,2.81,0,0,1,1.46-1A2.46,2.46,0,0,1,47,159.84Z"
                fill="#2f6840"
              />
              <path
                d="M45.36,163.63a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.57,2.57,0,0,1,1.44.65,2.13,2.13,0,0,1,.47.67A1.13,1.13,0,0,1,45.36,163.63Z"
                fill="#2f6840"
              />
              <path
                d="M43,161.32c-.29.07-.56.1-.82.19a3.44,3.44,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.36,2.36,0,0,1,43,161.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M39.43,171.54c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,4-3.55,3-2.67-2.69-2.46-2.8A17.12,17.12,0,0,1,39.43,171.54Z"
                fill="#2f6840"
              />
              <path
                d="M38.83,171.13c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.2,3.14,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.52,17.52,0,0,1,38.83,171.13Z"
                fill="#3ba525"
              />
              <path
                d="M39.72,171.1a2.51,2.51,0,0,0-.94-1.11c-.38-.32-.83-.54-1.27-.87a2.71,2.71,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,39.72,171.1Z"
                fill="#2f6840"
              />
              <path
                d="M43.83,170.16c-.3,0-.58.05-.86.11a4.49,4.49,0,0,0-.8.21,13.31,13.31,0,0,0-1.59.62,3,3,0,0,1,1.47-1A2.48,2.48,0,0,1,43.83,170.16Z"
                fill="#2f6840"
              />
              <path
                d="M42.21,174a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.08,1.08,0,0,1,42.21,174Z"
                fill="#2f6840"
              />
              <path
                d="M39.9,171.64c-.29.07-.56.1-.83.19a3.44,3.44,0,0,0-.76.27,10.94,10.94,0,0,0-1.48.76,2.65,2.65,0,0,1,1.32-1.15A2.36,2.36,0,0,1,39.9,171.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M33.1,165.68c5.23-.3-5.12.54-5.14-.73s5.14-3.1,6.24-2.9.31,2.66.31,2.66S36,161.43,38,162.16s4.29,4.21,3.14,4.07-5.56.06-5.56.06,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,33.1,165.68Z"
                fill="#2f6840"
              />
              <path
                d="M32.5,165.27c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.29,3.46-2.55,4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,32.5,165.27Z"
                fill="#3ba525"
              />
              <path
                d="M33.39,165.23a2.47,2.47,0,0,0-.94-1.1c-.38-.32-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,33.39,165.23Z"
                fill="#2f6840"
              />
              <path
                d="M37.5,164.29c-.3.05-.58.06-.85.12a4.28,4.28,0,0,0-.8.21,12.11,12.11,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.53,2.53,0,0,1,37.5,164.29Z"
                fill="#2f6840"
              />
              <path
                d="M35.89,168.09a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,35.89,168.09Z"
                fill="#2f6840"
              />
              <path
                d="M33.57,165.78c-.29.07-.56.1-.82.19a4,4,0,0,0-.76.26,11.63,11.63,0,0,0-1.48.77,2.7,2.7,0,0,1,1.31-1.16A2.41,2.41,0,0,1,33.57,165.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M23.24,161.69c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.47-3.28,3.46-2.55,4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.43,17.43,0,0,1,23.24,161.69Z"
                fill="#2f6840"
              />
              <path
                d="M22.64,161.28c5.23-.29-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.14,4.07-5.56,0-5.56,0,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.4,17.4,0,0,1,22.64,161.28Z"
                fill="#3ba525"
              />
              <path
                d="M23.53,161.25a2.51,2.51,0,0,0-.94-1.11c-.38-.31-.83-.54-1.27-.87a2.71,2.71,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,23.53,161.25Z"
                fill="#2f6840"
              />
              <path
                d="M27.64,160.31c-.3,0-.58.05-.85.11a5.34,5.34,0,0,0-.81.21c-.53.15-1,.4-1.59.62a2.88,2.88,0,0,1,1.47-1A2.43,2.43,0,0,1,27.64,160.31Z"
                fill="#2f6840"
              />
              <path
                d="M26,164.1a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.59-1.15-1a2.5,2.5,0,0,1,1.43.64,2,2,0,0,1,.48.67A1.08,1.08,0,0,1,26,164.1Z"
                fill="#2f6840"
              />
              <path
                d="M23.71,161.79c-.29.07-.56.11-.83.19a4.89,4.89,0,0,0-.76.27,12.23,12.23,0,0,0-1.48.76A2.65,2.65,0,0,1,22,161.86,2.41,2.41,0,0,1,23.71,161.79Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M40.62,180c5.23-.29-5.12.54-5.14-.72s5.14-3.11,6.24-2.9S42,179,42,179s1.47-3.28,3.47-2.55,4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2S41.25,181,41.25,181s-1.07,3.94-3.55,3-2.67-2.69-2.45-2.8A17.65,17.65,0,0,1,40.62,180Z"
                fill="#2f6840"
              />
              <path
                d="M40,179.59c5.24-.29-5.11.54-5.14-.72s5.14-3.1,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.11,1,4.7,1.82-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.79A17.21,17.21,0,0,1,40,179.59Z"
                fill="#3ba525"
              />
              <path
                d="M40.91,179.56a2.5,2.5,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.62,2.62,0,0,1,1.51.54,2.08,2.08,0,0,1,.56.62A1.13,1.13,0,0,1,40.91,179.56Z"
                fill="#2f6840"
              />
              <path
                d="M45,178.62a7.13,7.13,0,0,0-.86.12,4.26,4.26,0,0,0-.8.2,15.77,15.77,0,0,0-1.59.62,2.87,2.87,0,0,1,1.46-1A2.46,2.46,0,0,1,45,178.62Z"
                fill="#2f6840"
              />
              <path
                d="M43.41,182.42a2.32,2.32,0,0,0-.78-1.18c-.34-.34-.75-.59-1.15-1a2.62,2.62,0,0,1,1.44.64,2.18,2.18,0,0,1,.47.68A1.13,1.13,0,0,1,43.41,182.42Z"
                fill="#2f6840"
              />
              <path
                d="M41.09,180.1c-.29.07-.56.11-.82.19a4.89,4.89,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.68,2.68,0,0,1,1.31-1.15A2.41,2.41,0,0,1,41.09,180.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M24.71,173.42c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,4-3.55,3-2.66-2.69-2.45-2.8A17,17,0,0,1,24.71,173.42Z"
                fill="#2f6840"
              />
              <path
                d="M24.12,173c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66S27,168.77,29,169.5s4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.9,2.35-5.15,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.34,17.34,0,0,1,24.12,173Z"
                fill="#3ba525"
              />
              <path
                d="M25,173a2.53,2.53,0,0,0-1-1.11c-.38-.32-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.23,2.23,0,0,1,.55.63A1.19,1.19,0,0,1,25,173Z"
                fill="#2f6840"
              />
              <path
                d="M29.12,172c-.31,0-.59.05-.86.11a4.49,4.49,0,0,0-.8.21,12.68,12.68,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.51,2.51,0,0,1,29.12,172Z"
                fill="#2f6840"
              />
              <path
                d="M27.5,175.83a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.57,2.57,0,0,1,1.44.65,2.13,2.13,0,0,1,.47.67A1.13,1.13,0,0,1,27.5,175.83Z"
                fill="#2f6840"
              />
              <path
                d="M25.19,173.52a8.5,8.5,0,0,0-.83.19,3.44,3.44,0,0,0-.76.27,10.38,10.38,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.38,2.38,0,0,1,25.19,173.52Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M26.4,184.89c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.2,3.14,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2S27,185.93,27,185.93s-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.85,17.85,0,0,1,26.4,184.89Z"
                fill="#2f6840"
              />
              <path
                d="M25.8,184.48c5.23-.29-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55S35,185.18,33.81,185s-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.67-2.69-2.45-2.79A17.21,17.21,0,0,1,25.8,184.48Z"
                fill="#3ba525"
              />
              <path
                d="M26.69,184.45a2.56,2.56,0,0,0-.94-1.11c-.38-.31-.83-.54-1.27-.87A2.69,2.69,0,0,1,26,183a2.25,2.25,0,0,1,.56.63A1.18,1.18,0,0,1,26.69,184.45Z"
                fill="#2f6840"
              />
              <path
                d="M30.8,183.51a7.25,7.25,0,0,0-.85.12,4.36,4.36,0,0,0-.81.2c-.53.15-1,.4-1.59.62a2.88,2.88,0,0,1,1.47-1A2.43,2.43,0,0,1,30.8,183.51Z"
                fill="#2f6840"
              />
              <path
                d="M29.19,187.3a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.59-1.15-.95a2.56,2.56,0,0,1,1.43.64,2.11,2.11,0,0,1,.48.67A1.13,1.13,0,0,1,29.19,187.3Z"
                fill="#2f6840"
              />
              <path
                d="M26.87,185c-.29.07-.56.11-.82.19a5.41,5.41,0,0,0-.77.27,12.12,12.12,0,0,0-1.47.76,2.68,2.68,0,0,1,1.31-1.15A2.41,2.41,0,0,1,26.87,185Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M23.26,195.21c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.9,2.35-5.15,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.34,17.34,0,0,1,23.26,195.21Z"
                fill="#2f6840"
              />
              <path
                d="M22.66,194.8c5.23-.29-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55,0-5.55,0,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.31,17.31,0,0,1,22.66,194.8Z"
                fill="#3ba525"
              />
              <path
                d="M23.55,194.77a2.47,2.47,0,0,0-.95-1.11c-.38-.31-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.27,2.27,0,0,1,.56.63A1.18,1.18,0,0,1,23.55,194.77Z"
                fill="#2f6840"
              />
              <path
                d="M27.66,193.83c-.3,0-.58,0-.86.11a5.54,5.54,0,0,0-.8.21,16.76,16.76,0,0,0-1.59.62,2.85,2.85,0,0,1,1.46-1A2.46,2.46,0,0,1,27.66,193.83Z"
                fill="#2f6840"
              />
              <path
                d="M26,197.62a2.24,2.24,0,0,0-.78-1.17c-.33-.34-.75-.59-1.14-.95a2.53,2.53,0,0,1,1.43.64,2,2,0,0,1,.47.67A1.08,1.08,0,0,1,26,197.62Z"
                fill="#2f6840"
              />
              <path
                d="M23.73,195.31c-.29.07-.57.11-.83.19a4.89,4.89,0,0,0-.76.27,12.23,12.23,0,0,0-1.48.76A2.65,2.65,0,0,1,22,195.38,2.41,2.41,0,0,1,23.73,195.31Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M16.93,189.35c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66,1.47-3.29,3.46-2.56,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,4-3.55,3-2.67-2.69-2.46-2.8A17.21,17.21,0,0,1,16.93,189.35Z"
                fill="#2f6840"
              />
              <path
                d="M16.33,188.94c5.23-.29-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.2,3.14,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.15,2S17,190,17,190s-1.08,3.94-3.55,3-2.67-2.69-2.45-2.8A17.65,17.65,0,0,1,16.33,188.94Z"
                fill="#3ba525"
              />
              <path
                d="M17.22,188.91a2.51,2.51,0,0,0-.94-1.11c-.38-.31-.83-.54-1.27-.87a2.69,2.69,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,17.22,188.91Z"
                fill="#2f6840"
              />
              <path
                d="M21.33,188c-.3,0-.58.05-.85.11a5.34,5.34,0,0,0-.81.21c-.53.15-1,.4-1.59.62a2.88,2.88,0,0,1,1.47-1A2.43,2.43,0,0,1,21.33,188Z"
                fill="#2f6840"
              />
              <path
                d="M19.71,191.76a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.08,1.08,0,0,1,19.71,191.76Z"
                fill="#2f6840"
              />
              <path
                d="M17.4,189.45c-.29.07-.56.1-.82.19a3.35,3.35,0,0,0-.77.27,12.23,12.23,0,0,0-1.48.76,2.7,2.7,0,0,1,1.32-1.15A2.36,2.36,0,0,1,17.4,189.45Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M7.07,185.36c5.23-.29-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2S7.7,186.4,7.7,186.4s-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.22,17.22,0,0,1,7.07,185.36Z"
                fill="#2f6840"
              />
              <path
                d="M6.47,185c5.23-.3-5.12.54-5.15-.73s5.14-3.1,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.12,1,4.71,1.83-3.91,2.34-5.16,2S7.1,186,7.1,186,6,189.94,3.55,189s-2.67-2.69-2.46-2.8A17.12,17.12,0,0,1,6.47,185Z"
                fill="#3ba525"
              />
              <path
                d="M7.36,184.92a2.44,2.44,0,0,0-1-1.1c-.38-.32-.83-.55-1.26-.88a2.75,2.75,0,0,1,1.52.54,2.37,2.37,0,0,1,.56.62A1.19,1.19,0,0,1,7.36,184.92Z"
                fill="#2f6840"
              />
              <path
                d="M11.47,184a7.74,7.74,0,0,0-.86.12,4.46,4.46,0,0,0-.8.2,16.76,16.76,0,0,0-1.59.62,3,3,0,0,1,1.46-1A2.46,2.46,0,0,1,11.47,184Z"
                fill="#2f6840"
              />
              <path
                d="M9.85,187.78a2.2,2.2,0,0,0-.78-1.17c-.33-.34-.75-.6-1.14-1a2.59,2.59,0,0,1,1.43.64,2,2,0,0,1,.47.68A1.08,1.08,0,0,1,9.85,187.78Z"
                fill="#2f6840"
              />
              <path
                d="M7.54,185.47c-.29.06-.57.1-.83.18a4.89,4.89,0,0,0-.76.27,11,11,0,0,0-1.48.77,2.67,2.67,0,0,1,1.32-1.16A2.4,2.4,0,0,1,7.54,185.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M24.45,203.67c5.23-.29-5.12.54-5.15-.72s5.15-3.1,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.14,4.07-5.56.06-5.56.06,7.12,1,4.71,1.82-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.4,17.4,0,0,1,24.45,203.67Z"
                fill="#2f6840"
              />
              <path
                d="M23.85,203.27c5.23-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.91.31,2.66.31,2.66,1.47-3.28,3.47-2.55S33,204,31.86,203.83s-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,23.85,203.27Z"
                fill="#3ba525"
              />
              <path
                d="M24.74,203.23a2.48,2.48,0,0,0-.94-1.1c-.38-.32-.83-.54-1.27-.88a2.7,2.7,0,0,1,1.52.54,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,24.74,203.23Z"
                fill="#2f6840"
              />
              <path
                d="M28.85,202.29c-.3.05-.58.06-.85.12a5.33,5.33,0,0,0-.81.2,15.4,15.4,0,0,0-1.59.63,3,3,0,0,1,1.47-1A2.48,2.48,0,0,1,28.85,202.29Z"
                fill="#2f6840"
              />
              <path
                d="M27.24,206.09a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,27.24,206.09Z"
                fill="#2f6840"
              />
              <path
                d="M24.92,203.78c-.29.07-.56.1-.82.18a5.41,5.41,0,0,0-.77.27,10.94,10.94,0,0,0-1.47.77,2.65,2.65,0,0,1,1.31-1.16A2.41,2.41,0,0,1,24.92,203.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M8.54,197.09c5.23-.3-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.67-2.69-2.45-2.8A17.33,17.33,0,0,1,8.54,197.09Z"
                fill="#2f6840"
              />
              <path
                d="M7.94,196.68c5.24-.29-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3S2.36,198,2.57,197.94A17.21,17.21,0,0,1,7.94,196.68Z"
                fill="#3ba525"
              />
              <path
                d="M8.83,196.65a2.45,2.45,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.12,2.12,0,0,1,.56.63A1.13,1.13,0,0,1,8.83,196.65Z"
                fill="#2f6840"
              />
              <path
                d="M12.94,195.71c-.3,0-.58,0-.85.11a5.22,5.22,0,0,0-.8.21,15.77,15.77,0,0,0-1.59.62,2.81,2.81,0,0,1,1.46-1A2.43,2.43,0,0,1,12.94,195.71Z"
                fill="#2f6840"
              />
              <path
                d="M11.33,199.5a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.59-1.15-1a2.5,2.5,0,0,1,1.43.64,2,2,0,0,1,.48.67A1.13,1.13,0,0,1,11.33,199.5Z"
                fill="#2f6840"
              />
              <path
                d="M9,197.19c-.29.07-.56.11-.82.19a4.89,4.89,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.41,2.41,0,0,1,9,197.19Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M50.07,207.92c5.23-.3-5.12.54-5.15-.73s5.15-3.1,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.12,1,4.71,1.83-3.91,2.34-5.16,2S50.7,209,50.7,209s-1.08,4-3.55,3-2.67-2.69-2.46-2.8A17.21,17.21,0,0,1,50.07,207.92Z"
                fill="#2f6840"
              />
              <path
                d="M49.47,207.51c5.23-.3-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.65.31,2.65,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.08-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,4-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,49.47,207.51Z"
                fill="#3ba525"
              />
              <path
                d="M50.36,207.47a2.54,2.54,0,0,0-.94-1.1c-.38-.32-.83-.54-1.27-.87a2.69,2.69,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,50.36,207.47Z"
                fill="#2f6840"
              />
              <path
                d="M54.47,206.53c-.3.05-.58.06-.85.12a4.38,4.38,0,0,0-.81.21,13.31,13.31,0,0,0-1.59.62,3,3,0,0,1,1.47-1A2.53,2.53,0,0,1,54.47,206.53Z"
                fill="#2f6840"
              />
              <path
                d="M52.86,210.33a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,52.86,210.33Z"
                fill="#2f6840"
              />
              <path
                d="M50.54,208c-.29.07-.56.1-.82.18a5,5,0,0,0-.77.27,11.68,11.68,0,0,0-1.48.77,2.77,2.77,0,0,1,1.32-1.16A2.41,2.41,0,0,1,50.54,208Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M46.93,218.23c5.23-.29-5.12.54-5.15-.72s5.14-3.1,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.11,1,4.7,1.82-3.9,2.35-5.15,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.22,17.22,0,0,1,46.93,218.23Z"
                fill="#2f6840"
              />
              <path
                d="M46.33,217.83c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.34-5.16,2S47,218.86,47,218.86s-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17.12,17.12,0,0,1,46.33,217.83Z"
                fill="#3ba525"
              />
              <path
                d="M47.22,217.79a2.56,2.56,0,0,0-.95-1.1c-.38-.32-.83-.54-1.26-.88a2.75,2.75,0,0,1,1.52.54,2.09,2.09,0,0,1,.55.63A1.11,1.11,0,0,1,47.22,217.79Z"
                fill="#2f6840"
              />
              <path
                d="M51.33,216.85c-.3.05-.58.06-.86.12a4.49,4.49,0,0,0-.8.21,12.68,12.68,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.51,2.51,0,0,1,51.33,216.85Z"
                fill="#2f6840"
              />
              <path
                d="M49.71,220.65a2.24,2.24,0,0,0-.78-1.17c-.33-.34-.75-.6-1.14-1a2.54,2.54,0,0,1,1.43.65,1.89,1.89,0,0,1,.47.67A1.08,1.08,0,0,1,49.71,220.65Z"
                fill="#2f6840"
              />
              <path
                d="M47.4,218.34c-.29.07-.57.1-.83.18a4.89,4.89,0,0,0-.76.27,11,11,0,0,0-1.48.77,2.67,2.67,0,0,1,1.32-1.16A2.4,2.4,0,0,1,47.4,218.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M40.6,212.37c5.23-.29-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55,0-5.55,0,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.31,17.31,0,0,1,40.6,212.37Z"
                fill="#2f6840"
              />
              <path
                d="M40,212c5.23-.3-5.12.54-5.15-.73s5.15-3.1,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.14,4.07-5.56.06-5.56.06,7.12,1,4.71,1.83-3.91,2.34-5.16,2S40.63,213,40.63,213s-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17.21,17.21,0,0,1,40,212Z"
                fill="#3ba525"
              />
              <path
                d="M40.89,211.93a2.48,2.48,0,0,0-.94-1.1c-.38-.32-.83-.55-1.27-.88a2.72,2.72,0,0,1,1.52.54,2.21,2.21,0,0,1,.56.62A1.19,1.19,0,0,1,40.89,211.93Z"
                fill="#2f6840"
              />
              <path
                d="M45,211a7.74,7.74,0,0,0-.86.12,4.46,4.46,0,0,0-.8.2c-.53.15-1,.4-1.59.62a3,3,0,0,1,1.47-1A2.43,2.43,0,0,1,45,211Z"
                fill="#2f6840"
              />
              <path
                d="M43.38,214.79a2.18,2.18,0,0,0-.77-1.17c-.34-.34-.76-.6-1.15-1a2.56,2.56,0,0,1,1.43.64,2,2,0,0,1,.48.68A1.08,1.08,0,0,1,43.38,214.79Z"
                fill="#2f6840"
              />
              <path
                d="M41.07,212.48c-.29.06-.56.1-.83.18a4.89,4.89,0,0,0-.76.27,11,11,0,0,0-1.48.77,2.67,2.67,0,0,1,1.32-1.16A2.4,2.4,0,0,1,41.07,212.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M30.74,208.39c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.9,2.34-5.15,2-1.37-3.43-1.37-3.43-1.08,4-3.55,3-2.67-2.69-2.46-2.8A17,17,0,0,1,30.74,208.39Z"
                fill="#2f6840"
              />
              <path
                d="M30.14,208c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66S33,203.74,35,204.47s4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2S30.77,209,30.77,209s-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.43,17.43,0,0,1,30.14,208Z"
                fill="#3ba525"
              />
              <path
                d="M31,208a2.47,2.47,0,0,0-1-1.11c-.38-.32-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.27,2.27,0,0,1,.56.63A1.18,1.18,0,0,1,31,208Z"
                fill="#2f6840"
              />
              <path
                d="M35.14,207c-.3,0-.58.05-.86.11a4.49,4.49,0,0,0-.8.21,12.68,12.68,0,0,0-1.59.62,2.93,2.93,0,0,1,1.46-1A2.51,2.51,0,0,1,35.14,207Z"
                fill="#2f6840"
              />
              <path
                d="M33.52,210.8a2.24,2.24,0,0,0-.78-1.17c-.33-.34-.75-.6-1.14-1a2.54,2.54,0,0,1,1.43.65,2,2,0,0,1,.47.67A1.08,1.08,0,0,1,33.52,210.8Z"
                fill="#2f6840"
              />
              <path
                d="M31.21,208.49c-.29.07-.57.1-.83.19a3.44,3.44,0,0,0-.76.27,10.94,10.94,0,0,0-1.48.76,2.65,2.65,0,0,1,1.32-1.15A2.36,2.36,0,0,1,31.21,208.49Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M48.12,226.7c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66S51,222.45,53,223.18s4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,4-3.55,3-2.67-2.69-2.46-2.8A17.21,17.21,0,0,1,48.12,226.7Z"
                fill="#2f6840"
              />
              <path
                d="M47.52,226.29c5.23-.29-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.2,3.13,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.67-2.69-2.45-2.8A17.65,17.65,0,0,1,47.52,226.29Z"
                fill="#3ba525"
              />
              <path
                d="M48.41,226.26a2.51,2.51,0,0,0-.94-1.11c-.38-.31-.83-.54-1.27-.87a2.69,2.69,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,48.41,226.26Z"
                fill="#2f6840"
              />
              <path
                d="M52.52,225.32c-.3,0-.58.05-.85.11a5.34,5.34,0,0,0-.81.21,15.26,15.26,0,0,0-1.59.62,2.88,2.88,0,0,1,1.47-1A2.43,2.43,0,0,1,52.52,225.32Z"
                fill="#2f6840"
              />
              <path
                d="M50.91,229.11a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.13,1.13,0,0,1,50.91,229.11Z"
                fill="#2f6840"
              />
              <path
                d="M48.59,226.8c-.29.07-.56.1-.82.19a3.52,3.52,0,0,0-.77.27,13,13,0,0,0-1.48.76,2.7,2.7,0,0,1,1.32-1.15A2.36,2.36,0,0,1,48.59,226.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M32.21,220.11c5.23-.29-5.12.54-5.14-.72s5.14-3.1,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.07-5.56.06-5.56.06,7.12,1,4.71,1.82-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.08,3.94-3.55,3-2.67-2.69-2.45-2.79A17.21,17.21,0,0,1,32.21,220.11Z"
                fill="#2f6840"
              />
              <path
                d="M31.61,219.71c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3S26,221.07,26.24,221A17,17,0,0,1,31.61,219.71Z"
                fill="#3ba525"
              />
              <path
                d="M32.5,219.67a2.47,2.47,0,0,0-.94-1.1c-.38-.32-.83-.54-1.26-.88a2.69,2.69,0,0,1,1.51.54,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,32.5,219.67Z"
                fill="#2f6840"
              />
              <path
                d="M36.61,218.73c-.3.05-.58.06-.85.12a4.28,4.28,0,0,0-.8.21,12.11,12.11,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.48,2.48,0,0,1,36.61,218.73Z"
                fill="#2f6840"
              />
              <path
                d="M35,222.53a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,35,222.53Z"
                fill="#2f6840"
              />
              <path
                d="M32.68,220.22c-.29.07-.56.1-.82.18a4.89,4.89,0,0,0-.76.27,10.47,10.47,0,0,0-1.48.77,2.65,2.65,0,0,1,1.31-1.16A2.41,2.41,0,0,1,32.68,220.22Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M82,218.17c5.24-.29-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.9,2.35-5.15,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.65,17.65,0,0,1,82,218.17Z"
                fill="#2f6840"
              />
              <path
                d="M81.4,217.76c5.23-.29-5.12.54-5.15-.72s5.14-3.1,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.12,1,4.71,1.83-3.91,2.34-5.16,2S82,218.8,82,218.8s-1.08,3.95-3.55,3-2.67-2.7-2.46-2.8A17.22,17.22,0,0,1,81.4,217.76Z"
                fill="#3ba525"
              />
              <path
                d="M82.29,217.73a2.58,2.58,0,0,0-1-1.11c-.38-.31-.83-.54-1.26-.87a2.75,2.75,0,0,1,1.52.54,2.19,2.19,0,0,1,.55.62A1.14,1.14,0,0,1,82.29,217.73Z"
                fill="#2f6840"
              />
              <path
                d="M86.4,216.79a7.74,7.74,0,0,0-.86.12,4.46,4.46,0,0,0-.8.2,16.76,16.76,0,0,0-1.59.62,2.87,2.87,0,0,1,1.46-1A2.46,2.46,0,0,1,86.4,216.79Z"
                fill="#2f6840"
              />
              <path
                d="M84.78,220.59a2.32,2.32,0,0,0-.78-1.18c-.33-.34-.75-.59-1.14-.95a2.63,2.63,0,0,1,1.43.64,2,2,0,0,1,.47.68A1.13,1.13,0,0,1,84.78,220.59Z"
                fill="#2f6840"
              />
              <path
                d="M82.47,218.27c-.29.07-.57.11-.83.19a4.89,4.89,0,0,0-.76.27,12.23,12.23,0,0,0-1.48.76,2.7,2.7,0,0,1,1.32-1.15A2.41,2.41,0,0,1,82.47,218.27Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M78.85,228.49c5.23-.3-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.2,3.13,4.07-5.56,0-5.56,0,7.12,1,4.71,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.08,3.94-3.55,3-2.67-2.69-2.45-2.8A17.65,17.65,0,0,1,78.85,228.49Z"
                fill="#2f6840"
              />
              <path
                d="M78.25,228.08c5.24-.29-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.67-2.69-2.45-2.79A17.21,17.21,0,0,1,78.25,228.08Z"
                fill="#3ba525"
              />
              <path
                d="M79.14,228.05a2.5,2.5,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.25,2.25,0,0,1,.56.63A1.18,1.18,0,0,1,79.14,228.05Z"
                fill="#2f6840"
              />
              <path
                d="M83.25,227.11a7.25,7.25,0,0,0-.85.12,4.26,4.26,0,0,0-.8.2,15.77,15.77,0,0,0-1.59.62,2.87,2.87,0,0,1,1.46-1A2.43,2.43,0,0,1,83.25,227.11Z"
                fill="#2f6840"
              />
              <path
                d="M81.64,230.9a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.59-1.15-.95a2.56,2.56,0,0,1,1.43.64,2.11,2.11,0,0,1,.48.67A1.13,1.13,0,0,1,81.64,230.9Z"
                fill="#2f6840"
              />
              <path
                d="M79.32,228.59c-.29.07-.56.11-.82.19a4.89,4.89,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.68,2.68,0,0,1,1.31-1.15A2.41,2.41,0,0,1,79.32,228.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M72.52,222.63c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.29,3.46-2.55,4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.8A17.33,17.33,0,0,1,72.52,222.63Z"
                fill="#2f6840"
              />
              <path
                d="M71.93,222.22c5.23-.29-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.9,2.35-5.15,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.22,17.22,0,0,1,71.93,222.22Z"
                fill="#3ba525"
              />
              <path
                d="M72.82,222.19a2.53,2.53,0,0,0-.95-1.11c-.38-.31-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.23,2.23,0,0,1,.55.63A1.19,1.19,0,0,1,72.82,222.19Z"
                fill="#2f6840"
              />
              <path
                d="M76.93,221.25c-.31,0-.59.05-.86.11a5.54,5.54,0,0,0-.8.21,16.76,16.76,0,0,0-1.59.62,2.81,2.81,0,0,1,1.46-1A2.46,2.46,0,0,1,76.93,221.25Z"
                fill="#2f6840"
              />
              <path
                d="M75.31,225a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.59-1.15-1a2.56,2.56,0,0,1,1.44.64,2.13,2.13,0,0,1,.47.67A1.13,1.13,0,0,1,75.31,225Z"
                fill="#2f6840"
              />
              <path
                d="M73,222.73c-.3.07-.57.11-.83.19a4.89,4.89,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.38,2.38,0,0,1,73,222.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M62.66,218.64c5.23-.29-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.08,3.94-3.55,3-2.67-2.69-2.45-2.79A17.21,17.21,0,0,1,62.66,218.64Z"
                fill="#2f6840"
              />
              <path
                d="M62.06,218.24c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.66-2.69-2.45-2.8A17,17,0,0,1,62.06,218.24Z"
                fill="#3ba525"
              />
              <path
                d="M63,218.2a2.42,2.42,0,0,0-.94-1.1c-.38-.32-.83-.54-1.26-.88a2.69,2.69,0,0,1,1.51.54,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,63,218.2Z"
                fill="#2f6840"
              />
              <path
                d="M67.06,217.26c-.3.05-.58.06-.85.12a4.26,4.26,0,0,0-.8.2,13.8,13.8,0,0,0-1.59.63,2.89,2.89,0,0,1,1.46-1A2.48,2.48,0,0,1,67.06,217.26Z"
                fill="#2f6840"
              />
              <path
                d="M65.45,221.06a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,65.45,221.06Z"
                fill="#2f6840"
              />
              <path
                d="M63.13,218.75c-.29.07-.56.1-.82.18a4.89,4.89,0,0,0-.76.27,10.47,10.47,0,0,0-1.48.77,2.65,2.65,0,0,1,1.31-1.16A2.41,2.41,0,0,1,63.13,218.75Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M80,237c5.24-.3-5.11.54-5.14-.73s5.14-3.1,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.11,1,4.7,1.83-3.91,2.34-5.15,2S80.68,238,80.68,238s-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17,17,0,0,1,80,237Z"
                fill="#2f6840"
              />
              <path
                d="M79.45,236.55c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.29,3.46-2.56,4.28,4.21,3.13,4.08-5.55,0-5.55,0,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17,17,0,0,1,79.45,236.55Z"
                fill="#3ba525"
              />
              <path
                d="M80.34,236.51a2.56,2.56,0,0,0-1-1.1c-.38-.32-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.23,2.23,0,0,1,.55.63A1.12,1.12,0,0,1,80.34,236.51Z"
                fill="#2f6840"
              />
              <path
                d="M84.45,235.57c-.3.05-.58.06-.86.12a4.49,4.49,0,0,0-.8.21,12.68,12.68,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.56,2.56,0,0,1,84.45,235.57Z"
                fill="#2f6840"
              />
              <path
                d="M82.83,239.37a2.3,2.3,0,0,0-.78-1.17c-.33-.34-.75-.6-1.14-1a2.57,2.57,0,0,1,1.43.65,1.89,1.89,0,0,1,.47.67A1.13,1.13,0,0,1,82.83,239.37Z"
                fill="#2f6840"
              />
              <path
                d="M80.52,237.06c-.3.07-.57.1-.83.18a4.89,4.89,0,0,0-.76.27,11,11,0,0,0-1.48.77,2.72,2.72,0,0,1,1.32-1.16A2.4,2.4,0,0,1,80.52,237.06Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M64.14,230.37c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66S67,226.13,69,226.86s4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.66,17.66,0,0,1,64.14,230.37Z"
                fill="#2f6840"
              />
              <path
                d="M63.54,230c5.23-.29-5.12.54-5.15-.72s5.14-3.11,6.25-2.9S65,229,65,229s1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55,0-5.55,0,7.12,1,4.71,1.83-3.91,2.35-5.16,2S64.17,231,64.17,231s-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.31,17.31,0,0,1,63.54,230Z"
                fill="#3ba525"
              />
              <path
                d="M64.43,229.93a2.52,2.52,0,0,0-1-1.11c-.38-.31-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.41,2.41,0,0,1,.56.63A1.18,1.18,0,0,1,64.43,229.93Z"
                fill="#2f6840"
              />
              <path
                d="M68.54,229a7.74,7.74,0,0,0-.86.12,4.46,4.46,0,0,0-.8.2,16.76,16.76,0,0,0-1.59.62,2.91,2.91,0,0,1,1.46-1A2.46,2.46,0,0,1,68.54,229Z"
                fill="#2f6840"
              />
              <path
                d="M66.92,232.78a2.24,2.24,0,0,0-.78-1.17c-.33-.34-.75-.59-1.14-1a2.59,2.59,0,0,1,1.43.64,2.08,2.08,0,0,1,.47.67A1.08,1.08,0,0,1,66.92,232.78Z"
                fill="#2f6840"
              />
              <path
                d="M64.61,230.47c-.29.07-.57.11-.83.19a4.89,4.89,0,0,0-.76.27,12.23,12.23,0,0,0-1.48.76,2.7,2.7,0,0,1,1.32-1.15A2.41,2.41,0,0,1,64.61,230.47Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M113.46,230c5.23-.3-5.12.54-5.14-.72s5.14-3.11,6.24-2.91.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,4-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,113.46,230Z"
                fill="#2f6840"
              />
              <path
                d="M112.86,229.6c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.8A17.65,17.65,0,0,1,112.86,229.6Z"
                fill="#3ba525"
              />
              <path
                d="M113.75,229.57a2.45,2.45,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.12,2.12,0,0,1,.56.63A1.13,1.13,0,0,1,113.75,229.57Z"
                fill="#2f6840"
              />
              <path
                d="M117.87,228.63c-.31,0-.59.05-.86.11a4.28,4.28,0,0,0-.8.21,12.11,12.11,0,0,0-1.59.62,2.81,2.81,0,0,1,1.46-1A2.46,2.46,0,0,1,117.87,228.63Z"
                fill="#2f6840"
              />
              <path
                d="M116.25,232.42a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.13,1.13,0,0,1,116.25,232.42Z"
                fill="#2f6840"
              />
              <path
                d="M113.93,230.11c-.29.07-.56.1-.82.19a3.44,3.44,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.36,2.36,0,0,1,113.93,230.11Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M110.32,240.33c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17.12,17.12,0,0,1,110.32,240.33Z"
                fill="#2f6840"
              />
              <path
                d="M109.72,239.92c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66,1.47-3.29,3.46-2.55,4.29,4.2,3.13,4.07-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.52,17.52,0,0,1,109.72,239.92Z"
                fill="#3ba525"
              />
              <path
                d="M110.61,239.89a2.51,2.51,0,0,0-.94-1.11c-.38-.32-.83-.54-1.27-.87a2.71,2.71,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,110.61,239.89Z"
                fill="#2f6840"
              />
              <path
                d="M114.72,239c-.3,0-.58.05-.86.11a4.49,4.49,0,0,0-.8.21,13.31,13.31,0,0,0-1.59.62,2.91,2.91,0,0,1,1.47-1A2.48,2.48,0,0,1,114.72,239Z"
                fill="#2f6840"
              />
              <path
                d="M113.1,242.74a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.08,1.08,0,0,1,113.1,242.74Z"
                fill="#2f6840"
              />
              <path
                d="M110.79,240.43c-.29.07-.56.1-.83.19a3.44,3.44,0,0,0-.76.27,10.94,10.94,0,0,0-1.48.76A2.65,2.65,0,0,1,109,240.5,2.36,2.36,0,0,1,110.79,240.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M104,234.47c5.23-.3-5.12.54-5.14-.73s5.14-3.1,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.14,4.07-5.56.06-5.56.06,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,104,234.47Z"
                fill="#2f6840"
              />
              <path
                d="M103.39,234.06c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.29,3.47-2.56,4.28,4.21,3.13,4.08-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,103.39,234.06Z"
                fill="#3ba525"
              />
              <path
                d="M104.28,234a2.54,2.54,0,0,0-.94-1.1c-.38-.32-.83-.54-1.27-.87a2.69,2.69,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,104.28,234Z"
                fill="#2f6840"
              />
              <path
                d="M108.39,233.08c-.3,0-.58.06-.85.12a4.38,4.38,0,0,0-.81.21,12.56,12.56,0,0,0-1.58.62,2.89,2.89,0,0,1,1.46-1A2.53,2.53,0,0,1,108.39,233.08Z"
                fill="#2f6840"
              />
              <path
                d="M106.78,236.88a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,106.78,236.88Z"
                fill="#2f6840"
              />
              <path
                d="M104.46,234.57c-.29.07-.56.1-.82.18a4.89,4.89,0,0,0-.76.27,11.63,11.63,0,0,0-1.48.77,2.7,2.7,0,0,1,1.31-1.16A2.41,2.41,0,0,1,104.46,234.57Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M94.13,230.48c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66S97,226.23,99,227s4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.43,17.43,0,0,1,94.13,230.48Z"
                fill="#2f6840"
              />
              <path
                d="M93.53,230.07c5.23-.29-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.14,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.4,17.4,0,0,1,93.53,230.07Z"
                fill="#3ba525"
              />
              <path
                d="M94.42,230a2.51,2.51,0,0,0-.94-1.11c-.38-.31-.83-.54-1.27-.87a2.71,2.71,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,94.42,230Z"
                fill="#2f6840"
              />
              <path
                d="M98.53,229.1c-.3,0-.58.05-.86.11a5.54,5.54,0,0,0-.8.21c-.53.15-1,.4-1.59.62a2.88,2.88,0,0,1,1.47-1A2.43,2.43,0,0,1,98.53,229.1Z"
                fill="#2f6840"
              />
              <path
                d="M96.91,232.89a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.59-1.15-.95a2.5,2.5,0,0,1,1.43.64,2,2,0,0,1,.48.67A1.08,1.08,0,0,1,96.91,232.89Z"
                fill="#2f6840"
              />
              <path
                d="M94.6,230.58c-.29.07-.56.11-.83.19A4.89,4.89,0,0,0,93,231a12.23,12.23,0,0,0-1.48.76,2.65,2.65,0,0,1,1.32-1.15A2.36,2.36,0,0,1,94.6,230.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M111.51,248.79c5.23-.3-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.67-2.69-2.45-2.8A17.65,17.65,0,0,1,111.51,248.79Z"
                fill="#2f6840"
              />
              <path
                d="M110.91,248.38c5.24-.29-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.79A17.21,17.21,0,0,1,110.91,248.38Z"
                fill="#3ba525"
              />
              <path
                d="M111.8,248.35a2.5,2.5,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.25,2.25,0,0,1,.56.63A1.13,1.13,0,0,1,111.8,248.35Z"
                fill="#2f6840"
              />
              <path
                d="M115.91,247.41a7.25,7.25,0,0,0-.85.12,4.26,4.26,0,0,0-.8.2,15.77,15.77,0,0,0-1.59.62,2.87,2.87,0,0,1,1.46-1A2.43,2.43,0,0,1,115.91,247.41Z"
                fill="#2f6840"
              />
              <path
                d="M114.3,251.2a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.59-1.15-.95a2.56,2.56,0,0,1,1.43.64,2.11,2.11,0,0,1,.48.67A1.13,1.13,0,0,1,114.3,251.2Z"
                fill="#2f6840"
              />
              <path
                d="M112,248.89c-.29.07-.56.11-.82.19a4.89,4.89,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.68,2.68,0,0,1,1.31-1.15A2.41,2.41,0,0,1,112,248.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M95.6,242.21c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.66-2.69-2.45-2.8A17,17,0,0,1,95.6,242.21Z"
                fill="#2f6840"
              />
              <path
                d="M95,241.8c5.23-.3-5.12.54-5.15-.72S95,238,96.1,238.18s.32,2.66.32,2.66,1.46-3.29,3.46-2.55,4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.9,2.35-5.15,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.34,17.34,0,0,1,95,241.8Z"
                fill="#3ba525"
              />
              <path
                d="M95.9,241.77a2.53,2.53,0,0,0-1-1.11c-.38-.32-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.23,2.23,0,0,1,.55.63A1.19,1.19,0,0,1,95.9,241.77Z"
                fill="#2f6840"
              />
              <path
                d="M100,240.83c-.31,0-.59,0-.86.11a4.49,4.49,0,0,0-.8.21,12.68,12.68,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.51,2.51,0,0,1,100,240.83Z"
                fill="#2f6840"
              />
              <path
                d="M98.39,244.62a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.57,2.57,0,0,1,1.44.65,2.13,2.13,0,0,1,.47.67A1.13,1.13,0,0,1,98.39,244.62Z"
                fill="#2f6840"
              />
              <path
                d="M96.07,242.31c-.29.07-.56.1-.82.19a3.44,3.44,0,0,0-.76.27,10.38,10.38,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.36,2.36,0,0,1,96.07,242.31Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M142.48,247.05c5.23-.3-5.12.54-5.14-.73s5.14-3.1,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,142.48,247.05Z"
                fill="#2f6840"
              />
              <path
                d="M141.88,246.64c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.65.32,2.65,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,4-3.55,3-2.66-2.69-2.45-2.8A17,17,0,0,1,141.88,246.64Z"
                fill="#3ba525"
              />
              <path
                d="M142.77,246.6a2.47,2.47,0,0,0-.94-1.1c-.38-.32-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.12,2.12,0,0,1,.56.63A1.11,1.11,0,0,1,142.77,246.6Z"
                fill="#2f6840"
              />
              <path
                d="M146.89,245.66c-.31.05-.59.06-.86.12a4.28,4.28,0,0,0-.8.21,12.11,12.11,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.56,2.56,0,0,1,146.89,245.66Z"
                fill="#2f6840"
              />
              <path
                d="M145.27,249.46a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,145.27,249.46Z"
                fill="#2f6840"
              />
              <path
                d="M143,247.15c-.29.07-.56.1-.82.18a4.89,4.89,0,0,0-.76.27,10.47,10.47,0,0,0-1.48.77,2.7,2.7,0,0,1,1.31-1.16A2.41,2.41,0,0,1,143,247.15Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M139.34,257.36c5.23-.29-5.12.54-5.15-.72s5.14-3.1,6.24-2.9.32,2.66.32,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.12,1,4.71,1.82-3.91,2.35-5.16,2S140,258.4,140,258.4s-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.31,17.31,0,0,1,139.34,257.36Z"
                fill="#2f6840"
              />
              <path
                d="M138.74,257c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.91.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.13,4.08-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17.21,17.21,0,0,1,138.74,257Z"
                fill="#3ba525"
              />
              <path
                d="M139.63,256.92a2.54,2.54,0,0,0-.94-1.1c-.38-.32-.83-.54-1.27-.88a2.72,2.72,0,0,1,1.52.54,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,139.63,256.92Z"
                fill="#2f6840"
              />
              <path
                d="M143.74,256c-.3,0-.58.06-.86.12a4.49,4.49,0,0,0-.8.21,13.31,13.31,0,0,0-1.59.62,2.91,2.91,0,0,1,1.47-1A2.48,2.48,0,0,1,143.74,256Z"
                fill="#2f6840"
              />
              <path
                d="M142.12,259.78a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.08,1.08,0,0,1,142.12,259.78Z"
                fill="#2f6840"
              />
              <path
                d="M139.81,257.47c-.29.07-.56.1-.83.18a4.89,4.89,0,0,0-.76.27,11,11,0,0,0-1.48.77,2.67,2.67,0,0,1,1.32-1.16A2.4,2.4,0,0,1,139.81,257.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M133,251.5c5.23-.29-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.14,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.45-2.79A17.21,17.21,0,0,1,133,251.5Z"
                fill="#2f6840"
              />
              <path
                d="M132.41,251.1c5.23-.3-5.11.54-5.14-.73s5.14-3.1,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,132.41,251.1Z"
                fill="#3ba525"
              />
              <path
                d="M133.3,251.06a2.48,2.48,0,0,0-.94-1.1c-.38-.32-.83-.55-1.27-.88a2.7,2.7,0,0,1,1.52.54,2.21,2.21,0,0,1,.56.62A1.19,1.19,0,0,1,133.3,251.06Z"
                fill="#2f6840"
              />
              <path
                d="M137.41,250.12a7.25,7.25,0,0,0-.85.12,4.36,4.36,0,0,0-.81.2,16.6,16.6,0,0,0-1.58.62,2.93,2.93,0,0,1,1.46-1A2.43,2.43,0,0,1,137.41,250.12Z"
                fill="#2f6840"
              />
              <path
                d="M135.8,253.92a2.25,2.25,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.56,2.56,0,0,1,1.43.64,2,2,0,0,1,.48.68A1.13,1.13,0,0,1,135.8,253.92Z"
                fill="#2f6840"
              />
              <path
                d="M133.48,251.61c-.29.06-.56.1-.82.18a4.89,4.89,0,0,0-.76.27,10.47,10.47,0,0,0-1.48.77,2.65,2.65,0,0,1,1.31-1.16A2.41,2.41,0,0,1,133.48,251.61Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M123.15,247.52c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66S126,243.27,128,244s4.28,4.21,3.13,4.08-5.55,0-5.55,0,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17.12,17.12,0,0,1,123.15,247.52Z"
                fill="#2f6840"
              />
              <path
                d="M122.55,247.11c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.2,3.14,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.52,17.52,0,0,1,122.55,247.11Z"
                fill="#3ba525"
              />
              <path
                d="M123.44,247.08a2.51,2.51,0,0,0-.94-1.11c-.38-.32-.83-.54-1.27-.87a2.71,2.71,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,123.44,247.08Z"
                fill="#2f6840"
              />
              <path
                d="M127.55,246.14c-.3,0-.58.05-.86.11a4.49,4.49,0,0,0-.8.21,13.31,13.31,0,0,0-1.59.62,2.91,2.91,0,0,1,1.47-1A2.48,2.48,0,0,1,127.55,246.14Z"
                fill="#2f6840"
              />
              <path
                d="M125.93,249.93a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.08,1.08,0,0,1,125.93,249.93Z"
                fill="#2f6840"
              />
              <path
                d="M123.62,247.62c-.29.07-.56.1-.83.19a3.44,3.44,0,0,0-.76.27,10.94,10.94,0,0,0-1.48.76,2.65,2.65,0,0,1,1.32-1.15A2.36,2.36,0,0,1,123.62,247.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M140.53,265.83c5.23-.3-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.29,3.47-2.56,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,140.53,265.83Z"
                fill="#2f6840"
              />
              <path
                d="M139.93,265.42c5.24-.29-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.8A17.65,17.65,0,0,1,139.93,265.42Z"
                fill="#3ba525"
              />
              <path
                d="M140.82,265.39a2.45,2.45,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.12,2.12,0,0,1,.56.63A1.13,1.13,0,0,1,140.82,265.39Z"
                fill="#2f6840"
              />
              <path
                d="M144.93,264.45c-.3,0-.58.05-.85.11a5.22,5.22,0,0,0-.8.21,15.77,15.77,0,0,0-1.59.62,2.81,2.81,0,0,1,1.46-1A2.43,2.43,0,0,1,144.93,264.45Z"
                fill="#2f6840"
              />
              <path
                d="M143.32,268.24a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.13,1.13,0,0,1,143.32,268.24Z"
                fill="#2f6840"
              />
              <path
                d="M141,265.93c-.29.07-.56.1-.82.19a3.44,3.44,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.36,2.36,0,0,1,141,265.93Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M124.62,259.24c5.24-.29-5.11.54-5.14-.72s5.14-3.1,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.11,1,4.7,1.82-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.79A17.21,17.21,0,0,1,124.62,259.24Z"
                fill="#2f6840"
              />
              <path
                d="M124,258.84c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.9,2.34-5.15,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17,17,0,0,1,124,258.84Z"
                fill="#3ba525"
              />
              <path
                d="M124.92,258.8a2.56,2.56,0,0,0-1-1.1c-.38-.32-.83-.54-1.26-.88a2.75,2.75,0,0,1,1.52.54,2.23,2.23,0,0,1,.55.63A1.16,1.16,0,0,1,124.92,258.8Z"
                fill="#2f6840"
              />
              <path
                d="M129,257.86c-.31.05-.59.06-.86.12a4.49,4.49,0,0,0-.8.21,12.68,12.68,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.51,2.51,0,0,1,129,257.86Z"
                fill="#2f6840"
              />
              <path
                d="M127.41,261.66a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.57,2.57,0,0,1,1.44.65,2,2,0,0,1,.47.67A1.13,1.13,0,0,1,127.41,261.66Z"
                fill="#2f6840"
              />
              <path
                d="M125.09,259.35c-.29.07-.56.1-.82.18a4.89,4.89,0,0,0-.76.27,10.47,10.47,0,0,0-1.48.77,2.65,2.65,0,0,1,1.31-1.16A2.41,2.41,0,0,1,125.09,259.35Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M106,221.83s-1.53,5.14-4.41,6.43-7.79-1.33-6.75,1.32-5.1,4.91-7.9,4.59-9.56-5.89-9.78-8S106,221.83,106,221.83Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M105.63,217.87l.4,4-4.62,4.86-6.67.86-1.21,3.15s-4.28,3.15-7.67,1a26.65,26.65,0,0,1-6.29-6.42l-.4-4Z"
              fill="#ccae79"
            />
            <path
              d="M99.94,216l5.69,1.86-5,4.9-6.37.83-1.76,3.3s-6,2.91-7,.91-6.3-6.5-6.3-6.5l4.69-3.21Z"
              fill="#ffedc8"
            />
            <polygon
              points="100.63 222.77 101.41 226.69 94.74 227.55 94.26 223.6 100.63 222.77"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M87.17,228.51s-.64,3.76.39,3.85a16.16,16.16,0,0,1-8-7.09l-.4-4S85.71,228.72,87.17,228.51Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M91.4,227.38l-1.22.47s.75-.36.77,1.33A4.56,4.56,0,0,1,91.4,227.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M88.59,228.35c.13-.07-.25.07-1.55-1.1a8.39,8.39,0,0,1-1.89-2.47s3.14,3.09,2.54,3.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M102.71,220.74a25.35,25.35,0,0,0,.29,2.86s-.13-2.17-.7-2.46Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M92.28,217l-2.54.33c-.18,0,2-.27,2.67.94L92.27,217"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M102.76,216.93l-1.41-.46s.82.42.53.58-1.4.89-1.9.68-1.27.24-1.27.24Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M40.2,215.81s2.07,4.45,4.87,5.15,7-2.5,6.34.1,5.29,3.64,7.81,2.89,8-7,7.91-8.9S40.2,215.81,40.2,215.81Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M40.06,212.13l.14,3.68,4.85,3.68,6.21-.31,1.52,2.67s4.32,2.18,7.13-.35a26,26,0,0,0,4.92-6.91l-.14-3.68Z"
              fill="#ccae79"
            />
            <path
              d="M45,209.49l-4.95,2.64,5.2,3.65,5.93-.29,2,2.72s5.87,1.67,6.55-.32,4.92-7,4.92-7L60,208.75Z"
              fill="#ffedc8"
            />
            <polygon
              points="45.26 215.78 45.05 219.49 51.26 219.18 51.19 215.49 45.26 215.78"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M58.3,218.8s1.08,3.34.14,3.59a15.79,15.79,0,0,0,6.39-7.8l-.14-3.68S59.67,218.76,58.3,218.8Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M54.29,218.47l1.18.22s-.74-.2-.53,1.35A4,4,0,0,0,54.29,218.47Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M57,218.9c-.13-.05.23,0,1.27-1.27a8.18,8.18,0,0,0,1.4-2.56s-2.46,3.34-1.84,3.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M43.1,214.26a26,26,0,0,1,.1,2.67s-.16-2,.33-2.37Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M52.15,209.13l2.36-.11c.17,0-1.85.08-2.31,1.3l-.05-1.19"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M42.56,210.8l1.23-.66s-.69.52-.41.62,1.39.58,1.83.3a1.62,1.62,0,0,1,1.18,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M15.35,189.05l6.6,4.63a1.94,1.94,0,0,0,2,.15l15.85-8a2.58,2.58,0,0,0,.53-4h0a2,2,0,0,0-1.69-.58L16.2,184.58C14.2,184.88,13.64,187.84,15.35,189.05Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="27.07 170.51 18.13 172.66 10.26 179.49 23.45 185.47 39.61 177.99 27.07 170.51"
              fill="#ffedc8"
            />
            <polygon
              points="10.26 179.49 10.26 185.47 22.92 191.61 39.96 183.79 39.61 177.99 23.45 185.47 10.26 179.49"
              fill="#ccae79"
            />
            <polygon
              points="23.45 185.47 22.92 191.61 39.96 183.79 39.61 177.99 23.45 185.47"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M14,181.2a3,3,0,0,1,0,3.07c.6-1,.74-2.74,1-2.61Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M19.59,183.72a7.94,7.94,0,0,0,3.33-3.82l-2.4,4.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M30.12,182.38a2.78,2.78,0,0,1,1.32,2.42L31,182Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M36,175.86c-.17-.1-3.34.72-5.25,0a6.74,6.74,0,0,1-3.82.3s2.81-.31,3.82.77A20.51,20.51,0,0,1,36,175.86Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M295.06,311.66l6.6,4.63a1.94,1.94,0,0,0,2,.15l15.85-8a2.58,2.58,0,0,0,.53-4h0a2,2,0,0,0-1.69-.58l-22.45,3.38C293.91,307.49,293.35,310.45,295.06,311.66Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="306.78 293.12 297.84 295.27 289.97 302.1 303.16 308.08 319.32 300.6 306.78 293.12"
              fill="#ffedc8"
            />
            <polygon
              points="289.97 302.1 289.97 308.08 302.63 314.22 319.67 306.4 319.32 300.6 303.16 308.08 289.97 302.1"
              fill="#ccae79"
            />
            <polygon
              points="303.16 308.08 302.63 314.22 319.67 306.4 319.32 300.6 303.16 308.08"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M293.73,303.81a3,3,0,0,1,0,3.07c.6-1,.74-2.74,1-2.61Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M299.3,306.33a7.94,7.94,0,0,0,3.33-3.82l-2.39,4.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M309.83,305a2.78,2.78,0,0,1,1.32,2.42l-.39-2.84Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M315.74,298.47c-.17-.1-3.34.72-5.24,0a6.78,6.78,0,0,1-3.83.3s2.81-.31,3.83.77A20.38,20.38,0,0,1,315.74,298.47Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M4.16,212l5.4,3.79a1.57,1.57,0,0,0,1.64.13l13-6.55a2.12,2.12,0,0,0,.43-3.31h0a1.6,1.6,0,0,0-1.38-.46L4.86,208.37A2.06,2.06,0,0,0,4.16,212Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="13.74 196.88 6.43 198.63 0 204.22 10.78 209.1 23.99 202.99 13.74 196.88"
              fill="#ffedc8"
            />
            <polygon
              points="0 204.22 0 209.1 10.35 214.12 24.28 207.73 23.99 202.99 10.78 209.1 0 204.22"
              fill="#ccae79"
            />
            <polygon
              points="10.78 209.1 10.35 214.12 24.28 207.73 23.99 202.99 10.78 209.1"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M3.08,205.61a2.44,2.44,0,0,1,0,2.51c.49-.79.6-2.24.82-2.13Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M7.63,207.67a6.55,6.55,0,0,0,2.72-3.12l-2,3.47Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M16.24,206.58a2.25,2.25,0,0,1,1.07,2L17,206.23Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M21.06,201.25c-.13-.09-2.72.59-4.28,0a5.49,5.49,0,0,1-3.13.24s2.3-.25,3.13.64A16.21,16.21,0,0,1,21.06,201.25Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M22.2,229.73l5.4,3.78a1.57,1.57,0,0,0,1.64.13l13-6.55a2.12,2.12,0,0,0,.43-3.31h0a1.6,1.6,0,0,0-1.38-.46L22.9,226.08C21.26,226.32,20.8,228.74,22.2,229.73Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="31.78 214.58 24.48 216.33 18.04 221.92 28.82 226.81 42.03 220.69 31.78 214.58"
              fill="#ffedc8"
            />
            <polygon
              points="18.04 221.92 18.04 226.81 28.39 231.82 42.32 225.43 42.03 220.69 28.82 226.81 18.04 221.92"
              fill="#ccae79"
            />
            <polygon
              points="28.82 226.81 28.39 231.82 42.32 225.43 42.03 220.69 28.82 226.81"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M21.12,223.31a2.44,2.44,0,0,1,0,2.51c.49-.78.6-2.23.82-2.13Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M25.67,225.38a6.54,6.54,0,0,0,2.72-3.13l-2,3.47Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M34.28,224.28a2.26,2.26,0,0,1,1.07,2L35,223.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M39.1,219c-.13-.08-2.72.59-4.28,0a5.49,5.49,0,0,1-3.13.24s2.3-.25,3.13.64A16.65,16.65,0,0,1,39.1,219Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M41.07,236.16l3,2.11a.88.88,0,0,0,.91.07l7.22-3.65a1.18,1.18,0,0,0,.24-1.84h0a.9.9,0,0,0-.77-.26l-10.22,1.53A1.16,1.16,0,0,0,41.07,236.16Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="46.41 227.72 42.34 228.7 38.76 231.81 44.76 234.53 52.12 231.13 46.41 227.72"
              fill="#ffedc8"
            />
            <polygon
              points="38.76 231.81 38.76 234.53 44.52 237.32 52.28 233.76 52.12 231.13 44.76 234.53 38.76 231.81"
              fill="#ccae79"
            />
            <polygon
              points="44.76 234.53 44.52 237.32 52.28 233.76 52.12 231.13 44.76 234.53"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M40.47,232.59a1.34,1.34,0,0,1,0,1.39c.27-.43.34-1.24.46-1.18Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M43,233.74A3.6,3.6,0,0,0,44.52,232l-1.09,1.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M47.8,233.13a1.26,1.26,0,0,1,.6,1.1l-.18-1.3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M50.49,230.16a6.44,6.44,0,0,1-2.39,0,3,3,0,0,1-1.74.13s1.28-.14,1.74.36A9.11,9.11,0,0,1,50.49,230.16Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M390,332.07l3,2.11a.9.9,0,0,0,.92.07l7.21-3.64a1.19,1.19,0,0,0,.24-1.85h0a.93.93,0,0,0-.77-.26L390.41,330A1.14,1.14,0,0,0,390,332.07Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="395.36 323.64 391.29 324.61 387.71 327.73 393.71 330.45 401.07 327.04 395.36 323.64"
              fill="#ffedc8"
            />
            <polygon
              points="387.71 327.73 387.71 330.45 393.47 333.24 401.23 329.68 401.07 327.04 393.71 330.45 387.71 327.73"
              fill="#ccae79"
            />
            <polygon
              points="393.71 330.45 393.47 333.24 401.23 329.68 401.07 327.04 393.71 330.45"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M389.42,328.5a1.35,1.35,0,0,1,0,1.4c.27-.44.34-1.25.46-1.19Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M392,329.65a3.61,3.61,0,0,0,1.51-1.74l-1.09,1.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M396.75,329a1.26,1.26,0,0,1,.6,1.1l-.18-1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M399.44,326.07a6.44,6.44,0,0,1-2.39,0,3.1,3.1,0,0,1-1.74.14s1.28-.14,1.74.35A9.18,9.18,0,0,1,399.44,326.07Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M130,258.18l3,2.11a.88.88,0,0,0,.91.07l7.22-3.64a1.19,1.19,0,0,0,.24-1.85h0a.93.93,0,0,0-.77-.26l-10.22,1.54A1.15,1.15,0,0,0,130,258.18Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="135.37 249.75 131.3 250.72 127.71 253.83 133.72 256.56 141.07 253.15 135.37 249.75"
              fill="#ffedc8"
            />
            <polygon
              points="127.71 253.83 127.71 256.56 133.48 259.35 141.23 255.79 141.07 253.15 133.72 256.56 127.71 253.83"
              fill="#ccae79"
            />
            <polygon
              points="133.72 256.56 133.48 259.35 141.23 255.79 141.07 253.15 133.72 256.56"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M129.43,254.61a1.38,1.38,0,0,1,0,1.4c.27-.44.33-1.25.46-1.19Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M132,255.76a3.65,3.65,0,0,0,1.52-1.74L132.39,256Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M136.76,255.15a1.24,1.24,0,0,1,.59,1.1l-.17-1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M139.44,252.18a6.37,6.37,0,0,1-2.38,0,3.1,3.1,0,0,1-1.74.14s1.27-.14,1.74.35A9.06,9.06,0,0,1,139.44,252.18Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M135.25,246.48l3,2.11a.88.88,0,0,0,.91.07l7.22-3.65a1.18,1.18,0,0,0,.24-1.84h0a.9.9,0,0,0-.77-.26l-10.22,1.53A1.16,1.16,0,0,0,135.25,246.48Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="140.59 238.04 136.52 239.02 132.94 242.13 138.94 244.85 146.3 241.45 140.59 238.04"
              fill="#ffedc8"
            />
            <polygon
              points="132.94 242.13 132.94 244.85 138.7 247.64 146.46 244.09 146.3 241.45 138.94 244.85 132.94 242.13"
              fill="#ccae79"
            />
            <polygon
              points="138.94 244.85 138.7 247.64 146.46 244.09 146.3 241.45 138.94 244.85"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M134.65,242.91a1.34,1.34,0,0,1,0,1.39c.27-.43.34-1.24.46-1.18Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M137.19,244.06a3.61,3.61,0,0,0,1.51-1.74l-1.09,1.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M142,243.45a1.26,1.26,0,0,1,.6,1.09l-.18-1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M144.67,240.47a6,6,0,0,1-2.39,0,3,3,0,0,1-1.74.14s1.28-.14,1.74.35A9.56,9.56,0,0,1,144.67,240.47Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M114,251.83l3,2.11a.88.88,0,0,0,.91.07l7.22-3.64a1.19,1.19,0,0,0,.24-1.85h0a.93.93,0,0,0-.77-.26l-10.22,1.54A1.15,1.15,0,0,0,114,251.83Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="119.31 243.4 115.24 244.37 111.66 247.49 117.66 250.21 125.02 246.8 119.31 243.4"
              fill="#ffedc8"
            />
            <polygon
              points="111.66 247.49 111.66 250.21 117.42 253 125.18 249.44 125.02 246.8 117.66 250.21 111.66 247.49"
              fill="#ccae79"
            />
            <polygon
              points="117.66 250.21 117.42 253 125.18 249.44 125.02 246.8 117.66 250.21"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M113.37,248.26a1.35,1.35,0,0,1,0,1.4c.27-.44.34-1.25.46-1.19Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M115.9,249.41a3.6,3.6,0,0,0,1.52-1.74l-1.09,1.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M120.7,248.8a1.26,1.26,0,0,1,.6,1.1l-.18-1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M123.39,245.83a6.44,6.44,0,0,1-2.39,0,3.1,3.1,0,0,1-1.74.14s1.28-.14,1.74.35A9.11,9.11,0,0,1,123.39,245.83Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M62.17,235l4.45,3.13a1.33,1.33,0,0,0,1.36.1l10.69-5.4a1.75,1.75,0,0,0,.35-2.73h0a1.36,1.36,0,0,0-1.14-.38L62.75,232A1.7,1.7,0,0,0,62.17,235Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="70.07 222.53 64.05 223.97 58.74 228.59 67.64 232.62 78.53 227.57 70.07 222.53"
              fill="#ffedc8"
            />
            <polygon
              points="58.74 228.59 58.74 232.62 67.28 236.75 78.77 231.48 78.53 227.57 67.64 232.62 58.74 228.59"
              fill="#ccae79"
            />
            <polygon
              points="67.64 232.62 67.28 236.75 78.77 231.48 78.53 227.57 67.64 232.62"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M61.28,229.74a2,2,0,0,1,0,2.06c.4-.64.49-1.84.68-1.76Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M65,231.44a5.39,5.39,0,0,0,2.25-2.58l-1.62,2.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M72.13,230.53a1.87,1.87,0,0,1,.89,1.63l-.26-1.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M76.12,226.13c-.12-.06-2.25.49-3.54,0a4.5,4.5,0,0,1-2.58.21s1.89-.21,2.58.52A13.77,13.77,0,0,1,76.12,226.13Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M198.41,140.76c3.31-.19-3.24.34-3.26-.46s3.25-2,3.95-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.57-3.51,0-3.51,0,4.5.64,3,1.16-2.48,1.48-3.27,1.28-.86-2.17-.86-2.17-.69,2.49-2.25,1.91-1.69-1.71-1.56-1.78A11.32,11.32,0,0,1,198.41,140.76Z"
                fill="#2f6840"
              />
              <path
                d="M198,140.5c3.31-.18-3.24.35-3.26-.45s3.25-2,3.95-1.84.2,1.68.2,1.68.93-2.07,2.19-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.69,2.5-2.25,1.91-1.69-1.71-1.56-1.77A11,11,0,0,1,198,140.5Z"
                fill="#3ba525"
              />
              <path
                d="M198.59,140.48a1.64,1.64,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.67,1.67,0,0,1,1,.34,1.34,1.34,0,0,1,.36.39A.79.79,0,0,1,198.59,140.48Z"
                fill="#2f6840"
              />
              <path
                d="M201.19,139.89a4.68,4.68,0,0,0-.54.07,3.18,3.18,0,0,0-.51.13,9,9,0,0,0-1,.39,1.9,1.9,0,0,1,.92-.65A1.57,1.57,0,0,1,201.19,139.89Z"
                fill="#2f6840"
              />
              <path
                d="M200.17,142.29a1.43,1.43,0,0,0-.49-.74c-.22-.22-.48-.38-.73-.61a1.68,1.68,0,0,1,.91.41,1.45,1.45,0,0,1,.3.43A.69.69,0,0,1,200.17,142.29Z"
                fill="#2f6840"
              />
              <path
                d="M198.7,140.83c-.18,0-.35.06-.52.11a3.9,3.9,0,0,0-.48.17,7.71,7.71,0,0,0-.94.49,1.67,1.67,0,0,1,.84-.73A1.45,1.45,0,0,1,198.7,140.83Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M196.42,147.29c3.31-.18-3.24.35-3.26-.45s3.25-2,4-1.84.2,1.68.2,1.68.93-2.07,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.27,1.28-.87-2.17-.87-2.17-.68,2.5-2.24,1.91-1.69-1.7-1.56-1.77A10.88,10.88,0,0,1,196.42,147.29Z"
                fill="#2f6840"
              />
              <path
                d="M196,147c3.31-.19-3.24.34-3.26-.46s3.25-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.26,1.28-.87-2.17-.87-2.17-.69,2.5-2.25,1.91-1.69-1.7-1.56-1.77A10.78,10.78,0,0,1,196,147Z"
                fill="#3ba525"
              />
              <path
                d="M196.6,147a1.62,1.62,0,0,0-.6-.71c-.24-.19-.52-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.39,1.39,0,0,1,.36.4A.79.79,0,0,1,196.6,147Z"
                fill="#2f6840"
              />
              <path
                d="M199.2,146.42c-.19,0-.37,0-.54.07a4.77,4.77,0,0,0-.51.13,9.06,9.06,0,0,0-1,.4,1.79,1.79,0,0,1,.92-.65A1.52,1.52,0,0,1,199.2,146.42Z"
                fill="#2f6840"
              />
              <path
                d="M198.18,148.82a1.47,1.47,0,0,0-.49-.74c-.22-.21-.48-.38-.73-.6a1.6,1.6,0,0,1,.91.4,1.45,1.45,0,0,1,.3.43A.75.75,0,0,1,198.18,148.82Z"
                fill="#2f6840"
              />
              <path
                d="M196.71,147.36a4.37,4.37,0,0,0-.52.12,2.74,2.74,0,0,0-.48.17,7.6,7.6,0,0,0-.94.48,1.67,1.67,0,0,1,.84-.73A1.5,1.5,0,0,1,196.71,147.36Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M192.41,143.58c3.31-.18-3.24.35-3.26-.45s3.26-2,3.95-1.84.2,1.68.2,1.68.93-2.07,2.19-1.61,2.72,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.71-1.55-1.77A10.78,10.78,0,0,1,192.41,143.58Z"
                fill="#2f6840"
              />
              <path
                d="M192,143.33c3.31-.19-3.24.34-3.26-.46s3.26-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.2-1.62,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.6,10.6,0,0,1,192,143.33Z"
                fill="#3ba525"
              />
              <path
                d="M192.59,143.3a1.56,1.56,0,0,0-.59-.7c-.24-.2-.53-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.23,1.23,0,0,1,.35.4A.71.71,0,0,1,192.59,143.3Z"
                fill="#2f6840"
              />
              <path
                d="M195.2,142.71c-.19,0-.37,0-.55.07a4.07,4.07,0,0,0-.5.13,9.19,9.19,0,0,0-1,.4,1.76,1.76,0,0,1,.93-.65A1.52,1.52,0,0,1,195.2,142.71Z"
                fill="#2f6840"
              />
              <path
                d="M194.17,145.11a1.47,1.47,0,0,0-.49-.74c-.21-.22-.48-.38-.73-.61a1.62,1.62,0,0,1,.91.41,1.28,1.28,0,0,1,.3.43A.65.65,0,0,1,194.17,145.11Z"
                fill="#2f6840"
              />
              <path
                d="M192.71,143.65a4.12,4.12,0,0,0-.53.12,2.3,2.3,0,0,0-.48.17,6.86,6.86,0,0,0-.93.48,1.69,1.69,0,0,1,.83-.73A1.47,1.47,0,0,1,192.71,143.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M186.16,141.06c3.32-.19-3.24.34-3.25-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.57-3.51,0-3.51,0,4.5.64,3,1.15-2.48,1.49-3.27,1.29-.87-2.17-.87-2.17-.68,2.49-2.24,1.9-1.69-1.7-1.56-1.77A11.31,11.31,0,0,1,186.16,141.06Z"
                fill="#2f6840"
              />
              <path
                d="M185.79,140.8c3.31-.19-3.24.34-3.26-.45s3.25-2,3.95-1.84.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.48-3.27,1.28-.86-2.17-.86-2.17-.69,2.5-2.25,1.91-1.69-1.71-1.56-1.77A11,11,0,0,1,185.79,140.8Z"
                fill="#3ba525"
              />
              <path
                d="M186.35,140.78a1.64,1.64,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.49,1.49,0,0,1,.36.39A.79.79,0,0,1,186.35,140.78Z"
                fill="#2f6840"
              />
              <path
                d="M189,140.19a4.41,4.41,0,0,0-.54.07,2.39,2.39,0,0,0-.51.13,9,9,0,0,0-1,.39,1.79,1.79,0,0,1,.92-.65A1.57,1.57,0,0,1,189,140.19Z"
                fill="#2f6840"
              />
              <path
                d="M187.93,142.59a1.39,1.39,0,0,0-.49-.74c-.22-.22-.48-.38-.73-.61a1.68,1.68,0,0,1,.91.41,1.23,1.23,0,0,1,.3.43A.75.75,0,0,1,187.93,142.59Z"
                fill="#2f6840"
              />
              <path
                d="M186.46,141.12c-.18,0-.35.07-.52.12a3.9,3.9,0,0,0-.48.17,7.71,7.71,0,0,0-.94.49,1.69,1.69,0,0,1,.83-.73A1.53,1.53,0,0,1,186.46,141.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M197.17,152.65c3.31-.18-3.24.35-3.26-.45s3.26-2,4-1.84.2,1.68.2,1.68.92-2.07,2.19-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.71-1.55-1.77A10.78,10.78,0,0,1,197.17,152.65Z"
                fill="#2f6840"
              />
              <path
                d="M196.79,152.4c3.32-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.92-2.08,2.19-1.62,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.6,10.6,0,0,1,196.79,152.4Z"
                fill="#3ba525"
              />
              <path
                d="M197.36,152.37a1.64,1.64,0,0,0-.6-.7c-.24-.2-.53-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.23,1.23,0,0,1,.35.4A.71.71,0,0,1,197.36,152.37Z"
                fill="#2f6840"
              />
              <path
                d="M200,151.78c-.19,0-.37,0-.54.07a3.8,3.8,0,0,0-.51.13,9.19,9.19,0,0,0-1,.4,1.8,1.8,0,0,1,.93-.65A1.52,1.52,0,0,1,200,151.78Z"
                fill="#2f6840"
              />
              <path
                d="M198.94,154.18a1.49,1.49,0,0,0-.5-.74c-.21-.21-.48-.38-.72-.6a1.54,1.54,0,0,1,.9.4,1.28,1.28,0,0,1,.3.43A.69.69,0,0,1,198.94,154.18Z"
                fill="#2f6840"
              />
              <path
                d="M197.47,152.72a4,4,0,0,0-.52.12,2.84,2.84,0,0,0-.49.17,6.86,6.86,0,0,0-.93.48,1.69,1.69,0,0,1,.83-.73A1.47,1.47,0,0,1,197.47,152.72Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M187.1,148.48c3.31-.18-3.24.35-3.26-.45s3.26-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.72,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.78,10.78,0,0,1,187.1,148.48Z"
                fill="#2f6840"
              />
              <path
                d="M186.72,148.23c3.31-.19-3.24.34-3.26-.46s3.26-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.2-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.9,10.9,0,0,1,186.72,148.23Z"
                fill="#3ba525"
              />
              <path
                d="M187.28,148.21a1.53,1.53,0,0,0-.59-.71c-.25-.19-.53-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.35,1.35,0,0,1,.35.4A.73.73,0,0,1,187.28,148.21Z"
                fill="#2f6840"
              />
              <path
                d="M189.89,147.61c-.19,0-.37,0-.55.07a4.07,4.07,0,0,0-.5.13,9.19,9.19,0,0,0-1,.4,1.82,1.82,0,0,1,.93-.65A1.52,1.52,0,0,1,189.89,147.61Z"
                fill="#2f6840"
              />
              <path
                d="M188.86,150a1.47,1.47,0,0,0-.49-.74c-.21-.21-.48-.38-.73-.6a1.64,1.64,0,0,1,.91.4,1.28,1.28,0,0,1,.3.43A.69.69,0,0,1,188.86,150Z"
                fill="#2f6840"
              />
              <path
                d="M187.4,148.55c-.19,0-.36.07-.53.12a2.74,2.74,0,0,0-.48.17,6.86,6.86,0,0,0-.93.48,1.69,1.69,0,0,1,.83-.73A1.57,1.57,0,0,1,187.4,148.55Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M177.39,137.15c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.26,1.28-.87-2.17-.87-2.17-.69,2.5-2.25,1.91-1.69-1.7-1.56-1.77A10.78,10.78,0,0,1,177.39,137.15Z"
                fill="#2f6840"
              />
              <path
                d="M177,136.89c3.31-.19-3.24.34-3.26-.46s3.26-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.69,2.5-2.25,1.91-1.69-1.7-1.56-1.77A11.09,11.09,0,0,1,177,136.89Z"
                fill="#3ba525"
              />
              <path
                d="M177.57,136.87a1.54,1.54,0,0,0-.6-.7c-.24-.2-.52-.35-.8-.56a1.67,1.67,0,0,1,1,.34,1.38,1.38,0,0,1,.36.4A.79.79,0,0,1,177.57,136.87Z"
                fill="#2f6840"
              />
              <path
                d="M180.17,136.27c-.19,0-.36,0-.54.07a4.77,4.77,0,0,0-.51.13c-.34.1-.65.26-1,.4a1.84,1.84,0,0,1,.92-.65A1.52,1.52,0,0,1,180.17,136.27Z"
                fill="#2f6840"
              />
              <path
                d="M179.15,138.67a1.47,1.47,0,0,0-.49-.74c-.22-.21-.48-.38-.73-.6a1.64,1.64,0,0,1,.91.4,1.45,1.45,0,0,1,.3.43A.69.69,0,0,1,179.15,138.67Z"
                fill="#2f6840"
              />
              <path
                d="M177.68,137.21c-.18,0-.35.07-.52.12a2.74,2.74,0,0,0-.48.17,7.6,7.6,0,0,0-.94.48,1.67,1.67,0,0,1,.84-.73A1.55,1.55,0,0,1,177.68,137.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M175.4,143.68c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.64,3,1.15-2.48,1.49-3.27,1.29-.87-2.18-.87-2.18-.68,2.5-2.24,1.91-1.69-1.7-1.56-1.77A11,11,0,0,1,175.4,143.68Z"
                fill="#2f6840"
              />
              <path
                d="M175,143.42c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.57-3.52,0-3.52,0,4.51.64,3,1.16-2.48,1.48-3.26,1.28-.87-2.17-.87-2.17-.69,2.49-2.25,1.91-1.69-1.71-1.56-1.78A11.42,11.42,0,0,1,175,143.42Z"
                fill="#3ba525"
              />
              <path
                d="M175.58,143.4a1.59,1.59,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.73,1.73,0,0,1,1,.33,1.52,1.52,0,0,1,.36.4A.79.79,0,0,1,175.58,143.4Z"
                fill="#2f6840"
              />
              <path
                d="M178.18,142.8c-.19,0-.36,0-.54.08a2.39,2.39,0,0,0-.51.13,9,9,0,0,0-1,.39,1.79,1.79,0,0,1,.92-.65A1.62,1.62,0,0,1,178.18,142.8Z"
                fill="#2f6840"
              />
              <path
                d="M177.16,145.21a1.39,1.39,0,0,0-.49-.74c-.22-.22-.48-.38-.73-.61a1.68,1.68,0,0,1,.91.41,1.29,1.29,0,0,1,.3.42A.72.72,0,0,1,177.16,145.21Z"
                fill="#2f6840"
              />
              <path
                d="M175.69,143.74c-.18,0-.35.07-.52.12a2.74,2.74,0,0,0-.48.17,7.71,7.71,0,0,0-.94.49,1.63,1.63,0,0,1,.84-.73A1.5,1.5,0,0,1,175.69,143.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M171.39,140c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.93-2.08,2.2-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.9,10.9,0,0,1,171.39,140Z"
                fill="#2f6840"
              />
              <path
                d="M171,139.71c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.83.19,1.68.19,1.68.93-2.08,2.2-1.61,2.71,2.66,2,2.57-3.52,0-3.52,0,4.51.64,3,1.15-2.47,1.49-3.26,1.29-.87-2.17-.87-2.17-.68,2.49-2.25,1.9-1.69-1.7-1.55-1.77A11.22,11.22,0,0,1,171,139.71Z"
                fill="#3ba525"
              />
              <path
                d="M171.57,139.69a1.51,1.51,0,0,0-.59-.7c-.24-.2-.53-.34-.8-.55a1.76,1.76,0,0,1,1,.33,1.48,1.48,0,0,1,.35.4A.69.69,0,0,1,171.57,139.69Z"
                fill="#2f6840"
              />
              <path
                d="M174.18,139.09c-.19,0-.37,0-.55.08a2.17,2.17,0,0,0-.5.13,9.08,9.08,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.63,1.63,0,0,1,174.18,139.09Z"
                fill="#2f6840"
              />
              <path
                d="M173.15,141.5a1.46,1.46,0,0,0-.49-.75c-.21-.21-.48-.37-.73-.6a1.56,1.56,0,0,1,.91.41,1.15,1.15,0,0,1,.3.42A.67.67,0,0,1,173.15,141.5Z"
                fill="#2f6840"
              />
              <path
                d="M171.69,140c-.19.05-.36.07-.52.12a2.84,2.84,0,0,0-.49.17,7,7,0,0,0-.93.49,1.66,1.66,0,0,1,.83-.74A1.57,1.57,0,0,1,171.69,140Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M165.14,137.44c3.32-.18-3.23.35-3.25-.45s3.25-2,4-1.84.2,1.68.2,1.68.93-2.07,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.48-3.27,1.28-.87-2.17-.87-2.17-.68,2.5-2.24,1.91-1.69-1.7-1.56-1.77A10.87,10.87,0,0,1,165.14,137.44Z"
                fill="#2f6840"
              />
              <path
                d="M164.77,137.19c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.26,1.28-.87-2.17-.87-2.17-.69,2.5-2.25,1.91-1.69-1.7-1.56-1.77A10.78,10.78,0,0,1,164.77,137.19Z"
                fill="#3ba525"
              />
              <path
                d="M165.33,137.16a1.64,1.64,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.39,1.39,0,0,1,.36.4A.76.76,0,0,1,165.33,137.16Z"
                fill="#2f6840"
              />
              <path
                d="M167.93,136.57c-.19,0-.37,0-.54.07a4.77,4.77,0,0,0-.51.13,9.06,9.06,0,0,0-1,.4,1.79,1.79,0,0,1,.92-.65A1.52,1.52,0,0,1,167.93,136.57Z"
                fill="#2f6840"
              />
              <path
                d="M166.91,139a1.47,1.47,0,0,0-.49-.74c-.22-.21-.48-.38-.73-.6a1.6,1.6,0,0,1,.91.4,1.45,1.45,0,0,1,.3.43A.75.75,0,0,1,166.91,139Z"
                fill="#2f6840"
              />
              <path
                d="M165.44,137.51a4.37,4.37,0,0,0-.52.12,2.74,2.74,0,0,0-.48.17,7.6,7.6,0,0,0-.94.48,1.67,1.67,0,0,1,.84-.73A1.45,1.45,0,0,1,165.44,137.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M176.15,149c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.92-2.08,2.19-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.29-.87-2.18-.87-2.18-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.9,10.9,0,0,1,176.15,149Z"
                fill="#2f6840"
              />
              <path
                d="M175.77,148.78c3.32-.19-3.24.34-3.25-.46s3.25-2,3.95-1.83.2,1.68.2,1.68.92-2.08,2.19-1.61,2.71,2.66,2,2.57-3.51,0-3.51,0,4.5.64,3,1.16-2.48,1.48-3.27,1.28-.87-2.17-.87-2.17-.68,2.49-2.25,1.9-1.69-1.7-1.55-1.77A11.22,11.22,0,0,1,175.77,148.78Z"
                fill="#3ba525"
              />
              <path
                d="M176.34,148.76a1.59,1.59,0,0,0-.6-.7c-.24-.2-.53-.34-.8-.55a1.76,1.76,0,0,1,1,.33,1.48,1.48,0,0,1,.35.4A.74.74,0,0,1,176.34,148.76Z"
                fill="#2f6840"
              />
              <path
                d="M178.94,148.16c-.19,0-.37,0-.54.08a2.12,2.12,0,0,0-.51.13,9.91,9.91,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.63,1.63,0,0,1,178.94,148.16Z"
                fill="#2f6840"
              />
              <path
                d="M177.92,150.57a1.47,1.47,0,0,0-.5-.75c-.21-.21-.47-.37-.72-.6a1.56,1.56,0,0,1,.9.41,1.15,1.15,0,0,1,.3.42A.72.72,0,0,1,177.92,150.57Z"
                fill="#2f6840"
              />
              <path
                d="M176.45,149.1c-.18.05-.36.07-.52.12a2.48,2.48,0,0,0-.48.17,7,7,0,0,0-.94.49,1.66,1.66,0,0,1,.83-.74A1.57,1.57,0,0,1,176.45,149.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M166.08,144.87c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.83.2,1.68.2,1.68.93-2.08,2.2-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.64,3,1.15-2.47,1.49-3.26,1.29-.87-2.17-.87-2.17-.68,2.49-2.25,1.9-1.69-1.7-1.55-1.77A10.9,10.9,0,0,1,166.08,144.87Z"
                fill="#2f6840"
              />
              <path
                d="M165.7,144.61c3.31-.19-3.24.34-3.26-.46s3.26-2,3.95-1.83.2,1.68.2,1.68.93-2.08,2.2-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.64,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.49-2.25,1.91-1.69-1.71-1.55-1.78A11.22,11.22,0,0,1,165.7,144.61Z"
                fill="#3ba525"
              />
              <path
                d="M166.26,144.59a1.51,1.51,0,0,0-.59-.7c-.24-.2-.53-.34-.8-.55a1.76,1.76,0,0,1,1,.33,1.48,1.48,0,0,1,.35.4A.73.73,0,0,1,166.26,144.59Z"
                fill="#2f6840"
              />
              <path
                d="M168.87,144c-.19,0-.37,0-.55.08a2.17,2.17,0,0,0-.5.13,9.08,9.08,0,0,0-1,.39,1.82,1.82,0,0,1,.93-.65A1.63,1.63,0,0,1,168.87,144Z"
                fill="#2f6840"
              />
              <path
                d="M167.84,146.4a1.39,1.39,0,0,0-.49-.74c-.21-.22-.48-.38-.73-.61a1.62,1.62,0,0,1,.91.41,1.15,1.15,0,0,1,.3.42A.67.67,0,0,1,167.84,146.4Z"
                fill="#2f6840"
              />
              <path
                d="M166.38,144.93c-.19,0-.36.07-.52.12a2.84,2.84,0,0,0-.49.17,7,7,0,0,0-.93.49,1.69,1.69,0,0,1,.83-.73A1.52,1.52,0,0,1,166.38,144.93Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M156.13,135.55c3.31-.19-3.24.34-3.26-.46s3.26-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.2-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.29-.87-2.18-.87-2.18-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.9,10.9,0,0,1,156.13,135.55Z"
                fill="#2f6840"
              />
              <path
                d="M155.75,135.29c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.83.2,1.68.2,1.68.92-2.08,2.19-1.61,2.71,2.66,2,2.57-3.51,0-3.51,0,4.5.64,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.49-2.25,1.9-1.69-1.7-1.55-1.77A11.22,11.22,0,0,1,155.75,135.29Z"
                fill="#3ba525"
              />
              <path
                d="M156.32,135.27a1.59,1.59,0,0,0-.6-.7c-.24-.2-.53-.34-.8-.55a1.76,1.76,0,0,1,1,.33,1.48,1.48,0,0,1,.35.4A.74.74,0,0,1,156.32,135.27Z"
                fill="#2f6840"
              />
              <path
                d="M158.92,134.67c-.19,0-.37,0-.54.08a2.12,2.12,0,0,0-.51.13,9.08,9.08,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.63,1.63,0,0,1,158.92,134.67Z"
                fill="#2f6840"
              />
              <path
                d="M157.89,137.08a1.33,1.33,0,0,0-.49-.74c-.21-.22-.48-.38-.72-.61a1.56,1.56,0,0,1,.9.41,1.15,1.15,0,0,1,.3.42A.67.67,0,0,1,157.89,137.08Z"
                fill="#2f6840"
              />
              <path
                d="M156.43,135.61c-.19,0-.36.07-.52.12a2.84,2.84,0,0,0-.49.17,7,7,0,0,0-.93.49,1.66,1.66,0,0,1,.83-.74A1.57,1.57,0,0,1,156.43,135.61Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M154.14,142.08c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.83.2,1.68.2,1.68.93-2.08,2.2-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.64,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.71-1.55-1.77A10.78,10.78,0,0,1,154.14,142.08Z"
                fill="#2f6840"
              />
              <path
                d="M153.76,141.82c3.31-.18-3.24.35-3.26-.45s3.26-2,4-1.84.2,1.68.2,1.68.92-2.07,2.19-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.71-1.55-1.77A10.78,10.78,0,0,1,153.76,141.82Z"
                fill="#3ba525"
              />
              <path
                d="M154.32,141.8a1.56,1.56,0,0,0-.59-.7c-.24-.2-.53-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.31,1.31,0,0,1,.35.39A.69.69,0,0,1,154.32,141.8Z"
                fill="#2f6840"
              />
              <path
                d="M156.93,141.21a4.41,4.41,0,0,0-.54.07,3.8,3.8,0,0,0-.51.13,9.08,9.08,0,0,0-1,.39,1.85,1.85,0,0,1,.93-.64A1.52,1.52,0,0,1,156.93,141.21Z"
                fill="#2f6840"
              />
              <path
                d="M155.9,143.61a1.47,1.47,0,0,0-.49-.74c-.21-.22-.48-.38-.73-.61a1.62,1.62,0,0,1,.91.41,1.28,1.28,0,0,1,.3.43A.65.65,0,0,1,155.9,143.61Z"
                fill="#2f6840"
              />
              <path
                d="M154.44,142.15a3.62,3.62,0,0,0-.52.12,2.19,2.19,0,0,0-.49.17,6.86,6.86,0,0,0-.93.48,1.69,1.69,0,0,1,.83-.73A1.47,1.47,0,0,1,154.44,142.15Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M150.13,138.37c3.32-.19-3.24.34-3.25-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.57-3.51,0-3.51,0,4.5.64,3,1.16-2.48,1.48-3.27,1.28-.87-2.17-.87-2.17-.68,2.49-2.24,1.91-1.69-1.71-1.56-1.78A11.22,11.22,0,0,1,150.13,138.37Z"
                fill="#2f6840"
              />
              <path
                d="M149.76,138.11c3.31-.18-3.24.34-3.26-.45s3.25-2,3.95-1.84.2,1.68.2,1.68.93-2.07,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.48-3.27,1.28-.87-2.17-.87-2.17-.68,2.5-2.24,1.91-1.69-1.71-1.56-1.77A10.88,10.88,0,0,1,149.76,138.11Z"
                fill="#3ba525"
              />
              <path
                d="M150.32,138.09a1.64,1.64,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.31,1.31,0,0,1,.35.39A.74.74,0,0,1,150.32,138.09Z"
                fill="#2f6840"
              />
              <path
                d="M152.92,137.5a4.41,4.41,0,0,0-.54.07,2.25,2.25,0,0,0-.51.13,9.91,9.91,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.57,1.57,0,0,1,152.92,137.5Z"
                fill="#2f6840"
              />
              <path
                d="M151.9,139.9a1.4,1.4,0,0,0-.5-.74c-.21-.22-.47-.38-.72-.61a1.68,1.68,0,0,1,.91.41,1.5,1.5,0,0,1,.3.43A.75.75,0,0,1,151.9,139.9Z"
                fill="#2f6840"
              />
              <path
                d="M150.43,138.44c-.18,0-.35.06-.52.11a3.39,3.39,0,0,0-.48.17,7.71,7.71,0,0,0-.94.49,1.69,1.69,0,0,1,.83-.73A1.47,1.47,0,0,1,150.43,138.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M143.89,135.85c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.93-2.08,2.2-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.6,10.6,0,0,1,143.89,135.85Z"
                fill="#2f6840"
              />
              <path
                d="M143.51,135.59c3.31-.19-3.24.34-3.26-.46s3.26-2,3.95-1.83.2,1.68.2,1.68.93-2.08,2.2-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.64,3,1.15-2.47,1.49-3.26,1.29-.87-2.17-.87-2.17-.68,2.49-2.25,1.9-1.69-1.7-1.55-1.77A10.9,10.9,0,0,1,143.51,135.59Z"
                fill="#3ba525"
              />
              <path
                d="M144.07,135.57a1.51,1.51,0,0,0-.59-.7c-.24-.2-.53-.35-.8-.56a1.86,1.86,0,0,1,1,.34,1.48,1.48,0,0,1,.35.4A.69.69,0,0,1,144.07,135.57Z"
                fill="#2f6840"
              />
              <path
                d="M146.68,135c-.19,0-.37,0-.55.08a2.17,2.17,0,0,0-.5.13,9.08,9.08,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.63,1.63,0,0,1,146.68,135Z"
                fill="#2f6840"
              />
              <path
                d="M145.65,137.38a1.46,1.46,0,0,0-.49-.75c-.21-.21-.48-.37-.73-.6a1.56,1.56,0,0,1,.91.41,1.15,1.15,0,0,1,.3.42A.67.67,0,0,1,145.65,137.38Z"
                fill="#2f6840"
              />
              <path
                d="M144.19,135.91c-.19.05-.36.07-.52.12a2.84,2.84,0,0,0-.49.17,8.22,8.22,0,0,0-.93.48,1.69,1.69,0,0,1,.83-.73A1.57,1.57,0,0,1,144.19,135.91Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M154.9,147.44c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.57-3.51,0-3.51,0,4.5.64,3,1.16-2.48,1.48-3.27,1.28-.87-2.17-.87-2.17-.68,2.49-2.24,1.91-1.69-1.71-1.56-1.78A11.32,11.32,0,0,1,154.9,147.44Z"
                fill="#2f6840"
              />
              <path
                d="M154.52,147.18c3.31-.18-3.24.34-3.26-.45s3.25-2,4-1.84.2,1.68.2,1.68.93-2.07,2.19-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.48,1.48-3.26,1.28-.87-2.17-.87-2.17-.69,2.5-2.25,1.91S151,148,151.11,148A11,11,0,0,1,154.52,147.18Z"
                fill="#3ba525"
              />
              <path
                d="M155.08,147.16a1.64,1.64,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.67,1.67,0,0,1,1,.34,1.34,1.34,0,0,1,.36.39A.79.79,0,0,1,155.08,147.16Z"
                fill="#2f6840"
              />
              <path
                d="M157.68,146.57a4.68,4.68,0,0,0-.54.07,3.18,3.18,0,0,0-.51.13,9,9,0,0,0-1,.39,1.79,1.79,0,0,1,.92-.65A1.57,1.57,0,0,1,157.68,146.57Z"
                fill="#2f6840"
              />
              <path
                d="M156.66,149a1.43,1.43,0,0,0-.49-.74c-.22-.22-.48-.38-.73-.61a1.68,1.68,0,0,1,.91.41,1.45,1.45,0,0,1,.3.43A.69.69,0,0,1,156.66,149Z"
                fill="#2f6840"
              />
              <path
                d="M155.19,147.51c-.18,0-.35.06-.52.11a3.9,3.9,0,0,0-.48.17,7.71,7.71,0,0,0-.94.49,1.67,1.67,0,0,1,.84-.73A1.45,1.45,0,0,1,155.19,147.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M144.82,143.27c3.32-.19-3.24.34-3.25-.45s3.25-2,4-1.84.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.48-3.27,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.68-1.71-1.55-1.77A10.78,10.78,0,0,1,144.82,143.27Z"
                fill="#2f6840"
              />
              <path
                d="M144.44,143c3.32-.18-3.24.35-3.25-.45s3.25-2,3.95-1.84.2,1.68.2,1.68.93-2.07,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.48-3.27,1.28-.87-2.17-.87-2.17-.68,2.5-2.24,1.91-1.69-1.7-1.56-1.77A10.87,10.87,0,0,1,144.44,143Z"
                fill="#3ba525"
              />
              <path
                d="M145,143a1.64,1.64,0,0,0-.6-.7c-.24-.2-.53-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.23,1.23,0,0,1,.35.4A.7.7,0,0,1,145,143Z"
                fill="#2f6840"
              />
              <path
                d="M147.61,142.4a4.41,4.41,0,0,0-.54.07,4.23,4.23,0,0,0-.51.13,9.91,9.91,0,0,0-1,.39,1.85,1.85,0,0,1,.93-.64A1.52,1.52,0,0,1,147.61,142.4Z"
                fill="#2f6840"
              />
              <path
                d="M146.59,144.8a1.49,1.49,0,0,0-.5-.74c-.21-.22-.47-.38-.72-.61a1.68,1.68,0,0,1,.91.41,1.66,1.66,0,0,1,.3.43A.75.75,0,0,1,146.59,144.8Z"
                fill="#2f6840"
              />
              <path
                d="M145.12,143.34a4.37,4.37,0,0,0-.52.12,2,2,0,0,0-.48.17,7,7,0,0,0-.94.48,1.69,1.69,0,0,1,.83-.73A1.47,1.47,0,0,1,145.12,143.34Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M135,137.43c3.32-.19-3.24.34-3.25-.46s3.25-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.27,1.29-.87-2.18-.87-2.18-.68,2.5-2.24,1.91-1.69-1.7-1.56-1.77A11,11,0,0,1,135,137.43Z"
                fill="#2f6840"
              />
              <path
                d="M134.6,137.17c3.31-.19-3.24.34-3.26-.46s3.25-2,3.95-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.57-3.51,0-3.51,0,4.5.64,3,1.16-2.48,1.48-3.27,1.28-.86-2.17-.86-2.17-.69,2.49-2.25,1.9-1.69-1.7-1.56-1.77A11.42,11.42,0,0,1,134.6,137.17Z"
                fill="#3ba525"
              />
              <path
                d="M135.16,137.15a1.59,1.59,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.76,1.76,0,0,1,1,.33,1.72,1.72,0,0,1,.36.4A.79.79,0,0,1,135.16,137.15Z"
                fill="#2f6840"
              />
              <path
                d="M137.76,136.55c-.19,0-.37,0-.54.08a2.39,2.39,0,0,0-.51.13,9,9,0,0,0-1,.39,1.79,1.79,0,0,1,.92-.65A1.62,1.62,0,0,1,137.76,136.55Z"
                fill="#2f6840"
              />
              <path
                d="M136.74,139a1.46,1.46,0,0,0-.49-.75c-.22-.21-.48-.37-.73-.6a1.61,1.61,0,0,1,.91.41,1.29,1.29,0,0,1,.3.42A.77.77,0,0,1,136.74,139Z"
                fill="#2f6840"
              />
              <path
                d="M135.27,137.49c-.18,0-.35.07-.52.12a2.74,2.74,0,0,0-.48.17,7.71,7.71,0,0,0-.94.49,1.66,1.66,0,0,1,.83-.74A1.58,1.58,0,0,1,135.27,137.49Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M133,144c3.32-.19-3.24.34-3.25-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.64,3,1.16-2.48,1.48-3.27,1.28-.87-2.17-.87-2.17-.68,2.49-2.24,1.91-1.69-1.71-1.56-1.78A11.31,11.31,0,0,1,133,144Z"
                fill="#2f6840"
              />
              <path
                d="M132.61,143.7c3.31-.18-3.24.35-3.26-.45s3.25-2,4-1.84.2,1.68.2,1.68.93-2.07,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.48-3.27,1.28-.87-2.17-.87-2.17-.68,2.5-2.24,1.91-1.69-1.71-1.56-1.77A10.88,10.88,0,0,1,132.61,143.7Z"
                fill="#3ba525"
              />
              <path
                d="M133.17,143.68a1.64,1.64,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.31,1.31,0,0,1,.35.39A.74.74,0,0,1,133.17,143.68Z"
                fill="#2f6840"
              />
              <path
                d="M135.77,143.09a4.41,4.41,0,0,0-.54.07,4.77,4.77,0,0,0-.51.13,9.91,9.91,0,0,0-1,.39,1.85,1.85,0,0,1,.93-.64A1.52,1.52,0,0,1,135.77,143.09Z"
                fill="#2f6840"
              />
              <path
                d="M134.75,145.49a1.42,1.42,0,0,0-.5-.74c-.21-.22-.47-.38-.72-.61a1.68,1.68,0,0,1,.91.41,1.45,1.45,0,0,1,.3.43A.75.75,0,0,1,134.75,145.49Z"
                fill="#2f6840"
              />
              <path
                d="M133.28,144c-.18,0-.35.06-.52.11a2.5,2.5,0,0,0-.48.18,6.43,6.43,0,0,0-.94.48,1.69,1.69,0,0,1,.83-.73A1.47,1.47,0,0,1,133.28,144Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M129,140.25c3.31-.19-3.24.34-3.26-.46s3.26-2,3.95-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.57-3.52,0-3.52,0,4.51.64,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.49-2.25,1.91-1.69-1.71-1.56-1.78A11.42,11.42,0,0,1,129,140.25Z"
                fill="#2f6840"
              />
              <path
                d="M128.6,140c3.31-.18-3.24.34-3.26-.45s3.26-2,3.95-1.84.2,1.68.2,1.68.93-2.08,2.2-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.71-1.55-1.77A10.78,10.78,0,0,1,128.6,140Z"
                fill="#3ba525"
              />
              <path
                d="M129.16,140a1.62,1.62,0,0,0-.59-.7c-.25-.2-.53-.34-.81-.55a1.7,1.7,0,0,1,1,.34,1.46,1.46,0,0,1,.35.39A.73.73,0,0,1,129.16,140Z"
                fill="#2f6840"
              />
              <path
                d="M131.77,139.38a4.58,4.58,0,0,0-.55.07,2.17,2.17,0,0,0-.5.13,9.08,9.08,0,0,0-1,.39,1.84,1.84,0,0,1,.92-.65A1.6,1.6,0,0,1,131.77,139.38Z"
                fill="#2f6840"
              />
              <path
                d="M130.74,141.78a1.39,1.39,0,0,0-.49-.74c-.21-.22-.48-.38-.73-.61a1.65,1.65,0,0,1,.91.41,1.19,1.19,0,0,1,.3.43A.69.69,0,0,1,130.74,141.78Z"
                fill="#2f6840"
              />
              <path
                d="M129.28,140.32c-.19,0-.36.06-.53.11a3.9,3.9,0,0,0-.48.17,7.71,7.71,0,0,0-.94.49,1.76,1.76,0,0,1,.84-.73A1.47,1.47,0,0,1,129.28,140.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M122.73,137.73c3.32-.19-3.24.34-3.25-.46s3.25-2,4-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.27,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.68-1.7-1.55-1.77A10.6,10.6,0,0,1,122.73,137.73Z"
                fill="#2f6840"
              />
              <path
                d="M122.35,137.47c3.32-.19-3.24.34-3.25-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.64,3,1.15-2.48,1.49-3.27,1.29-.87-2.17-.87-2.17-.68,2.49-2.24,1.9-1.69-1.7-1.56-1.77A11,11,0,0,1,122.35,137.47Z"
                fill="#3ba525"
              />
              <path
                d="M122.92,137.45a1.59,1.59,0,0,0-.6-.7c-.24-.2-.53-.35-.8-.56a1.77,1.77,0,0,1,1,.34,1.48,1.48,0,0,1,.35.4A.74.74,0,0,1,122.92,137.45Z"
                fill="#2f6840"
              />
              <path
                d="M125.52,136.85c-.19,0-.37,0-.54.08a2.25,2.25,0,0,0-.51.13,9.91,9.91,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.62,1.62,0,0,1,125.52,136.85Z"
                fill="#2f6840"
              />
              <path
                d="M124.5,139.26a1.47,1.47,0,0,0-.5-.75c-.21-.21-.47-.37-.72-.6a1.61,1.61,0,0,1,.91.41,1.45,1.45,0,0,1,.3.42A.77.77,0,0,1,124.5,139.26Z"
                fill="#2f6840"
              />
              <path
                d="M123,137.79c-.18.05-.35.07-.52.12a2.48,2.48,0,0,0-.48.17,8.35,8.35,0,0,0-.94.48,1.69,1.69,0,0,1,.83-.73A1.57,1.57,0,0,1,123,137.79Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M133.74,149.32c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.83.2,1.68.2,1.68.93-2.08,2.2-1.61,2.71,2.66,2,2.57-3.52,0-3.52,0,4.51.64,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.49-2.25,1.91-1.69-1.71-1.55-1.78A11.22,11.22,0,0,1,133.74,149.32Z"
                fill="#2f6840"
              />
              <path
                d="M133.36,149.06c3.31-.18-3.24.34-3.26-.45s3.26-2,4-1.84.2,1.68.2,1.68.92-2.07,2.19-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.71-1.55-1.77A10.78,10.78,0,0,1,133.36,149.06Z"
                fill="#3ba525"
              />
              <path
                d="M133.92,149a1.56,1.56,0,0,0-.59-.7c-.24-.2-.53-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.31,1.31,0,0,1,.35.39A.69.69,0,0,1,133.92,149Z"
                fill="#2f6840"
              />
              <path
                d="M136.53,148.45a4.41,4.41,0,0,0-.54.07,2.72,2.72,0,0,0-.51.13,9.08,9.08,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.57,1.57,0,0,1,136.53,148.45Z"
                fill="#2f6840"
              />
              <path
                d="M135.5,150.85a1.43,1.43,0,0,0-.49-.74c-.21-.22-.48-.38-.73-.61a1.62,1.62,0,0,1,.91.41,1.28,1.28,0,0,1,.3.43A.65.65,0,0,1,135.5,150.85Z"
                fill="#2f6840"
              />
              <path
                d="M134,149.39c-.19,0-.36.06-.52.11a4,4,0,0,0-.49.17,7,7,0,0,0-.93.49,1.69,1.69,0,0,1,.83-.73A1.47,1.47,0,0,1,134,149.39Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M123.67,145.15c3.31-.19-3.24.34-3.26-.45s3.26-2,4-1.84.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.64,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.69,2.5-2.25,1.91-1.69-1.71-1.56-1.77A11,11,0,0,1,123.67,145.15Z"
                fill="#2f6840"
              />
              <path
                d="M123.29,144.89c3.31-.18-3.24.35-3.26-.45s3.26-2,4-1.84.2,1.68.2,1.68.93-2.07,2.19-1.61,2.72,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.78,10.78,0,0,1,123.29,144.89Z"
                fill="#3ba525"
              />
              <path
                d="M123.85,144.87a1.64,1.64,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.73,1.73,0,0,1,1,.34,1.46,1.46,0,0,1,.35.39A.73.73,0,0,1,123.85,144.87Z"
                fill="#2f6840"
              />
              <path
                d="M126.46,144.28a4.58,4.58,0,0,0-.55.07,4.77,4.77,0,0,0-.51.13,9,9,0,0,0-1,.39,1.82,1.82,0,0,1,.92-.64A1.55,1.55,0,0,1,126.46,144.28Z"
                fill="#2f6840"
              />
              <path
                d="M125.43,146.68a1.47,1.47,0,0,0-.49-.74c-.21-.22-.48-.38-.73-.61a1.65,1.65,0,0,1,.91.41,1.28,1.28,0,0,1,.3.43A.69.69,0,0,1,125.43,146.68Z"
                fill="#2f6840"
              />
              <path
                d="M124,145.22a4.12,4.12,0,0,0-.53.12,2.11,2.11,0,0,0-.48.17,7.6,7.6,0,0,0-.94.48,1.76,1.76,0,0,1,.84-.73A1.47,1.47,0,0,1,124,145.22Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M114.93,144c3.31-.18-3.24.34-3.26-.45s3.26-2,4-1.84.2,1.68.2,1.68.92-2.07,2.19-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.71-1.55-1.77A10.78,10.78,0,0,1,114.93,144Z"
                fill="#2f6840"
              />
              <path
                d="M114.55,143.78c3.32-.19-3.24.34-3.25-.46s3.25-2,4-1.84.2,1.69.2,1.69.92-2.08,2.19-1.62,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.27,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.6,10.6,0,0,1,114.55,143.78Z"
                fill="#3ba525"
              />
              <path
                d="M115.12,143.75a1.64,1.64,0,0,0-.6-.7c-.24-.2-.53-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.23,1.23,0,0,1,.35.4A.71.71,0,0,1,115.12,143.75Z"
                fill="#2f6840"
              />
              <path
                d="M117.72,143.16c-.19,0-.37,0-.54.07a3.8,3.8,0,0,0-.51.13,8.13,8.13,0,0,0-1,.4,1.8,1.8,0,0,1,.93-.65A1.52,1.52,0,0,1,117.72,143.16Z"
                fill="#2f6840"
              />
              <path
                d="M116.7,145.56a1.49,1.49,0,0,0-.5-.74c-.21-.22-.47-.38-.72-.61a1.62,1.62,0,0,1,.9.41,1.28,1.28,0,0,1,.3.43A.69.69,0,0,1,116.7,145.56Z"
                fill="#2f6840"
              />
              <path
                d="M115.23,144.1a4,4,0,0,0-.52.12,2,2,0,0,0-.48.17,7,7,0,0,0-.94.48,1.69,1.69,0,0,1,.83-.73A1.47,1.47,0,0,1,115.23,144.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M112.94,150.57c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.92-2.08,2.19-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.6,10.6,0,0,1,112.94,150.57Z"
                fill="#2f6840"
              />
              <path
                d="M112.56,150.31c3.32-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.92-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.64,3,1.15-2.47,1.49-3.26,1.29S113,151,113,151s-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.9,10.9,0,0,1,112.56,150.31Z"
                fill="#3ba525"
              />
              <path
                d="M113.13,150.29a1.59,1.59,0,0,0-.6-.7c-.24-.2-.53-.35-.8-.56a1.77,1.77,0,0,1,1,.34,1.48,1.48,0,0,1,.35.4A.74.74,0,0,1,113.13,150.29Z"
                fill="#2f6840"
              />
              <path
                d="M115.73,149.69c-.19,0-.37,0-.54.08a2.12,2.12,0,0,0-.51.13,9.08,9.08,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.63,1.63,0,0,1,115.73,149.69Z"
                fill="#2f6840"
              />
              <path
                d="M114.71,152.09a1.49,1.49,0,0,0-.5-.74c-.21-.21-.48-.37-.72-.6a1.56,1.56,0,0,1,.9.41,1.15,1.15,0,0,1,.3.42A.7.7,0,0,1,114.71,152.09Z"
                fill="#2f6840"
              />
              <path
                d="M113.24,150.63c-.18.05-.36.07-.52.12a2.84,2.84,0,0,0-.49.17,6.86,6.86,0,0,0-.93.48,1.69,1.69,0,0,1,.83-.73A1.57,1.57,0,0,1,113.24,150.63Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M108.93,146.86c3.32-.19-3.24.34-3.25-.46s3.25-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.27,1.28-.87-2.17-.87-2.17-.68,2.5-2.24,1.91-1.69-1.7-1.56-1.77A10.68,10.68,0,0,1,108.93,146.86Z"
                fill="#2f6840"
              />
              <path
                d="M108.56,146.6c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.26,1.28-.87-2.17-.87-2.17-.69,2.5-2.25,1.91-1.69-1.7-1.56-1.77A11.09,11.09,0,0,1,108.56,146.6Z"
                fill="#3ba525"
              />
              <path
                d="M109.12,146.58a1.54,1.54,0,0,0-.6-.7c-.24-.2-.52-.35-.8-.56a1.7,1.7,0,0,1,1,.34,1.54,1.54,0,0,1,.36.4A.79.79,0,0,1,109.12,146.58Z"
                fill="#2f6840"
              />
              <path
                d="M111.72,146c-.19,0-.37,0-.54.07a4.77,4.77,0,0,0-.51.13c-.34.1-.65.26-1,.4a1.79,1.79,0,0,1,.92-.65A1.52,1.52,0,0,1,111.72,146Z"
                fill="#2f6840"
              />
              <path
                d="M110.7,148.38a1.47,1.47,0,0,0-.49-.74c-.22-.21-.48-.38-.73-.6a1.67,1.67,0,0,1,.91.4,1.45,1.45,0,0,1,.3.43A.75.75,0,0,1,110.7,148.38Z"
                fill="#2f6840"
              />
              <path
                d="M109.23,146.92c-.18,0-.35.07-.52.12a2.74,2.74,0,0,0-.48.17,7.6,7.6,0,0,0-.94.48,1.69,1.69,0,0,1,.83-.73A1.58,1.58,0,0,1,109.23,146.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M102.69,144.33c3.31-.19-3.24.34-3.26-.46s3.26-2,3.95-1.83.2,1.68.2,1.68.93-2.08,2.2-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.64,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.71-1.55-1.77A10.78,10.78,0,0,1,102.69,144.33Z"
                fill="#2f6840"
              />
              <path
                d="M102.31,144.07c3.31-.18-3.24.35-3.26-.45s3.26-2,4-1.84.2,1.68.2,1.68.92-2.07,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.71-1.55-1.77A10.78,10.78,0,0,1,102.31,144.07Z"
                fill="#3ba525"
              />
              <path
                d="M102.88,144.05a1.64,1.64,0,0,0-.6-.7c-.24-.2-.53-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.31,1.31,0,0,1,.35.39A.74.74,0,0,1,102.88,144.05Z"
                fill="#2f6840"
              />
              <path
                d="M105.48,143.46a4.41,4.41,0,0,0-.54.07,3.8,3.8,0,0,0-.51.13,9.08,9.08,0,0,0-1,.39,1.85,1.85,0,0,1,.93-.64A1.52,1.52,0,0,1,105.48,143.46Z"
                fill="#2f6840"
              />
              <path
                d="M104.45,145.86a1.41,1.41,0,0,0-.49-.74c-.21-.22-.48-.38-.72-.61a1.62,1.62,0,0,1,.9.41,1.28,1.28,0,0,1,.3.43A.65.65,0,0,1,104.45,145.86Z"
                fill="#2f6840"
              />
              <path
                d="M103,144.4c-.19,0-.36.06-.52.11a2.88,2.88,0,0,0-.49.18,6.86,6.86,0,0,0-.93.48,1.69,1.69,0,0,1,.83-.73A1.47,1.47,0,0,1,103,144.4Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M113.7,155.93c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.48,1.49-3.26,1.28-.87-2.17-.87-2.17-.69,2.5-2.25,1.91-1.69-1.7-1.56-1.77A10.78,10.78,0,0,1,113.7,155.93Z"
                fill="#2f6840"
              />
              <path
                d="M113.32,155.67c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.29-.87-2.18-.87-2.18-.68,2.5-2.25,1.91-1.69-1.7-1.56-1.77A11.09,11.09,0,0,1,113.32,155.67Z"
                fill="#3ba525"
              />
              <path
                d="M113.88,155.65a1.54,1.54,0,0,0-.6-.7c-.24-.2-.52-.35-.8-.56a1.73,1.73,0,0,1,1,.34,1.51,1.51,0,0,1,.35.4A.73.73,0,0,1,113.88,155.65Z"
                fill="#2f6840"
              />
              <path
                d="M116.48,155.05c-.19,0-.36,0-.54.07a4.77,4.77,0,0,0-.51.13c-.34.1-.65.26-1,.4a1.84,1.84,0,0,1,.92-.65A1.52,1.52,0,0,1,116.48,155.05Z"
                fill="#2f6840"
              />
              <path
                d="M115.46,157.45a1.47,1.47,0,0,0-.49-.74c-.22-.21-.48-.38-.73-.6a1.58,1.58,0,0,1,.91.41,1.15,1.15,0,0,1,.3.42A.69.69,0,0,1,115.46,157.45Z"
                fill="#2f6840"
              />
              <path
                d="M114,156c-.19,0-.36.07-.53.12a2.74,2.74,0,0,0-.48.17,7.6,7.6,0,0,0-.94.48,1.76,1.76,0,0,1,.84-.73A1.57,1.57,0,0,1,114,156Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M103.62,151.76c3.32-.19-3.24.34-3.25-.46s3.25-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.27,1.28-.87-2.17-.87-2.17-.68,2.5-2.24,1.91-1.69-1.7-1.56-1.77A10.68,10.68,0,0,1,103.62,151.76Z"
                fill="#2f6840"
              />
              <path
                d="M103.25,151.5c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.64,3,1.15-2.48,1.49-3.27,1.29-.86-2.17-.86-2.17-.69,2.49-2.25,1.9-1.69-1.7-1.56-1.77A11,11,0,0,1,103.25,151.5Z"
                fill="#3ba525"
              />
              <path
                d="M103.81,151.48a1.59,1.59,0,0,0-.6-.7c-.24-.2-.52-.35-.8-.56a1.77,1.77,0,0,1,1,.34,1.72,1.72,0,0,1,.36.4A.79.79,0,0,1,103.81,151.48Z"
                fill="#2f6840"
              />
              <path
                d="M106.41,150.88c-.19,0-.37,0-.54.08a2.39,2.39,0,0,0-.51.13,9,9,0,0,0-1,.39,1.79,1.79,0,0,1,.92-.65A1.62,1.62,0,0,1,106.41,150.88Z"
                fill="#2f6840"
              />
              <path
                d="M105.39,153.29a1.46,1.46,0,0,0-.49-.75c-.22-.21-.48-.37-.73-.6a1.61,1.61,0,0,1,.91.41,1.29,1.29,0,0,1,.3.42A.77.77,0,0,1,105.39,153.29Z"
                fill="#2f6840"
              />
              <path
                d="M103.92,151.82c-.18.05-.35.07-.52.12a2.74,2.74,0,0,0-.48.17,9.29,9.29,0,0,0-.94.48,1.69,1.69,0,0,1,.83-.73A1.58,1.58,0,0,1,103.92,151.82Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M96.36,154.37c3.32-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.92-2.08,2.19-1.62,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.6,10.6,0,0,1,96.36,154.37Z"
                fill="#2f6840"
              />
              <path
                d="M96,154.11c3.32-.19-3.24.34-3.25-.46s3.25-2,4-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.27,1.28-.87-2.17-.87-2.17-.68,2.5-2.24,1.91-1.69-1.7-1.56-1.77A10.9,10.9,0,0,1,96,154.11Z"
                fill="#3ba525"
              />
              <path
                d="M96.55,154.09a1.54,1.54,0,0,0-.6-.7c-.24-.2-.53-.35-.8-.56a1.7,1.7,0,0,1,1,.34,1.35,1.35,0,0,1,.35.4A.74.74,0,0,1,96.55,154.09Z"
                fill="#2f6840"
              />
              <path
                d="M99.15,153.49c-.19,0-.37,0-.54.07a4.23,4.23,0,0,0-.51.13c-.34.1-.65.26-1,.4a1.86,1.86,0,0,1,.93-.65A1.52,1.52,0,0,1,99.15,153.49Z"
                fill="#2f6840"
              />
              <path
                d="M98.13,155.89a1.49,1.49,0,0,0-.5-.74c-.21-.21-.47-.38-.72-.6a1.61,1.61,0,0,1,.9.4,1.28,1.28,0,0,1,.3.43A.7.7,0,0,1,98.13,155.89Z"
                fill="#2f6840"
              />
              <path
                d="M96.66,154.43c-.18,0-.36.07-.52.12a2.48,2.48,0,0,0-.48.17,7,7,0,0,0-.94.48,1.69,1.69,0,0,1,.83-.73A1.57,1.57,0,0,1,96.66,154.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M94.37,160.9c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.83.2,1.68.2,1.68.92-2.08,2.19-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.64,3,1.15-2.47,1.49-3.26,1.29-.87-2.17-.87-2.17-.68,2.49-2.25,1.9-1.69-1.7-1.55-1.77A10.9,10.9,0,0,1,94.37,160.9Z"
                fill="#2f6840"
              />
              <path
                d="M94,160.64c3.32-.19-3.24.34-3.25-.46s3.25-2,4-1.83.2,1.68.2,1.68.92-2.08,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.64,3,1.16-2.48,1.48-3.27,1.28-.87-2.17-.87-2.17-.68,2.49-2.25,1.91-1.69-1.71-1.55-1.78A11.22,11.22,0,0,1,94,160.64Z"
                fill="#3ba525"
              />
              <path
                d="M94.56,160.62a1.59,1.59,0,0,0-.6-.7c-.24-.2-.53-.34-.8-.55a1.76,1.76,0,0,1,1,.33,1.48,1.48,0,0,1,.35.4A.74.74,0,0,1,94.56,160.62Z"
                fill="#2f6840"
              />
              <path
                d="M97.16,160c-.19,0-.37,0-.54.08a2.12,2.12,0,0,0-.51.13,9.91,9.91,0,0,0-1,.39A1.86,1.86,0,0,1,96,160,1.63,1.63,0,0,1,97.16,160Z"
                fill="#2f6840"
              />
              <path
                d="M96.14,162.43a1.4,1.4,0,0,0-.5-.74c-.21-.22-.47-.38-.72-.61a1.62,1.62,0,0,1,.9.41,1.15,1.15,0,0,1,.3.42A.72.72,0,0,1,96.14,162.43Z"
                fill="#2f6840"
              />
              <path
                d="M94.67,161c-.18,0-.36.07-.52.12a2.48,2.48,0,0,0-.48.17,7,7,0,0,0-.94.49,1.65,1.65,0,0,1,.83-.73A1.52,1.52,0,0,1,94.67,161Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M90.37,157.19c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.27,1.29-.87-2.18-.87-2.18-.68,2.5-2.24,1.91S86.83,158.05,87,158A11,11,0,0,1,90.37,157.19Z"
                fill="#2f6840"
              />
              <path
                d="M90,156.93c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.57-3.52,0-3.52,0,4.51.64,3,1.15S92,160,91.26,159.76s-.87-2.17-.87-2.17-.69,2.49-2.25,1.9-1.69-1.7-1.56-1.77A11.42,11.42,0,0,1,90,156.93Z"
                fill="#3ba525"
              />
              <path
                d="M90.55,156.91a1.59,1.59,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.76,1.76,0,0,1,1,.33,1.52,1.52,0,0,1,.36.4A.79.79,0,0,1,90.55,156.91Z"
                fill="#2f6840"
              />
              <path
                d="M93.15,156.31c-.19,0-.37,0-.54.08a2.39,2.39,0,0,0-.51.13,9,9,0,0,0-1,.39,1.79,1.79,0,0,1,.92-.65A1.62,1.62,0,0,1,93.15,156.31Z"
                fill="#2f6840"
              />
              <path
                d="M92.13,158.72a1.46,1.46,0,0,0-.49-.75c-.22-.21-.48-.37-.73-.6a1.61,1.61,0,0,1,.91.41,1.29,1.29,0,0,1,.3.42A.72.72,0,0,1,92.13,158.72Z"
                fill="#2f6840"
              />
              <path
                d="M90.66,157.25c-.18.05-.35.07-.52.12a2.74,2.74,0,0,0-.48.17,7.71,7.71,0,0,0-.94.49,1.65,1.65,0,0,1,.84-.74A1.55,1.55,0,0,1,90.66,157.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M84.12,154.66c3.31-.18-3.24.35-3.26-.45s3.26-2,4-1.84.2,1.68.2,1.68.92-2.07,2.19-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.78,10.78,0,0,1,84.12,154.66Z"
                fill="#2f6840"
              />
              <path
                d="M83.74,154.41c3.32-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.92-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.6,10.6,0,0,1,83.74,154.41Z"
                fill="#3ba525"
              />
              <path
                d="M84.31,154.38a1.64,1.64,0,0,0-.6-.7c-.24-.2-.53-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.23,1.23,0,0,1,.35.4A.71.71,0,0,1,84.31,154.38Z"
                fill="#2f6840"
              />
              <path
                d="M86.91,153.79c-.19,0-.37,0-.54.07a3.8,3.8,0,0,0-.51.13,9.19,9.19,0,0,0-1,.4,1.86,1.86,0,0,1,.93-.65A1.52,1.52,0,0,1,86.91,153.79Z"
                fill="#2f6840"
              />
              <path
                d="M85.88,156.19a1.41,1.41,0,0,0-.49-.74c-.21-.21-.48-.38-.72-.6a1.54,1.54,0,0,1,.9.4,1.28,1.28,0,0,1,.3.43A.65.65,0,0,1,85.88,156.19Z"
                fill="#2f6840"
              />
              <path
                d="M84.42,154.73a4,4,0,0,0-.52.12,2.84,2.84,0,0,0-.49.17,6.86,6.86,0,0,0-.93.48,1.69,1.69,0,0,1,.83-.73A1.52,1.52,0,0,1,84.42,154.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M95.13,166.26c3.31-.19-3.24.34-3.26-.46s3.26-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.29-.87-2.18-.87-2.18-.69,2.5-2.25,1.91-1.69-1.7-1.56-1.77A11.09,11.09,0,0,1,95.13,166.26Z"
                fill="#2f6840"
              />
              <path
                d="M94.75,166c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.72,2.66,2,2.57-3.52,0-3.52,0,4.51.64,3,1.16S96.81,169,96,168.83s-.87-2.17-.87-2.17-.68,2.49-2.25,1.9-1.69-1.7-1.55-1.77A11.22,11.22,0,0,1,94.75,166Z"
                fill="#3ba525"
              />
              <path
                d="M95.31,166a1.53,1.53,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.77,1.77,0,0,1,1,.33,1.68,1.68,0,0,1,.35.4A.73.73,0,0,1,95.31,166Z"
                fill="#2f6840"
              />
              <path
                d="M97.92,165.38c-.2,0-.37,0-.55.08a2.17,2.17,0,0,0-.5.13,8.38,8.38,0,0,0-1,.39,1.84,1.84,0,0,1,.92-.65A1.65,1.65,0,0,1,97.92,165.38Z"
                fill="#2f6840"
              />
              <path
                d="M96.89,167.79a1.39,1.39,0,0,0-.49-.74c-.21-.22-.48-.38-.73-.61a1.58,1.58,0,0,1,.91.41,1.15,1.15,0,0,1,.3.42A.72.72,0,0,1,96.89,167.79Z"
                fill="#2f6840"
              />
              <path
                d="M95.43,166.32c-.19.05-.36.07-.53.12a2.74,2.74,0,0,0-.48.17,7.71,7.71,0,0,0-.94.49,1.73,1.73,0,0,1,.84-.74A1.57,1.57,0,0,1,95.43,166.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M85.06,162.09c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.64,3,1.15-2.48,1.49-3.27,1.29-.87-2.17-.87-2.17-.68,2.49-2.24,1.9-1.69-1.7-1.56-1.77A11,11,0,0,1,85.06,162.09Z"
                fill="#2f6840"
              />
              <path
                d="M84.68,161.83c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.64,3,1.16-2.48,1.48-3.26,1.28-.87-2.17-.87-2.17-.69,2.49-2.25,1.91-1.69-1.71-1.56-1.78A11.42,11.42,0,0,1,84.68,161.83Z"
                fill="#3ba525"
              />
              <path
                d="M85.24,161.81a1.59,1.59,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.76,1.76,0,0,1,1,.33,1.72,1.72,0,0,1,.36.4A.79.79,0,0,1,85.24,161.81Z"
                fill="#2f6840"
              />
              <path
                d="M87.84,161.21c-.19,0-.37,0-.54.08a2.39,2.39,0,0,0-.51.13,9,9,0,0,0-1,.39,1.79,1.79,0,0,1,.92-.65A1.62,1.62,0,0,1,87.84,161.21Z"
                fill="#2f6840"
              />
              <path
                d="M86.82,163.62a1.39,1.39,0,0,0-.49-.74c-.22-.22-.48-.38-.73-.61a1.68,1.68,0,0,1,.91.41,1.29,1.29,0,0,1,.3.42A.77.77,0,0,1,86.82,163.62Z"
                fill="#2f6840"
              />
              <path
                d="M85.35,162.15c-.18,0-.35.07-.52.12a3.9,3.9,0,0,0-.48.17,7.71,7.71,0,0,0-.94.49,1.67,1.67,0,0,1,.84-.73A1.5,1.5,0,0,1,85.35,162.15Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M77.38,163.67c3.31-.18-3.24.35-3.26-.45s3.26-2,3.95-1.84.2,1.68.2,1.68.93-2.07,2.19-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.69,2.5-2.25,1.91-1.69-1.71-1.56-1.77A11,11,0,0,1,77.38,163.67Z"
                fill="#2f6840"
              />
              <path
                d="M77,163.42c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.72,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.6,10.6,0,0,1,77,163.42Z"
                fill="#3ba525"
              />
              <path
                d="M77.56,163.39a1.64,1.64,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.73,1.73,0,0,1,1,.34,1.36,1.36,0,0,1,.35.4A.71.71,0,0,1,77.56,163.39Z"
                fill="#2f6840"
              />
              <path
                d="M80.17,162.8c-.2,0-.37,0-.55.07a4.77,4.77,0,0,0-.51.13,9.06,9.06,0,0,0-1,.4,1.78,1.78,0,0,1,.92-.65A1.55,1.55,0,0,1,80.17,162.8Z"
                fill="#2f6840"
              />
              <path
                d="M79.14,165.2a1.47,1.47,0,0,0-.49-.74c-.21-.22-.48-.38-.73-.61a1.65,1.65,0,0,1,.91.41,1.28,1.28,0,0,1,.3.43A.69.69,0,0,1,79.14,165.2Z"
                fill="#2f6840"
              />
              <path
                d="M77.68,163.74a4.12,4.12,0,0,0-.53.12,2.11,2.11,0,0,0-.48.17,7.6,7.6,0,0,0-.94.48,1.76,1.76,0,0,1,.84-.73A1.47,1.47,0,0,1,77.68,163.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M75.39,170.21c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.48,1.49-3.26,1.28-.87-2.17-.87-2.17-.69,2.5-2.25,1.91S71.85,171.07,72,171A10.78,10.78,0,0,1,75.39,170.21Z"
                fill="#2f6840"
              />
              <path
                d="M75,170c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.64,3,1.15-2.47,1.49-3.26,1.29-.87-2.17-.87-2.17-.68,2.49-2.25,1.9-1.69-1.7-1.56-1.77A11.09,11.09,0,0,1,75,170Z"
                fill="#3ba525"
              />
              <path
                d="M75.57,169.93a1.59,1.59,0,0,0-.6-.7c-.24-.2-.52-.35-.8-.56a1.83,1.83,0,0,1,1,.34,1.52,1.52,0,0,1,.36.4A.79.79,0,0,1,75.57,169.93Z"
                fill="#2f6840"
              />
              <path
                d="M78.17,169.33c-.19,0-.36,0-.54.08a2.39,2.39,0,0,0-.51.13,9,9,0,0,0-1,.39,1.84,1.84,0,0,1,.92-.65A1.62,1.62,0,0,1,78.17,169.33Z"
                fill="#2f6840"
              />
              <path
                d="M77.15,171.74a1.46,1.46,0,0,0-.49-.75c-.22-.21-.48-.37-.73-.6a1.58,1.58,0,0,1,.91.41,1.15,1.15,0,0,1,.3.42A.72.72,0,0,1,77.15,171.74Z"
                fill="#2f6840"
              />
              <path
                d="M75.69,170.27c-.19,0-.36.07-.53.12a2.74,2.74,0,0,0-.48.17,9.29,9.29,0,0,0-.94.48,1.76,1.76,0,0,1,.84-.73A1.57,1.57,0,0,1,75.69,170.27Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M71.38,166.5c3.31-.19-3.24.34-3.26-.46s3.26-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.2-1.62,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.6,10.6,0,0,1,71.38,166.5Z"
                fill="#2f6840"
              />
              <path
                d="M71,166.24c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.92-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.47,1.49-3.26,1.29-.87-2.18-.87-2.18-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.9,10.9,0,0,1,71,166.24Z"
                fill="#3ba525"
              />
              <path
                d="M71.57,166.22a1.54,1.54,0,0,0-.6-.7c-.24-.2-.53-.35-.8-.56a1.7,1.7,0,0,1,1,.34,1.35,1.35,0,0,1,.35.4A.74.74,0,0,1,71.57,166.22Z"
                fill="#2f6840"
              />
              <path
                d="M74.17,165.62c-.19,0-.37,0-.54.07a2.73,2.73,0,0,0-.51.14,9.08,9.08,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.52,1.52,0,0,1,74.17,165.62Z"
                fill="#2f6840"
              />
              <path
                d="M73.14,168a1.41,1.41,0,0,0-.49-.74c-.21-.21-.48-.38-.72-.6a1.56,1.56,0,0,1,.9.41,1.15,1.15,0,0,1,.3.42A.65.65,0,0,1,73.14,168Z"
                fill="#2f6840"
              />
              <path
                d="M71.68,166.56c-.19,0-.36.07-.52.12a2.84,2.84,0,0,0-.49.17,6.86,6.86,0,0,0-.93.48,1.69,1.69,0,0,1,.83-.73A1.57,1.57,0,0,1,71.68,166.56Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M65.14,164c3.31-.19-3.24.34-3.26-.45s3.25-2,3.95-1.84.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16S67.19,167,66.4,166.8s-.86-2.17-.86-2.17-.69,2.5-2.25,1.91-1.69-1.71-1.56-1.77A11,11,0,0,1,65.14,164Z"
                fill="#2f6840"
              />
              <path
                d="M64.76,163.71c3.31-.18-3.24.35-3.26-.45s3.26-2,4-1.84.2,1.68.2,1.68.93-2.07,2.19-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.69,2.5-2.25,1.91-1.69-1.7-1.56-1.77A11,11,0,0,1,64.76,163.71Z"
                fill="#3ba525"
              />
              <path
                d="M65.32,163.69a1.64,1.64,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.67,1.67,0,0,1,1,.34,1.26,1.26,0,0,1,.36.4A.75.75,0,0,1,65.32,163.69Z"
                fill="#2f6840"
              />
              <path
                d="M67.92,163.1a4.68,4.68,0,0,0-.54.07,4.77,4.77,0,0,0-.51.13,9,9,0,0,0-1,.39,1.82,1.82,0,0,1,.92-.64A1.52,1.52,0,0,1,67.92,163.1Z"
                fill="#2f6840"
              />
              <path
                d="M66.9,165.5a1.47,1.47,0,0,0-.49-.74c-.22-.22-.48-.38-.73-.61a1.65,1.65,0,0,1,.91.41,1.45,1.45,0,0,1,.3.43A.69.69,0,0,1,66.9,165.5Z"
                fill="#2f6840"
              />
              <path
                d="M65.43,164a4.37,4.37,0,0,0-.52.12,2.11,2.11,0,0,0-.48.17,7.6,7.6,0,0,0-.94.48,1.67,1.67,0,0,1,.84-.73A1.45,1.45,0,0,1,65.43,164Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M76.14,175.57c3.32-.19-3.24.34-3.26-.46s3.26-2,4-1.84S77,175,77,175s.92-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16-2.48,1.49-3.27,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.6,10.6,0,0,1,76.14,175.57Z"
                fill="#2f6840"
              />
              <path
                d="M75.76,175.31c3.32-.19-3.24.34-3.25-.46s3.25-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.64,3,1.15-2.48,1.49-3.27,1.29-.87-2.18-.87-2.18-.68,2.5-2.24,1.91-1.69-1.7-1.56-1.77A11,11,0,0,1,75.76,175.31Z"
                fill="#3ba525"
              />
              <path
                d="M76.33,175.29a1.54,1.54,0,0,0-.6-.7c-.24-.2-.53-.35-.8-.56a1.77,1.77,0,0,1,1,.34,1.48,1.48,0,0,1,.35.4A.74.74,0,0,1,76.33,175.29Z"
                fill="#2f6840"
              />
              <path
                d="M78.93,174.69c-.19,0-.37,0-.54.07a3,3,0,0,0-.51.14,9.91,9.91,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.63,1.63,0,0,1,78.93,174.69Z"
                fill="#2f6840"
              />
              <path
                d="M77.91,177.09a1.49,1.49,0,0,0-.5-.74c-.21-.21-.47-.37-.72-.6a1.56,1.56,0,0,1,.9.41,1.31,1.31,0,0,1,.31.42A.75.75,0,0,1,77.91,177.09Z"
                fill="#2f6840"
              />
              <path
                d="M76.44,175.63c-.18,0-.36.07-.52.12a2.48,2.48,0,0,0-.48.17,7,7,0,0,0-.94.48,1.69,1.69,0,0,1,.83-.73A1.57,1.57,0,0,1,76.44,175.63Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M66.07,171.4c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.93-2.08,2.2-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.9,10.9,0,0,1,66.07,171.4Z"
                fill="#2f6840"
              />
              <path
                d="M65.69,171.14c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.83.2,1.68.2,1.68.92-2.08,2.19-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.64,3,1.15S67.75,174.17,67,174s-.87-2.17-.87-2.17-.68,2.49-2.25,1.9-1.69-1.7-1.55-1.77A11.22,11.22,0,0,1,65.69,171.14Z"
                fill="#3ba525"
              />
              <path
                d="M66.26,171.12a1.59,1.59,0,0,0-.6-.7c-.24-.2-.53-.34-.8-.55a1.76,1.76,0,0,1,1,.33,1.48,1.48,0,0,1,.35.4A.74.74,0,0,1,66.26,171.12Z"
                fill="#2f6840"
              />
              <path
                d="M68.86,170.52c-.19,0-.37,0-.54.08a2.12,2.12,0,0,0-.51.13,9.08,9.08,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.63,1.63,0,0,1,68.86,170.52Z"
                fill="#2f6840"
              />
              <path
                d="M67.83,172.93a1.4,1.4,0,0,0-.49-.75c-.21-.21-.48-.37-.73-.6a1.56,1.56,0,0,1,.91.41,1.15,1.15,0,0,1,.3.42A.67.67,0,0,1,67.83,172.93Z"
                fill="#2f6840"
              />
              <path
                d="M66.37,171.46c-.19,0-.36.07-.52.12a2.84,2.84,0,0,0-.49.17,8.22,8.22,0,0,0-.93.48,1.69,1.69,0,0,1,.83-.73A1.57,1.57,0,0,1,66.37,171.46Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M56.38,163.91c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.93-2.08,2.2-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.6,10.6,0,0,1,56.38,163.91Z"
                fill="#2f6840"
              />
              <path
                d="M56,163.65c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.92-2.08,2.19-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.64,3,1.15-2.47,1.49-3.26,1.29-.87-2.18-.87-2.18-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.9,10.9,0,0,1,56,163.65Z"
                fill="#3ba525"
              />
              <path
                d="M56.56,163.63a1.46,1.46,0,0,0-.59-.7c-.24-.2-.53-.35-.8-.56a1.77,1.77,0,0,1,1,.34,1.48,1.48,0,0,1,.35.4A.69.69,0,0,1,56.56,163.63Z"
                fill="#2f6840"
              />
              <path
                d="M59.17,163c-.19,0-.37,0-.54.07a2.73,2.73,0,0,0-.51.14,9.08,9.08,0,0,0-1,.39A1.86,1.86,0,0,1,58,163,1.63,1.63,0,0,1,59.17,163Z"
                fill="#2f6840"
              />
              <path
                d="M58.14,165.43a1.41,1.41,0,0,0-.49-.74c-.21-.21-.48-.37-.73-.6a1.56,1.56,0,0,1,.91.41,1.15,1.15,0,0,1,.3.42A.65.65,0,0,1,58.14,165.43Z"
                fill="#2f6840"
              />
              <path
                d="M56.68,164c-.19,0-.36.07-.52.12a2.84,2.84,0,0,0-.49.17,6.86,6.86,0,0,0-.93.48,1.69,1.69,0,0,1,.83-.73A1.57,1.57,0,0,1,56.68,164Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M54.39,170.44c3.31-.19-3.24.34-3.26-.46s3.26-2,3.95-1.83.2,1.68.2,1.68.93-2.08,2.2-1.61,2.71,2.66,2,2.57-3.52,0-3.52,0,4.51.64,3,1.15-2.47,1.49-3.26,1.29-.87-2.17-.87-2.17-.68,2.49-2.25,1.9-1.69-1.7-1.55-1.77A11.22,11.22,0,0,1,54.39,170.44Z"
                fill="#2f6840"
              />
              <path
                d="M54,170.18c3.31-.19-3.24.34-3.26-.45s3.26-2,4-1.84.2,1.68.2,1.68.92-2.08,2.19-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.48-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91S50.47,171,50.61,171A10.78,10.78,0,0,1,54,170.18Z"
                fill="#3ba525"
              />
              <path
                d="M54.57,170.16a1.56,1.56,0,0,0-.59-.7c-.24-.2-.53-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.31,1.31,0,0,1,.35.39A.69.69,0,0,1,54.57,170.16Z"
                fill="#2f6840"
              />
              <path
                d="M57.18,169.57a4.41,4.41,0,0,0-.54.07,2.12,2.12,0,0,0-.51.13,9.08,9.08,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.58,1.58,0,0,1,57.18,169.57Z"
                fill="#2f6840"
              />
              <path
                d="M56.15,172a1.39,1.39,0,0,0-.49-.74c-.21-.22-.48-.38-.73-.61a1.62,1.62,0,0,1,.91.41,1.11,1.11,0,0,1,.3.43A.65.65,0,0,1,56.15,172Z"
                fill="#2f6840"
              />
              <path
                d="M54.69,170.5c-.19.05-.36.07-.52.12a4,4,0,0,0-.49.17,7,7,0,0,0-.93.49,1.69,1.69,0,0,1,.83-.73A1.52,1.52,0,0,1,54.69,170.5Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M50.38,166.73c3.32-.19-3.24.34-3.25-.46s3.25-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.64,3,1.15-2.48,1.49-3.27,1.29-.87-2.18-.87-2.18-.68,2.5-2.25,1.91-1.68-1.7-1.55-1.77A10.9,10.9,0,0,1,50.38,166.73Z"
                fill="#2f6840"
              />
              <path
                d="M50,166.47c3.32-.19-3.24.34-3.25-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.57-3.51,0-3.51,0,4.5.64,3,1.16-2.48,1.48-3.27,1.28-.87-2.17-.87-2.17-.68,2.49-2.24,1.91-1.69-1.71-1.56-1.78A11.31,11.31,0,0,1,50,166.47Z"
                fill="#3ba525"
              />
              <path
                d="M50.57,166.45a1.59,1.59,0,0,0-.6-.7c-.24-.2-.53-.34-.8-.55a1.76,1.76,0,0,1,1,.33,1.48,1.48,0,0,1,.35.4A.74.74,0,0,1,50.57,166.45Z"
                fill="#2f6840"
              />
              <path
                d="M53.17,165.85c-.19,0-.37,0-.54.08a2.25,2.25,0,0,0-.51.13,9.91,9.91,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.62,1.62,0,0,1,53.17,165.85Z"
                fill="#2f6840"
              />
              <path
                d="M52.15,168.26a1.4,1.4,0,0,0-.5-.74c-.21-.22-.47-.38-.72-.61a1.68,1.68,0,0,1,.91.41,1.45,1.45,0,0,1,.3.42A.77.77,0,0,1,52.15,168.26Z"
                fill="#2f6840"
              />
              <path
                d="M50.68,166.79c-.18.05-.35.07-.52.12a2.48,2.48,0,0,0-.48.17,7,7,0,0,0-.94.49,1.65,1.65,0,0,1,.83-.73A1.52,1.52,0,0,1,50.68,166.79Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M44.14,164.21c3.31-.19-3.24.34-3.26-.46s3.26-2,3.95-1.84.2,1.69.2,1.69.93-2.08,2.19-1.62,2.72,2.66,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16-2.47,1.49-3.26,1.28-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.6,10.6,0,0,1,44.14,164.21Z"
                fill="#2f6840"
              />
              <path
                d="M43.76,164c3.31-.19-3.24.34-3.26-.46s3.26-2,4-1.84.2,1.69.2,1.69.93-2.08,2.2-1.62,2.71,2.67,2,2.58-3.52,0-3.52,0,4.51.65,3,1.16S45.82,167,45,166.77s-.87-2.17-.87-2.17-.68,2.5-2.25,1.91-1.69-1.7-1.55-1.77A10.9,10.9,0,0,1,43.76,164Z"
                fill="#3ba525"
              />
              <path
                d="M44.32,163.93a1.46,1.46,0,0,0-.59-.7c-.24-.2-.53-.35-.8-.56a1.7,1.7,0,0,1,1,.34,1.35,1.35,0,0,1,.35.4A.73.73,0,0,1,44.32,163.93Z"
                fill="#2f6840"
              />
              <path
                d="M46.93,163.33c-.19,0-.37,0-.55.07a4.07,4.07,0,0,0-.5.13,9.19,9.19,0,0,0-1,.4,1.82,1.82,0,0,1,.93-.65A1.52,1.52,0,0,1,46.93,163.33Z"
                fill="#2f6840"
              />
              <path
                d="M45.9,165.73a1.47,1.47,0,0,0-.49-.74c-.21-.21-.48-.38-.73-.6a1.61,1.61,0,0,1,.91.4,1.28,1.28,0,0,1,.3.43A.69.69,0,0,1,45.9,165.73Z"
                fill="#2f6840"
              />
              <path
                d="M44.44,164.27c-.19,0-.36.07-.53.12a3.06,3.06,0,0,0-.48.17,6.86,6.86,0,0,0-.93.48,1.69,1.69,0,0,1,.83-.73A1.57,1.57,0,0,1,44.44,164.27Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M55.15,175.8c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.62,2.71,2.67,2,2.58-3.51,0-3.51,0,4.5.64,3,1.15-2.48,1.49-3.27,1.29-.87-2.17-.87-2.17-.68,2.49-2.24,1.9-1.69-1.7-1.56-1.77A11,11,0,0,1,55.15,175.8Z"
                fill="#2f6840"
              />
              <path
                d="M54.77,175.54c3.31-.19-3.24.34-3.26-.46s3.25-2,4-1.83.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.58-3.52,0-3.52,0,4.51.64,3,1.16-2.48,1.48-3.26,1.28-.87-2.17-.87-2.17-.69,2.49-2.25,1.91-1.69-1.71-1.56-1.78A11.42,11.42,0,0,1,54.77,175.54Z"
                fill="#3ba525"
              />
              <path
                d="M55.33,175.52a1.59,1.59,0,0,0-.6-.7c-.24-.2-.52-.34-.8-.55a1.76,1.76,0,0,1,1,.33,1.52,1.52,0,0,1,.36.4A.79.79,0,0,1,55.33,175.52Z"
                fill="#2f6840"
              />
              <path
                d="M57.93,174.92c-.19,0-.37,0-.54.08a2.39,2.39,0,0,0-.51.13,9,9,0,0,0-1,.39,1.79,1.79,0,0,1,.92-.65A1.62,1.62,0,0,1,57.93,174.92Z"
                fill="#2f6840"
              />
              <path
                d="M56.91,177.33a1.39,1.39,0,0,0-.49-.74c-.22-.22-.48-.38-.73-.61a1.68,1.68,0,0,1,.91.41,1.29,1.29,0,0,1,.3.42A.72.72,0,0,1,56.91,177.33Z"
                fill="#2f6840"
              />
              <path
                d="M55.44,175.86c-.18,0-.35.07-.52.12a2.74,2.74,0,0,0-.48.17,7.71,7.71,0,0,0-.94.49,1.63,1.63,0,0,1,.84-.73A1.5,1.5,0,0,1,55.44,175.86Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M45.07,171.63c3.32-.19-3.24.34-3.25-.46s3.25-2,4-1.83S46,171,46,171s.92-2.08,2.19-1.61,2.71,2.66,2,2.57-3.51,0-3.51,0,4.5.64,3,1.16-2.48,1.48-3.27,1.28-.87-2.17-.87-2.17-.68,2.49-2.25,1.9-1.69-1.7-1.55-1.77A11.22,11.22,0,0,1,45.07,171.63Z"
                fill="#2f6840"
              />
              <path
                d="M44.69,171.37c3.32-.19-3.24.34-3.25-.45s3.25-2,4-1.84.2,1.68.2,1.68.93-2.08,2.19-1.61,2.71,2.66,2,2.58-3.51,0-3.51,0,4.5.65,3,1.16S46.75,174.4,46,174.2s-.87-2.17-.87-2.17-.68,2.5-2.24,1.91-1.69-1.71-1.56-1.77A10.87,10.87,0,0,1,44.69,171.37Z"
                fill="#3ba525"
              />
              <path
                d="M45.26,171.35a1.64,1.64,0,0,0-.6-.7c-.24-.2-.53-.34-.8-.55a1.7,1.7,0,0,1,1,.34,1.31,1.31,0,0,1,.35.39A.74.74,0,0,1,45.26,171.35Z"
                fill="#2f6840"
              />
              <path
                d="M47.86,170.76a4.41,4.41,0,0,0-.54.07,2.25,2.25,0,0,0-.51.13,9.91,9.91,0,0,0-1,.39,1.86,1.86,0,0,1,.93-.65A1.57,1.57,0,0,1,47.86,170.76Z"
                fill="#2f6840"
              />
              <path
                d="M46.84,173.16a1.4,1.4,0,0,0-.5-.74c-.21-.22-.47-.38-.72-.61a1.62,1.62,0,0,1,.9.41,1.35,1.35,0,0,1,.31.43A.75.75,0,0,1,46.84,173.16Z"
                fill="#2f6840"
              />
              <path
                d="M45.37,171.69c-.18.05-.36.07-.52.12a3.39,3.39,0,0,0-.48.17,7,7,0,0,0-.94.49,1.69,1.69,0,0,1,.83-.73A1.52,1.52,0,0,1,45.37,171.69Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M67.78,166.22s.42,2.55,1.36,3.26,2.63-.39,2.24.86,1.62,2.54,2.56,2.48,3.3-2.55,3.41-3.54S67.78,166.22,67.78,166.22Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M68,164.32l-.21,1.9,1.46,2.51,2.22.63.35,1.56s1.37,1.67,2.54.73a11.2,11.2,0,0,0,2.22-2.91l.2-1.9Z"
              fill="#ccae79"
            />
            <path
              d="M69.92,163.6l-1.93.72,1.58,2.54,2.12.6.52,1.66s2,1.6,2.34.67a17.14,17.14,0,0,1,2.22-2.95l-1.51-1.7Z"
              fill="#ffedc8"
            />
            <polygon
              points="69.57 166.86 69.24 168.73 71.46 169.36 71.69 167.46 69.57 166.86"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M74,170.07s.15,1.84-.2,1.85a6.45,6.45,0,0,0,2.8-3.18l.2-1.9S74.46,170.22,74,170.07Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M72.57,169.39l.41.26s-.25-.2-.29.62A2.73,2.73,0,0,0,72.57,169.39Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M73.5,170s.08,0,.54-.49a4,4,0,0,0,.67-1.13s-1.1,1.39-.91,1.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M68.91,165.8s0,.81-.15,1.38c0,0,.08-1.05.28-1.17Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M72.46,164.33l.84.25c.07,0-.66-.2-.9.37l.06-.62"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M69,164l.48-.18s-.28.18-.19.26.45.48.63.4.42.15.42.15Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M169.38,154.34,171,156a.35.35,0,0,0,.49.05l3.79-2.77a1.17,1.17,0,0,0,.13-1.41h0a.4.4,0,0,0-.41-.2l-5.37,1.18C169.11,152.9,169,153.93,169.38,154.34Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="172.19 147.92 170.05 148.66 168.16 151.03 171.32 153.1 175.19 150.51 172.19 147.92"
              fill="#ffedc8"
            />
            <polygon
              points="168.16 151.03 168.16 153.1 171.2 155.23 175.28 152.52 175.19 150.51 171.32 153.1 168.16 151.03"
              fill="#ccae79"
            />
            <polygon
              points="171.32 153.1 171.2 155.23 175.28 152.52 175.19 150.51 171.32 153.1"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M169.07,151.62a1.45,1.45,0,0,1,0,1.07c.14-.34.17-.95.24-.91S169.07,151.62,169.07,151.62Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M170.4,152.5a2.63,2.63,0,0,0,.8-1.33l-.58,1.48Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M172.92,152a1.11,1.11,0,0,1,.32.84l-.1-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M174.34,149.77s-.8.25-1.26,0a1.13,1.13,0,0,1-.92.1s.68-.1.92.27A3.63,3.63,0,0,1,174.34,149.77Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M165.82,145.86l1.58,1.61a.34.34,0,0,0,.48.05l3.8-2.77a1.18,1.18,0,0,0,.13-1.41h0a.4.4,0,0,0-.41-.2L166,144.31C165.55,144.42,165.41,145.45,165.82,145.86Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="168.63 139.43 166.49 140.18 164.6 142.55 167.76 144.62 171.63 142.03 168.63 139.43"
              fill="#ffedc8"
            />
            <polygon
              points="164.6 142.55 164.6 144.62 167.64 146.75 171.72 144.04 171.63 142.03 167.76 144.62 164.6 142.55"
              fill="#ccae79"
            />
            <polygon
              points="167.76 144.62 167.64 146.75 171.72 144.04 171.63 142.03 167.76 144.62"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M165.51,143.14a1.45,1.45,0,0,1,0,1.07c.14-.34.17-1,.24-.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M166.84,144a2.63,2.63,0,0,0,.8-1.33l-.58,1.47Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M169.36,143.55a1.09,1.09,0,0,1,.32.84l-.1-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M170.77,141.29s-.79.25-1.25,0a1.13,1.13,0,0,1-.92.1s.68-.1.92.27A3.54,3.54,0,0,1,170.77,141.29Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M158,139.1l1.58,1.61a.34.34,0,0,0,.48,0l3.79-2.78a1.15,1.15,0,0,0,.13-1.4h0a.4.4,0,0,0-.4-.2l-5.38,1.17C157.69,137.66,157.56,138.68,158,139.1Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="160.77 132.67 158.63 133.42 156.75 135.79 159.91 137.86 163.78 135.27 160.77 132.67"
              fill="#ffedc8"
            />
            <polygon
              points="156.75 135.79 156.75 137.86 159.78 139.99 163.86 137.28 163.78 135.27 159.91 137.86 156.75 135.79"
              fill="#ccae79"
            />
            <polygon
              points="159.91 137.86 159.78 139.99 163.86 137.28 163.78 135.27 159.91 137.86"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M157.65,136.38a1.42,1.42,0,0,1,0,1.06c.14-.33.18-.94.24-.9Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M159,137.25a2.48,2.48,0,0,0,.8-1.32l-.57,1.47Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M161.5,136.79a1.05,1.05,0,0,1,.32.84l-.1-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M162.92,134.53s-.8.25-1.26,0a1.11,1.11,0,0,1-.91.1s.67-.11.91.27A3.63,3.63,0,0,1,162.92,134.53Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M158.28,149.41l1.58,1.61a.34.34,0,0,0,.48,0l3.79-2.78a1.15,1.15,0,0,0,.13-1.4h0a.4.4,0,0,0-.41-.2l-5.37,1.17C158,148,157.87,149,158.28,149.41Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="161.08 142.98 158.94 143.73 157.06 146.1 160.22 148.17 164.08 145.58 161.08 142.98"
              fill="#ffedc8"
            />
            <polygon
              points="157.06 146.1 157.06 148.17 160.09 150.3 164.17 147.59 164.08 145.58 160.22 148.17 157.06 146.1"
              fill="#ccae79"
            />
            <polygon
              points="160.22 148.17 160.09 150.3 164.17 147.59 164.08 145.58 160.22 148.17"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M158,146.69a1.44,1.44,0,0,1,0,1.07c.14-.34.17-.95.24-.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M159.29,147.57a2.63,2.63,0,0,0,.8-1.33l-.57,1.47Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M161.81,147.1a1.05,1.05,0,0,1,.32.84l-.1-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M163.23,144.84s-.8.25-1.26,0a1.11,1.11,0,0,1-.91.1s.67-.1.91.27A3.63,3.63,0,0,1,163.23,144.84Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M52.48,173.49l1.58,1.6a.35.35,0,0,0,.48.06l3.79-2.78a1.17,1.17,0,0,0,.13-1.41h0a.39.39,0,0,0-.41-.19l-5.37,1.17C52.2,172,52.07,173.07,52.48,173.49Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="55.28 167.06 53.14 167.8 51.26 170.17 54.41 172.25 58.28 169.65 55.28 167.06"
              fill="#ffedc8"
            />
            <polygon
              points="51.26 170.17 51.26 172.25 54.29 174.37 58.37 171.66 58.28 169.65 54.41 172.25 51.26 170.17"
              fill="#ccae79"
            />
            <polygon
              points="54.41 172.25 54.29 174.37 58.37 171.66 58.28 169.65 54.41 172.25"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M52.16,170.77a1.42,1.42,0,0,1,0,1.06c.14-.33.17-1,.24-.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M53.49,171.64a2.63,2.63,0,0,0,.8-1.33l-.58,1.48Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M56,171.18a1.08,1.08,0,0,1,.32.83l-.1-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M57.43,168.91s-.8.25-1.26,0a1.13,1.13,0,0,1-.91.11s.67-.11.91.27A3.5,3.5,0,0,1,57.43,168.91Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M60.05,168.71l1.58,1.61a.36.36,0,0,0,.48.05l3.8-2.78a1.15,1.15,0,0,0,.12-1.4h0a.39.39,0,0,0-.4-.2l-5.38,1.17C59.78,167.27,59.64,168.29,60.05,168.71Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="62.86 162.28 60.72 163.03 58.83 165.4 61.99 167.47 65.86 164.88 62.86 162.28"
              fill="#ffedc8"
            />
            <polygon
              points="58.83 165.4 58.83 167.47 61.86 169.6 65.94 166.89 65.86 164.88 61.99 167.47 58.83 165.4"
              fill="#ccae79"
            />
            <polygon
              points="61.99 167.47 61.86 169.6 65.94 166.89 65.86 164.88 61.99 167.47"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M59.73,166a1.42,1.42,0,0,1,0,1.06c.15-.33.18-1,.24-.9Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M61.07,166.86a2.52,2.52,0,0,0,.79-1.32L61.29,167Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M63.59,166.4a1.06,1.06,0,0,1,.31.84l-.09-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M65,164.14s-.8.25-1.25,0a1.18,1.18,0,0,1-.92.1s.67-.11.92.27A3.54,3.54,0,0,1,65,164.14Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M62.53,175.58l1.58,1.6a.35.35,0,0,0,.48.06l3.8-2.78a1.15,1.15,0,0,0,.12-1.4h0a.39.39,0,0,0-.4-.2L62.73,174C62.26,174.13,62.12,175.16,62.53,175.58Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="65.34 169.15 63.2 169.89 61.31 172.26 64.47 174.34 68.34 171.74 65.34 169.15"
              fill="#ffedc8"
            />
            <polygon
              points="61.31 172.26 61.31 174.34 64.34 176.47 68.42 173.75 68.34 171.74 64.47 174.34 61.31 172.26"
              fill="#ccae79"
            />
            <polygon
              points="64.47 174.34 64.34 176.47 68.42 173.75 68.34 171.74 64.47 174.34"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M62.21,172.86a1.42,1.42,0,0,1,0,1.06c.15-.33.18-.95.24-.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M63.55,173.73a2.59,2.59,0,0,0,.79-1.33l-.57,1.48Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M66.07,173.27a1.05,1.05,0,0,1,.31.83l-.09-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M67.48,171s-.8.25-1.25,0a1.16,1.16,0,0,1-.92.11s.67-.11.92.27A3.41,3.41,0,0,1,67.48,171Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M94.83,156.79,96,158a.26.26,0,0,0,.36,0L99.19,156a.88.88,0,0,0,.09-1.05h0a.3.3,0,0,0-.3-.15l-4,.87C94.62,155.71,94.52,156.48,94.83,156.79Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="96.92 152 95.32 152.56 93.92 154.32 96.27 155.87 99.15 153.93 96.92 152"
              fill="#ffedc8"
            />
            <polygon
              points="93.92 154.32 93.92 155.87 96.17 157.45 99.21 155.43 99.15 153.93 96.27 155.87 93.92 154.32"
              fill="#ccae79"
            />
            <polygon
              points="96.27 155.87 96.17 157.45 99.21 155.43 99.15 153.93 96.27 155.87"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M94.59,154.76a1.06,1.06,0,0,1,0,.79c.11-.24.13-.7.18-.67Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M95.58,155.41a1.91,1.91,0,0,0,.6-1l-.43,1.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M97.46,155.07a.78.78,0,0,1,.23.62l-.07-.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M98.51,153.38s-.59.19-.93,0a.85.85,0,0,1-.68.08s.5-.08.68.2A2.68,2.68,0,0,1,98.51,153.38Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M98.88,152.09l.88.89a.19.19,0,0,0,.26,0l2.11-1.54a.64.64,0,0,0,.07-.78h0a.21.21,0,0,0-.23-.11l-3,.65C98.73,151.29,98.65,151.86,98.88,152.09Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="100.44 148.52 99.25 148.94 98.21 150.25 99.96 151.4 102.1 149.96 100.44 148.52"
              fill="#ffedc8"
            />
            <polygon
              points="98.21 150.25 98.21 151.4 99.89 152.58 102.15 151.08 102.1 149.96 99.96 151.4 98.21 150.25"
              fill="#ccae79"
            />
            <polygon
              points="99.96 151.4 99.89 152.58 102.15 151.08 102.1 149.96 99.96 151.4"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M98.71,150.58a.81.81,0,0,1,0,.59c.08-.19.09-.53.13-.5Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M99.44,151.06a1.36,1.36,0,0,0,.45-.73l-.32.81Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M100.84,150.81a.6.6,0,0,1,.18.46l0-.55Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M101.63,149.55s-.45.14-.7,0a.64.64,0,0,1-.51.06s.38-.06.51.15A2,2,0,0,1,101.63,149.55Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M100.26,146.42l.87.89a.18.18,0,0,0,.27,0l2.1-1.54a.64.64,0,0,0,.07-.78h0a.24.24,0,0,0-.22-.11l-3,.65C100.1,145.62,100,146.19,100.26,146.42Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="101.81 142.86 100.63 143.27 99.58 144.59 101.33 145.74 103.48 144.3 101.81 142.86"
              fill="#ffedc8"
            />
            <polygon
              points="99.58 144.59 99.58 145.74 101.26 146.91 103.52 145.41 103.48 144.3 101.33 145.74 99.58 144.59"
              fill="#ccae79"
            />
            <polygon
              points="101.33 145.74 101.26 146.91 103.52 145.41 103.48 144.3 101.33 145.74"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M100.08,144.91a.82.82,0,0,1,0,.59c.08-.18.1-.52.13-.5Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M100.82,145.4a1.47,1.47,0,0,0,.44-.74l-.32.82Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M102.22,145.14a.58.58,0,0,1,.17.47l0-.55Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M287.54,128.16s-.45.14-.7,0a.61.61,0,0,1-.51.05s.37-.05.51.15A1.93,1.93,0,0,1,287.54,128.16Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M92.08,150.45l1.18,1.2a.25.25,0,0,0,.35,0l2.83-2.07a.85.85,0,0,0,.09-1h0a.28.28,0,0,0-.3-.15l-4,.87C91.87,149.38,91.77,150.14,92.08,150.45Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="94.17 145.67 92.57 146.22 91.17 147.99 93.52 149.53 96.4 147.6 94.17 145.67"
              fill="#ffedc8"
            />
            <polygon
              points="91.17 147.99 91.17 149.53 93.43 151.11 96.47 149.09 96.4 147.6 93.52 149.53 91.17 147.99"
              fill="#ccae79"
            />
            <polygon
              points="93.52 149.53 93.43 151.11 96.47 149.09 96.4 147.6 93.52 149.53"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M91.84,148.43a1.06,1.06,0,0,1,0,.79c.11-.25.13-.71.18-.68Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M92.83,149.08a1.92,1.92,0,0,0,.6-1l-.43,1.1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M94.71,148.73a.8.8,0,0,1,.24.63l-.07-.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M95.76,147.05s-.59.18-.93,0a.82.82,0,0,1-.68.07s.5-.07.68.2A2.65,2.65,0,0,1,95.76,147.05Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M169.06,137.42l2.13,2.16a.46.46,0,0,0,.64.07l5.1-3.73a1.56,1.56,0,0,0,.17-1.89h0a.52.52,0,0,0-.54-.26l-7.22,1.57C168.69,135.48,168.51,136.86,169.06,137.42Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="172.83 128.79 169.96 129.79 167.43 132.97 171.67 135.76 176.86 132.27 172.83 128.79"
              fill="#ffedc8"
            />
            <polygon
              points="167.43 132.97 167.43 135.76 171.5 138.61 176.98 134.97 176.86 132.27 171.67 135.76 167.43 132.97"
              fill="#ccae79"
            />
            <polygon
              points="171.67 135.76 171.5 138.61 176.98 134.97 176.86 132.27 171.67 135.76"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M168.64,133.77a1.94,1.94,0,0,1,0,1.43c.19-.45.23-1.28.32-1.22Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M170.43,134.94a3.53,3.53,0,0,0,1.07-1.78l-.77,2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M173.81,134.32a1.44,1.44,0,0,1,.43,1.12l-.13-1.32Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M175.71,131.28c-.05-.05-1.07.34-1.68,0a1.53,1.53,0,0,1-1.23.14s.9-.15,1.23.36A4.62,4.62,0,0,1,175.71,131.28Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M184.47,143l2.12,2.16a.47.47,0,0,0,.65.07l5.09-3.73a1.55,1.55,0,0,0,.17-1.89h0a.51.51,0,0,0-.54-.26L184.74,141C184.1,141.1,183.92,142.48,184.47,143Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="188.24 134.41 185.36 135.41 182.83 138.59 187.07 141.38 192.27 137.89 188.24 134.41"
              fill="#ffedc8"
            />
            <polygon
              points="182.83 138.59 182.83 141.38 186.9 144.23 192.38 140.59 192.27 137.89 187.07 141.38 182.83 138.59"
              fill="#ccae79"
            />
            <polygon
              points="187.07 141.38 186.9 144.23 192.38 140.59 192.27 137.89 187.07 141.38"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M184,139.39a1.94,1.94,0,0,1,0,1.43c.19-.45.24-1.28.33-1.22Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M185.83,140.56a3.45,3.45,0,0,0,1.07-1.78l-.77,2Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M189.22,139.94a1.41,1.41,0,0,1,.42,1.12l-.12-1.32Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M191.12,136.9c-.06-.05-1.08.34-1.69,0a1.54,1.54,0,0,1-1.23.14s.9-.15,1.23.36A4.71,4.71,0,0,1,191.12,136.9Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M173.5,147.52,175,149a.31.31,0,0,0,.44,0l3.47-2.54a1.06,1.06,0,0,0,.12-1.29h0a.35.35,0,0,0-.37-.18l-4.93,1.07C173.25,146.2,173.12,147.14,173.5,147.52Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="176.07 141.63 174.11 142.31 172.38 144.48 175.28 146.38 178.82 144.01 176.07 141.63"
              fill="#ffedc8"
            />
            <polygon
              points="172.38 144.48 172.38 146.38 175.16 148.33 178.9 145.85 178.82 144.01 175.28 146.38 172.38 144.48"
              fill="#ccae79"
            />
            <polygon
              points="175.28 146.38 175.16 148.33 178.9 145.85 178.82 144.01 175.28 146.38"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M173.21,145a1.3,1.3,0,0,1,0,1c.13-.3.16-.87.22-.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M174.43,145.83a2.38,2.38,0,0,0,.73-1.22l-.53,1.35Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M176.74,145.4a1,1,0,0,1,.29.77l-.09-.9Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M178,143.33s-.73.23-1.15,0a1,1,0,0,1-.83.09s.61-.09.83.25A3.28,3.28,0,0,1,178,143.33Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M421.53,131.65c4.23-.24-4.13.44-4.15-.58s4.15-2.51,5-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,421.53,131.65Z"
                fill="#2f6840"
              />
              <path
                d="M421.05,131.32c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.84,13.84,0,0,1,421.05,131.32Z"
                fill="#3ba525"
              />
              <path
                d="M421.77,131.3a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A1,1,0,0,1,421.77,131.3Z"
                fill="#2f6840"
              />
              <path
                d="M425.09,130.54c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,425.09,130.54Z"
                fill="#2f6840"
              />
              <path
                d="M423.79,133.6a1.9,1.9,0,0,0-.63-.94c-.28-.28-.61-.48-.93-.77a2.08,2.08,0,0,1,1.16.52,1.6,1.6,0,0,1,.38.54A.91.91,0,0,1,423.79,133.6Z"
                fill="#2f6840"
              />
              <path
                d="M421.91,131.74a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61,2.14,2.14,0,0,1,1.06-.93A1.91,1.91,0,0,1,421.91,131.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M419,140c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,419,140Z"
                fill="#2f6840"
              />
              <path
                d="M418.51,139.66c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5-2.34.25,2.15.25,2.15,1.18-2.66,2.8-2.06,3.46,3.39,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63S419,140.5,419,140.5s-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.84,13.84,0,0,1,418.51,139.66Z"
                fill="#3ba525"
              />
              <path
                d="M419.23,139.64a2,2,0,0,0-.76-.9c-.31-.25-.68-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,419.23,139.64Z"
                fill="#2f6840"
              />
              <path
                d="M422.55,138.88c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.33,2.33,0,0,1,1.18-.83A2,2,0,0,1,422.55,138.88Z"
                fill="#2f6840"
              />
              <path
                d="M421.24,141.94a1.77,1.77,0,0,0-.63-.94c-.27-.28-.6-.48-.92-.77a2.08,2.08,0,0,1,1.16.52,1.75,1.75,0,0,1,.38.54A.86.86,0,0,1,421.24,141.94Z"
                fill="#2f6840"
              />
              <path
                d="M419.37,140.08a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61,2.1,2.1,0,0,1,1.06-.93A1.91,1.91,0,0,1,419.37,140.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M413.88,135.26c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.25,2.15.25,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.15,1.9-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.85,13.85,0,0,1,413.88,135.26Z"
                fill="#2f6840"
              />
              <path
                d="M413.4,134.93c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.54,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77S413,139,411,138.2s-2.16-2.17-2-2.26A13.76,13.76,0,0,1,413.4,134.93Z"
                fill="#3ba525"
              />
              <path
                d="M414.11,134.9a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A.9.9,0,0,1,414.11,134.9Z"
                fill="#2f6840"
              />
              <path
                d="M417.44,134.14c-.25,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2.07,2.07,0,0,1,417.44,134.14Z"
                fill="#2f6840"
              />
              <path
                d="M416.13,137.21a1.82,1.82,0,0,0-.63-1c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.74,1.74,0,0,1,.39.54A.94.94,0,0,1,416.13,137.21Z"
                fill="#2f6840"
              />
              <path
                d="M414.26,135.34c-.24.06-.46.08-.67.15a3.16,3.16,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.19,2.19,0,0,1,1.07-.94A2,2,0,0,1,414.26,135.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M405.91,132c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.85,13.85,0,0,1,405.91,132Z"
                fill="#2f6840"
              />
              <path
                d="M405.42,131.71c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.86,2.44-2.16-2.17-2-2.26A13.75,13.75,0,0,1,405.42,131.71Z"
                fill="#3ba525"
              />
              <path
                d="M406.14,131.68a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A.9.9,0,0,1,406.14,131.68Z"
                fill="#2f6840"
              />
              <path
                d="M409.47,130.92c-.25,0-.47,0-.7.09a4.29,4.29,0,0,0-.64.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,409.47,130.92Z"
                fill="#2f6840"
              />
              <path
                d="M408.16,134a1.82,1.82,0,0,0-.63-1c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,408.16,134Z"
                fill="#2f6840"
              />
              <path
                d="M406.29,132.12a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,10.44,10.44,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,406.29,132.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M420,146.83c4.23-.23-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,420,146.83Z"
                fill="#2f6840"
              />
              <path
                d="M419.47,146.51c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.66,13.66,0,0,1,419.47,146.51Z"
                fill="#3ba525"
              />
              <path
                d="M420.19,146.48a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A1,1,0,0,1,420.19,146.48Z"
                fill="#2f6840"
              />
              <path
                d="M423.52,145.72c-.25,0-.47,0-.7.09a3.35,3.35,0,0,0-.64.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,423.52,145.72Z"
                fill="#2f6840"
              />
              <path
                d="M422.21,148.79a1.82,1.82,0,0,0-.63-.95c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.47,1.47,0,0,1,.38.54A.89.89,0,0,1,422.21,148.79Z"
                fill="#2f6840"
              />
              <path
                d="M420.34,146.92a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,8.48,8.48,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,420.34,146.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M407.1,141.51c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.14.25,2.14,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.84,13.84,0,0,1,407.1,141.51Z"
                fill="#2f6840"
              />
              <path
                d="M406.62,141.18c4.23-.24-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,406.62,141.18Z"
                fill="#3ba525"
              />
              <path
                d="M407.34,141.16a2,2,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.71,1.71,0,0,1,.45.51A1,1,0,0,1,407.34,141.16Z"
                fill="#2f6840"
              />
              <path
                d="M410.66,140.4a6.81,6.81,0,0,0-.69.09,3.66,3.66,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.35,2.35,0,0,1,1.19-.83A2,2,0,0,1,410.66,140.4Z"
                fill="#2f6840"
              />
              <path
                d="M409.35,143.46a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.48-.92-.78a2.11,2.11,0,0,1,1.15.53,1.53,1.53,0,0,1,.39.54A.86.86,0,0,1,409.35,143.46Z"
                fill="#2f6840"
              />
              <path
                d="M407.48,141.6c-.23.05-.45.08-.67.15a4,4,0,0,0-.61.21,10.56,10.56,0,0,0-1.2.62,2.17,2.17,0,0,1,1.07-.93A1.86,1.86,0,0,1,407.48,141.6Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M394.7,127c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,394.7,127Z"
                fill="#2f6840"
              />
              <path
                d="M394.22,126.71c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A14,14,0,0,1,394.22,126.71Z"
                fill="#3ba525"
              />
              <path
                d="M394.94,126.69a2,2,0,0,0-.76-.9c-.31-.25-.68-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,394.94,126.69Z"
                fill="#2f6840"
              />
              <path
                d="M398.26,125.93c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.33,2.33,0,0,1,1.18-.83A2,2,0,0,1,398.26,125.93Z"
                fill="#2f6840"
              />
              <path
                d="M397,129a1.77,1.77,0,0,0-.63-.94c-.27-.28-.6-.48-.92-.77a2.08,2.08,0,0,1,1.16.52,1.75,1.75,0,0,1,.38.54A.86.86,0,0,1,397,129Z"
                fill="#2f6840"
              />
              <path
                d="M395.08,127.13a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61,2.1,2.1,0,0,1,1.06-.93A1.91,1.91,0,0,1,395.08,127.13Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M392.16,135.38c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,392.16,135.38Z"
                fill="#2f6840"
              />
              <path
                d="M391.68,135.05c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A14,14,0,0,1,391.68,135.05Z"
                fill="#3ba525"
              />
              <path
                d="M392.4,135a2,2,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,392.4,135Z"
                fill="#2f6840"
              />
              <path
                d="M395.72,134.27c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13.1,13.1,0,0,0-1.29.5,2.4,2.4,0,0,1,1.19-.83A2,2,0,0,1,395.72,134.27Z"
                fill="#2f6840"
              />
              <path
                d="M394.41,137.33a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.63,1.63,0,0,1,.39.54A.86.86,0,0,1,394.41,137.33Z"
                fill="#2f6840"
              />
              <path
                d="M392.54,135.47a6.38,6.38,0,0,0-.66.15,3,3,0,0,0-.62.22,9.05,9.05,0,0,0-1.2.61,2.17,2.17,0,0,1,1.07-.93A1.91,1.91,0,0,1,392.54,135.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M387.05,130.65c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.85,13.85,0,0,1,387.05,130.65Z"
                fill="#2f6840"
              />
              <path
                d="M386.56,130.32c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A13.75,13.75,0,0,1,386.56,130.32Z"
                fill="#3ba525"
              />
              <path
                d="M387.28,130.29a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A.9.9,0,0,1,387.28,130.29Z"
                fill="#2f6840"
              />
              <path
                d="M390.61,129.53c-.25,0-.47,0-.7.09a4.29,4.29,0,0,0-.64.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2.07,2.07,0,0,1,390.61,129.53Z"
                fill="#2f6840"
              />
              <path
                d="M389.3,132.6a1.82,1.82,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.56,1.56,0,0,1,.38.54A.89.89,0,0,1,389.3,132.6Z"
                fill="#2f6840"
              />
              <path
                d="M387.43,130.73c-.24.06-.46.08-.67.15a3.16,3.16,0,0,0-.61.22,8.57,8.57,0,0,0-1.2.62,2.21,2.21,0,0,1,1.06-.94A2,2,0,0,1,387.43,130.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M379.08,127.43c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.76,13.76,0,0,1,379.08,127.43Z"
                fill="#2f6840"
              />
              <path
                d="M378.59,127.1c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.66,13.66,0,0,1,378.59,127.1Z"
                fill="#3ba525"
              />
              <path
                d="M379.31,127.07a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A1,1,0,0,1,379.31,127.07Z"
                fill="#2f6840"
              />
              <path
                d="M382.64,126.31c-.25,0-.47,0-.7.09a4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,382.64,126.31Z"
                fill="#2f6840"
              />
              <path
                d="M381.33,129.38a1.82,1.82,0,0,0-.63-.95c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.47,1.47,0,0,1,.38.54A.89.89,0,0,1,381.33,129.38Z"
                fill="#2f6840"
              />
              <path
                d="M379.46,127.51a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,9.69,9.69,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,379.46,127.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M393.13,142.22c4.23-.24-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,393.13,142.22Z"
                fill="#2f6840"
              />
              <path
                d="M392.64,141.9c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.66,13.66,0,0,1,392.64,141.9Z"
                fill="#3ba525"
              />
              <path
                d="M393.36,141.87a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.15,2.15,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,393.36,141.87Z"
                fill="#2f6840"
              />
              <path
                d="M396.68,141.11c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,396.68,141.11Z"
                fill="#2f6840"
              />
              <path
                d="M395.38,144.18a1.82,1.82,0,0,0-.63-1c-.27-.28-.61-.48-.93-.77A2.05,2.05,0,0,1,395,143a1.47,1.47,0,0,1,.38.54A.94.94,0,0,1,395.38,144.18Z"
                fill="#2f6840"
              />
              <path
                d="M393.51,142.31a6,6,0,0,0-.67.15,3.52,3.52,0,0,0-.62.22,9,9,0,0,0-1.19.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,393.51,142.31Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M380.27,136.9c4.23-.24-4.14.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.14.25,2.14,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49.05-4.49.05,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A14,14,0,0,1,380.27,136.9Z"
                fill="#2f6840"
              />
              <path
                d="M379.79,136.57c4.22-.24-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,379.79,136.57Z"
                fill="#3ba525"
              />
              <path
                d="M380.51,136.55a2.07,2.07,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.71,1.71,0,0,1,.45.51A1,1,0,0,1,380.51,136.55Z"
                fill="#2f6840"
              />
              <path
                d="M383.83,135.79a6.81,6.81,0,0,0-.69.09,3.66,3.66,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,383.83,135.79Z"
                fill="#2f6840"
              />
              <path
                d="M382.52,138.85a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.48-.93-.78a2.1,2.1,0,0,1,1.16.53,1.53,1.53,0,0,1,.39.54A.91.91,0,0,1,382.52,138.85Z"
                fill="#2f6840"
              />
              <path
                d="M380.65,137a6.58,6.58,0,0,0-.67.15,4,4,0,0,0-.61.21,10.56,10.56,0,0,0-1.2.62,2.17,2.17,0,0,1,1.07-.93A1.86,1.86,0,0,1,380.65,137Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M367.57,125c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.25,2.15.25,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.66,13.66,0,0,1,367.57,125Z"
                fill="#2f6840"
              />
              <path
                d="M367.09,124.69c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.76,13.76,0,0,1,367.09,124.69Z"
                fill="#3ba525"
              />
              <path
                d="M367.81,124.66a2.12,2.12,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,367.81,124.66Z"
                fill="#2f6840"
              />
              <path
                d="M371.13,123.9a6.81,6.81,0,0,0-.69.09,4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,371.13,123.9Z"
                fill="#2f6840"
              />
              <path
                d="M369.82,127a1.82,1.82,0,0,0-.63-1c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,369.82,127Z"
                fill="#2f6840"
              />
              <path
                d="M368,125.1c-.23.05-.45.08-.67.15a3.16,3.16,0,0,0-.61.22,10.44,10.44,0,0,0-1.2.61,2.22,2.22,0,0,1,1.07-.93A1.91,1.91,0,0,1,368,125.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M365,133.36c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.85,13.85,0,0,1,365,133.36Z"
                fill="#2f6840"
              />
              <path
                d="M364.55,133c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.64-1.11-2.78-1.11-2.78-.88,3.19-2.87,2.44-2.16-2.17-2-2.26A13.76,13.76,0,0,1,364.55,133Z"
                fill="#3ba525"
              />
              <path
                d="M365.26,133a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A.9.9,0,0,1,365.26,133Z"
                fill="#2f6840"
              />
              <path
                d="M368.59,132.24a6.81,6.81,0,0,0-.69.09,4.42,4.42,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,368.59,132.24Z"
                fill="#2f6840"
              />
              <path
                d="M367.28,135.31a1.82,1.82,0,0,0-.63-.95c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,367.28,135.31Z"
                fill="#2f6840"
              />
              <path
                d="M365.41,133.44a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,10.44,10.44,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,365.41,133.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M359.91,128.62c4.23-.24-4.13.43-4.15-.58s4.15-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.86,2.43-2.16-2.17-2-2.26A13.75,13.75,0,0,1,359.91,128.62Z"
                fill="#2f6840"
              />
              <path
                d="M359.43,128.29c4.23-.24-4.13.44-4.16-.58s4.16-2.52,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A14,14,0,0,1,359.43,128.29Z"
                fill="#3ba525"
              />
              <path
                d="M360.15,128.26a2.08,2.08,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,360.15,128.26Z"
                fill="#2f6840"
              />
              <path
                d="M363.47,127.5c-.24,0-.47,0-.69.1a3.63,3.63,0,0,0-.65.16,13,13,0,0,0-1.28.5,2.29,2.29,0,0,1,1.18-.82A2,2,0,0,1,363.47,127.5Z"
                fill="#2f6840"
              />
              <path
                d="M362.17,130.57a1.86,1.86,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,362.17,130.57Z"
                fill="#2f6840"
              />
              <path
                d="M360.3,128.7c-.24.06-.46.08-.67.15a3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.21,2.21,0,0,1,1.06-.94A2,2,0,0,1,360.3,128.7Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M351.94,125.4c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.66,13.66,0,0,1,351.94,125.4Z"
                fill="#2f6840"
              />
              <path
                d="M351.46,125.07c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A13.66,13.66,0,0,1,351.46,125.07Z"
                fill="#3ba525"
              />
              <path
                d="M352.18,125a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,352.18,125Z"
                fill="#2f6840"
              />
              <path
                d="M355.5,124.28c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,355.5,124.28Z"
                fill="#2f6840"
              />
              <path
                d="M354.2,127.35a1.82,1.82,0,0,0-.63-.95c-.28-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,354.2,127.35Z"
                fill="#2f6840"
              />
              <path
                d="M352.33,125.48c-.24.06-.46.08-.67.15a3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.16,2.16,0,0,1,1.06-.94A2,2,0,0,1,352.33,125.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M366,140.2c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63S366.5,141,366.5,141s-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.66,13.66,0,0,1,366,140.2Z"
                fill="#2f6840"
              />
              <path
                d="M365.51,139.87c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64S366,140.7,366,140.7s-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.66,13.66,0,0,1,365.51,139.87Z"
                fill="#3ba525"
              />
              <path
                d="M366.23,139.84a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A1,1,0,0,1,366.23,139.84Z"
                fill="#2f6840"
              />
              <path
                d="M369.55,139.08c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,369.55,139.08Z"
                fill="#2f6840"
              />
              <path
                d="M368.24,142.15a1.8,1.8,0,0,0-.62-1c-.28-.27-.61-.48-.93-.77a2.08,2.08,0,0,1,1.16.52,1.6,1.6,0,0,1,.38.54A.89.89,0,0,1,368.24,142.15Z"
                fill="#2f6840"
              />
              <path
                d="M366.37,140.28a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.16,2.16,0,0,1,1.06-.94A2,2,0,0,1,366.37,140.28Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M353.14,134.87c4.23-.23-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,353.14,134.87Z"
                fill="#2f6840"
              />
              <path
                d="M352.65,134.55c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.66,13.66,0,0,1,352.65,134.55Z"
                fill="#3ba525"
              />
              <path
                d="M353.37,134.52a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A1,1,0,0,1,353.37,134.52Z"
                fill="#2f6840"
              />
              <path
                d="M356.7,133.76a7,7,0,0,0-.7.09,4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,356.7,133.76Z"
                fill="#2f6840"
              />
              <path
                d="M355.39,136.83a1.82,1.82,0,0,0-.63-1c-.27-.28-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.47,1.47,0,0,1,.38.54A.94.94,0,0,1,355.39,136.83Z"
                fill="#2f6840"
              />
              <path
                d="M353.52,135a6,6,0,0,0-.67.15,3.52,3.52,0,0,0-.62.22,10.33,10.33,0,0,0-1.19.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,353.52,135Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M340.57,127.42c4.22-.24-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.79-2.07,3.46,3.4,2.53,3.3-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.86,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,340.57,127.42Z"
                fill="#2f6840"
              />
              <path
                d="M340.08,127.1c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.76.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.66,13.66,0,0,1,340.08,127.1Z"
                fill="#3ba525"
              />
              <path
                d="M340.8,127.07a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.17,2.17,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,340.8,127.07Z"
                fill="#2f6840"
              />
              <path
                d="M344.12,126.31c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,344.12,126.31Z"
                fill="#2f6840"
              />
              <path
                d="M342.82,129.37a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.6,1.6,0,0,1,.38.54A.91.91,0,0,1,342.82,129.37Z"
                fill="#2f6840"
              />
              <path
                d="M341,127.51a6,6,0,0,0-.67.15,3.52,3.52,0,0,0-.62.22,9,9,0,0,0-1.19.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,341,127.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M338,135.76c4.23-.24-4.13.44-4.15-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.79-2.07,3.46,3.4,2.53,3.3-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,338,135.76Z"
                fill="#2f6840"
              />
              <path
                d="M337.54,135.43c4.23-.23-4.13.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.84,13.84,0,0,1,337.54,135.43Z"
                fill="#3ba525"
              />
              <path
                d="M338.26,135.41a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,338.26,135.41Z"
                fill="#2f6840"
              />
              <path
                d="M341.58,134.65c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,341.58,134.65Z"
                fill="#2f6840"
              />
              <path
                d="M340.28,137.71a1.83,1.83,0,0,0-.63-.94c-.28-.28-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.6,1.6,0,0,1,.38.54A.91.91,0,0,1,340.28,137.71Z"
                fill="#2f6840"
              />
              <path
                d="M338.41,135.85a6,6,0,0,0-.67.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61,2.14,2.14,0,0,1,1.06-.93A1.94,1.94,0,0,1,338.41,135.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M332.91,131c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.66,13.66,0,0,1,332.91,131Z"
                fill="#2f6840"
              />
              <path
                d="M332.43,130.7c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A13.76,13.76,0,0,1,332.43,130.7Z"
                fill="#3ba525"
              />
              <path
                d="M333.15,130.67a2,2,0,0,0-.77-.89c-.3-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,333.15,130.67Z"
                fill="#2f6840"
              />
              <path
                d="M336.47,129.91c-.25,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.35,2.35,0,0,1,1.19-.83A2,2,0,0,1,336.47,129.91Z"
                fill="#2f6840"
              />
              <path
                d="M335.16,133a1.82,1.82,0,0,0-.63-.95c-.27-.27-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.74,1.74,0,0,1,.39.54A.89.89,0,0,1,335.16,133Z"
                fill="#2f6840"
              />
              <path
                d="M333.29,131.11c-.23.06-.45.08-.67.15a3.16,3.16,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.19,2.19,0,0,1,1.07-.94A2,2,0,0,1,333.29,131.11Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M324.94,127.81c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.66,13.66,0,0,1,324.94,127.81Z"
                fill="#2f6840"
              />
              <path
                d="M324.46,127.48c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.76,13.76,0,0,1,324.46,127.48Z"
                fill="#3ba525"
              />
              <path
                d="M325.18,127.45a2.06,2.06,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,325.18,127.45Z"
                fill="#2f6840"
              />
              <path
                d="M328.5,126.69a6.81,6.81,0,0,0-.69.09,4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.35,2.35,0,0,1,1.19-.83A2,2,0,0,1,328.5,126.69Z"
                fill="#2f6840"
              />
              <path
                d="M327.19,129.76a1.82,1.82,0,0,0-.63-.95c-.27-.27-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.63,1.63,0,0,1,.39.54A.89.89,0,0,1,327.19,129.76Z"
                fill="#2f6840"
              />
              <path
                d="M325.32,127.89c-.23,0-.45.08-.67.15a3.16,3.16,0,0,0-.61.22,10.44,10.44,0,0,0-1.2.61,2.22,2.22,0,0,1,1.07-.93A1.91,1.91,0,0,1,325.32,127.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M339,142.6c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A14,14,0,0,1,339,142.6Z"
                fill="#2f6840"
              />
              <path
                d="M338.51,142.28c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.79-2.06,3.46,3.4,2.54,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.76,13.76,0,0,1,338.51,142.28Z"
                fill="#3ba525"
              />
              <path
                d="M339.23,142.25a2.12,2.12,0,0,0-.77-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,339.23,142.25Z"
                fill="#2f6840"
              />
              <path
                d="M342.55,141.49a6.81,6.81,0,0,0-.69.09,3.66,3.66,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,342.55,141.49Z"
                fill="#2f6840"
              />
              <path
                d="M341.24,144.56a1.82,1.82,0,0,0-.63-.95c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,341.24,144.56Z"
                fill="#2f6840"
              />
              <path
                d="M339.37,142.69a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,9.05,9.05,0,0,0-1.2.61,2.17,2.17,0,0,1,1.07-.93A1.91,1.91,0,0,1,339.37,142.69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M326.13,137.28c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5-2.34.25,2.14.25,2.14,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.76.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,326.13,137.28Z"
                fill="#2f6840"
              />
              <path
                d="M325.65,137c4.23-.24-4.14.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A14,14,0,0,1,325.65,137Z"
                fill="#3ba525"
              />
              <path
                d="M326.37,136.93a2,2,0,0,0-.76-.9c-.31-.25-.68-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.71,1.71,0,0,1,.45.51A1,1,0,0,1,326.37,136.93Z"
                fill="#2f6840"
              />
              <path
                d="M329.69,136.17c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.33,2.33,0,0,1,1.18-.83A2,2,0,0,1,329.69,136.17Z"
                fill="#2f6840"
              />
              <path
                d="M328.38,139.23a1.77,1.77,0,0,0-.63-.94c-.27-.28-.6-.48-.92-.78A2.17,2.17,0,0,1,328,138a1.75,1.75,0,0,1,.38.54A.86.86,0,0,1,328.38,139.23Z"
                fill="#2f6840"
              />
              <path
                d="M326.51,137.37a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61,2.1,2.1,0,0,1,1.06-.93A1.91,1.91,0,0,1,326.51,137.37Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M315,135.86c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.66,13.66,0,0,1,315,135.86Z"
                fill="#2f6840"
              />
              <path
                d="M314.5,135.53c4.23-.24-4.14.43-4.16-.58s4.16-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A13.85,13.85,0,0,1,314.5,135.53Z"
                fill="#3ba525"
              />
              <path
                d="M315.22,135.5a2,2,0,0,0-.77-.89c-.3-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,315.22,135.5Z"
                fill="#2f6840"
              />
              <path
                d="M318.54,134.74c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13.1,13.1,0,0,0-1.29.5,2.32,2.32,0,0,1,1.19-.82A2,2,0,0,1,318.54,134.74Z"
                fill="#2f6840"
              />
              <path
                d="M317.23,137.81a1.82,1.82,0,0,0-.63-.95c-.27-.27-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.74,1.74,0,0,1,.39.54A.89.89,0,0,1,317.23,137.81Z"
                fill="#2f6840"
              />
              <path
                d="M315.36,135.94c-.23.06-.45.08-.66.15a3,3,0,0,0-.62.22,9.15,9.15,0,0,0-1.2.62A2.19,2.19,0,0,1,314,136,2,2,0,0,1,315.36,135.94Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M312.44,144.2c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64S313,145,313,145s-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.66,13.66,0,0,1,312.44,144.2Z"
                fill="#2f6840"
              />
              <path
                d="M312,143.87c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A13.76,13.76,0,0,1,312,143.87Z"
                fill="#3ba525"
              />
              <path
                d="M312.68,143.84a2,2,0,0,0-.77-.89c-.3-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,312.68,143.84Z"
                fill="#2f6840"
              />
              <path
                d="M316,143.08c-.25,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.35,2.35,0,0,1,1.19-.83A2,2,0,0,1,316,143.08Z"
                fill="#2f6840"
              />
              <path
                d="M314.69,146.15a1.82,1.82,0,0,0-.63-1c-.27-.27-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.74,1.74,0,0,1,.39.54A.89.89,0,0,1,314.69,146.15Z"
                fill="#2f6840"
              />
              <path
                d="M312.82,144.28c-.23.06-.45.08-.67.15a3.16,3.16,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.19,2.19,0,0,1,1.07-.94A2,2,0,0,1,312.82,144.28Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M307.33,139.46c4.23-.24-4.14.44-4.16-.58s4.15-2.51,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.43-2.16-2.17-2-2.26A14.39,14.39,0,0,1,307.33,139.46Z"
                fill="#2f6840"
              />
              <path
                d="M306.84,139.13c4.23-.24-4.13.44-4.15-.58s4.15-2.51,5-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.43-2.15-2.17-2-2.26A14.29,14.29,0,0,1,306.84,139.13Z"
                fill="#3ba525"
              />
              <path
                d="M307.56,139.1a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.14,2.14,0,0,1,1.23.44,1.81,1.81,0,0,1,.45.5A1,1,0,0,1,307.56,139.1Z"
                fill="#2f6840"
              />
              <path
                d="M310.89,138.34c-.25,0-.47,0-.7.1a3.63,3.63,0,0,0-.65.16,11,11,0,0,0-1.28.51,2.31,2.31,0,0,1,1.18-.83A2,2,0,0,1,310.89,138.34Z"
                fill="#2f6840"
              />
              <path
                d="M309.58,141.41a1.9,1.9,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.51,1.51,0,0,1,.38.55A.91.91,0,0,1,309.58,141.41Z"
                fill="#2f6840"
              />
              <path
                d="M307.71,139.54c-.24.06-.46.09-.67.15a4,4,0,0,0-.61.22,8.57,8.57,0,0,0-1.2.62,2.14,2.14,0,0,1,1.06-.93A1.94,1.94,0,0,1,307.71,139.54Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M299.36,136.24c4.22-.24-4.14.44-4.16-.58s4.15-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A14.07,14.07,0,0,1,299.36,136.24Z"
                fill="#2f6840"
              />
              <path
                d="M298.87,135.91c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A14,14,0,0,1,298.87,135.91Z"
                fill="#3ba525"
              />
              <path
                d="M299.59,135.88a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.15,2.15,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.92.92,0,0,1,299.59,135.88Z"
                fill="#2f6840"
              />
              <path
                d="M302.91,135.12c-.24,0-.47,0-.69.1a3.63,3.63,0,0,0-.65.16,13,13,0,0,0-1.28.5,2.29,2.29,0,0,1,1.18-.82A2,2,0,0,1,302.91,135.12Z"
                fill="#2f6840"
              />
              <path
                d="M301.61,138.19a1.86,1.86,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.56,1.56,0,0,1,.38.54A.94.94,0,0,1,301.61,138.19Z"
                fill="#2f6840"
              />
              <path
                d="M299.74,136.32c-.24.06-.46.09-.67.15a3.52,3.52,0,0,0-.62.22,9.06,9.06,0,0,0-1.19.62,2.14,2.14,0,0,1,1.06-.93A1.94,1.94,0,0,1,299.74,136.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M313.41,151c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.88,3.18-2.87,2.43-2.16-2.17-2-2.26A13.76,13.76,0,0,1,313.41,151Z"
                fill="#2f6840"
              />
              <path
                d="M312.92,150.71c4.23-.24-4.13.44-4.16-.58s4.16-2.52,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.76.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A14,14,0,0,1,312.92,150.71Z"
                fill="#3ba525"
              />
              <path
                d="M313.64,150.68a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.17,2.17,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,313.64,150.68Z"
                fill="#2f6840"
              />
              <path
                d="M317,149.92c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.29,2.29,0,0,1,1.18-.82A2,2,0,0,1,317,149.92Z"
                fill="#2f6840"
              />
              <path
                d="M315.66,153a1.86,1.86,0,0,0-.63-1c-.27-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,315.66,153Z"
                fill="#2f6840"
              />
              <path
                d="M313.79,151.12c-.24.06-.46.08-.67.15a3.52,3.52,0,0,0-.62.22,9.06,9.06,0,0,0-1.19.62,2.21,2.21,0,0,1,1.06-.94A2,2,0,0,1,313.79,151.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M300.55,145.72c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.15,1.9-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.85,13.85,0,0,1,300.55,145.72Z"
                fill="#2f6840"
              />
              <path
                d="M300.07,145.39c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.86,2.43-2.16-2.17-2-2.26A13.76,13.76,0,0,1,300.07,145.39Z"
                fill="#3ba525"
              />
              <path
                d="M300.78,145.36a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A.9.9,0,0,1,300.78,145.36Z"
                fill="#2f6840"
              />
              <path
                d="M304.11,144.6c-.25,0-.47,0-.7.09a4.64,4.64,0,0,0-.64.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2.07,2.07,0,0,1,304.11,144.6Z"
                fill="#2f6840"
              />
              <path
                d="M302.8,147.67a1.82,1.82,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.74,1.74,0,0,1,.39.54A.94.94,0,0,1,302.8,147.67Z"
                fill="#2f6840"
              />
              <path
                d="M300.93,145.8c-.24.06-.46.08-.67.15a3.16,3.16,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.21,2.21,0,0,1,1.06-.94A2,2,0,0,1,300.93,145.8Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M291.27,149c4.23-.24-4.13.44-4.15-.58s4.15-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A13.75,13.75,0,0,1,291.27,149Z"
                fill="#2f6840"
              />
              <path
                d="M290.79,148.71c4.23-.24-4.13.44-4.16-.58s4.16-2.52,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A14,14,0,0,1,290.79,148.71Z"
                fill="#3ba525"
              />
              <path
                d="M291.51,148.68a2.08,2.08,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.91.91,0,0,1,291.51,148.68Z"
                fill="#2f6840"
              />
              <path
                d="M294.83,147.92c-.24,0-.47,0-.69.1a3.63,3.63,0,0,0-.65.16,13,13,0,0,0-1.28.5,2.29,2.29,0,0,1,1.18-.82A2,2,0,0,1,294.83,147.92Z"
                fill="#2f6840"
              />
              <path
                d="M293.53,151a1.86,1.86,0,0,0-.63-1c-.28-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,293.53,151Z"
                fill="#2f6840"
              />
              <path
                d="M291.66,149.12c-.24.06-.46.08-.67.15a3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.16,2.16,0,0,1,1.06-.94A2,2,0,0,1,291.66,149.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M288.73,157.38c4.23-.24-4.13.43-4.15-.58s4.15-2.52,5-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A13.66,13.66,0,0,1,288.73,157.38Z"
                fill="#2f6840"
              />
              <path
                d="M288.25,157.05c4.23-.24-4.14.44-4.16-.58s4.16-2.52,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A14,14,0,0,1,288.25,157.05Z"
                fill="#3ba525"
              />
              <path
                d="M289,157a2.08,2.08,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A1,1,0,0,1,289,157Z"
                fill="#2f6840"
              />
              <path
                d="M292.29,156.26c-.24,0-.47,0-.69.1a3.63,3.63,0,0,0-.65.16,13,13,0,0,0-1.28.5,2.29,2.29,0,0,1,1.18-.82A2,2,0,0,1,292.29,156.26Z"
                fill="#2f6840"
              />
              <path
                d="M291,159.33a1.92,1.92,0,0,0-.63-1c-.28-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,291,159.33Z"
                fill="#2f6840"
              />
              <path
                d="M289.11,157.46c-.23.06-.45.08-.66.15a3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.16,2.16,0,0,1,1.06-.94A2,2,0,0,1,289.11,157.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M283.62,152.64c4.23-.24-4.14.44-4.16-.58s4.16-2.51,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.47-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.43-2.16-2.17-2-2.26A14.29,14.29,0,0,1,283.62,152.64Z"
                fill="#2f6840"
              />
              <path
                d="M283.14,152.31c4.23-.24-4.14.44-4.16-.58s4.15-2.51,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49.05-4.49.05,5.75.82,3.8,1.47-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.27A14.39,14.39,0,0,1,283.14,152.31Z"
                fill="#3ba525"
              />
              <path
                d="M283.86,152.28a2,2,0,0,0-.77-.89c-.3-.25-.67-.44-1-.7a2.21,2.21,0,0,1,1.23.43,1.67,1.67,0,0,1,.45.5A1,1,0,0,1,283.86,152.28Z"
                fill="#2f6840"
              />
              <path
                d="M287.18,151.53a6.81,6.81,0,0,0-.69.09,3,3,0,0,0-.65.17,10.36,10.36,0,0,0-1.29.5,2.35,2.35,0,0,1,1.19-.83A2,2,0,0,1,287.18,151.53Z"
                fill="#2f6840"
              />
              <path
                d="M285.87,154.59a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.49-.92-.78a2,2,0,0,1,1.15.52,1.67,1.67,0,0,1,.39.55A.86.86,0,0,1,285.87,154.59Z"
                fill="#2f6840"
              />
              <path
                d="M284,152.72c-.23.06-.45.09-.67.16a3.14,3.14,0,0,0-.61.21,10.56,10.56,0,0,0-1.2.62,2.17,2.17,0,0,1,1.07-.93A1.91,1.91,0,0,1,284,152.72Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M275.65,149.42c4.23-.24-4.14.44-4.16-.58s4.16-2.51,5.05-2.35.25,2.15.25,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.15,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.43-2.16-2.17-2-2.26A14.49,14.49,0,0,1,275.65,149.42Z"
                fill="#2f6840"
              />
              <path
                d="M275.17,149.09c4.22-.24-4.14.44-4.16-.58s4.15-2.51,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.43-2.16-2.17-2-2.26A14.39,14.39,0,0,1,275.17,149.09Z"
                fill="#3ba525"
              />
              <path
                d="M275.89,149.06a2.1,2.1,0,0,0-.77-.89c-.31-.26-.67-.44-1-.71a2.14,2.14,0,0,1,1.23.44,1.67,1.67,0,0,1,.45.5A1,1,0,0,1,275.89,149.06Z"
                fill="#2f6840"
              />
              <path
                d="M279.21,148.3c-.25,0-.47,0-.69.1a3.63,3.63,0,0,0-.65.16,10.45,10.45,0,0,0-1.29.51,2.31,2.31,0,0,1,1.18-.83A2,2,0,0,1,279.21,148.3Z"
                fill="#2f6840"
              />
              <path
                d="M277.9,151.37a1.9,1.9,0,0,0-.63-1c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.67,1.67,0,0,1,.39.55A.91.91,0,0,1,277.9,151.37Z"
                fill="#2f6840"
              />
              <path
                d="M276,149.5c-.24.06-.45.09-.67.15a4,4,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.12,2.12,0,0,1,1.07-.93A1.91,1.91,0,0,1,276,149.5Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M289.7,164.22c4.23-.24-4.14.44-4.16-.58s4.16-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.15,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A14.16,14.16,0,0,1,289.7,164.22Z"
                fill="#2f6840"
              />
              <path
                d="M289.22,163.89c4.22-.24-4.14.44-4.16-.58s4.15-2.51,5-2.35.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.86,2.43-2.16-2.17-2-2.26A14.39,14.39,0,0,1,289.22,163.89Z"
                fill="#3ba525"
              />
              <path
                d="M289.93,163.86a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A.91.91,0,0,1,289.93,163.86Z"
                fill="#2f6840"
              />
              <path
                d="M293.26,163.1c-.25,0-.47.05-.7.1a3.53,3.53,0,0,0-.64.16,10.45,10.45,0,0,0-1.29.51,2.25,2.25,0,0,1,1.18-.83A2,2,0,0,1,293.26,163.1Z"
                fill="#2f6840"
              />
              <path
                d="M292,166.17a1.86,1.86,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.67,1.67,0,0,1,.39.55A.91.91,0,0,1,292,166.17Z"
                fill="#2f6840"
              />
              <path
                d="M290.08,164.3c-.24.06-.46.09-.67.15a3.16,3.16,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.14,2.14,0,0,1,1.06-.93A1.94,1.94,0,0,1,290.08,164.3Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M276.84,158.9c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A13.66,13.66,0,0,1,276.84,158.9Z"
                fill="#2f6840"
              />
              <path
                d="M276.36,158.57c4.23-.24-4.14.44-4.16-.58s4.16-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.15,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A14.16,14.16,0,0,1,276.36,158.57Z"
                fill="#3ba525"
              />
              <path
                d="M277.08,158.54a2,2,0,0,0-.77-.89c-.3-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,277.08,158.54Z"
                fill="#2f6840"
              />
              <path
                d="M280.4,157.78c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13.1,13.1,0,0,0-1.29.5,2.32,2.32,0,0,1,1.19-.82A2,2,0,0,1,280.4,157.78Z"
                fill="#2f6840"
              />
              <path
                d="M279.09,160.85a1.86,1.86,0,0,0-.63-.95c-.27-.27-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.74,1.74,0,0,1,.39.54A.89.89,0,0,1,279.09,160.85Z"
                fill="#2f6840"
              />
              <path
                d="M277.22,159c-.23.06-.45.08-.66.15a3,3,0,0,0-.62.22,9.15,9.15,0,0,0-1.2.62,2.19,2.19,0,0,1,1.07-.94A2,2,0,0,1,277.22,159Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M267,160.9c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,267,160.9Z"
                fill="#2f6840"
              />
              <path
                d="M266.55,160.57c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.84,13.84,0,0,1,266.55,160.57Z"
                fill="#3ba525"
              />
              <path
                d="M267.27,160.55a2,2,0,0,0-.76-.9c-.31-.25-.68-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,267.27,160.55Z"
                fill="#2f6840"
              />
              <path
                d="M270.59,159.79c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.33,2.33,0,0,1,1.18-.83A2,2,0,0,1,270.59,159.79Z"
                fill="#2f6840"
              />
              <path
                d="M269.28,162.85a1.77,1.77,0,0,0-.63-.94c-.27-.28-.6-.48-.92-.77a2.08,2.08,0,0,1,1.16.52,1.6,1.6,0,0,1,.38.54A.86.86,0,0,1,269.28,162.85Z"
                fill="#2f6840"
              />
              <path
                d="M267.41,161a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61A2.1,2.1,0,0,1,266,161,1.91,1.91,0,0,1,267.41,161Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M264.49,169.24c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.76.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,264.49,169.24Z"
                fill="#2f6840"
              />
              <path
                d="M264,168.91c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5-2.34.25,2.15.25,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A14,14,0,0,1,264,168.91Z"
                fill="#3ba525"
              />
              <path
                d="M264.73,168.89a2,2,0,0,0-.76-.9c-.31-.25-.68-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.71,1.71,0,0,1,.45.51A1,1,0,0,1,264.73,168.89Z"
                fill="#2f6840"
              />
              <path
                d="M268.05,168.13c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.33,2.33,0,0,1,1.18-.83A2,2,0,0,1,268.05,168.13Z"
                fill="#2f6840"
              />
              <path
                d="M266.74,171.19a1.77,1.77,0,0,0-.63-.94c-.27-.28-.6-.48-.92-.78a2.17,2.17,0,0,1,1.16.53,1.75,1.75,0,0,1,.38.54A.86.86,0,0,1,266.74,171.19Z"
                fill="#2f6840"
              />
              <path
                d="M264.87,169.33a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61,2.1,2.1,0,0,1,1.06-.93A1.91,1.91,0,0,1,264.87,169.33Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M259.38,164.51c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.85,13.85,0,0,1,259.38,164.51Z"
                fill="#2f6840"
              />
              <path
                d="M258.9,164.18c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64S259.4,165,259.4,165s-.87,3.19-2.86,2.44-2.16-2.17-2-2.26A13.76,13.76,0,0,1,258.9,164.18Z"
                fill="#3ba525"
              />
              <path
                d="M259.61,164.15a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A.9.9,0,0,1,259.61,164.15Z"
                fill="#2f6840"
              />
              <path
                d="M262.94,163.39c-.25,0-.47,0-.7.09a4.29,4.29,0,0,0-.64.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,262.94,163.39Z"
                fill="#2f6840"
              />
              <path
                d="M261.63,166.46a1.82,1.82,0,0,0-.63-1c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,261.63,166.46Z"
                fill="#2f6840"
              />
              <path
                d="M259.76,164.59a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.21,2.21,0,0,1,1.06-.94A2,2,0,0,1,259.76,164.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M251.41,161.29c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.85,13.85,0,0,1,251.41,161.29Z"
                fill="#2f6840"
              />
              <path
                d="M250.92,161c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.75,13.75,0,0,1,250.92,161Z"
                fill="#3ba525"
              />
              <path
                d="M251.64,160.93a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A.9.9,0,0,1,251.64,160.93Z"
                fill="#2f6840"
              />
              <path
                d="M255,160.17c-.25,0-.47,0-.7.09a4.29,4.29,0,0,0-.64.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,255,160.17Z"
                fill="#2f6840"
              />
              <path
                d="M253.66,163.24a1.82,1.82,0,0,0-.63-1c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.47,1.47,0,0,1,.38.54A.89.89,0,0,1,253.66,163.24Z"
                fill="#2f6840"
              />
              <path
                d="M251.79,161.37a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,9.69,9.69,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,251.79,161.37Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M265.46,176.08c4.23-.24-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,265.46,176.08Z"
                fill="#2f6840"
              />
              <path
                d="M265,175.75c4.23-.23-4.13.44-4.15-.58s4.15-2.51,5-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,265,175.75Z"
                fill="#3ba525"
              />
              <path
                d="M265.69,175.73a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A1,1,0,0,1,265.69,175.73Z"
                fill="#2f6840"
              />
              <path
                d="M269,175c-.25,0-.47,0-.7.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,269,175Z"
                fill="#2f6840"
              />
              <path
                d="M267.71,178a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.47,1.47,0,0,1,.38.54A.91.91,0,0,1,267.71,178Z"
                fill="#2f6840"
              />
              <path
                d="M265.84,176.17a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,8.48,8.48,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,265.84,176.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M252.6,170.76c4.23-.24-4.14.44-4.16-.58s4.16-2.51,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.47-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.84,13.84,0,0,1,252.6,170.76Z"
                fill="#2f6840"
              />
              <path
                d="M252.12,170.43c4.23-.24-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,252.12,170.43Z"
                fill="#3ba525"
              />
              <path
                d="M252.84,170.41a2,2,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.71,1.71,0,0,1,.45.51A1,1,0,0,1,252.84,170.41Z"
                fill="#2f6840"
              />
              <path
                d="M256.16,169.65a6.81,6.81,0,0,0-.69.09,3.66,3.66,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.35,2.35,0,0,1,1.19-.83A2,2,0,0,1,256.16,169.65Z"
                fill="#2f6840"
              />
              <path
                d="M254.85,172.71a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.48-.92-.78a2.11,2.11,0,0,1,1.15.53,1.53,1.53,0,0,1,.39.54A.86.86,0,0,1,254.85,172.71Z"
                fill="#2f6840"
              />
              <path
                d="M253,170.85c-.23.05-.45.08-.67.15a3.14,3.14,0,0,0-.61.21,10.56,10.56,0,0,0-1.2.62,2.17,2.17,0,0,1,1.07-.93A1.86,1.86,0,0,1,253,170.85Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M240.23,161.2c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.66,13.66,0,0,1,240.23,161.2Z"
                fill="#2f6840"
              />
              <path
                d="M239.75,160.87c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.76,13.76,0,0,1,239.75,160.87Z"
                fill="#3ba525"
              />
              <path
                d="M240.47,160.84a2.06,2.06,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,240.47,160.84Z"
                fill="#2f6840"
              />
              <path
                d="M243.79,160.08a6.81,6.81,0,0,0-.69.09,4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,243.79,160.08Z"
                fill="#2f6840"
              />
              <path
                d="M242.48,163.15a1.82,1.82,0,0,0-.63-1c-.27-.28-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,242.48,163.15Z"
                fill="#2f6840"
              />
              <path
                d="M240.61,161.28c-.23.05-.45.08-.67.15a3.16,3.16,0,0,0-.61.22,10.44,10.44,0,0,0-1.2.61,2.22,2.22,0,0,1,1.07-.93A1.91,1.91,0,0,1,240.61,161.28Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M237.69,169.54c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.85,13.85,0,0,1,237.69,169.54Z"
                fill="#2f6840"
              />
              <path
                d="M237.21,169.21c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.54,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.64-1.11-2.78-1.11-2.78-.88,3.19-2.87,2.44-2.16-2.17-2-2.26A13.76,13.76,0,0,1,237.21,169.21Z"
                fill="#3ba525"
              />
              <path
                d="M237.92,169.18a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A.9.9,0,0,1,237.92,169.18Z"
                fill="#2f6840"
              />
              <path
                d="M241.25,168.42a6.81,6.81,0,0,0-.69.09,4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,241.25,168.42Z"
                fill="#2f6840"
              />
              <path
                d="M239.94,171.49a1.82,1.82,0,0,0-.63-1c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,239.94,171.49Z"
                fill="#2f6840"
              />
              <path
                d="M238.07,169.62a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,10.44,10.44,0,0,0-1.2.61,2.17,2.17,0,0,1,1.07-.93A1.91,1.91,0,0,1,238.07,169.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M232.58,164.8c4.22-.24-4.14.43-4.16-.58s4.15-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.86,2.43-2.16-2.17-2-2.26A13.76,13.76,0,0,1,232.58,164.8Z"
                fill="#2f6840"
              />
              <path
                d="M232.09,164.47c4.23-.24-4.13.44-4.16-.58s4.16-2.52,5-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A14,14,0,0,1,232.09,164.47Z"
                fill="#3ba525"
              />
              <path
                d="M232.81,164.44a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.17,2.17,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,232.81,164.44Z"
                fill="#2f6840"
              />
              <path
                d="M236.13,163.68c-.24,0-.47,0-.69.1a3.63,3.63,0,0,0-.65.16,13,13,0,0,0-1.28.5,2.29,2.29,0,0,1,1.18-.82A2,2,0,0,1,236.13,163.68Z"
                fill="#2f6840"
              />
              <path
                d="M234.83,166.75a1.86,1.86,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,234.83,166.75Z"
                fill="#2f6840"
              />
              <path
                d="M233,164.88c-.24.06-.46.08-.67.15a3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.21,2.21,0,0,1,1.06-.94A2,2,0,0,1,233,164.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M224.6,161.58c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.75,13.75,0,0,1,224.6,161.58Z"
                fill="#2f6840"
              />
              <path
                d="M224.12,161.25c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A13.66,13.66,0,0,1,224.12,161.25Z"
                fill="#3ba525"
              />
              <path
                d="M224.84,161.22a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,224.84,161.22Z"
                fill="#2f6840"
              />
              <path
                d="M228.16,160.46c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,228.16,160.46Z"
                fill="#2f6840"
              />
              <path
                d="M226.86,163.53a1.82,1.82,0,0,0-.63-.95c-.28-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,226.86,163.53Z"
                fill="#2f6840"
              />
              <path
                d="M225,161.66c-.24.06-.46.08-.67.15a3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.16,2.16,0,0,1,1.06-.94A2,2,0,0,1,225,161.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M238.65,176.38c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.66,13.66,0,0,1,238.65,176.38Z"
                fill="#2f6840"
              />
              <path
                d="M238.17,176.05c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.66,13.66,0,0,1,238.17,176.05Z"
                fill="#3ba525"
              />
              <path
                d="M238.89,176a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A1,1,0,0,1,238.89,176Z"
                fill="#2f6840"
              />
              <path
                d="M242.21,175.26c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,242.21,175.26Z"
                fill="#2f6840"
              />
              <path
                d="M240.91,178.33a1.88,1.88,0,0,0-.63-1c-.28-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.6,1.6,0,0,1,.38.54A.94.94,0,0,1,240.91,178.33Z"
                fill="#2f6840"
              />
              <path
                d="M239,176.46a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.16,2.16,0,0,1,1.06-.94A2,2,0,0,1,239,176.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M225.8,171.05c4.23-.23-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.06,3.46,3.39,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,225.8,171.05Z"
                fill="#2f6840"
              />
              <path
                d="M225.31,170.73c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77S225,174.75,223,174s-2.15-2.18-2-2.26A13.66,13.66,0,0,1,225.31,170.73Z"
                fill="#3ba525"
              />
              <path
                d="M226,170.7a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A1,1,0,0,1,226,170.7Z"
                fill="#2f6840"
              />
              <path
                d="M229.36,169.94c-.25,0-.47,0-.7.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,229.36,169.94Z"
                fill="#2f6840"
              />
              <path
                d="M228.05,173a1.82,1.82,0,0,0-.63-.95c-.27-.28-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.47,1.47,0,0,1,.38.54A.94.94,0,0,1,228.05,173Z"
                fill="#2f6840"
              />
              <path
                d="M226.18,171.14a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,8.48,8.48,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,226.18,171.14Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M254.8,164.16s.54,3.24,1.74,4.16,3.35-.51,2.85,1.09,2.07,3.24,3.27,3.16,4.21-3.25,4.35-4.52S254.8,164.16,254.8,164.16Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M255.06,161.73l-.26,2.43,1.86,3.19,2.83.81.45,2s1.75,2.13,3.25.93a14.39,14.39,0,0,0,2.83-3.71l.26-2.42Z"
              fill="#ccae79"
            />
            <path
              d="M257.52,160.81l-2.46.92,2,3.23,2.7.78.68,2.11s2.5,2,3,.85a21.57,21.57,0,0,1,2.84-3.75l-1.93-2.18Z"
              fill="#ffedc8"
            />
            <polygon
              points="257.08 164.96 256.66 167.35 259.49 168.16 259.78 165.74 257.08 164.96"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M262.7,169.06s.19,2.36-.25,2.37a8.28,8.28,0,0,0,3.57-4.06l.26-2.42S263.32,169.25,262.7,169.06Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M260.92,168.19l.51.34s-.31-.25-.36.79A4.09,4.09,0,0,0,260.92,168.19Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M262.1,168.91c-.06,0,.1.05.68-.62a5.19,5.19,0,0,0,.86-1.44s-1.41,1.77-1.16,2.17Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M256.24,163.62s-.07,1-.19,1.76c0,0,.1-1.34.35-1.49Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M260.77,161.75l1.08.3c.08,0-.84-.24-1.16.48l.09-.78"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M256.3,161.27l.61-.23s-.36.23-.24.34.58.6.8.5.54.19.54.19Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M368.78,124.66l2,1.84a.49.49,0,0,0,.62.06l4.84-3.18a1.21,1.21,0,0,0,.17-1.6h0a.55.55,0,0,0-.52-.23L369,122.89C368.43,123,368.26,124.19,368.78,124.66Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="372.37 117.31 369.63 118.16 367.23 120.87 371.26 123.25 376.2 120.28 372.37 117.31"
              fill="#ffedc8"
            />
            <polygon
              points="367.23 120.87 367.23 123.25 371.1 125.68 376.31 122.58 376.2 120.28 371.26 123.25 367.23 120.87"
              fill="#ccae79"
            />
            <polygon
              points="371.26 123.25 371.1 125.68 376.31 122.58 376.2 120.28 371.26 123.25"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M368.38,121.55a1.52,1.52,0,0,1,0,1.22c.18-.38.22-1.09.31-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M370.08,122.55a3,3,0,0,0,1-1.52l-.73,1.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M373.3,122a1.15,1.15,0,0,1,.4,1l-.12-1.13Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M375.11,119.43c-.05,0-1,.29-1.61,0a1.6,1.6,0,0,1-1.17.12s.86-.12,1.17.31A5.12,5.12,0,0,1,375.11,119.43Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M373.05,146.49l2,2a.45.45,0,0,0,.62.07l4.85-3.54a1.49,1.49,0,0,0,.16-1.79h0a.5.5,0,0,0-.52-.26l-6.86,1.5C372.69,144.65,372.52,146,373.05,146.49Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="376.63 138.29 373.9 139.24 371.49 142.27 375.52 144.91 380.46 141.6 376.63 138.29"
              fill="#ffedc8"
            />
            <polygon
              points="371.49 142.27 371.49 144.91 375.36 147.63 380.57 144.17 380.46 141.6 375.52 144.91 371.49 142.27"
              fill="#ccae79"
            />
            <polygon
              points="375.52 144.91 375.36 147.63 380.57 144.17 380.46 141.6 375.52 144.91"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M372.64,143a1.82,1.82,0,0,1,0,1.36c.18-.43.23-1.21.31-1.16Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M374.34,144.14a3.29,3.29,0,0,0,1-1.69l-.73,1.88Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M377.56,143.54a1.39,1.39,0,0,1,.41,1.07l-.12-1.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M379.37,140.66c-.05,0-1,.32-1.6,0a1.46,1.46,0,0,1-1.17.13s.85-.14,1.17.34A4.65,4.65,0,0,1,379.37,140.66Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M327.93,144.86l4.23,2.85a1.28,1.28,0,0,0,1.28.1l10.15-4.93a1.56,1.56,0,0,0,.34-2.49h0a1.36,1.36,0,0,0-1.08-.35l-14.38,2.08A1.52,1.52,0,0,0,327.93,144.86Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="335.43 133.47 329.71 134.79 324.67 138.99 333.12 142.67 343.46 138.07 335.43 133.47"
              fill="#ffedc8"
            />
            <polygon
              points="324.67 138.99 324.67 142.67 332.78 146.44 343.69 141.63 343.46 138.07 333.12 142.67 324.67 138.99"
              fill="#ccae79"
            />
            <polygon
              points="333.12 142.67 332.78 146.44 343.69 141.63 343.46 138.07 333.12 142.67"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M327.08,140a1.78,1.78,0,0,1,0,1.89c.38-.59.47-1.68.65-1.61Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M330.64,141.59a4.94,4.94,0,0,0,2.14-2.35l-1.54,2.61Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M337.39,140.77a1.71,1.71,0,0,1,.84,1.48l-.25-1.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M341.17,136.76c-.11-.06-2.14.44-3.36,0a4.51,4.51,0,0,1-2.45.18s1.8-.19,2.45.48A13.56,13.56,0,0,1,341.17,136.76Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M352.56,138l2.94,3a.63.63,0,0,0,.89.1l7.05-5.15a2.14,2.14,0,0,0,.24-2.61h0a.74.74,0,0,0-.75-.36l-10,2.17C352.05,135.33,351.8,137.24,352.56,138Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="357.78 126.08 353.8 127.46 350.3 131.87 356.17 135.71 363.35 130.9 357.78 126.08"
              fill="#ffedc8"
            />
            <polygon
              points="350.3 131.87 350.3 135.71 355.93 139.66 363.51 134.63 363.35 130.9 356.17 135.71 350.3 131.87"
              fill="#ccae79"
            />
            <polygon
              points="356.17 135.71 355.93 139.66 363.51 134.63 363.35 130.9 356.17 135.71"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M352,133a2.65,2.65,0,0,1,0,2c.27-.62.33-1.76.45-1.68Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M354.45,134.59a4.77,4.77,0,0,0,1.48-2.46l-1.06,2.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M359.13,133.73a2,2,0,0,1,.59,1.55l-.18-1.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M361.76,129.52c-.07-.06-1.48.47-2.33,0a2.13,2.13,0,0,1-1.7.2s1.25-.2,1.7.5A6.61,6.61,0,0,1,361.76,129.52Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M235.25,173.42l2,2.05a.45.45,0,0,0,.62.07l4.85-3.54a1.5,1.5,0,0,0,.16-1.8h0a.51.51,0,0,0-.52-.25l-6.86,1.5C234.9,171.58,234.72,172.89,235.25,173.42Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="238.83 165.22 236.1 166.17 233.69 169.19 237.72 171.84 242.66 168.53 238.83 165.22"
              fill="#ffedc8"
            />
            <polygon
              points="233.69 169.19 233.69 171.84 237.56 174.55 242.77 171.09 242.66 168.53 237.72 171.84 233.69 169.19"
              fill="#ccae79"
            />
            <polygon
              points="237.72 171.84 237.56 174.55 242.77 171.09 242.66 168.53 237.72 171.84"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M234.84,170a1.82,1.82,0,0,1,0,1.36c.18-.43.23-1.21.31-1.16Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M236.54,171.07a3.29,3.29,0,0,0,1-1.7l-.73,1.88Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M239.76,170.47a1.39,1.39,0,0,1,.41,1.07l-.12-1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M241.57,167.59c0-.05-1,.32-1.6,0a1.46,1.46,0,0,1-1.17.13s.85-.14,1.17.34A4.65,4.65,0,0,1,241.57,167.59Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M244.92,167.33l2,2a.44.44,0,0,0,.61.07l4.85-3.55a1.46,1.46,0,0,0,.16-1.79h0a.5.5,0,0,0-.51-.25l-6.87,1.49C244.57,165.49,244.4,166.8,244.92,167.33Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="248.5 159.13 245.77 160.08 243.36 163.1 247.4 165.75 252.34 162.44 248.5 159.13"
              fill="#ffedc8"
            />
            <polygon
              points="243.36 163.1 243.36 165.75 247.24 168.46 252.45 165 252.34 162.44 247.4 165.75 243.36 163.1"
              fill="#ccae79"
            />
            <polygon
              points="247.4 165.75 247.24 168.46 252.45 165 252.34 162.44 247.4 165.75"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M244.52,163.86a1.87,1.87,0,0,1,0,1.36c.18-.43.22-1.22.3-1.16Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M246.22,165a3.29,3.29,0,0,0,1-1.69l-.74,1.88Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M249.44,164.38a1.34,1.34,0,0,1,.4,1.07l-.12-1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M251.24,161.49c-.05,0-1,.32-1.6,0a1.44,1.44,0,0,1-1.17.14s.86-.14,1.17.34A4.51,4.51,0,0,1,251.24,161.49Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M248.09,176.09l2,2a.44.44,0,0,0,.61.07l4.85-3.55a1.47,1.47,0,0,0,.16-1.79h0a.51.51,0,0,0-.52-.25l-6.86,1.49C247.74,174.25,247.57,175.56,248.09,176.09Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="251.67 167.89 248.94 168.84 246.53 171.86 250.57 174.51 255.51 171.2 251.67 167.89"
              fill="#ffedc8"
            />
            <polygon
              points="246.53 171.86 246.53 174.51 250.4 177.22 255.61 173.76 255.51 171.2 250.57 174.51 246.53 171.86"
              fill="#ccae79"
            />
            <polygon
              points="250.57 174.51 250.4 177.22 255.61 173.76 255.51 171.2 250.57 174.51"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M247.68,172.62a1.82,1.82,0,0,1,0,1.36c.19-.43.23-1.22.31-1.16Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M249.39,173.73a3.32,3.32,0,0,0,1-1.69l-.73,1.88Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M252.61,173.14a1.38,1.38,0,0,1,.4,1.07l-.12-1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M254.41,170.25s-1,.32-1.6,0a1.44,1.44,0,0,1-1.17.14s.86-.14,1.17.34A4.51,4.51,0,0,1,254.41,170.25Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M281.15,162.46l2.25,2.29a.5.5,0,0,0,.69.07l5.39-3.94a1.64,1.64,0,0,0,.18-2h0a.55.55,0,0,0-.57-.28l-7.65,1.66C280.76,160.41,280.57,161.87,281.15,162.46Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="285.14 153.33 282.1 154.39 279.42 157.76 283.91 160.7 289.42 157.02 285.14 153.33"
              fill="#ffedc8"
            />
            <polygon
              points="279.42 157.76 279.42 160.7 283.73 163.72 289.53 159.87 289.42 157.02 283.91 160.7 279.42 157.76"
              fill="#ccae79"
            />
            <polygon
              points="283.91 160.7 283.73 163.72 289.53 159.87 289.42 157.02 283.91 160.7"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M280.7,158.6a2,2,0,0,1,0,1.51c.21-.47.25-1.35.35-1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M282.6,159.84a3.66,3.66,0,0,0,1.13-1.88l-.81,2.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M286.19,159.18a1.51,1.51,0,0,1,.44,1.19l-.13-1.4Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M288.2,156c-.06-.05-1.14.36-1.79,0a1.58,1.58,0,0,1-1.3.15s.95-.15,1.3.38A5.26,5.26,0,0,1,288.2,156Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M312.54,137.67l2.25,2.29a.49.49,0,0,0,.68.07l5.4-3.94a1.64,1.64,0,0,0,.18-2h0a.56.56,0,0,0-.57-.28l-7.65,1.66C312.15,135.62,312,137.08,312.54,137.67Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="316.53 128.54 313.49 129.6 310.81 132.97 315.3 135.91 320.8 132.23 316.53 128.54"
              fill="#ffedc8"
            />
            <polygon
              points="310.81 132.97 310.81 135.91 315.12 138.94 320.92 135.08 320.8 132.23 315.3 135.91 310.81 132.97"
              fill="#ccae79"
            />
            <polygon
              points="315.3 135.91 315.12 138.94 320.92 135.08 320.8 132.23 315.3 135.91"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M312.09,133.81a2,2,0,0,1,0,1.51c.2-.47.25-1.35.34-1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M314,135.05a3.62,3.62,0,0,0,1.14-1.88l-.82,2.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M317.57,134.39a1.5,1.5,0,0,1,.45,1.19l-.13-1.4Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M319.58,131.17c-.05,0-1.13.36-1.78,0a1.58,1.58,0,0,1-1.3.15s.95-.15,1.3.38A5.23,5.23,0,0,1,319.58,131.17Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M294.52,146.12l1.12,1.14a.25.25,0,0,0,.34,0l2.68-2a.81.81,0,0,0,.09-1h0a.28.28,0,0,0-.28-.14l-3.81.83C294.32,145.1,294.23,145.83,294.52,146.12Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="296.5 141.58 294.99 142.1 293.65 143.78 295.89 145.25 298.63 143.41 296.5 141.58"
              fill="#ffedc8"
            />
            <polygon
              points="293.65 143.78 293.65 145.25 295.8 146.75 298.69 144.83 298.63 143.41 295.89 145.25 293.65 143.78"
              fill="#ccae79"
            />
            <polygon
              points="295.89 145.25 295.8 146.75 298.69 144.83 298.63 143.41 295.89 145.25"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M294.29,144.2a1,1,0,0,1,0,.75c.1-.24.13-.67.17-.64Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M295.24,144.82a1.81,1.81,0,0,0,.56-.94l-.41,1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M297,144.49a.74.74,0,0,1,.22.59l-.06-.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M298,142.89s-.56.18-.89,0a.78.78,0,0,1-.64.07s.47-.07.64.19A2.59,2.59,0,0,1,298,142.89Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M296.27,138.9l1.12,1.13a.24.24,0,0,0,.34,0l2.69-2a.83.83,0,0,0,.09-1h0a.29.29,0,0,0-.29-.14l-3.8.83C296.08,137.87,296,138.6,296.27,138.9Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="298.26 134.35 296.75 134.88 295.41 136.55 297.65 138.02 300.39 136.19 298.26 134.35"
              fill="#ffedc8"
            />
            <polygon
              points="295.41 136.55 295.41 138.02 297.56 139.53 300.44 137.61 300.39 136.19 297.65 138.02 295.41 136.55"
              fill="#ccae79"
            />
            <polygon
              points="297.65 138.02 297.56 139.53 300.44 137.61 300.39 136.19 297.65 138.02"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M296.05,137a1,1,0,0,1,0,.75c.1-.23.12-.67.17-.64Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M297,137.59a1.85,1.85,0,0,0,.57-.94l-.41,1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M298.78,137.26a.76.76,0,0,1,.22.59l-.07-.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M535.47,115.59s-.57.18-.89,0a.83.83,0,0,1-.65.08s.47-.08.65.19A2.63,2.63,0,0,1,535.47,115.59Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M285.83,144l1.5,1.52a.34.34,0,0,0,.46.06L291.4,143a1.11,1.11,0,0,0,.12-1.34h0a.39.39,0,0,0-.39-.19L286,142.57C285.57,142.67,285.44,143.64,285.83,144Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="288.5 137.93 286.46 138.64 284.67 140.89 287.67 142.86 291.35 140.4 288.5 137.93"
              fill="#ffedc8"
            />
            <polygon
              points="284.67 140.89 284.67 142.86 287.55 144.88 291.43 142.31 291.35 140.4 287.67 142.86 284.67 140.89"
              fill="#ccae79"
            />
            <polygon
              points="287.67 142.86 287.55 144.88 291.43 142.31 291.35 140.4 287.67 142.86"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M285.53,141.45a1.41,1.41,0,0,1,0,1c.13-.31.16-.9.23-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M286.79,142.28a2.44,2.44,0,0,0,.76-1.26l-.54,1.4Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M289.19,141.84a1,1,0,0,1,.3.8l-.09-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M290.54,139.69s-.76.24-1.2,0a1.06,1.06,0,0,1-.87.1s.64-.1.87.26A3.45,3.45,0,0,1,290.54,139.69Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M384.15,127.41l2.71,2.76a.61.61,0,0,0,.83.09l6.51-4.76a2,2,0,0,0,.22-2.41h0a.71.71,0,0,0-.7-.34l-9.22,2C383.68,124.94,383.45,126.7,384.15,127.41Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="388.96 116.4 385.29 117.67 382.06 121.74 387.48 125.29 394.12 120.84 388.96 116.4"
              fill="#ffedc8"
            />
            <polygon
              points="382.06 121.74 382.06 125.29 387.26 128.94 394.26 124.29 394.12 120.84 387.48 125.29 382.06 121.74"
              fill="#ccae79"
            />
            <polygon
              points="387.48 125.29 387.26 128.94 394.26 124.29 394.12 120.84 387.48 125.29"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M383.61,122.75a2.48,2.48,0,0,1,0,1.83c.24-.58.3-1.63.41-1.56Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M385.89,124.25a4.4,4.4,0,0,0,1.37-2.27l-1,2.52Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M390.22,123.45a1.82,1.82,0,0,1,.54,1.44l-.16-1.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M392.64,119.58c-.06-.06-1.37.43-2.15,0a1.93,1.93,0,0,1-1.57.17s1.15-.18,1.57.47A6,6,0,0,1,392.64,119.58Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M403.83,134.58l2.71,2.76a.6.6,0,0,0,.82.09l6.51-4.76a2,2,0,0,0,.22-2.41h0a.68.68,0,0,0-.69-.34l-9.22,2C403.36,132.11,403.12,133.87,403.83,134.58Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="408.64 123.57 404.97 124.84 401.74 128.91 407.15 132.46 413.79 128.01 408.64 123.57"
              fill="#ffedc8"
            />
            <polygon
              points="401.74 128.91 401.74 132.46 406.94 136.1 413.93 131.46 413.79 128.01 407.15 132.46 401.74 128.91"
              fill="#ccae79"
            />
            <polygon
              points="407.15 132.46 406.94 136.1 413.93 131.46 413.79 128.01 407.15 132.46"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M403.28,129.92a2.46,2.46,0,0,1,0,1.82c.25-.57.3-1.62.42-1.55Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M405.57,131.42a4.4,4.4,0,0,0,1.37-2.27l-1,2.52Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M409.89,130.62a1.82,1.82,0,0,1,.54,1.44l-.16-1.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M412.32,126.74c-.07,0-1.37.44-2.15,0a1.91,1.91,0,0,1-1.57.18s1.15-.18,1.57.46A6.26,6.26,0,0,1,412.32,126.74Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M389.82,140.3l1.85,1.87a.4.4,0,0,0,.56.07l4.44-3.25a1.35,1.35,0,0,0,.15-1.64h0a.45.45,0,0,0-.48-.23l-6.29,1.37C389.49,138.61,389.34,139.81,389.82,140.3Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="393.1 132.78 390.6 133.65 388.39 136.42 392.09 138.85 396.61 135.82 393.1 132.78"
              fill="#ffedc8"
            />
            <polygon
              points="388.39 136.42 388.39 138.85 391.94 141.33 396.71 138.16 396.61 135.82 392.09 138.85 388.39 136.42"
              fill="#ccae79"
            />
            <polygon
              points="392.09 138.85 391.94 141.33 396.71 138.16 396.61 135.82 392.09 138.85"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M389.45,137.12a1.67,1.67,0,0,1,0,1.24c.16-.39.2-1.11.28-1.06Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M391,138.14a3.06,3.06,0,0,0,.94-1.55l-.67,1.72Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M394,137.6a1.21,1.21,0,0,1,.36,1l-.11-1.15Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M395.61,135c-.05,0-.94.29-1.47,0a1.34,1.34,0,0,1-1.07.12s.79-.12,1.07.32A4.17,4.17,0,0,1,395.61,135Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1037.66,34.48l2.7,1.67a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.86.86,0,0,0-.69-.2L1038,32.86A.88.88,0,0,0,1037.66,34.48Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1042.45 27.76 1038.8 28.54 1035.57 31.02 1040.97 33.18 1047.59 30.47 1042.45 27.76"
            fill="#ffedc8"
          />
          <polygon
            points="1035.57 31.02 1035.57 33.18 1040.76 35.4 1047.73 32.57 1047.59 30.47 1040.97 33.18 1035.57 31.02"
            fill="#ccae79"
          />
          <polygon
            points="1040.97 33.18 1040.76 35.4 1047.73 32.57 1047.59 30.47 1040.97 33.18"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1037.12,31.63a1,1,0,0,1,0,1.12c.24-.35.3-1,.41-.95Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1039.39,32.55a3.08,3.08,0,0,0,1.37-1.39l-1,1.54Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1043.71,32.06a1,1,0,0,1,.53.88l-.16-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1046.12,29.7a6.56,6.56,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A8.93,8.93,0,0,1,1046.12,29.7Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1055.56,24.33l2.7,1.68a.9.9,0,0,0,.83,0l6.48-2.9a.88.88,0,0,0,.22-1.47h0a.86.86,0,0,0-.69-.2l-9.19,1.22A.88.88,0,0,0,1055.56,24.33Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1060.36 17.62 1056.7 18.39 1053.48 20.87 1058.88 23.03 1065.49 20.32 1060.36 17.62"
            fill="#ffedc8"
          />
          <polygon
            points="1053.48 20.87 1053.48 23.03 1058.66 25.25 1065.63 22.42 1065.49 20.32 1058.88 23.03 1053.48 20.87"
            fill="#ccae79"
          />
          <polygon
            points="1058.88 23.03 1058.66 25.25 1065.63 22.42 1065.49 20.32 1058.88 23.03"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1055,21.49a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1057.3,22.4a3.09,3.09,0,0,0,1.36-1.38l-1,1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1061.61,21.91a1,1,0,0,1,.54.88l-.16-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1064,19.55a6.34,6.34,0,0,1-2.15,0,3.13,3.13,0,0,1-1.57.11s1.15-.11,1.57.28A9.54,9.54,0,0,1,1064,19.55Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M889.3,3.42c4.42-.25-4.33.46-4.36-.61S889.29.18,890.22.36s.27,2.25.27,2.25,1.24-2.78,2.93-2.16S897,4,896.07,3.9s-4.7,0-4.7,0,6,.86,4,1.55S892,7.47,891,7.2s-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,889.3,3.42Z"
              fill="#2f6840"
            />
            <path
              d="M888.79,3.08c4.43-.25-4.33.45-4.35-.61S888.79-.16,889.72,0s.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72S889.32,4,889.32,4s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,888.79,3.08Z"
              fill="#3ba525"
            />
            <path
              d="M889.54,3.05a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,889.54,3.05Z"
              fill="#2f6840"
            />
            <path
              d="M893,2.25c-.26,0-.49,0-.72.1a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,893,2.25Z"
              fill="#2f6840"
            />
            <path
              d="M891.65,5.46a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,891.65,5.46Z"
              fill="#2f6840"
            />
            <path
              d="M889.69,3.51c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,889.69,3.51Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M886.64,12.15c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,886.64,12.15Z"
              fill="#2f6840"
            />
            <path
              d="M886.13,11.81c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,886.13,11.81Z"
              fill="#3ba525"
            />
            <path
              d="M886.88,11.78a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,886.88,11.78Z"
              fill="#2f6840"
            />
            <path
              d="M890.36,11c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,890.36,11Z"
              fill="#2f6840"
            />
            <path
              d="M889,14.19a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,889,14.19Z"
              fill="#2f6840"
            />
            <path
              d="M887,12.24c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,887,12.24Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M881.28,7.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55S884,11.24,883,11s-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,881.28,7.19Z"
              fill="#2f6840"
            />
            <path
              d="M880.78,6.85c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46S882,6,882,6s1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55S876.05,8,876.23,7.91A14.65,14.65,0,0,1,880.78,6.85Z"
              fill="#3ba525"
            />
            <path
              d="M881.53,6.82a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73A2.26,2.26,0,0,1,881,5.6a1.85,1.85,0,0,1,.47.53A1,1,0,0,1,881.53,6.82Z"
              fill="#2f6840"
            />
            <path
              d="M885,6c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52A2.38,2.38,0,0,1,883.5,6,2.12,2.12,0,0,1,885,6Z"
              fill="#2f6840"
            />
            <path
              d="M883.64,9.23a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,883.64,9.23Z"
              fill="#2f6840"
            />
            <path
              d="M881.68,7.28c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,881.68,7.28Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M872.94,3.82c4.43-.25-4.33.46-4.35-.61S872.94.58,873.87.76s.27,2.25.27,2.25S875.37.23,877.06.85s3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55S868.21,5,868.39,4.88A14.65,14.65,0,0,1,872.94,3.82Z"
              fill="#2f6840"
            />
            <path
              d="M872.44,3.48c4.42-.25-4.33.45-4.36-.61S872.43.24,873.36.41s.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71S873,4.35,873,4.35s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,872.44,3.48Z"
              fill="#3ba525"
            />
            <path
              d="M873.19,3.45a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,873.19,3.45Z"
              fill="#2f6840"
            />
            <path
              d="M876.67,2.65c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,876.67,2.65Z"
              fill="#2f6840"
            />
            <path
              d="M875.3,5.86a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,875.3,5.86Z"
              fill="#2f6840"
            />
            <path
              d="M873.34,3.91c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,873.34,3.91Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M887.65,19.31c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,887.65,19.31Z"
              fill="#2f6840"
            />
            <path
              d="M887.14,19c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,887.14,19Z"
              fill="#3ba525"
            />
            <path
              d="M887.89,18.94a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,887.89,18.94Z"
              fill="#2f6840"
            />
            <path
              d="M891.37,18.14c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,891.37,18.14Z"
              fill="#2f6840"
            />
            <path
              d="M890,21.35a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,890,21.35Z"
              fill="#2f6840"
            />
            <path
              d="M888,19.4c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,888,19.4Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M874.19,13.74c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,874.19,13.74Z"
              fill="#2f6840"
            />
            <path
              d="M873.68,13.4c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,873.68,13.4Z"
              fill="#3ba525"
            />
            <path
              d="M874.44,13.37a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,874.44,13.37Z"
              fill="#2f6840"
            />
            <path
              d="M877.91,12.57c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,877.91,12.57Z"
              fill="#2f6840"
            />
            <path
              d="M876.55,15.78a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,876.55,15.78Z"
              fill="#2f6840"
            />
            <path
              d="M874.59,13.83c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,874.59,13.83Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M917.63,6.36c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S925.37,7,924.4,6.83s-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,917.63,6.36Z"
              fill="#2f6840"
            />
            <path
              d="M917.12,6c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,917.12,6Z"
              fill="#3ba525"
            />
            <path
              d="M917.87,6a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,917.87,6Z"
              fill="#2f6840"
            />
            <path
              d="M921.35,5.19c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18A11.31,11.31,0,0,0,918.6,6a2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,921.35,5.19Z"
              fill="#2f6840"
            />
            <path
              d="M920,8.4a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,920,8.4Z"
              fill="#2f6840"
            />
            <path
              d="M918,6.45c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,918,6.45Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M915,15.09c4.42-.25-4.33.46-4.36-.61S915,11.85,915.89,12s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71S915.5,16,915.5,16s-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,915,15.09Z"
              fill="#2f6840"
            />
            <path
              d="M914.46,14.75c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,914.46,14.75Z"
              fill="#3ba525"
            />
            <path
              d="M915.21,14.72a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.25,2.25,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,915.21,14.72Z"
              fill="#2f6840"
            />
            <path
              d="M918.69,13.92c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,918.69,13.92Z"
              fill="#2f6840"
            />
            <path
              d="M917.32,17.13a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,917.32,17.13Z"
              fill="#2f6840"
            />
            <path
              d="M915.37,15.18a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,915.37,15.18Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M909.61,10.13c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,909.61,10.13Z"
              fill="#2f6840"
            />
            <path
              d="M909.11,9.79c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46S910.3,9,910.3,9s1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,909.11,9.79Z"
              fill="#3ba525"
            />
            <path
              d="M909.86,9.76a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,909.86,9.76Z"
              fill="#2f6840"
            />
            <path
              d="M913.34,9c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,913.34,9Z"
              fill="#2f6840"
            />
            <path
              d="M912,12.17a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,912,12.17Z"
              fill="#2f6840"
            />
            <path
              d="M910,10.22c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,910,10.22Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M901.27,6.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S909,7.35,908,7.23s-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,901.27,6.76Z"
              fill="#2f6840"
            />
            <path
              d="M900.77,6.42c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46S902,5.6,902,5.6s1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S896,7.57,896.22,7.48A14.56,14.56,0,0,1,900.77,6.42Z"
              fill="#3ba525"
            />
            <path
              d="M901.52,6.39a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,901.52,6.39Z"
              fill="#2f6840"
            />
            <path
              d="M905,5.59c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,905,5.59Z"
              fill="#2f6840"
            />
            <path
              d="M903.63,8.8a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,903.63,8.8Z"
              fill="#2f6840"
            />
            <path
              d="M901.67,6.85c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,901.67,6.85Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M916,22.25c4.42-.25-4.33.46-4.36-.61S916,19,916.9,19.19s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,916,22.25Z"
              fill="#2f6840"
            />
            <path
              d="M915.47,21.91c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,915.47,21.91Z"
              fill="#3ba525"
            />
            <path
              d="M916.22,21.88a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,916.22,21.88Z"
              fill="#2f6840"
            />
            <path
              d="M919.7,21.08c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,919.7,21.08Z"
              fill="#2f6840"
            />
            <path
              d="M918.33,24.29a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,918.33,24.29Z"
              fill="#2f6840"
            />
            <path
              d="M916.38,22.34a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,916.38,22.34Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M902.52,16.68c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,902.52,16.68Z"
              fill="#2f6840"
            />
            <path
              d="M902,16.34c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,902,16.34Z"
              fill="#3ba525"
            />
            <path
              d="M902.77,16.31a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,902.77,16.31Z"
              fill="#2f6840"
            />
            <path
              d="M906.24,15.51c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,906.24,15.51Z"
              fill="#2f6840"
            />
            <path
              d="M904.88,18.72a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,904.88,18.72Z"
              fill="#2f6840"
            />
            <path
              d="M902.92,16.77c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,902.92,16.77Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M945.71,11.17c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,945.71,11.17Z"
              fill="#2f6840"
            />
            <path
              d="M945.2,10.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,945.2,10.83Z"
              fill="#3ba525"
            />
            <path
              d="M946,10.8a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,946,10.8Z"
              fill="#2f6840"
            />
            <path
              d="M949.43,10c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,949.43,10Z"
              fill="#2f6840"
            />
            <path
              d="M948.06,13.21a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,948.06,13.21Z"
              fill="#2f6840"
            />
            <path
              d="M946.1,11.26c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,946.1,11.26Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M943.05,19.9c4.42-.25-4.33.46-4.36-.61S943,16.66,944,16.84s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,943.05,19.9Z"
              fill="#2f6840"
            />
            <path
              d="M942.54,19.56c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25S945,16,946.66,16.59s3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,942.54,19.56Z"
              fill="#3ba525"
            />
            <path
              d="M943.29,19.53a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,943.29,19.53Z"
              fill="#2f6840"
            />
            <path
              d="M946.77,18.73c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,946.77,18.73Z"
              fill="#2f6840"
            />
            <path
              d="M945.4,21.94a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,945.4,21.94Z"
              fill="#2f6840"
            />
            <path
              d="M943.45,20c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65A2.36,2.36,0,0,1,942,20,2.07,2.07,0,0,1,943.45,20Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M937.69,14.94c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S933,16.09,933.15,16A14.55,14.55,0,0,1,937.69,14.94Z"
              fill="#2f6840"
            />
            <path
              d="M937.19,14.6c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,937.19,14.6Z"
              fill="#3ba525"
            />
            <path
              d="M937.94,14.57a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,937.94,14.57Z"
              fill="#2f6840"
            />
            <path
              d="M941.42,13.78c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,941.42,13.78Z"
              fill="#2f6840"
            />
            <path
              d="M940.05,17a1.94,1.94,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,940.05,17Z"
              fill="#2f6840"
            />
            <path
              d="M938.09,15c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,938.09,15Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M929.35,11.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25S931.79,8,933.47,8.6s3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,929.35,11.57Z"
              fill="#2f6840"
            />
            <path
              d="M928.85,11.23c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,928.85,11.23Z"
              fill="#3ba525"
            />
            <path
              d="M929.6,11.2a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74A2.29,2.29,0,0,1,929,10a1.88,1.88,0,0,1,.48.53A1,1,0,0,1,929.6,11.2Z"
              fill="#2f6840"
            />
            <path
              d="M933.08,10.4c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,933.08,10.4Z"
              fill="#2f6840"
            />
            <path
              d="M931.71,13.61a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,931.71,13.61Z"
              fill="#2f6840"
            />
            <path
              d="M929.75,11.66c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,929.75,11.66Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M944.06,27.06c4.42-.25-4.33.46-4.36-.61S944.05,23.82,945,24s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,944.06,27.06Z"
              fill="#2f6840"
            />
            <path
              d="M943.55,26.72c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,943.55,26.72Z"
              fill="#3ba525"
            />
            <path
              d="M944.3,26.69a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,944.3,26.69Z"
              fill="#2f6840"
            />
            <path
              d="M947.78,25.89c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,947.78,25.89Z"
              fill="#2f6840"
            />
            <path
              d="M946.41,29.1a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,946.41,29.1Z"
              fill="#2f6840"
            />
            <path
              d="M944.45,27.15c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,944.45,27.15Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M930.6,21.49c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,930.6,21.49Z"
              fill="#2f6840"
            />
            <path
              d="M930.09,21.15c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,930.09,21.15Z"
              fill="#3ba525"
            />
            <path
              d="M930.85,21.12a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,930.85,21.12Z"
              fill="#2f6840"
            />
            <path
              d="M934.32,20.32c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,934.32,20.32Z"
              fill="#2f6840"
            />
            <path
              d="M933,23.53a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,933,23.53Z"
              fill="#2f6840"
            />
            <path
              d="M931,21.58c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,931,21.58Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M973.63,16.84c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S968.9,18,969.08,17.9A14.65,14.65,0,0,1,973.63,16.84Z"
              fill="#2f6840"
            />
            <path
              d="M973.12,16.5c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,973.12,16.5Z"
              fill="#3ba525"
            />
            <path
              d="M973.88,16.47a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,973.88,16.47Z"
              fill="#2f6840"
            />
            <path
              d="M977.35,15.67c-.25,0-.49.05-.72.1A4,4,0,0,0,976,16a11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,977.35,15.67Z"
              fill="#2f6840"
            />
            <path
              d="M976,18.88a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,976,18.88Z"
              fill="#2f6840"
            />
            <path
              d="M974,16.93c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,974,16.93Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M971,25.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,971,25.57Z"
              fill="#2f6840"
            />
            <path
              d="M970.46,25.23c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71S971,26.1,971,26.1s-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,970.46,25.23Z"
              fill="#3ba525"
            />
            <path
              d="M971.22,25.2a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,971.22,25.2Z"
              fill="#2f6840"
            />
            <path
              d="M974.69,24.4c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,974.69,24.4Z"
              fill="#2f6840"
            />
            <path
              d="M973.33,27.61a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,973.33,27.61Z"
              fill="#2f6840"
            />
            <path
              d="M971.37,25.66c-.25.06-.48.09-.7.16A3.45,3.45,0,0,0,970,26a9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,971.37,25.66Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M965.62,20.61c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,965.62,20.61Z"
              fill="#2f6840"
            />
            <path
              d="M965.11,20.27c4.43-.25-4.33.46-4.35-.61S965.11,17,966,17.2s.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,965.11,20.27Z"
              fill="#3ba525"
            />
            <path
              d="M965.86,20.24a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,965.86,20.24Z"
              fill="#2f6840"
            />
            <path
              d="M969.34,19.45c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,969.34,19.45Z"
              fill="#2f6840"
            />
            <path
              d="M968,22.66a1.93,1.93,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,968,22.66Z"
              fill="#2f6840"
            />
            <path
              d="M966,20.7c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,966,20.7Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M957.27,17.24c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55S960,21.29,959,21s-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,957.27,17.24Z"
              fill="#2f6840"
            />
            <path
              d="M956.77,16.9c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S952,18.05,952.22,18A14.65,14.65,0,0,1,956.77,16.9Z"
              fill="#3ba525"
            />
            <path
              d="M957.52,16.87a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,957.52,16.87Z"
              fill="#2f6840"
            />
            <path
              d="M961,16.07c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,961,16.07Z"
              fill="#2f6840"
            />
            <path
              d="M959.63,19.28a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,959.63,19.28Z"
              fill="#2f6840"
            />
            <path
              d="M957.67,17.33c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,957.67,17.33Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M972,32.73c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,972,32.73Z"
              fill="#2f6840"
            />
            <path
              d="M971.47,32.39c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,971.47,32.39Z"
              fill="#3ba525"
            />
            <path
              d="M972.23,32.36a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,972.23,32.36Z"
              fill="#2f6840"
            />
            <path
              d="M975.7,31.56c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,975.7,31.56Z"
              fill="#2f6840"
            />
            <path
              d="M974.34,34.77a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,974.34,34.77Z"
              fill="#2f6840"
            />
            <path
              d="M972.38,32.82c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,972.38,32.82Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M958.52,27.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,958.52,27.16Z"
              fill="#2f6840"
            />
            <path
              d="M958,26.82c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,958,26.82Z"
              fill="#3ba525"
            />
            <path
              d="M958.77,26.79a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,958.77,26.79Z"
              fill="#2f6840"
            />
            <path
              d="M962.25,26c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,962.25,26Z"
              fill="#2f6840"
            />
            <path
              d="M960.88,29.2a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,960.88,29.2Z"
              fill="#2f6840"
            />
            <path
              d="M958.92,27.25c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,958.92,27.25Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1001.4,23.2c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1001.4,23.2Z"
              fill="#2f6840"
            />
            <path
              d="M1000.9,22.86c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1000.9,22.86Z"
              fill="#3ba525"
            />
            <path
              d="M1001.65,22.83a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1001.65,22.83Z"
              fill="#2f6840"
            />
            <path
              d="M1005.13,22c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1005.13,22Z"
              fill="#2f6840"
            />
            <path
              d="M1003.76,25.25a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1003.76,25.25Z"
              fill="#2f6840"
            />
            <path
              d="M1001.8,23.29c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1001.8,23.29Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M998.74,31.93c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S994,33.08,994.2,33A14.55,14.55,0,0,1,998.74,31.93Z"
              fill="#2f6840"
            />
            <path
              d="M998.24,31.59c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,998.24,31.59Z"
              fill="#3ba525"
            />
            <path
              d="M999,31.56a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,999,31.56Z"
              fill="#2f6840"
            />
            <path
              d="M1002.47,30.77c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1002.47,30.77Z"
              fill="#2f6840"
            />
            <path
              d="M1001.1,34a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1001.1,34Z"
              fill="#2f6840"
            />
            <path
              d="M999.14,32c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,999.14,32Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M993.39,27c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,993.39,27Z"
              fill="#2f6840"
            />
            <path
              d="M992.88,26.63c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25S995.32,23,997,23.66s3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,992.88,26.63Z"
              fill="#3ba525"
            />
            <path
              d="M993.64,26.6a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,993.64,26.6Z"
              fill="#2f6840"
            />
            <path
              d="M997.12,25.81a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,997.12,25.81Z"
              fill="#2f6840"
            />
            <path
              d="M995.75,29a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,995.75,29Z"
              fill="#2f6840"
            />
            <path
              d="M993.79,27.06c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,993.79,27.06Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M985.05,23.6c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,985.05,23.6Z"
              fill="#2f6840"
            />
            <path
              d="M984.54,23.26c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,984.54,23.26Z"
              fill="#3ba525"
            />
            <path
              d="M985.3,23.23a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,985.3,23.23Z"
              fill="#2f6840"
            />
            <path
              d="M988.77,22.44c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,988.77,22.44Z"
              fill="#2f6840"
            />
            <path
              d="M987.4,25.65a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,987.4,25.65Z"
              fill="#2f6840"
            />
            <path
              d="M985.45,23.69c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,985.45,23.69Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M999.75,39.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,999.75,39.09Z"
              fill="#2f6840"
            />
            <path
              d="M999.25,38.75c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,999.25,38.75Z"
              fill="#3ba525"
            />
            <path
              d="M1000,38.72a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1000,38.72Z"
              fill="#2f6840"
            />
            <path
              d="M1003.48,37.93c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1003.48,37.93Z"
              fill="#2f6840"
            />
            <path
              d="M1002.11,41.14a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1002.11,41.14Z"
              fill="#2f6840"
            />
            <path
              d="M1000.15,39.18c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1000.15,39.18Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M986.3,33.52c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S994,34.11,993.07,34s-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,986.3,33.52Z"
              fill="#2f6840"
            />
            <path
              d="M985.79,33.18c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,985.79,33.18Z"
              fill="#3ba525"
            />
            <path
              d="M986.54,33.15a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,986.54,33.15Z"
              fill="#2f6840"
            />
            <path
              d="M990,32.36c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,990,32.36Z"
              fill="#2f6840"
            />
            <path
              d="M988.65,35.57a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,988.65,35.57Z"
              fill="#2f6840"
            />
            <path
              d="M986.69,33.61c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,986.69,33.61Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1029.62,24.64c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1029.62,24.64Z"
              fill="#2f6840"
            />
            <path
              d="M1029.12,24.3c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1029.12,24.3Z"
              fill="#3ba525"
            />
            <path
              d="M1029.87,24.27a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1029.87,24.27Z"
              fill="#2f6840"
            />
            <path
              d="M1033.35,23.47c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1033.35,23.47Z"
              fill="#2f6840"
            />
            <path
              d="M1032,26.68a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1032,26.68Z"
              fill="#2f6840"
            />
            <path
              d="M1030,24.73c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1030,24.73Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1027,33.37c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1027,33.37Z"
              fill="#2f6840"
            />
            <path
              d="M1026.46,33c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1026.46,33Z"
              fill="#3ba525"
            />
            <path
              d="M1027.21,33a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1027.21,33Z"
              fill="#2f6840"
            />
            <path
              d="M1030.69,32.2c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1030.69,32.2Z"
              fill="#2f6840"
            />
            <path
              d="M1029.32,35.41a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1029.32,35.41Z"
              fill="#2f6840"
            />
            <path
              d="M1027.36,33.46c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1027.36,33.46Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1021.61,28.41c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1021.61,28.41Z"
              fill="#2f6840"
            />
            <path
              d="M1021.11,28.07c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1021.11,28.07Z"
              fill="#3ba525"
            />
            <path
              d="M1021.86,28a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1021.86,28Z"
              fill="#2f6840"
            />
            <path
              d="M1025.34,27.24c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1025.34,27.24Z"
              fill="#2f6840"
            />
            <path
              d="M1024,30.45a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1024,30.45Z"
              fill="#2f6840"
            />
            <path
              d="M1022,28.5c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1022,28.5Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1013.27,25c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1013.27,25Z"
              fill="#2f6840"
            />
            <path
              d="M1012.76,24.7c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1012.76,24.7Z"
              fill="#3ba525"
            />
            <path
              d="M1013.52,24.67a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1013.52,24.67Z"
              fill="#2f6840"
            />
            <path
              d="M1017,23.87c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1017,23.87Z"
              fill="#2f6840"
            />
            <path
              d="M1015.63,27.08a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1015.63,27.08Z"
              fill="#2f6840"
            />
            <path
              d="M1013.67,25.13c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1013.67,25.13Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1028,40.53c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1028,40.53Z"
              fill="#2f6840"
            />
            <path
              d="M1027.47,40.19c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1027.47,40.19Z"
              fill="#3ba525"
            />
            <path
              d="M1028.22,40.16a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1028.22,40.16Z"
              fill="#2f6840"
            />
            <path
              d="M1031.7,39.36c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1031.7,39.36Z"
              fill="#2f6840"
            />
            <path
              d="M1030.33,42.57a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1030.33,42.57Z"
              fill="#2f6840"
            />
            <path
              d="M1028.37,40.62c-.24.06-.47.09-.69.16a3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1028.37,40.62Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1014.52,35c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1014.52,35Z"
              fill="#2f6840"
            />
            <path
              d="M1014,34.62c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1014,34.62Z"
              fill="#3ba525"
            />
            <path
              d="M1014.76,34.59a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1014.76,34.59Z"
              fill="#2f6840"
            />
            <path
              d="M1018.24,33.79c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1018.24,33.79Z"
              fill="#2f6840"
            />
            <path
              d="M1016.87,37a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1016.87,37Z"
              fill="#2f6840"
            />
            <path
              d="M1014.92,35.05c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1014.92,35.05Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1056.37,15.6c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1056.37,15.6Z"
              fill="#2f6840"
            />
            <path
              d="M1055.86,15.25c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1055.86,15.25Z"
              fill="#3ba525"
            />
            <path
              d="M1056.62,15.22a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74A2.28,2.28,0,0,1,1056,14a1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1056.62,15.22Z"
              fill="#2f6840"
            />
            <path
              d="M1060.1,14.43c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1060.1,14.43Z"
              fill="#2f6840"
            />
            <path
              d="M1058.73,17.64a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1058.73,17.64Z"
              fill="#2f6840"
            />
            <path
              d="M1056.77,15.68c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1056.77,15.68Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1053.71,24.33c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1053.71,24.33Z"
              fill="#2f6840"
            />
            <path
              d="M1053.21,24c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1053.21,24Z"
              fill="#3ba525"
            />
            <path
              d="M1054,24a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1054,24Z"
              fill="#2f6840"
            />
            <path
              d="M1057.44,23.16a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1057.44,23.16Z"
              fill="#2f6840"
            />
            <path
              d="M1056.07,26.37a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1056.07,26.37Z"
              fill="#2f6840"
            />
            <path
              d="M1054.11,24.41c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1054.11,24.41Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1048.36,19.37c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1048.36,19.37Z"
              fill="#2f6840"
            />
            <path
              d="M1047.85,19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1047.85,19Z"
              fill="#3ba525"
            />
            <path
              d="M1048.61,19a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1048.61,19Z"
              fill="#2f6840"
            />
            <path
              d="M1052.08,18.2c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1052.08,18.2Z"
              fill="#2f6840"
            />
            <path
              d="M1050.72,21.41a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1050.72,21.41Z"
              fill="#2f6840"
            />
            <path
              d="M1048.76,19.45c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1048.76,19.45Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1040,16c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1040,16Z"
              fill="#2f6840"
            />
            <path
              d="M1039.51,15.65c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1039.51,15.65Z"
              fill="#3ba525"
            />
            <path
              d="M1040.26,15.62a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1040.26,15.62Z"
              fill="#2f6840"
            />
            <path
              d="M1043.74,14.83a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1043.74,14.83Z"
              fill="#2f6840"
            />
            <path
              d="M1042.37,18a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1042.37,18Z"
              fill="#2f6840"
            />
            <path
              d="M1040.42,16.08c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1040.42,16.08Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1054.72,31.49c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1054.72,31.49Z"
              fill="#2f6840"
            />
            <path
              d="M1054.22,31.14c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1054.22,31.14Z"
              fill="#3ba525"
            />
            <path
              d="M1055,31.11a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1055,31.11Z"
              fill="#2f6840"
            />
            <path
              d="M1058.45,30.32a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1058.45,30.32Z"
              fill="#2f6840"
            />
            <path
              d="M1057.08,33.53a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1057.08,33.53Z"
              fill="#2f6840"
            />
            <path
              d="M1055.12,31.57c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1055.12,31.57Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1041.26,25.92c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1041.26,25.92Z"
              fill="#2f6840"
            />
            <path
              d="M1040.76,25.57c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1040.76,25.57Z"
              fill="#3ba525"
            />
            <path
              d="M1041.51,25.54a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1041.51,25.54Z"
              fill="#2f6840"
            />
            <path
              d="M1045,24.75a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1045,24.75Z"
              fill="#2f6840"
            />
            <path
              d="M1043.62,28a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1043.62,28Z"
              fill="#2f6840"
            />
            <path
              d="M1041.66,26c-.24.06-.47.09-.69.16a4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1041.66,26Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1082.66,5.77c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1082.66,5.77Z"
              fill="#2f6840"
            />
            <path
              d="M1082.15,5.43c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1082.15,5.43Z"
              fill="#3ba525"
            />
            <path
              d="M1082.9,5.4a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1082.9,5.4Z"
              fill="#2f6840"
            />
            <path
              d="M1086.38,4.6c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,1086.38,4.6Z"
              fill="#2f6840"
            />
            <path
              d="M1085,7.81a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1085,7.81Z"
              fill="#2f6840"
            />
            <path
              d="M1083.06,5.86c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1083.06,5.86Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1080,14.5c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1080,14.5Z"
              fill="#2f6840"
            />
            <path
              d="M1079.49,14.16c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71S1080,15,1080,15s-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1079.49,14.16Z"
              fill="#3ba525"
            />
            <path
              d="M1080.24,14.13a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1080.24,14.13Z"
              fill="#2f6840"
            />
            <path
              d="M1083.72,13.33c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1083.72,13.33Z"
              fill="#2f6840"
            />
            <path
              d="M1082.35,16.54a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1082.35,16.54Z"
              fill="#2f6840"
            />
            <path
              d="M1080.4,14.59c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1080.4,14.59Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1074.65,9.54c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1074.65,9.54Z"
              fill="#2f6840"
            />
            <path
              d="M1074.14,9.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1074.14,9.2Z"
              fill="#3ba525"
            />
            <path
              d="M1074.89,9.17a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1074.89,9.17Z"
              fill="#2f6840"
            />
            <path
              d="M1078.37,8.38c-.26,0-.49,0-.72.09a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1078.37,8.38Z"
              fill="#2f6840"
            />
            <path
              d="M1077,11.59a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1077,11.59Z"
              fill="#2f6840"
            />
            <path
              d="M1075,9.63c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1075,9.63Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1066.3,6.17c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1066.3,6.17Z"
              fill="#2f6840"
            />
            <path
              d="M1065.8,5.83c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46S1067,5,1067,5s1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1065.8,5.83Z"
              fill="#3ba525"
            />
            <path
              d="M1066.55,5.8a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1066.55,5.8Z"
              fill="#2f6840"
            />
            <path
              d="M1070,5c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1070,5Z"
              fill="#2f6840"
            />
            <path
              d="M1068.66,8.21a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1068.66,8.21Z"
              fill="#2f6840"
            />
            <path
              d="M1066.7,6.26c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1066.7,6.26Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1081,21.66c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1081,21.66Z"
              fill="#2f6840"
            />
            <path
              d="M1080.5,21.32c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1080.5,21.32Z"
              fill="#3ba525"
            />
            <path
              d="M1081.25,21.29a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1081.25,21.29Z"
              fill="#2f6840"
            />
            <path
              d="M1084.73,20.49c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1084.73,20.49Z"
              fill="#2f6840"
            />
            <path
              d="M1083.36,23.7a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1083.36,23.7Z"
              fill="#2f6840"
            />
            <path
              d="M1081.41,21.75c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1081.41,21.75Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1067.55,16.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1067.55,16.09Z"
              fill="#2f6840"
            />
            <path
              d="M1067,15.75c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1067,15.75Z"
              fill="#3ba525"
            />
            <path
              d="M1067.8,15.72a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1067.8,15.72Z"
              fill="#2f6840"
            />
            <path
              d="M1071.28,14.92c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1071.28,14.92Z"
              fill="#2f6840"
            />
            <path
              d="M1069.91,18.13a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1069.91,18.13Z"
              fill="#2f6840"
            />
            <path
              d="M1068,16.18c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1068,16.18Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1104,18.21c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1104,18.21Z"
              fill="#2f6840"
            />
            <path
              d="M1103.47,17.87c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1103.47,17.87Z"
              fill="#3ba525"
            />
            <path
              d="M1104.22,17.84a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1104.22,17.84Z"
              fill="#2f6840"
            />
            <path
              d="M1107.7,17c-.26,0-.49.05-.72.1a4.83,4.83,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1107.7,17Z"
              fill="#2f6840"
            />
            <path
              d="M1106.33,20.25a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1106.33,20.25Z"
              fill="#2f6840"
            />
            <path
              d="M1104.37,18.3a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1104.37,18.3Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1101.32,26.94c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1101.32,26.94Z"
              fill="#2f6840"
            />
            <path
              d="M1100.81,26.59c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1100.81,26.59Z"
              fill="#3ba525"
            />
            <path
              d="M1101.56,26.57a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1101.56,26.57Z"
              fill="#2f6840"
            />
            <path
              d="M1105,25.77c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1105,25.77Z"
              fill="#2f6840"
            />
            <path
              d="M1103.67,29a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1103.67,29Z"
              fill="#2f6840"
            />
            <path
              d="M1101.71,27a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1101.71,27Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1096,22c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1096,22Z"
              fill="#2f6840"
            />
            <path
              d="M1095.46,21.64c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1095.46,21.64Z"
              fill="#3ba525"
            />
            <path
              d="M1096.21,21.61a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1096.21,21.61Z"
              fill="#2f6840"
            />
            <path
              d="M1099.69,20.81c-.26,0-.49.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1099.69,20.81Z"
              fill="#2f6840"
            />
            <path
              d="M1098.32,24a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1098.32,24Z"
              fill="#2f6840"
            />
            <path
              d="M1096.36,22.07c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1096.36,22.07Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1087.62,18.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1087.62,18.61Z"
              fill="#2f6840"
            />
            <path
              d="M1087.12,18.26c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1087.12,18.26Z"
              fill="#3ba525"
            />
            <path
              d="M1087.87,18.24a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1087.87,18.24Z"
              fill="#2f6840"
            />
            <path
              d="M1091.35,17.44c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.1,2.1,0,0,1,1091.35,17.44Z"
              fill="#2f6840"
            />
            <path
              d="M1090,20.65a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1090,20.65Z"
              fill="#2f6840"
            />
            <path
              d="M1088,18.7a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1088,18.7Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1102.33,34.1c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1102.33,34.1Z"
              fill="#2f6840"
            />
            <path
              d="M1101.82,33.75c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1101.82,33.75Z"
              fill="#3ba525"
            />
            <path
              d="M1102.57,33.73a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1102.57,33.73Z"
              fill="#2f6840"
            />
            <path
              d="M1106.05,32.93c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1106.05,32.93Z"
              fill="#2f6840"
            />
            <path
              d="M1104.68,36.14a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1104.68,36.14Z"
              fill="#2f6840"
            />
            <path
              d="M1102.72,34.19a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1102.72,34.19Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1088.87,28.53c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1088.87,28.53Z"
              fill="#2f6840"
            />
            <path
              d="M1088.36,28.18c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1088.36,28.18Z"
              fill="#3ba525"
            />
            <path
              d="M1089.12,28.16a2.12,2.12,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1089.12,28.16Z"
              fill="#2f6840"
            />
            <path
              d="M1092.59,27.36c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1092.59,27.36Z"
              fill="#2f6840"
            />
            <path
              d="M1091.23,30.57a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1091.23,30.57Z"
              fill="#2f6840"
            />
            <path
              d="M1089.27,28.62a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1089.27,28.62Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1131.24,22.07c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1131.24,22.07Z"
              fill="#2f6840"
            />
            <path
              d="M1130.73,21.72c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1130.73,21.72Z"
              fill="#3ba525"
            />
            <path
              d="M1131.48,21.7a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1131.48,21.7Z"
              fill="#2f6840"
            />
            <path
              d="M1135,20.9c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1135,20.9Z"
              fill="#2f6840"
            />
            <path
              d="M1133.59,24.11a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1133.59,24.11Z"
              fill="#2f6840"
            />
            <path
              d="M1131.64,22.16a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1131.64,22.16Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1128.58,30.8c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1128.58,30.8Z"
              fill="#2f6840"
            />
            <path
              d="M1128.07,30.45c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1128.07,30.45Z"
              fill="#3ba525"
            />
            <path
              d="M1128.82,30.43a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1128.82,30.43Z"
              fill="#2f6840"
            />
            <path
              d="M1132.3,29.63c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1132.3,29.63Z"
              fill="#2f6840"
            />
            <path
              d="M1130.93,32.84a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1130.93,32.84Z"
              fill="#2f6840"
            />
            <path
              d="M1129,30.88c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1129,30.88Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1123.22,25.84c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1123.22,25.84Z"
              fill="#2f6840"
            />
            <path
              d="M1122.72,25.5c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1122.72,25.5Z"
              fill="#3ba525"
            />
            <path
              d="M1123.47,25.47a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1123.47,25.47Z"
              fill="#2f6840"
            />
            <path
              d="M1127,24.67c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1127,24.67Z"
              fill="#2f6840"
            />
            <path
              d="M1125.58,27.88a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1125.58,27.88Z"
              fill="#2f6840"
            />
            <path
              d="M1123.62,25.93a7,7,0,0,0-.69.16,3.31,3.31,0,0,0-.65.22A10,10,0,0,0,1121,27a2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1123.62,25.93Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1114.88,22.47c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1114.88,22.47Z"
              fill="#2f6840"
            />
            <path
              d="M1114.38,22.12c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1114.38,22.12Z"
              fill="#3ba525"
            />
            <path
              d="M1115.13,22.1a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1115.13,22.1Z"
              fill="#2f6840"
            />
            <path
              d="M1118.61,21.3c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1118.61,21.3Z"
              fill="#2f6840"
            />
            <path
              d="M1117.24,24.51a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1117.24,24.51Z"
              fill="#2f6840"
            />
            <path
              d="M1115.28,22.56a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1115.28,22.56Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1129.59,38c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1129.59,38Z"
              fill="#2f6840"
            />
            <path
              d="M1129.08,37.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1129.08,37.61Z"
              fill="#3ba525"
            />
            <path
              d="M1129.83,37.59a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1129.83,37.59Z"
              fill="#2f6840"
            />
            <path
              d="M1133.31,36.79c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1133.31,36.79Z"
              fill="#2f6840"
            />
            <path
              d="M1131.94,40a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1131.94,40Z"
              fill="#2f6840"
            />
            <path
              d="M1130,38c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1130,38Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1116.13,32.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1116.13,32.39Z"
              fill="#2f6840"
            />
            <path
              d="M1115.62,32c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1115.62,32Z"
              fill="#3ba525"
            />
            <path
              d="M1116.38,32a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1116.38,32Z"
              fill="#2f6840"
            />
            <path
              d="M1119.85,31.22c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1119.85,31.22Z"
              fill="#2f6840"
            />
            <path
              d="M1118.49,34.43a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1118.49,34.43Z"
              fill="#2f6840"
            />
            <path
              d="M1116.53,32.48a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1116.53,32.48Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1103.57,33.85l1.84,1.14a.59.59,0,0,0,.56,0l4.41-2a.59.59,0,0,0,.15-1h0a.55.55,0,0,0-.47-.14l-6.25.83A.59.59,0,0,0,1103.57,33.85Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1106.83 29.3 1104.35 29.82 1102.16 31.5 1105.83 32.98 1110.32 31.14 1106.83 29.3"
            fill="#ffedc8"
          />
          <polygon
            points="1102.16 31.5 1102.16 32.98 1105.68 34.48 1110.42 32.56 1110.32 31.14 1105.83 32.98 1102.16 31.5"
            fill="#ccae79"
          />
          <polygon
            points="1105.83 32.98 1105.68 34.48 1110.42 32.56 1110.32 31.14 1105.83 32.98"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1103.21,31.92a.69.69,0,0,1,0,.76c.16-.24.2-.67.28-.64Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1104.75,32.55a2.15,2.15,0,0,0,.93-.95l-.67,1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1107.68,32.22a.67.67,0,0,1,.37.59l-.11-.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1109.33,30.61a4.2,4.2,0,0,1-1.46,0,2.1,2.1,0,0,1-1.07.07s.78-.07,1.07.19A6.41,6.41,0,0,1,1109.33,30.61Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M976.27,24.42l1.84,1.14a.61.61,0,0,0,.56,0l4.4-2a.6.6,0,0,0,.15-1h0a.61.61,0,0,0-.47-.14l-6.24.83A.6.6,0,0,0,976.27,24.42Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="979.53 19.86 977.04 20.39 974.85 22.07 978.52 23.54 983.02 21.7 979.53 19.86"
            fill="#ffedc8"
          />
          <polygon
            points="974.85 22.07 974.85 23.54 978.38 25.05 983.12 23.13 983.02 21.7 978.52 23.54 974.85 22.07"
            fill="#ccae79"
          />
          <polygon
            points="978.52 23.54 978.38 25.05 983.12 23.13 983.02 21.7 978.52 23.54"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M975.9,22.49a.65.65,0,0,1,0,.75c.17-.23.21-.67.28-.64Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M977.45,23.11a2.08,2.08,0,0,0,.93-.94l-.67,1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M980.38,22.78a.69.69,0,0,1,.37.59l-.11-.69Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M982,21.17a4.19,4.19,0,0,1-1.46,0,2,2,0,0,1-1.06.08s.78-.08,1.06.19A6.61,6.61,0,0,1,982,21.17Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M927.29,23.43l1.83,1.14a.62.62,0,0,0,.56,0l4.41-2a.59.59,0,0,0,.15-1h0a.55.55,0,0,0-.47-.14l-6.25.83A.6.6,0,0,0,927.29,23.43Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="930.55 18.86 928.06 19.39 925.87 21.07 929.54 22.55 934.03 20.71 930.55 18.86"
            fill="#ffedc8"
          />
          <polygon
            points="925.87 21.07 925.87 22.55 929.39 24.05 934.13 22.13 934.03 20.71 929.54 22.55 925.87 21.07"
            fill="#ccae79"
          />
          <polygon
            points="929.54 22.55 929.39 24.05 934.13 22.13 934.03 20.71 929.54 22.55"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M926.92,21.5a.65.65,0,0,1,0,.75c.16-.24.2-.67.28-.64Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M928.47,22.12a2.09,2.09,0,0,0,.92-.94l-.66,1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M931.4,21.79a.67.67,0,0,1,.36.59l-.11-.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M933,20.18a4.2,4.2,0,0,1-1.46,0,2.06,2.06,0,0,1-1.06.07s.78-.07,1.06.2A6,6,0,0,1,933,20.18Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1079.93,17.12l4,2.49a1.29,1.29,0,0,0,1.22.08l9.62-4.3a1.31,1.31,0,0,0,.32-2.18h0a1.3,1.3,0,0,0-1-.3l-13.64,1.81A1.3,1.3,0,0,0,1079.93,17.12Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1087.05 7.17 1081.62 8.32 1076.84 11.99 1084.85 15.2 1094.66 11.18 1087.05 7.17"
            fill="#ffedc8"
          />
          <polygon
            points="1076.84 11.99 1076.84 15.2 1084.53 18.5 1094.87 14.3 1094.66 11.18 1084.85 15.2 1076.84 11.99"
            fill="#ccae79"
          />
          <polygon
            points="1084.85 15.2 1084.53 18.5 1094.87 14.3 1094.66 11.18 1084.85 15.2"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1079.12,12.91a1.43,1.43,0,0,1,0,1.64c.37-.51.45-1.47.62-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1082.5,14.26a4.6,4.6,0,0,0,2-2l-1.46,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1088.9,13.54a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1092.49,10a9.72,9.72,0,0,1-3.19,0,4.65,4.65,0,0,1-2.32.16s1.7-.17,2.32.41A13.73,13.73,0,0,1,1092.49,10Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M894.68,20.33l4,2.49a1.29,1.29,0,0,0,1.22.08l9.63-4.3a1.3,1.3,0,0,0,.32-2.17h0a1.27,1.27,0,0,0-1-.31l-13.64,1.81A1.3,1.3,0,0,0,894.68,20.33Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="901.79 10.38 896.37 11.53 891.59 15.2 899.6 18.41 909.41 14.39 901.79 10.38"
            fill="#ffedc8"
          />
          <polygon
            points="891.59 15.2 891.59 18.41 899.27 21.71 909.62 17.51 909.41 14.39 899.6 18.41 891.59 15.2"
            fill="#ccae79"
          />
          <polygon
            points="899.6 18.41 899.27 21.71 909.62 17.51 909.41 14.39 899.6 18.41"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M893.87,16.12a1.44,1.44,0,0,1,0,1.65c.36-.52.45-1.47.61-1.41Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M897.25,17.47a4.56,4.56,0,0,0,2-2l-1.45,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M903.65,16.75a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M907.23,13.25a9.65,9.65,0,0,1-3.18,0,4.64,4.64,0,0,1-2.32.16s1.7-.17,2.32.42A13.32,13.32,0,0,1,907.23,13.25Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M955,30.72l4,2.49a1.29,1.29,0,0,0,1.22.08l9.63-4.3a1.31,1.31,0,0,0,.32-2.18h0a1.32,1.32,0,0,0-1-.3l-13.63,1.81A1.31,1.31,0,0,0,955,30.72Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="962.11 20.77 956.68 21.92 951.9 25.59 959.91 28.8 969.72 24.78 962.11 20.77"
            fill="#ffedc8"
          />
          <polygon
            points="951.9 25.59 951.9 28.8 959.59 32.1 969.94 27.9 969.72 24.78 959.91 28.8 951.9 25.59"
            fill="#ccae79"
          />
          <polygon
            points="959.91 28.8 959.59 32.1 969.94 27.9 969.72 24.78 959.91 28.8"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M954.19,26.51a1.44,1.44,0,0,1,0,1.65c.36-.52.44-1.47.61-1.41Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M957.57,27.86a4.56,4.56,0,0,0,2-2.05l-1.45,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M964,27.14a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M967.55,23.64a9.66,9.66,0,0,1-3.18,0,4.69,4.69,0,0,1-2.33.16s1.71-.17,2.33.41A13.59,13.59,0,0,1,967.55,23.64Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1086.2,34.47l3,1.85a1,1,0,0,0,.91.06l7.16-3.2a1,1,0,0,0,.24-1.62h0a1,1,0,0,0-.76-.23l-10.15,1.35A1,1,0,0,0,1086.2,34.47Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1091.5 27.05 1087.46 27.91 1083.9 30.65 1089.87 33.04 1097.17 30.05 1091.5 27.05"
            fill="#ffedc8"
          />
          <polygon
            points="1083.9 30.65 1083.9 33.04 1089.63 35.49 1097.33 32.36 1097.17 30.05 1089.87 33.04 1083.9 30.65"
            fill="#ccae79"
          />
          <polygon
            points="1089.87 33.04 1089.63 35.49 1097.33 32.36 1097.17 30.05 1089.87 33.04"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1085.6,31.33a1.07,1.07,0,0,1,0,1.23c.27-.39.34-1.1.46-1.05Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1088.12,32.34a3.45,3.45,0,0,0,1.51-1.53l-1.09,1.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1092.88,31.8a1.12,1.12,0,0,1,.6,1l-.18-1.14Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1095.55,29.19a7.07,7.07,0,0,1-2.37,0,3.41,3.41,0,0,1-1.73.12s1.27-.12,1.73.31A10.46,10.46,0,0,1,1095.55,29.19Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M987.05,39.19l3,1.86a1,1,0,0,0,.91.06l7.16-3.2a1,1,0,0,0,.24-1.62h0a.93.93,0,0,0-.76-.23l-10.15,1.35A1,1,0,0,0,987.05,39.19Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="992.35 31.78 988.31 32.64 984.75 35.37 990.72 37.76 998.02 34.77 992.35 31.78"
            fill="#ffedc8"
          />
          <polygon
            points="984.75 35.37 984.75 37.76 990.48 40.22 998.18 37.09 998.02 34.77 990.72 37.76 984.75 35.37"
            fill="#ccae79"
          />
          <polygon
            points="990.72 37.76 990.48 40.22 998.18 37.09 998.02 34.77 990.72 37.76"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M986.45,36.06a1.05,1.05,0,0,1,0,1.22c.27-.38.34-1.09.46-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M989,37.06a3.39,3.39,0,0,0,1.51-1.52l-1.09,1.69Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M993.73,36.53a1.12,1.12,0,0,1,.6,1l-.18-1.14Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M996.4,33.92a7.07,7.07,0,0,1-2.37,0,3.41,3.41,0,0,1-1.73.12s1.27-.12,1.73.31A10.46,10.46,0,0,1,996.4,33.92Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M886.14,9.86l3,1.86a1,1,0,0,0,.91.06l7.16-3.2A1,1,0,0,0,897.43,7h0a.92.92,0,0,0-.76-.23L886.52,8.08A1,1,0,0,0,886.14,9.86Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="891.43 2.45 887.39 3.31 883.83 6.04 889.8 8.44 897.1 5.44 891.43 2.45"
            fill="#ffedc8"
          />
          <polygon
            points="883.83 6.04 883.83 8.44 889.56 10.89 897.26 7.76 897.1 5.44 889.8 8.44 883.83 6.04"
            fill="#ccae79"
          />
          <polygon
            points="889.8 8.44 889.56 10.89 897.26 7.76 897.1 5.44 889.8 8.44"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M885.54,6.73a1.07,1.07,0,0,1,0,1.22c.27-.38.33-1.09.45-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M888.05,7.74a3.45,3.45,0,0,0,1.51-1.53l-1.08,1.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M892.81,7.2a1.12,1.12,0,0,1,.6,1L893.23,7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M895.48,4.59a7.06,7.06,0,0,1-2.37,0,3.37,3.37,0,0,1-1.72.12s1.26-.12,1.72.31A10.46,10.46,0,0,1,895.48,4.59Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1057.39,38.12l4,2.49a1.29,1.29,0,0,0,1.22.08l9.62-4.3a1.31,1.31,0,0,0,.32-2.18h0a1.3,1.3,0,0,0-1-.3l-13.63,1.81A1.3,1.3,0,0,0,1057.39,38.12Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1064.51 28.16 1059.08 29.32 1054.3 32.99 1062.31 36.2 1072.12 32.18 1064.51 28.16"
            fill="#ffedc8"
          />
          <polygon
            points="1054.3 32.99 1054.3 36.2 1061.99 39.49 1072.33 35.3 1072.12 32.18 1062.31 36.2 1054.3 32.99"
            fill="#ccae79"
          />
          <polygon
            points="1062.31 36.2 1061.99 39.49 1072.33 35.3 1072.12 32.18 1062.31 36.2"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1056.59,33.91a1.45,1.45,0,0,1,0,1.64c.36-.51.44-1.47.61-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1060,35.26a4.6,4.6,0,0,0,2-2l-1.46,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1066.36,34.54a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1070,31a9.72,9.72,0,0,1-3.19,0,4.65,4.65,0,0,1-2.32.16s1.7-.17,2.32.41A13.73,13.73,0,0,1,1070,31Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1005.54,27.77l4,2.49a1.32,1.32,0,0,0,1.22.09L1020.4,26a1.3,1.3,0,0,0,.32-2.17h0a1.29,1.29,0,0,0-1-.31l-13.63,1.81A1.31,1.31,0,0,0,1005.54,27.77Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1012.66 17.82 1007.23 18.97 1002.45 22.64 1010.46 25.85 1020.27 21.84 1012.66 17.82"
            fill="#ffedc8"
          />
          <polygon
            points="1002.45 22.64 1002.45 25.85 1010.14 29.15 1020.49 24.95 1020.27 21.84 1010.46 25.85 1002.45 22.64"
            fill="#ccae79"
          />
          <polygon
            points="1010.46 25.85 1010.14 29.15 1020.49 24.95 1020.27 21.84 1010.46 25.85"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1004.74,23.56a1.44,1.44,0,0,1,0,1.65c.36-.52.44-1.47.61-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1008.12,24.91a4.56,4.56,0,0,0,2-2.05l-1.45,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1014.51,24.19a1.5,1.5,0,0,1,.8,1.3l-.24-1.52Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1018.1,20.69a9.38,9.38,0,0,1-3.18,0,4.55,4.55,0,0,1-2.33.16s1.71-.16,2.33.42A13.78,13.78,0,0,1,1018.1,20.69Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1104.51,24.22s1.69,3.36,4,3.93,5.91-1.78,5.36.16,4.44,2.8,6.57,2.27,6.83-5.09,6.8-6.54S1104.51,24.22,1104.51,24.22Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1104.43,21.47l.08,2.75,4,2.82,5.25-.14,1.25,2s3.63,1.69,6-.16a19.74,19.74,0,0,0,4.24-5.1l-.07-2.76Z"
            fill="#ccae79"
          />
          <path
            d="M1108.65,19.56l-4.22,1.91,4.35,2.8,5-.13,1.68,2.07s4.94,1.33,5.54-.15,4.25-5.16,4.25-5.16l-4-1.68Z"
            fill="#ffedc8"
          />
          <polygon
            points="1108.78 24.27 1108.56 27.04 1113.81 26.9 1113.8 24.14 1108.78 24.27"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1119.77,26.72s.87,2.51.08,2.68a12,12,0,0,0,5.49-5.74l-.07-2.76S1120.93,26.7,1119.77,26.72Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1116.38,26.42l1,.18s-.62-.16-.47,1A2.74,2.74,0,0,0,1116.38,26.42Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1118.66,26.77c-.11,0,.2,0,1.09-.93a5.86,5.86,0,0,0,1.22-1.9s-2.13,2.47-1.6,2.81Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1107,23.11a15.82,15.82,0,0,1,.06,2s-.12-1.5.3-1.76Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1114.69,19.4l2,0c.14,0-1.57,0-2,.94l0-.89"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1106.56,20.51l1-.47s-.59.37-.36.45,1.17.45,1.55.25a1.58,1.58,0,0,1,1,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M930.23,13.32s1.69,3.36,4,3.93,5.9-1.78,5.36.16,4.43,2.8,6.57,2.27,6.83-5.09,6.8-6.54S930.23,13.32,930.23,13.32Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M930.16,10.56l.07,2.76,4.06,2.82,5.25-.14,1.25,2s3.62,1.69,6-.16a19.74,19.74,0,0,0,4.24-5.1L951,10Z"
            fill="#ccae79"
          />
          <path
            d="M934.38,8.66l-4.22,1.9,4.35,2.81,5-.13,1.69,2.07s4.94,1.32,5.54-.15S951,10,951,10l-4-1.68Z"
            fill="#ffedc8"
          />
          <polygon
            points="934.5 13.37 934.29 16.14 939.54 16 939.52 13.24 934.5 13.37"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M945.5,15.82s.86,2.51.07,2.68a12.08,12.08,0,0,0,5.5-5.74L951,10S946.65,15.8,945.5,15.82Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M942.11,15.51l1,.19s-.62-.16-.47,1A2.9,2.9,0,0,0,942.11,15.51Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M944.39,15.87c-.11,0,.19,0,1.08-.93A5.9,5.9,0,0,0,946.7,13s-2.13,2.47-1.61,2.81Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M932.7,12.21a16.74,16.74,0,0,1,0,2s-.11-1.5.31-1.76Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M940.42,8.5l2-.06c.15,0-1.57,0-2,1l0-.89"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M932.28,9.61l1.05-.48s-.59.38-.35.46,1.17.45,1.54.25a1.53,1.53,0,0,1,1,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M1224.76,494.49c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1224.76,494.49Z"
              fill="#2f6840"
            />
            <path
              d="M1224.26,494.15c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1224.26,494.15Z"
              fill="#3ba525"
            />
            <path
              d="M1225,494.12a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1225,494.12Z"
              fill="#2f6840"
            />
            <path
              d="M1228.49,493.32c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1228.49,493.32Z"
              fill="#2f6840"
            />
            <path
              d="M1227.12,496.53a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1227.12,496.53Z"
              fill="#2f6840"
            />
            <path
              d="M1225.16,494.58a7,7,0,0,0-.69.16,3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1225.16,494.58Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1222.11,503.22c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1222.11,503.22Z"
              fill="#2f6840"
            />
            <path
              d="M1221.6,502.88c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1221.6,502.88Z"
              fill="#3ba525"
            />
            <path
              d="M1222.35,502.85a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1222.35,502.85Z"
              fill="#2f6840"
            />
            <path
              d="M1225.83,502.05c-.26,0-.49.05-.72.1a4.83,4.83,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1225.83,502.05Z"
              fill="#2f6840"
            />
            <path
              d="M1224.46,505.26a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1224.46,505.26Z"
              fill="#2f6840"
            />
            <path
              d="M1222.5,503.31a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1222.5,503.31Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1216.75,498.26c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1216.75,498.26Z"
              fill="#2f6840"
            />
            <path
              d="M1216.25,497.92c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1216.25,497.92Z"
              fill="#3ba525"
            />
            <path
              d="M1217,497.89a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1217,497.89Z"
              fill="#2f6840"
            />
            <path
              d="M1220.48,497.09c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52A2.45,2.45,0,0,1,1219,497,2.12,2.12,0,0,1,1220.48,497.09Z"
              fill="#2f6840"
            />
            <path
              d="M1219.11,500.3a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1219.11,500.3Z"
              fill="#2f6840"
            />
            <path
              d="M1217.15,498.35c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1217.15,498.35Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1208.41,494.89c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1208.41,494.89Z"
              fill="#2f6840"
            />
            <path
              d="M1207.9,494.55c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1207.9,494.55Z"
              fill="#3ba525"
            />
            <path
              d="M1208.66,494.52a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.94.94,0,0,1,1208.66,494.52Z"
              fill="#2f6840"
            />
            <path
              d="M1212.13,493.72c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1212.13,493.72Z"
              fill="#2f6840"
            />
            <path
              d="M1210.77,496.93a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1210.77,496.93Z"
              fill="#2f6840"
            />
            <path
              d="M1208.81,495a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1208.81,495Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1223.12,510.38c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1223.12,510.38Z"
              fill="#2f6840"
            />
            <path
              d="M1222.61,510c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1222.61,510Z"
              fill="#3ba525"
            />
            <path
              d="M1223.36,510a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.16,2.16,0,0,1,.47.53A1,1,0,0,1,1223.36,510Z"
              fill="#2f6840"
            />
            <path
              d="M1226.84,509.21c-.26,0-.49.05-.72.1a4.51,4.51,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1226.84,509.21Z"
              fill="#2f6840"
            />
            <path
              d="M1225.47,512.42a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1225.47,512.42Z"
              fill="#2f6840"
            />
            <path
              d="M1223.51,510.47a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1223.51,510.47Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1209.66,504.81c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1209.66,504.81Z"
              fill="#2f6840"
            />
            <path
              d="M1209.15,504.47c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1209.15,504.47Z"
              fill="#3ba525"
            />
            <path
              d="M1209.91,504.44a2.24,2.24,0,0,0-.8-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1209.91,504.44Z"
              fill="#2f6840"
            />
            <path
              d="M1213.38,503.64c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17c-.45.13-.87.34-1.35.53a2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1213.38,503.64Z"
              fill="#2f6840"
            />
            <path
              d="M1212,506.85a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1212,506.85Z"
              fill="#2f6840"
            />
            <path
              d="M1210.06,504.9a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1210.06,504.9Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1250.66,506.15c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1250.66,506.15Z"
              fill="#2f6840"
            />
            <path
              d="M1250.16,505.8c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1250.16,505.8Z"
              fill="#3ba525"
            />
            <path
              d="M1250.91,505.78a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.38,2.38,0,0,1,.47.53A1,1,0,0,1,1250.91,505.78Z"
              fill="#2f6840"
            />
            <path
              d="M1254.39,505c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1254.39,505Z"
              fill="#2f6840"
            />
            <path
              d="M1253,508.19a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1253,508.19Z"
              fill="#2f6840"
            />
            <path
              d="M1251.06,506.24a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1251.06,506.24Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1248,514.88c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1248,514.88Z"
              fill="#2f6840"
            />
            <path
              d="M1247.5,514.53c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1247.5,514.53Z"
              fill="#3ba525"
            />
            <path
              d="M1248.25,514.5a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1248.25,514.5Z"
              fill="#2f6840"
            />
            <path
              d="M1251.73,513.71c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1251.73,513.71Z"
              fill="#2f6840"
            />
            <path
              d="M1250.36,516.92a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1250.36,516.92Z"
              fill="#2f6840"
            />
            <path
              d="M1248.4,515c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1248.4,515Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1242.65,509.92c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1242.65,509.92Z"
              fill="#2f6840"
            />
            <path
              d="M1242.14,509.58c4.43-.26-4.32.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1242.14,509.58Z"
              fill="#3ba525"
            />
            <path
              d="M1242.9,509.55a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1242.9,509.55Z"
              fill="#2f6840"
            />
            <path
              d="M1246.37,508.75c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1246.37,508.75Z"
              fill="#2f6840"
            />
            <path
              d="M1245,512a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1245,512Z"
              fill="#2f6840"
            />
            <path
              d="M1243.05,510a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1243.05,510Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1234.31,506.55c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1234.31,506.55Z"
              fill="#2f6840"
            />
            <path
              d="M1233.8,506.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1233.8,506.2Z"
              fill="#3ba525"
            />
            <path
              d="M1234.55,506.17a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1234.55,506.17Z"
              fill="#2f6840"
            />
            <path
              d="M1238,505.38c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1238,505.38Z"
              fill="#2f6840"
            />
            <path
              d="M1236.66,508.59a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1236.66,508.59Z"
              fill="#2f6840"
            />
            <path
              d="M1234.71,506.63c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1234.71,506.63Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1249,522c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1249,522Z"
              fill="#2f6840"
            />
            <path
              d="M1248.51,521.69c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1248.51,521.69Z"
              fill="#3ba525"
            />
            <path
              d="M1249.26,521.66a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1249.26,521.66Z"
              fill="#2f6840"
            />
            <path
              d="M1252.74,520.87c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1252.74,520.87Z"
              fill="#2f6840"
            />
            <path
              d="M1251.37,524.08a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1251.37,524.08Z"
              fill="#2f6840"
            />
            <path
              d="M1249.41,522.12c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1249.41,522.12Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1235.56,516.47c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1235.56,516.47Z"
              fill="#2f6840"
            />
            <path
              d="M1235.05,516.12c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1235.05,516.12Z"
              fill="#3ba525"
            />
            <path
              d="M1235.8,516.09a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1235.8,516.09Z"
              fill="#2f6840"
            />
            <path
              d="M1239.28,515.3c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1239.28,515.3Z"
              fill="#2f6840"
            />
            <path
              d="M1237.91,518.51a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1237.91,518.51Z"
              fill="#2f6840"
            />
            <path
              d="M1236,516.55c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1236,516.55Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1278.64,507.87c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1278.64,507.87Z"
              fill="#2f6840"
            />
            <path
              d="M1278.13,507.53c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1278.13,507.53Z"
              fill="#3ba525"
            />
            <path
              d="M1278.89,507.5a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1278.89,507.5Z"
              fill="#2f6840"
            />
            <path
              d="M1282.37,506.7c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1282.37,506.7Z"
              fill="#2f6840"
            />
            <path
              d="M1281,509.91a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1281,509.91Z"
              fill="#2f6840"
            />
            <path
              d="M1279,508a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1279,508Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1276,516.6c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1276,516.6Z"
              fill="#2f6840"
            />
            <path
              d="M1275.48,516.26c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,1275.48,516.26Z"
              fill="#3ba525"
            />
            <path
              d="M1276.23,516.23a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1276.23,516.23Z"
              fill="#2f6840"
            />
            <path
              d="M1279.71,515.43c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1279.71,515.43Z"
              fill="#2f6840"
            />
            <path
              d="M1278.34,518.64a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1278.34,518.64Z"
              fill="#2f6840"
            />
            <path
              d="M1276.38,516.69a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1276.38,516.69Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1270.63,511.64c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1270.63,511.64Z"
              fill="#2f6840"
            />
            <path
              d="M1270.12,511.3c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1270.12,511.3Z"
              fill="#3ba525"
            />
            <path
              d="M1270.88,511.27a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1270.88,511.27Z"
              fill="#2f6840"
            />
            <path
              d="M1274.35,510.47c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1274.35,510.47Z"
              fill="#2f6840"
            />
            <path
              d="M1273,513.68a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1273,513.68Z"
              fill="#2f6840"
            />
            <path
              d="M1271,511.73c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1271,511.73Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1262.29,508.27c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1262.29,508.27Z"
              fill="#2f6840"
            />
            <path
              d="M1261.78,507.93c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1261.78,507.93Z"
              fill="#3ba525"
            />
            <path
              d="M1262.53,507.9a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1262.53,507.9Z"
              fill="#2f6840"
            />
            <path
              d="M1266,507.1c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1266,507.1Z"
              fill="#2f6840"
            />
            <path
              d="M1264.64,510.31a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1264.64,510.31Z"
              fill="#2f6840"
            />
            <path
              d="M1262.68,508.36c-.24.06-.47.08-.69.15a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1262.68,508.36Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1277,523.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1277,523.76Z"
              fill="#2f6840"
            />
            <path
              d="M1276.49,523.42c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.68,14.68,0,0,1,1276.49,523.42Z"
              fill="#3ba525"
            />
            <path
              d="M1277.24,523.39a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1277.24,523.39Z"
              fill="#2f6840"
            />
            <path
              d="M1280.72,522.59c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1280.72,522.59Z"
              fill="#2f6840"
            />
            <path
              d="M1279.35,525.8a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1279.35,525.8Z"
              fill="#2f6840"
            />
            <path
              d="M1277.39,523.85a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1277.39,523.85Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1263.53,518.19c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1263.53,518.19Z"
              fill="#2f6840"
            />
            <path
              d="M1263,517.85c4.42-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1263,517.85Z"
              fill="#3ba525"
            />
            <path
              d="M1263.78,517.82a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1263.78,517.82Z"
              fill="#2f6840"
            />
            <path
              d="M1267.26,517c-.26,0-.49.05-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1267.26,517Z"
              fill="#2f6840"
            />
            <path
              d="M1265.89,520.23a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1265.89,520.23Z"
              fill="#2f6840"
            />
            <path
              d="M1263.93,518.28c-.24.06-.47.08-.7.15a4.41,4.41,0,0,0-.64.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1263.93,518.28Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1291.25,484.24c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1291.25,484.24Z"
              fill="#2f6840"
            />
            <path
              d="M1290.75,483.89c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S1286,485,1286.2,485A14.56,14.56,0,0,1,1290.75,483.89Z"
              fill="#3ba525"
            />
            <path
              d="M1291.5,483.86a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.48.53A1,1,0,0,1,1291.5,483.86Z"
              fill="#2f6840"
            />
            <path
              d="M1295,483.07c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1295,483.07Z"
              fill="#2f6840"
            />
            <path
              d="M1293.61,486.28a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1293.61,486.28Z"
              fill="#2f6840"
            />
            <path
              d="M1291.65,484.32c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1291.65,484.32Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1288.59,493c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1288.59,493Z"
              fill="#2f6840"
            />
            <path
              d="M1288.09,492.62c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1288.09,492.62Z"
              fill="#3ba525"
            />
            <path
              d="M1288.84,492.59a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1288.84,492.59Z"
              fill="#2f6840"
            />
            <path
              d="M1292.32,491.8a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1292.32,491.8Z"
              fill="#2f6840"
            />
            <path
              d="M1291,495a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1291,495Z"
              fill="#2f6840"
            />
            <path
              d="M1289,493.05c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1289,493.05Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1283.24,488c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1283.24,488Z"
              fill="#2f6840"
            />
            <path
              d="M1282.73,487.66c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1282.73,487.66Z"
              fill="#3ba525"
            />
            <path
              d="M1283.49,487.64a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1283.49,487.64Z"
              fill="#2f6840"
            />
            <path
              d="M1287,486.84c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1287,486.84Z"
              fill="#2f6840"
            />
            <path
              d="M1285.6,490.05a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1285.6,490.05Z"
              fill="#2f6840"
            />
            <path
              d="M1283.64,488.1a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1283.64,488.1Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1274.9,484.64c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1274.9,484.64Z"
              fill="#2f6840"
            />
            <path
              d="M1274.39,484.29c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1274.39,484.29Z"
              fill="#3ba525"
            />
            <path
              d="M1275.14,484.26a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1275.14,484.26Z"
              fill="#2f6840"
            />
            <path
              d="M1278.62,483.47c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1278.62,483.47Z"
              fill="#2f6840"
            />
            <path
              d="M1277.25,486.68a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1277.25,486.68Z"
              fill="#2f6840"
            />
            <path
              d="M1275.3,484.72c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1275.3,484.72Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1289.6,500.13c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1289.6,500.13Z"
              fill="#2f6840"
            />
            <path
              d="M1289.1,499.78c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1289.1,499.78Z"
              fill="#3ba525"
            />
            <path
              d="M1289.85,499.75a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1289.85,499.75Z"
              fill="#2f6840"
            />
            <path
              d="M1293.33,499a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1293.33,499Z"
              fill="#2f6840"
            />
            <path
              d="M1292,502.17a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1292,502.17Z"
              fill="#2f6840"
            />
            <path
              d="M1290,500.21c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1290,500.21Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1276.14,494.56c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1276.14,494.56Z"
              fill="#2f6840"
            />
            <path
              d="M1275.64,494.21c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1275.64,494.21Z"
              fill="#3ba525"
            />
            <path
              d="M1276.39,494.18a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1276.39,494.18Z"
              fill="#2f6840"
            />
            <path
              d="M1279.87,493.39c-.26,0-.49,0-.72.1a3,3,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1279.87,493.39Z"
              fill="#2f6840"
            />
            <path
              d="M1278.5,496.6a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1278.5,496.6Z"
              fill="#2f6840"
            />
            <path
              d="M1276.54,494.64c-.24.06-.47.09-.69.16a4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1276.54,494.64Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1280.86,461.15c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1280.86,461.15Z"
              fill="#2f6840"
            />
            <path
              d="M1280.35,460.8c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1280.35,460.8Z"
              fill="#3ba525"
            />
            <path
              d="M1281.11,460.78a2.12,2.12,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1281.11,460.78Z"
              fill="#2f6840"
            />
            <path
              d="M1284.58,460c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1284.58,460Z"
              fill="#2f6840"
            />
            <path
              d="M1283.22,463.19a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1283.22,463.19Z"
              fill="#2f6840"
            />
            <path
              d="M1281.26,461.24a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1281.26,461.24Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1278.2,469.88c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1278.2,469.88Z"
              fill="#2f6840"
            />
            <path
              d="M1277.69,469.53c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1277.69,469.53Z"
              fill="#3ba525"
            />
            <path
              d="M1278.45,469.5a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1278.45,469.5Z"
              fill="#2f6840"
            />
            <path
              d="M1281.92,468.71c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1281.92,468.71Z"
              fill="#2f6840"
            />
            <path
              d="M1280.56,471.92a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1280.56,471.92Z"
              fill="#2f6840"
            />
            <path
              d="M1278.6,470c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1278.6,470Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1272.85,464.92c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1272.85,464.92Z"
              fill="#2f6840"
            />
            <path
              d="M1272.34,464.57c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1272.34,464.57Z"
              fill="#3ba525"
            />
            <path
              d="M1273.09,464.55a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.31,2.31,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1273.09,464.55Z"
              fill="#2f6840"
            />
            <path
              d="M1276.57,463.75c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1276.57,463.75Z"
              fill="#2f6840"
            />
            <path
              d="M1275.2,467a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1275.2,467Z"
              fill="#2f6840"
            />
            <path
              d="M1273.25,465a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1273.25,465Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1264.5,461.55c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1264.5,461.55Z"
              fill="#2f6840"
            />
            <path
              d="M1264,461.2c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1264,461.2Z"
              fill="#3ba525"
            />
            <path
              d="M1264.75,461.17a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1264.75,461.17Z"
              fill="#2f6840"
            />
            <path
              d="M1268.23,460.38c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1268.23,460.38Z"
              fill="#2f6840"
            />
            <path
              d="M1266.86,463.59a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1266.86,463.59Z"
              fill="#2f6840"
            />
            <path
              d="M1264.9,461.63c-.24.06-.47.09-.69.16a4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1264.9,461.63Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1279.21,477c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1279.21,477Z"
              fill="#2f6840"
            />
            <path
              d="M1278.7,476.69c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1278.7,476.69Z"
              fill="#3ba525"
            />
            <path
              d="M1279.46,476.66a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1279.46,476.66Z"
              fill="#2f6840"
            />
            <path
              d="M1282.93,475.87c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1282.93,475.87Z"
              fill="#2f6840"
            />
            <path
              d="M1281.57,479.08a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1281.57,479.08Z"
              fill="#2f6840"
            />
            <path
              d="M1279.61,477.12c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1279.61,477.12Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1265.75,471.47c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1265.75,471.47Z"
              fill="#2f6840"
            />
            <path
              d="M1265.25,471.12c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1265.25,471.12Z"
              fill="#3ba525"
            />
            <path
              d="M1266,471.09a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1266,471.09Z"
              fill="#2f6840"
            />
            <path
              d="M1269.48,470.3c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1269.48,470.3Z"
              fill="#2f6840"
            />
            <path
              d="M1268.11,473.51a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1268.11,473.51Z"
              fill="#2f6840"
            />
            <path
              d="M1266.15,471.55c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1266.15,471.55Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1254.52,450.43c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1254.52,450.43Z"
              fill="#2f6840"
            />
            <path
              d="M1254,450.09c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1254,450.09Z"
              fill="#3ba525"
            />
            <path
              d="M1254.77,450.06a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1254.77,450.06Z"
              fill="#2f6840"
            />
            <path
              d="M1258.24,449.26c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1258.24,449.26Z"
              fill="#2f6840"
            />
            <path
              d="M1256.88,452.47a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1256.88,452.47Z"
              fill="#2f6840"
            />
            <path
              d="M1254.92,450.52c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1254.92,450.52Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1251.86,459.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1251.86,459.16Z"
              fill="#2f6840"
            />
            <path
              d="M1251.36,458.82c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1251.36,458.82Z"
              fill="#3ba525"
            />
            <path
              d="M1252.11,458.79a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1252.11,458.79Z"
              fill="#2f6840"
            />
            <path
              d="M1255.59,458c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1255.59,458Z"
              fill="#2f6840"
            />
            <path
              d="M1254.22,461.2a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1254.22,461.2Z"
              fill="#2f6840"
            />
            <path
              d="M1252.26,459.25c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1252.26,459.25Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1246.51,454.2c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1246.51,454.2Z"
              fill="#2f6840"
            />
            <path
              d="M1246,453.86c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1246,453.86Z"
              fill="#3ba525"
            />
            <path
              d="M1246.76,453.83a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1246.76,453.83Z"
              fill="#2f6840"
            />
            <path
              d="M1250.23,453c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1250.23,453Z"
              fill="#2f6840"
            />
            <path
              d="M1248.87,456.25a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1248.87,456.25Z"
              fill="#2f6840"
            />
            <path
              d="M1246.91,454.29c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1246.91,454.29Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1238.17,450.83c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1238.17,450.83Z"
              fill="#2f6840"
            />
            <path
              d="M1237.66,450.49c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1237.66,450.49Z"
              fill="#3ba525"
            />
            <path
              d="M1238.41,450.46a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1238.41,450.46Z"
              fill="#2f6840"
            />
            <path
              d="M1241.89,449.66c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1241.89,449.66Z"
              fill="#2f6840"
            />
            <path
              d="M1240.52,452.87a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1240.52,452.87Z"
              fill="#2f6840"
            />
            <path
              d="M1238.56,450.92c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1238.56,450.92Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1252.87,466.32c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1252.87,466.32Z"
              fill="#2f6840"
            />
            <path
              d="M1252.36,466c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1252.36,466Z"
              fill="#3ba525"
            />
            <path
              d="M1253.12,466a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1253.12,466Z"
              fill="#2f6840"
            />
            <path
              d="M1256.6,465.15c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1256.6,465.15Z"
              fill="#2f6840"
            />
            <path
              d="M1255.23,468.36a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1255.23,468.36Z"
              fill="#2f6840"
            />
            <path
              d="M1253.27,466.41c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1253.27,466.41Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1239.41,460.75c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1239.41,460.75Z"
              fill="#2f6840"
            />
            <path
              d="M1238.91,460.41c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1238.91,460.41Z"
              fill="#3ba525"
            />
            <path
              d="M1239.66,460.38a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1239.66,460.38Z"
              fill="#2f6840"
            />
            <path
              d="M1243.14,459.58c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1243.14,459.58Z"
              fill="#2f6840"
            />
            <path
              d="M1241.77,462.79a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1241.77,462.79Z"
              fill="#2f6840"
            />
            <path
              d="M1239.81,460.84c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1239.81,460.84Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1231,438.41c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1231,438.41Z"
              fill="#2f6840"
            />
            <path
              d="M1230.52,438.06c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1230.52,438.06Z"
              fill="#3ba525"
            />
            <path
              d="M1231.28,438a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1231.28,438Z"
              fill="#2f6840"
            />
            <path
              d="M1234.76,437.24c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.23-.86A2.1,2.1,0,0,1,1234.76,437.24Z"
              fill="#2f6840"
            />
            <path
              d="M1233.39,440.45a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1233.39,440.45Z"
              fill="#2f6840"
            />
            <path
              d="M1231.43,438.49c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,1231.43,438.49Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1228.37,447.13c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1228.37,447.13Z"
              fill="#2f6840"
            />
            <path
              d="M1227.87,446.79c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1227.87,446.79Z"
              fill="#3ba525"
            />
            <path
              d="M1228.62,446.76a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1228.62,446.76Z"
              fill="#2f6840"
            />
            <path
              d="M1232.1,446c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1232.1,446Z"
              fill="#2f6840"
            />
            <path
              d="M1230.73,449.18a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1230.73,449.18Z"
              fill="#2f6840"
            />
            <path
              d="M1228.77,447.22c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1228.77,447.22Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1223,442.18c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1223,442.18Z"
              fill="#2f6840"
            />
            <path
              d="M1222.51,441.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1222.51,441.83Z"
              fill="#3ba525"
            />
            <path
              d="M1223.27,441.8a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1223.27,441.8Z"
              fill="#2f6840"
            />
            <path
              d="M1226.74,441a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1226.74,441Z"
              fill="#2f6840"
            />
            <path
              d="M1225.38,444.22a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1225.38,444.22Z"
              fill="#2f6840"
            />
            <path
              d="M1223.42,442.26c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1223.42,442.26Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1214.68,438.8c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1214.68,438.8Z"
              fill="#2f6840"
            />
            <path
              d="M1214.17,438.46c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1214.17,438.46Z"
              fill="#3ba525"
            />
            <path
              d="M1214.92,438.43a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1214.92,438.43Z"
              fill="#2f6840"
            />
            <path
              d="M1218.4,437.64c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1218.4,437.64Z"
              fill="#2f6840"
            />
            <path
              d="M1217,440.85a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1217,440.85Z"
              fill="#2f6840"
            />
            <path
              d="M1215.08,438.89c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1215.08,438.89Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1229.38,454.29c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1229.38,454.29Z"
              fill="#2f6840"
            />
            <path
              d="M1228.88,454c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1228.88,454Z"
              fill="#3ba525"
            />
            <path
              d="M1229.63,453.92a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1229.63,453.92Z"
              fill="#2f6840"
            />
            <path
              d="M1233.11,453.13c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1233.11,453.13Z"
              fill="#2f6840"
            />
            <path
              d="M1231.74,456.34a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1231.74,456.34Z"
              fill="#2f6840"
            />
            <path
              d="M1229.78,454.38c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1229.78,454.38Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1215.92,448.72c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1215.92,448.72Z"
              fill="#2f6840"
            />
            <path
              d="M1215.42,448.38c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1215.42,448.38Z"
              fill="#3ba525"
            />
            <path
              d="M1216.17,448.35a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1216.17,448.35Z"
              fill="#2f6840"
            />
            <path
              d="M1219.65,447.56c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1219.65,447.56Z"
              fill="#2f6840"
            />
            <path
              d="M1218.28,450.77a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1218.28,450.77Z"
              fill="#2f6840"
            />
            <path
              d="M1216.32,448.81c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1216.32,448.81Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M1192,431.7c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1192,431.7Z"
              fill="#2f6840"
            />
            <path
              d="M1191.52,431.36c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1191.52,431.36Z"
              fill="#3ba525"
            />
            <path
              d="M1192.27,431.33a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1192.27,431.33Z"
              fill="#2f6840"
            />
            <path
              d="M1195.75,430.54c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1195.75,430.54Z"
              fill="#2f6840"
            />
            <path
              d="M1194.38,433.75a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1194.38,433.75Z"
              fill="#2f6840"
            />
            <path
              d="M1192.42,431.79c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1192.42,431.79Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1189.36,440.43c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1189.36,440.43Z"
              fill="#2f6840"
            />
            <path
              d="M1188.86,440.09c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1188.86,440.09Z"
              fill="#3ba525"
            />
            <path
              d="M1189.61,440.06a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1189.61,440.06Z"
              fill="#2f6840"
            />
            <path
              d="M1193.09,439.27c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1193.09,439.27Z"
              fill="#2f6840"
            />
            <path
              d="M1191.72,442.48a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1191.72,442.48Z"
              fill="#2f6840"
            />
            <path
              d="M1189.76,440.52c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1189.76,440.52Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1184,435.48c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1184,435.48Z"
              fill="#2f6840"
            />
            <path
              d="M1183.51,435.13c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71S1184,436,1184,436s-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1183.51,435.13Z"
              fill="#3ba525"
            />
            <path
              d="M1184.26,435.1a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1184.26,435.1Z"
              fill="#2f6840"
            />
            <path
              d="M1187.74,434.31a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1187.74,434.31Z"
              fill="#2f6840"
            />
            <path
              d="M1186.37,437.52a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1186.37,437.52Z"
              fill="#2f6840"
            />
            <path
              d="M1184.41,435.56c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1184.41,435.56Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1175.67,432.1c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1175.67,432.1Z"
              fill="#2f6840"
            />
            <path
              d="M1175.16,431.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1175.16,431.76Z"
              fill="#3ba525"
            />
            <path
              d="M1175.92,431.73a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1175.92,431.73Z"
              fill="#2f6840"
            />
            <path
              d="M1179.39,430.94c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1179.39,430.94Z"
              fill="#2f6840"
            />
            <path
              d="M1178,434.15a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1178,434.15Z"
              fill="#2f6840"
            />
            <path
              d="M1176.07,432.19c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1176.07,432.19Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1190.37,447.59c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1190.37,447.59Z"
              fill="#2f6840"
            />
            <path
              d="M1189.87,447.25c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1189.87,447.25Z"
              fill="#3ba525"
            />
            <path
              d="M1190.62,447.22a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1190.62,447.22Z"
              fill="#2f6840"
            />
            <path
              d="M1194.1,446.43c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1194.1,446.43Z"
              fill="#2f6840"
            />
            <path
              d="M1192.73,449.64a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1192.73,449.64Z"
              fill="#2f6840"
            />
            <path
              d="M1190.77,447.68c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1190.77,447.68Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1176.92,442c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1176.92,442Z"
              fill="#2f6840"
            />
            <path
              d="M1176.41,441.68c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1176.41,441.68Z"
              fill="#3ba525"
            />
            <path
              d="M1177.16,441.65a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1177.16,441.65Z"
              fill="#2f6840"
            />
            <path
              d="M1180.64,440.86c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1180.64,440.86Z"
              fill="#2f6840"
            />
            <path
              d="M1179.27,444.07a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1179.27,444.07Z"
              fill="#2f6840"
            />
            <path
              d="M1177.32,442.11c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1177.32,442.11Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1170.92,413.08c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1170.92,413.08Z"
              fill="#2f6840"
            />
            <path
              d="M1170.42,412.73c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1170.42,412.73Z"
              fill="#3ba525"
            />
            <path
              d="M1171.17,412.7a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1171.17,412.7Z"
              fill="#2f6840"
            />
            <path
              d="M1174.65,411.91c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1174.65,411.91Z"
              fill="#2f6840"
            />
            <path
              d="M1173.28,415.12a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1173.28,415.12Z"
              fill="#2f6840"
            />
            <path
              d="M1171.32,413.16c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1171.32,413.16Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1168.26,421.8c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1168.26,421.8Z"
              fill="#2f6840"
            />
            <path
              d="M1167.76,421.46c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1167.76,421.46Z"
              fill="#3ba525"
            />
            <path
              d="M1168.51,421.43a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1168.51,421.43Z"
              fill="#2f6840"
            />
            <path
              d="M1172,420.64c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1172,420.64Z"
              fill="#2f6840"
            />
            <path
              d="M1170.62,423.85a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1170.62,423.85Z"
              fill="#2f6840"
            />
            <path
              d="M1168.66,421.89c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1168.66,421.89Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1162.91,416.85c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1162.91,416.85Z"
              fill="#2f6840"
            />
            <path
              d="M1162.41,416.5c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1162.41,416.5Z"
              fill="#3ba525"
            />
            <path
              d="M1163.16,416.47a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1163.16,416.47Z"
              fill="#2f6840"
            />
            <path
              d="M1166.64,415.68a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1166.64,415.68Z"
              fill="#2f6840"
            />
            <path
              d="M1165.27,418.89a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1165.27,418.89Z"
              fill="#2f6840"
            />
            <path
              d="M1163.31,416.93c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1163.31,416.93Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1154.57,413.47c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1154.57,413.47Z"
              fill="#2f6840"
            />
            <path
              d="M1154.06,413.13c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1154.06,413.13Z"
              fill="#3ba525"
            />
            <path
              d="M1154.82,413.1a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1154.82,413.1Z"
              fill="#2f6840"
            />
            <path
              d="M1158.29,412.31c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,1158.29,412.31Z"
              fill="#2f6840"
            />
            <path
              d="M1156.93,415.52a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,1156.93,415.52Z"
              fill="#2f6840"
            />
            <path
              d="M1155,413.56c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1155,413.56Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1169.27,429c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1169.27,429Z"
              fill="#2f6840"
            />
            <path
              d="M1168.77,428.62c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1168.77,428.62Z"
              fill="#3ba525"
            />
            <path
              d="M1169.52,428.59a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1169.52,428.59Z"
              fill="#2f6840"
            />
            <path
              d="M1173,427.8c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1173,427.8Z"
              fill="#2f6840"
            />
            <path
              d="M1171.63,431a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1171.63,431Z"
              fill="#2f6840"
            />
            <path
              d="M1169.67,429.05c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1169.67,429.05Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1155.82,423.39c4.42-.25-4.33.46-4.35-.61s4.34-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1155.82,423.39Z"
              fill="#2f6840"
            />
            <path
              d="M1155.31,423.05c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1155.31,423.05Z"
              fill="#3ba525"
            />
            <path
              d="M1156.06,423a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1156.06,423Z"
              fill="#2f6840"
            />
            <path
              d="M1159.54,422.23c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1159.54,422.23Z"
              fill="#2f6840"
            />
            <path
              d="M1158.17,425.44a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1158.17,425.44Z"
              fill="#2f6840"
            />
            <path
              d="M1156.22,423.48c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1156.22,423.48Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1221.87,460.64l2.26,1.4a.71.71,0,0,0,.68,0l5.42-2.43a.73.73,0,0,0,.18-1.22h0a.72.72,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1221.87,460.64Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1225.88 455.03 1222.82 455.68 1220.13 457.75 1224.64 459.56 1230.16 457.3 1225.88 455.03"
            fill="#ffedc8"
          />
          <polygon
            points="1220.13 457.75 1220.13 459.56 1224.46 461.41 1230.28 459.05 1230.16 457.3 1224.64 459.56 1220.13 457.75"
            fill="#ccae79"
          />
          <polygon
            points="1224.64 459.56 1224.46 461.41 1230.28 459.05 1230.16 457.3 1224.64 459.56"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1221.42,458.27a.81.81,0,0,1,0,.92c.2-.29.25-.82.34-.79Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1223.32,459a2.57,2.57,0,0,0,1.14-1.16l-.82,1.29Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1226.92,458.62a.84.84,0,0,1,.45.73l-.14-.85Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1228.94,456.65a5.32,5.32,0,0,1-1.79,0,2.51,2.51,0,0,1-1.31.09s1-.09,1.31.24A7.66,7.66,0,0,1,1228.94,456.65Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1230.24,510.4l2.25,1.4a.74.74,0,0,0,.69.05l5.42-2.42a.74.74,0,0,0,.18-1.23h0a.72.72,0,0,0-.58-.17l-7.67,1A.73.73,0,0,0,1230.24,510.4Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1234.24 504.8 1231.19 505.44 1228.5 507.51 1233.01 509.32 1238.53 507.06 1234.24 504.8"
            fill="#ffedc8"
          />
          <polygon
            points="1228.5 507.51 1228.5 509.32 1232.83 511.18 1238.65 508.81 1238.53 507.06 1233.01 509.32 1228.5 507.51"
            fill="#ccae79"
          />
          <polygon
            points="1233.01 509.32 1232.83 511.18 1238.65 508.81 1238.53 507.06 1233.01 509.32"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1229.78,508a.8.8,0,0,1,0,.93c.21-.29.26-.83.35-.79Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1231.69,508.79a2.58,2.58,0,0,0,1.13-1.15l-.81,1.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1235.29,508.39a.83.83,0,0,1,.45.73l-.14-.86Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1237.31,506.41a5.37,5.37,0,0,1-1.8,0,2.47,2.47,0,0,1-1.3.09s1-.09,1.3.24A7.72,7.72,0,0,1,1237.31,506.41Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1242.16,467.21l3.89,2.41a1.27,1.27,0,0,0,1.18.08l9.34-4.17a1.27,1.27,0,0,0,.32-2.11h0a1.26,1.26,0,0,0-1-.3l-13.23,1.76A1.26,1.26,0,0,0,1242.16,467.21Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1249.06 457.54 1243.8 458.66 1239.16 462.23 1246.93 465.34 1256.45 461.44 1249.06 457.54"
            fill="#ffedc8"
          />
          <polygon
            points="1239.16 462.23 1239.16 465.34 1246.62 468.54 1256.66 464.46 1256.45 461.44 1246.93 465.34 1239.16 462.23"
            fill="#ccae79"
          />
          <polygon
            points="1246.93 465.34 1246.62 468.54 1256.66 464.46 1256.45 461.44 1246.93 465.34"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1241.38,463.12a1.4,1.4,0,0,1,0,1.6c.35-.51.43-1.43.59-1.37Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1244.66,464.43a4.48,4.48,0,0,0,2-2l-1.41,2.21Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1250.86,463.73a1.44,1.44,0,0,1,.78,1.26l-.23-1.48Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1254.34,460.33a9.1,9.1,0,0,1-3.09,0,4.52,4.52,0,0,1-2.25.16s1.65-.16,2.25.4A13.28,13.28,0,0,1,1254.34,460.33Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1289.6,482.86s-1.6,3.18-3.83,3.72-5.6-1.68-5.08.15-4.2,2.65-6.23,2.16-6.47-4.83-6.45-6.21S1289.6,482.86,1289.6,482.86Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1289.67,480.24l-.07,2.62-3.84,2.67-5-.13-1.18,1.91s-3.44,1.6-5.73-.15a18.76,18.76,0,0,1-4-4.84l.07-2.61Z"
            fill="#ccae79"
          />
          <path
            d="M1285.67,478.44l4,1.8-4.12,2.67-4.76-.13-1.59,2s-4.68,1.26-5.25-.14-4-4.89-4-4.89l3.74-1.59Z"
            fill="#ffedc8"
          />
          <polygon
            points="1285.55 482.91 1285.76 485.53 1280.78 485.4 1280.8 482.78 1285.55 482.91"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1275.13,485.23s-.82,2.37-.07,2.54a11.47,11.47,0,0,1-5.21-5.45l.07-2.61S1274,485.21,1275.13,485.23Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1278.35,484.94l-.95.17s.59-.15.45.95A2.61,2.61,0,0,1,1278.35,484.94Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1276.19,485.27a6.13,6.13,0,0,1-1-.88,5.53,5.53,0,0,1-1.15-1.8s2,2.34,1.52,2.66Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1287.26,481.8a17.55,17.55,0,0,0,0,1.89s.11-1.42-.28-1.67Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1280,478.29l-1.89-.06c-.14,0,1.48,0,1.87.9l0-.84"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1287.66,479.34l-1-.45s.55.36.33.43-1.11.43-1.46.24a1.45,1.45,0,0,0-1,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1270.52,511.45s-1,2.07-2.5,2.42-3.65-1.09-3.31.1-2.74,1.73-4.06,1.41-4.22-3.15-4.2-4.05S1270.52,511.45,1270.52,511.45Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1270.57,509.74l0,1.71-2.51,1.74-3.24-.09-.77,1.25s-2.24,1-3.73-.1a12.1,12.1,0,0,1-2.63-3.15l0-1.71Z"
            fill="#ccae79"
          />
          <path
            d="M1268,508.57l2.61,1.17-2.69,1.74-3.1-.09-1,1.28s-3,.82-3.43-.09a19,19,0,0,0-2.62-3.19l2.44-1Z"
            fill="#ffedc8"
          />
          <polygon
            points="1267.88 511.48 1268.02 513.19 1264.77 513.1 1264.78 511.39 1267.88 511.48"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1261.09,513s-.54,1.55,0,1.66a7.49,7.49,0,0,1-3.4-3.55l0-1.71S1260.37,513,1261.09,513Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1263.18,512.8l-.61.11s.38-.1.29.62A1.7,1.7,0,0,1,1263.18,512.8Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1261.77,513c.07,0-.12,0-.67-.57a3.67,3.67,0,0,1-.75-1.17s1.31,1.52,1,1.73Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1269,510.76a10.65,10.65,0,0,0,0,1.23s.07-.93-.19-1.09Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1264.23,508.47l-1.24,0c-.09,0,1,0,1.22.58v-.54"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1269.25,509.15l-.65-.29s.37.23.22.28-.72.28-1,.16a.91.91,0,0,0-.62,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
    </g>
  );
};

export default Trope2;
